<template>
  <div style="width: 100%; min-height: 100vh; background: rgb(237, 241, 255)">
    <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: #ede9e7" title="协议的区别"
      left-arrow @click-left="$router.back()" />
    <div style="height: 46px"></div>
    <div data-v-9c86c1e4="" class="virtualProto__virtualCurrency__b7CGB undefined">
      <div data-v-9c86c1e4="" class="virtualProto__block__3o4T3">
        <div data-v-9c86c1e4="" class="virtualProto__top_img__2l2NV"
          style="background-image: url('/static/image/title-bg6.ac4a470f9139139d8e0364b02421375b.png'); width: 206px">
          协议介绍
        </div>
        <div data-v-9c86c1e4="" class="virtualProto__firstPart__1A0Z-">
          <span data-v-9c86c1e4="">TRC20：基于波场网络协议</span>
          <p data-v-9c86c1e4="">TRC20的提币手续费最低，这意味着用户可以享受低手续费的交易所提币服务。同时，波场网络的TPS能够达到上千级别，可以实现交易秒级确认。</p>
        </div>
        <div data-v-9c86c1e4="" class="virtualProto__firstPart__1A0Z-">
          <span data-v-9c86c1e4="">ERC20：基于以太坊网络协议</span>
          <p data-v-9c86c1e4="">以太坊发行自己的原生代币及其他代币。但成千上万种代币的规则都不一样，这对后期市场发展非常不利。所以代币发行者做了一个智能合约标准，也就是ERC20。</p>
        </div>
      </div>
      <div data-v-9c86c1e4="" class="virtualProto__block__3o4T3">
        <div data-v-9c86c1e4="" class="virtualProto__top_img__2l2NV"
          style="background-image: url('/static/image/title-bg6.ac4a470f9139139d8e0364b02421375b.png'); width: 206px">
          协议的区别？
        </div>
        <table data-v-9c86c1e4="">
          <thead data-v-9c86c1e4="">
            <tr data-v-9c86c1e4="">
              <th data-v-9c86c1e4="">区别点</th>
              <th data-v-9c86c1e4="">TRC20协议</th>
              <th data-v-9c86c1e4="">ERC20协议</th>
            </tr>
          </thead>
          <tbody data-v-9c86c1e4="">
            <tr data-v-9c86c1e4="">
              <td data-v-9c86c1e4="">地址样式</td>
              <td data-v-9c86c1e4="">TRC20-USDT地址以T开头</td>
              <td data-v-9c86c1e4="">ERC20-USDT地址以0x开头</td>
            </tr>
            <tr data-v-9c86c1e4="">
              <td data-v-9c86c1e4="">使用网络</td>
              <td data-v-9c86c1e4="">波场网络</td>
              <td data-v-9c86c1e4="">以太坊网络</td>
            </tr>
            <tr data-v-9c86c1e4="">
              <td data-v-9c86c1e4="">网络状态</td>
              <td data-v-9c86c1e4="">基本不堵</td>
              <td data-v-9c86c1e4="">经常拥堵</td>
            </tr>
            <tr data-v-9c86c1e4="">
              <td data-v-9c86c1e4="">转账速度</td>
              <td data-v-9c86c1e4="">
                <div data-v-9c86c1e4="">极快</div>
                <div data-v-9c86c1e4="">(几秒到几分钟)</div>
              </td>
              <td data-v-9c86c1e4="">
                <div data-v-9c86c1e4="">普通</div>
                <div data-v-9c86c1e4="">(几分钟到数十分钟)</div>
              </td>
            </tr>
            <tr data-v-9c86c1e4="">
              <td data-v-9c86c1e4="">手续费用</td>
              <td data-v-9c86c1e4="">低</td>
              <td data-v-9c86c1e4="">普通</td>
            </tr>
            <tr data-v-9c86c1e4="">
              <td data-v-9c86c1e4="">安全系数</td>
              <td data-v-9c86c1e4="">普通</td>
              <td data-v-9c86c1e4="">高</td>
            </tr>
            <tr data-v-9c86c1e4="">
              <td data-v-9c86c1e4="">使用建议</td>
              <td data-v-9c86c1e4="">
                <div data-v-9c86c1e4="">小额高频</div>
                <div data-v-9c86c1e4="">交易推荐</div>
              </td>
              <td data-v-9c86c1e4="">
                <div data-v-9c86c1e4="">中等额度</div>
                <div data-v-9c86c1e4="">常规交易推荐</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div data-v-9c86c1e4="" class="virtualProto__block__3o4T3">
        <div data-v-9c86c1e4="" class="virtualProto__top_img__2l2NV"
          style="background-image: url('/static/image/title-bg6.ac4a470f9139139d8e0364b02421375b.png'); width: 206px">
          到底选哪种协议更好？
        </div>
        <div data-v-9c86c1e4="" class="virtualProto__container__3gv6Q">
          <img data-v-9c86c1e4="" src="/static/image/pic-xiaoe@2x.dad75f2e30f8e82488d587df87d8aef3.png" width="72px" />
          <div data-v-9c86c1e4="" class="virtualProto__rightContent__3OhXd">
            <span data-v-9c86c1e4="">小额交易推荐</span>
            <div data-v-9c86c1e4="">低手续费，秒级到账。</div>
          </div>
        </div>
        <div data-v-9c86c1e4="" class="virtualProto__container__3gv6Q">
          <img data-v-9c86c1e4="" src="/static/image/pic-zhonge@2x.e0bb8a0ad2b83c10733aa1d33dba786c.png" width="72px" />
          <div data-v-9c86c1e4="" class="virtualProto__rightContent__3OhXd">
            <span data-v-9c86c1e4="">中等额度推荐</span>
            <div data-v-9c86c1e4="">手续费和速度都介于中间值。</div>
          </div>
        </div>
        <p data-v-9c86c1e4="" class="virtualProto__bot__1w1K_">*两种协议对应的USDT地址不互通，进行转账、充值等操作时，应仔细核对正确地址！</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'usdtmore',
  data() {
    return {};
  },
  created() {
    let that = this;
  },
  methods: {},
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
.header__header__2qJGg[data-v-9c86c1e4] {
  position: fixed;
  top: env(safe-area-inset-top);
  left: 0;
  right: 0;
  height: 0.9rem;
  border: 1px solid #eee;
  color: #333;
  font-family: PingFang SC;
}

.header__header-title__2Ljwg[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 69%;
  text-align: center;
  margin: 0 auto;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 0.36rem;
  font-weight: 700;
  height: 100%;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.header__back-icon-wrapper__1BYD_[data-v-9c86c1e4] {
  width: 0.48rem;
  height: 0.48rem;
  display: block;
  position: absolute;
  left: 0.255rem;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}

.header__back-icon-wrapper__1BYD_>img[data-v-9c86c1e4] {
  display: block;
  width: 100%;
  height: 100%;
}

.header__cs-icon__30Y0g[data-v-9c86c1e4] {
  position: absolute;
  right: 0.4rem;
  top: 0.24rem;
  height: 0.36rem;
  width: 0.48rem;
  height: 0.48rem;
}

.header__cs-icon__30Y0g>img[data-v-9c86c1e4] {
  display: block;
  width: 100%;
  height: 100%;
}

.header__subtitle__2tEaB[data-v-9c86c1e4] {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
}

.header__hidden__gukei[data-v-9c86c1e4] {
  display: none;
}

.total-funds__total-funds-wrapper__3zi5c[data-v-9c86c1e4] {
  margin-top: 0.48rem;
  padding-left: 0.68rem;
}

.total-funds__funds-content__lTvBZ[data-v-9c86c1e4] {
  color: #f8f8f8;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.total-funds__funds-text__2a2cg[data-v-9c86c1e4] {
  font-size: 0.28rem;
  font-weight: 400;
}

.total-funds__icon-help__2vnXN[data-v-9c86c1e4] {
  width: 0.28rem;
  height: 0.28rem;
  display: inline-block;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALuSURBVHgBvVYtk+JAEJ1kKRgoBBIZeRKJRJ5EIleevJ9y8iRy5UpkJBIZGRmJAQJVwL2X6qa65vK1J66rYCYzPf16+ms6cj3ocrkkURR9w5Tj7PF4eK7HcVxiXmCteD6f2Xg8zrtkRW2bt9ttAYErCJu5HgTgI5RIh8Ph4UuABCjLco1pEqwf397eCkxLWfJYm4cKEXg0Gm05dgJer1eabh2Ybe+9P9QJUAVhDVoiUXCMJZT7BHDWCEgwCN8YTfc4kGIsXQ9SYMhY6BoU/rCgUcD8Q28GShEEaSiUAQTN5/f73WMscSafTqdFwLPCsNKbQs5vtc4LED77aXzxFxh9BQts6gJIInRnTW5BQTn2t9WN+cdoVEEwwaEGjLd/Vx6mAYW8tEbKUBl7hjLoEvlMiMHJgH8MfTl4REin4Q0kYr1E34cAVnQ6ndZQkgrPaW6bi/S/pJYXjENMJqN5HkYi9ujTRD4zC0aaTCapzqU4OPNdRbhaiVixZWq43dwIyMN9qyDmPtxnOlmFBjSFHqzLM5oIPL8UP9ynyRCx1RxjUafQ+XymbFoxgfnjCpA10TWQKhPmI82k/hflsrrzUp2IMYs175hT7gtEMETmu6ksu6ZK5MQyNPnA/QNZMJY+CNq1FWxLA6mVnpXD9SRbAAC0DSO3hrwoWsZ8AfihvuwiAmmgsUj0AHMmMAtWmtwI6nz3kCaWJ+vit3IrQNZBI2zRJQB5xRtt+YM58y5+vh4GPIuZZxpdWFhKZWkkpgb8zWDxXc+W3C6Rc0diVcWbbYEsegTEqk0IrPAdKcQHeiMvQuvtzKOQViP/JKRz0WrZJkgqhlLSxEcZ+hDLo3B4AZLgm0+miHyumkBZb6VZKvHbN4E5eQvJx/7mpbBlDFsMhr0CuB5E/9MltJKRUd9iWFBnmiipoXkbsHR5Cwhf2uYLQ3sTZQXYOvliBiCLvNZdqU7zwK+knC7q1SZa+m+NcEja6rNEsQRas0lpzPu2+n8AJzE1enmbCCcAAAAASUVORK5CYII=);
}

.webpa .total-funds__icon-help__2vnXN[data-v-9c86c1e4] {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALuSURBVHgBvVYtk+JAEJ1kKRgoBBIZeRKJRJ5EIleevJ9y8iRy5UpkJBIZGRmJAQJVwL2X6qa65vK1J66rYCYzPf16+ms6cj3ocrkkURR9w5Tj7PF4eK7HcVxiXmCteD6f2Xg8zrtkRW2bt9ttAYErCJu5HgTgI5RIh8Ph4UuABCjLco1pEqwf397eCkxLWfJYm4cKEXg0Gm05dgJer1eabh2Ybe+9P9QJUAVhDVoiUXCMJZT7BHDWCEgwCN8YTfc4kGIsXQ9SYMhY6BoU/rCgUcD8Q28GShEEaSiUAQTN5/f73WMscSafTqdFwLPCsNKbQs5vtc4LED77aXzxFxh9BQts6gJIInRnTW5BQTn2t9WN+cdoVEEwwaEGjLd/Vx6mAYW8tEbKUBl7hjLoEvlMiMHJgH8MfTl4REin4Q0kYr1E34cAVnQ6ndZQkgrPaW6bi/S/pJYXjENMJqN5HkYi9ujTRD4zC0aaTCapzqU4OPNdRbhaiVixZWq43dwIyMN9qyDmPtxnOlmFBjSFHqzLM5oIPL8UP9ynyRCx1RxjUafQ+XymbFoxgfnjCpA10TWQKhPmI82k/hflsrrzUp2IMYs175hT7gtEMETmu6ksu6ZK5MQyNPnA/QNZMJY+CNq1FWxLA6mVnpXD9SRbAAC0DSO3hrwoWsZ8AfihvuwiAmmgsUj0AHMmMAtWmtwI6nz3kCaWJ+vit3IrQNZBI2zRJQB5xRtt+YM58y5+vh4GPIuZZxpdWFhKZWkkpgb8zWDxXc+W3C6Rc0diVcWbbYEsegTEqk0IrPAdKcQHeiMvQuvtzKOQViP/JKRz0WrZJkgqhlLSxEcZ+hDLo3B4AZLgm0+miHyumkBZb6VZKvHbN4E5eQvJx/7mpbBlDFsMhr0CuB5E/9MltJKRUd9iWFBnmiipoXkbsHR5Cwhf2uYLQ3sTZQXYOvliBiCLvNZdqU7zwK+knC7q1SZa+m+NcEja6rNEsQRas0lpzPu2+n8AJzE1enmbCCcAAAAASUVORK5CYII=);
}

.total-funds__amount-content__2zpO0[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  color: #f8f8f8;
  line-height: 1;
  -webkit-box-align: end;
  -webkit-align-items: flex-end;
  -ms-flex-align: end;
  align-items: flex-end;
  height: 0.62rem;
}

.total-funds__unit__2jieQ[data-v-9c86c1e4] {
  font-size: 0.28rem;
}

.total-funds__amount__XKU2r[data-v-9c86c1e4] {
  font-family: DINPro;
  font-size: 0.48rem;
  margin: 0;
}

.total-funds__refresh-wrapper__3pSCp[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  margin-left: 0.16rem;
  height: 0.48rem;
}

.total-funds__refresh__FuNCE[data-v-9c86c1e4] {
  display: block;
  width: 0.32rem;
  height: 0.32rem;
  background-image: url(/static/style/icon_sx.88b45347bfcdb11586ef9a0872038bf9.png);
  background-repeat: no-repeat;
  background-size: 100%;
}

.webpa .total-funds__refresh__FuNCE[data-v-9c86c1e4] {
  background-image: url(/static/style/icon_sx.88b45347bfcdb11586ef9a0872038bf9.png);
}

.total-funds__loading__aPUx_[data-v-9c86c1e4] {
  -webkit-animation: total-funds__loading__aPUx_-data-v-9c86c1e4 1s linear infinite;
  animation: total-funds__loading__aPUx_-data-v-9c86c1e4 1s linear infinite;
}

.total-funds__help-content__3MOgp[data-v-9c86c1e4] {
  font-size: 0.24rem;
  line-height: 1.33;
  text-align: left;
  color: #fff;
}

@-webkit-keyframes total-funds__loading__aPUx_-data-v-9c86c1e4 {
  0% {
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }

  to {
    transform: rotate(-1turn);
    -ms-transform: rotate(-1turn);
    -webkit-transform: rotate(-1turn);
  }
}

@keyframes total-funds__loading__aPUx_-data-v-9c86c1e4 {
  0% {
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }

  to {
    transform: rotate(-1turn);
    -ms-transform: rotate(-1turn);
    -webkit-transform: rotate(-1turn);
  }
}

.popover-time__popover__13843[data-v-9c86c1e4] {
  position: fixed;
  background-color: rgba(62, 68, 87, 0.9);
  border-radius: 0.12rem;
  padding: 0.18rem 0.22rem;
  -webkit-transform: translateX(-1.16rem) translateY(0.2rem);
  transform: translateX(-1.16rem) translateY(0.2rem);
  z-index: 11;
}

.popover-time__popover__13843[data-v-9c86c1e4]:before {
  content: '';
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  top: -4.32px;
  top: -0.27rem;
  left: 16.32px;
  left: 1.02rem;
  border-radius: 0;
  border: 0.14rem solid transparent;
  border-top-color: rgba(62, 68, 87, 0.9);
  background-color: initial;
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.popover-time__hidden__Gznhg[data-v-9c86c1e4] {
  display: none;
}

.index__venuesContainer__2R49F .index__venuesTable__3DJUL[data-v-9c86c1e4] {
  display: block;
  color: #626571;
}

.index__venuesContainer__2R49F .index__venuesTable__3DJUL>thead[data-v-9c86c1e4] {
  display: block;
  height: 0.64rem;
  color: #414655;
  background: #f5f6fa;
  font-weight: 700;
  border: 0.02rem solid #eee;
}

.index__venuesContainer__2R49F .index__venuesTable__3DJUL>thead>tr[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 0.64rem;
}

.index__venuesContainer__2R49F .index__venuesTable__3DJUL>thead>tr td[data-v-9c86c1e4]:first-child {
  border-right: 0.01rem solid #eee;
}

.index__venuesContainer__2R49F .index__venuesTable__3DJUL>thead>tr>td[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  line-height: 0.64rem;
}

.index__venuesContainer__2R49F .index__venuesTable__3DJUL>tbody[data-v-9c86c1e4] {
  display: block;
  max-height: 3.2rem;
  overflow-y: auto;
}

.index__venuesContainer__2R49F .index__venuesTable__3DJUL>tbody>tr[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 0.64rem;
  border: 0.02rem solid #eee;
  border-top: none;
}

.index__venuesContainer__2R49F .index__venuesTable__3DJUL>tbody>tr td[data-v-9c86c1e4]:first-child {
  border-right: 0.01rem solid #eee;
}

.index__venuesContainer__2R49F .index__venuesTable__3DJUL>tbody>tr>td[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  line-height: 0.64rem;
}

.index__venuesContainer__2R49F .index__tips__2TZqE[data-v-9c86c1e4] {
  color: #626571;
  text-align: left;
  position: relative;
  top: 0.2rem;
}

.card__card-container__Bdm34[data-v-9c86c1e4] {
  border-radius: 0.28rem;
  background: -webkit-gradient(linear, left bottom, left top, from(#fff), to(#fff)), hsla(0, 0%, 100%, 0.9);
  background: -webkit-linear-gradient(bottom, #fff, #fff), hsla(0, 0%, 100%, 0.9);
  background: linear-gradient(0deg, #fff, #fff), hsla(0, 0%, 100%, 0.9);
  -webkit-backdrop-filter: blur(0.38rem);
  backdrop-filter: blur(0.38rem);
}

.card__card-title__1FpY_[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background: #f2f4fc;
  height: 0.82rem;
  color: #383b43;
  font-size: 0.28rem;
  padding-left: 0.46rem;
  margin: 0;
  font-weight: 400;
  border-top-left-radius: 0.28rem;
  border-top-right-radius: 0.28rem;
  position: relative;
  line-height: 1;
  font-family: PingFang SC;
}

.card__card-title__1FpY_[data-v-9c86c1e4]:before {
  content: '';
  display: block;
  width: 0;
  height: 5.12px;
  height: 0.32rem;
  border-left: 2px solid #383b43;
  position: absolute;
  top: 50%;
  left: 4.48px;
  left: 0.28rem;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}

.card__card-content__3x1az[data-v-9c86c1e4] {
  margin-top: 0.38rem;
}

.card__card-container-hidden__241c2[data-v-9c86c1e4] {
  display: none;
}

.link-card__link-container__1sCSU[data-v-9c86c1e4] {
  margin-left: 0.6rem;
}

.link-card__link-container__1sCSU>.link-card__link-container__1sCSU[data-v-9c86c1e4] {
  margin-left: 0.72rem;
}

.link-card__link-icon__3L-fP[data-v-9c86c1e4] {
  display: block;
  width: 0.94rem;
  height: 0.94rem;
  background-size: cover;
  background-repeat: no-repeat;
}

.link-card__link-text___bi8A[data-v-9c86c1e4] {
  font-family: PingFang SC;
  font-size: 0.24rem;
  line-height: 0.34rem;
  text-align: center;
  color: #414655;
  margin-top: 0.14rem;
}

.link-card__deposit-icon__3ciqI[data-v-9c86c1e4] {
  background-image: url(/static/img/feature_moneydraw.ddbdd6cb1996bc0dccf6c8570d9e0183.ddbdd6cb.png);
}

.webpa .link-card__deposit-icon__3ciqI[data-v-9c86c1e4] {
  background-image: url(/static/img/feature_moneydraw.ddbdd6cb1996bc0dccf6c8570d9e0183.ddbdd6cb.png);
}

.link-card__transfer-icon__20Xdv[data-v-9c86c1e4] {
  background-image: url(/static/img/feature_moneytransfer.5a83f20d17131faad2162df5435af5ca.5a83f20d.png);
}

.webpa .link-card__transfer-icon__20Xdv[data-v-9c86c1e4] {
  background-image: url(/static/img/feature_moneytransfer.5a83f20d17131faad2162df5435af5ca.5a83f20d.png);
}

.link-card__withdraw-icon__1ggIB[data-v-9c86c1e4] {
  background-image: url(/static/img/feature_withdrawmoney.932feadcf30fa1646577e19f04412aaf.932feadc.png);
}

.webpa .link-card__withdraw-icon__1ggIB[data-v-9c86c1e4] {
  background-image: url(/static/img/feature_withdrawmoney.932feadcf30fa1646577e19f04412aaf.932feadc.png);
}

.link-card__bankcard-icon__1SMvt[data-v-9c86c1e4] {
  background-image: url(/static/img/feature_bankcard.30833143844bfe739725bd4781495a2d.30833143.png);
}

.webpa .link-card__bankcard-icon__1SMvt[data-v-9c86c1e4] {
  background-image: url(/static/img/feature_bankcard.30833143844bfe739725bd4781495a2d.30833143.png);
}

.link-card__usdt-recharge-icon__PWqVi[data-v-9c86c1e4] {
  background-image: url(/static/img/usdt_recharge.8fc411869d432472b204f620c771a7b7.8fc41186.png);
}

.webpa .link-card__usdt-recharge-icon__PWqVi[data-v-9c86c1e4] {
  background-image: url(/static/img/usdt_recharge.8fc411869d432472b204f620c771a7b7.8fc41186.png);
}

.link-card__usdt-withdrawal-icon__efx-S[data-v-9c86c1e4] {
  background-image: url(/static/img/usdt_withdrawal.569c9ee9d25aaadfcf0aaf964cfa22aa.569c9ee9.png);
}

.webpa .link-card__usdt-withdrawal-icon__efx-S[data-v-9c86c1e4] {
  background-image: url(/static/img/usdt_withdrawal.569c9ee9d25aaadfcf0aaf964cfa22aa.569c9ee9.png);
}

.link-card__usdt-exchange-icon__2OuxR[data-v-9c86c1e4] {
  background-image: url(/static/img/usdt_exchange.8ccbebcaf5460a7246356dc18a778032.8ccbebca.png);
}

.webpa .link-card__usdt-exchange-icon__2OuxR[data-v-9c86c1e4] {
  background-image: url(/static/img/usdt_exchange.8ccbebcaf5460a7246356dc18a778032.8ccbebca.png);
}

.link-card__usdt-address-icon__36xPc[data-v-9c86c1e4] {
  background-image: url(/static/img/usdt_address.995d6615a8fa278fcc3d87df7b28d8dd.995d6615.png);
}

.webpa .link-card__usdt-address-icon__36xPc[data-v-9c86c1e4] {
  background-image: url(/static/img/usdt_address.995d6615a8fa278fcc3d87df7b28d8dd.995d6615.png);
}

.wallet-balance__wallet-balance-wrapper__3VgBU[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.wallet-balance__wallet-balance-container__2Sdki[data-v-9c86c1e4] {
  position: relative;
  width: 50%;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  text-align: center;
}

.wallet-balance__wallet-balance-container__2Sdki+.wallet-balance__wallet-balance-container__2Sdki[data-v-9c86c1e4]:before {
  content: '';
  position: absolute;
  width: 0;
  height: 6.4px;
  height: 0.4rem;
  border-left: 1px solid rgba(0, 0, 0, 0.05);
  -webkit-box-shadow: inset 0.5px 0 0 #eee;
  box-shadow: inset 0.5px 0 0 #eee;
  top: 50%;
  left: 1px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}

.wallet-balance__wallet-balance-title__3u1CI[data-v-9c86c1e4] {
  font-size: 0.24rem;
  line-height: 0.34rem;
  color: #383b43;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.wallet-balance__wallet-balance-title__3u1CI>div[data-v-9c86c1e4] {
  font-family: PingFang SC;
}

.wallet-balance__wallet-icon__3NX9l[data-v-9c86c1e4] {
  display: block;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGBSURBVHgB7VbRbYNADDXkBsgIdINuULoBmaDlB8QX3QCYAPGF4IdkgqYTtCNkBDYo/QUJ+txcKn5AQIBKUZ90+ABzz/bZ5ohuHQpfkiQxFEXxmqa5pwWAtU8QkWVZeyWO42dVVTNaBzux2WxceMY3eV3XAc0MOLOFcDE0eOqKSxhxEziOs6cFgCgWHEVw6SqtjNsnFJcJ4huiPLwuRexxAZ0c8o3Tmyai7SFnk9Y1ZHIZkBkMC2kifj2E5R8QeZ8yZ5k04AWkX7Zt+zSVEDh0hSrLMvaeTNMsQPSKqUHn2vJpJAYlTVVV72VZfqKedDSHSD7ewhCNRmJolhY/yugaQgi6BoMIEepHeHaHPTtCuvJxjhDnNBJtc5/SNH3oU8Z7TSYOgfhAE9CuQ33oR0yGvuvTBLQ95KLO+5RhFO8lkx1pItp1GFzTQYbi/28xOwT3UM5QDA9ta8t/BZoZvLacnviIwa1Kp3NTDuX5ZhHAmUiV3cOUR7mliHjt3RpV8Pf4BnQPqAW1xMDiAAAAAElFTkSuQmCC);
  width: 0.28rem;
  height: 0.28rem;
  background-size: contain;
  margin-right: 0.08rem;
}

.webpa .wallet-balance__wallet-icon__3NX9l[data-v-9c86c1e4] {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGBSURBVHgB7VbRbYNADDXkBsgIdINuULoBmaDlB8QX3QCYAPGF4IdkgqYTtCNkBDYo/QUJ+txcKn5AQIBKUZ90+ABzz/bZ5ohuHQpfkiQxFEXxmqa5pwWAtU8QkWVZeyWO42dVVTNaBzux2WxceMY3eV3XAc0MOLOFcDE0eOqKSxhxEziOs6cFgCgWHEVw6SqtjNsnFJcJ4huiPLwuRexxAZ0c8o3Tmyai7SFnk9Y1ZHIZkBkMC2kifj2E5R8QeZ8yZ5k04AWkX7Zt+zSVEDh0hSrLMvaeTNMsQPSKqUHn2vJpJAYlTVVV72VZfqKedDSHSD7ewhCNRmJolhY/yugaQgi6BoMIEepHeHaHPTtCuvJxjhDnNBJtc5/SNH3oU8Z7TSYOgfhAE9CuQ33oR0yGvuvTBLQ95KLO+5RhFO8lkx1pItp1GFzTQYbi/28xOwT3UM5QDA9ta8t/BZoZvLacnviIwa1Kp3NTDuX5ZhHAmUiV3cOUR7mliHjt3RpV8Pf4BnQPqAW1xMDiAAAAAElFTkSuQmCC);
}

.wallet-balance__balance-content__33R5b[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: end;
  -webkit-align-items: flex-end;
  -ms-flex-align: end;
  align-items: flex-end;
  color: #ede9e7;
  margin-top: 0.08rem;
}

.wallet-balance__unit__1fSTu[data-v-9c86c1e4] {
  font-size: 0.24rem;
  line-height: 0.24rem;
  position: relative;
}

.wallet-balance__balance__4DISs[data-v-9c86c1e4] {
  font-family: DINPro;
  font-size: 0.36rem;
  line-height: 1;
  text-align: center;
}

@-webkit-keyframes venue-list__loading__2ONHw-data-v-9c86c1e4 {
  0% {
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }

  to {
    transform: rotate(-1turn);
    -ms-transform: rotate(-1turn);
    -webkit-transform: rotate(-1turn);
  }
}

@keyframes venue-list__loading__2ONHw-data-v-9c86c1e4 {
  0% {
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }

  to {
    transform: rotate(-1turn);
    -ms-transform: rotate(-1turn);
    -webkit-transform: rotate(-1turn);
  }
}

.venue-list__venue-list__2Z3rJ[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.venue-list__venue-item-place__2ZYGJ[data-v-9c86c1e4],
.venue-list__venue-item__30mtB[data-v-9c86c1e4] {
  width: 25%;
  border-top: 1px solid #eee;
}

.venue-list__venue-item__30mtB[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  font-size: 0.24rem;
  color: #383b43;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-top: 0.42rem;
  padding-bottom: 0.24rem;
  -webkit-transition: height 0.3s ease;
  transition: height 0.3s ease;
}

.venue-list__venue-item__30mtB[data-v-9c86c1e4]:after {
  content: '';
  display: block;
  position: absolute;
  height: 6.4px;
  height: 0.4rem;
  width: 1px;
  background: #fff;
  -webkit-box-shadow: inset 0.5px 0 0 #eee;
  box-shadow: inset 0.5px 0 0 #eee;
  right: 0;
  top: 50%;
  -webkit-transform: translateY(-1.28px);
  transform: translateY(-1.28px);
  -webkit-transform: translateY(-0.08rem);
  transform: translateY(-0.08rem);
}

.venue-list__venue-item__30mtB[data-v-9c86c1e4]:nth-child(4n):after {
  content: none;
}

.venue-list__venue-item-title__2qo2H[data-v-9c86c1e4] {
  width: 100%;
  text-align: center;
  line-height: 0.34rem;
}

.venue-list__venue-item-status__2C3Pn[data-v-9c86c1e4] {
  display: block;
  margin-top: 0.08rem;
  font-family: DINPro;
  height: 0.32rem;
  line-height: 0.28rem;
  text-align: center;
  color: #cbced8;
}

.venue-list__venue-item__30mtB[data-v-9c86c1e4] {
  padding: 0.18rem 0;
  border-top: none;
}

.venue-list__loading__2ONHw[data-v-9c86c1e4] {
  display: block;
  width: 0.3rem;
  height: 0.3rem;
  -webkit-animation: venue-list__loading__2ONHw-data-v-9c86c1e4 1s linear infinite;
  animation: venue-list__loading__2ONHw-data-v-9c86c1e4 1s linear infinite;
  -webkit-transform-origin: center center;
  transform-origin: center center;
  background-size: contain;
  background-image: url(/static/img/loading.19fd8b4b8852b18075b8bb2a2b62a120.19fd8b4b.png);
}

.webpa .venue-list__loading__2ONHw[data-v-9c86c1e4] {
  background-image: url(/static/img/loading.19fd8b4b8852b18075b8bb2a2b62a120.19fd8b4b.png);
}

.venue-list__expand__3XRKy[data-v-9c86c1e4] {
  display: block;
  width: 0.3rem;
  height: 0.3rem;
  -webkit-transform-origin: center center;
  transform-origin: center center;
  background-size: contain;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAilBMVEUAAADQ5fXS1t/Z4+P////Lz9rLz9rLz9rO0dzS1N/Lz9rLz9rLz9rU1OzLz9nLz9rLz9rMz9rMz9rLz9rLz9rLz9vM0NvN0dzP0d3Q097R1N7P2N/////Mz9rMz9rLz9rKz9rLz9rL0NrMz9rKz9rKztnLz9rLz9rN0NvM0dvN0d3MztrLz9rKztnS59vlAAAALXRSTlMABQ8IAvbsti8X28u+C/Po5ODW066YPTYoIBsTA/DDqaOej4fPxrKmS0Qkfnntr8fyAAAA6ElEQVQ4y82N2Y7CMAxF3RbSna4sZSmUdYaZ+/+/R6RYMVUqnjlPts5xQt9C2Mfk4IetnTPUseNTpO9Lsh373XV05N9MIb5Bw56LHkkna9zguqMReYaqs75GKl6K8mnGbYLUJ4cgRLlhf2PvFIUuugp9TpN4LVSkfeb4IOfiCFUiC3jzbFAXkS0Qsn9WjQ0GKC72pzv7TYlWPn9Arc0489gX9ilziIMuhKjAnVM+HLBYvXmF1ngpllywP4qXYv5rxvUBjz25nHXB/sTeLX6IVgsMM5rmogvtl+yni7n4Kf6AM33k/0LfxwupXhPD2m3cLgAAAABJRU5ErkJggg==);
}

.webpa .venue-list__expand__3XRKy[data-v-9c86c1e4] {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAilBMVEUAAADQ5fXS1t/Z4+P////Lz9rLz9rLz9rO0dzS1N/Lz9rLz9rLz9rU1OzLz9nLz9rLz9rMz9rMz9rLz9rLz9rLz9vM0NvN0dzP0d3Q097R1N7P2N/////Mz9rMz9rLz9rKz9rLz9rL0NrMz9rKz9rKztnLz9rLz9rN0NvM0dvN0d3MztrLz9rKztnS59vlAAAALXRSTlMABQ8IAvbsti8X28u+C/Po5ODW066YPTYoIBsTA/DDqaOej4fPxrKmS0Qkfnntr8fyAAAA6ElEQVQ4y82N2Y7CMAxF3RbSna4sZSmUdYaZ+/+/R6RYMVUqnjlPts5xQt9C2Mfk4IetnTPUseNTpO9Lsh373XV05N9MIb5Bw56LHkkna9zguqMReYaqs75GKl6K8mnGbYLUJ4cgRLlhf2PvFIUuugp9TpN4LVSkfeb4IOfiCFUiC3jzbFAXkS0Qsn9WjQ0GKC72pzv7TYlWPn9Arc0489gX9ilziIMuhKjAnVM+HLBYvXmF1ngpllywP4qXYv5rxvUBjz25nHXB/sTeLX6IVgsMM5rmogvtl+yni7n4Kf6AM33k/0LfxwupXhPD2m3cLgAAAABJRU5ErkJggg==);
}

.venue-list__pack-up__jIG2z[data-v-9c86c1e4] {
  display: block;
  width: 0.3rem;
  height: 0.3rem;
  -webkit-transform-origin: center center;
  transform-origin: center center;
  background-size: contain;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAh1BMVEUAAADQ5fXS1t/Z4+P////Lz9nLz9rLz9rLz9rLz9rS1N/Lz9rMz9rLz9rMz9rLz9rQ0d3Q0t3U1OzLztrLz9rLz9vN0dvO0dzO0dzP0d3P2N/////Mz9rLz9nKz9rLz9rL0NrL0dvMztnKz9rLz9rLz9rL0NnMztnNz9vMztnLz9rM0dzKztkvzfF+AAAALHRSTlMABQ8IAvPXy7WvF+nl3tHEIx0L9+2YPjMtKBMD8L+jnoo44byqppGAR7h5TbasA/sAAADlSURBVDjLzY5ZtoIwEESRCIRBJlGZcX5Prf2vz3CIHTDit/XVlXu7T4wfzH3/nf8B1+98bWGznOV7rB9baczwf8MQRvfZuPZc5FCjrXS83MDaDuOuxqWa4dLIcF688Q7WQdXchzsxqha14rqxuCDbyVPyuQjAGQkd8arljAyXBNvP5akzaDFehSSwVHIXWYATk230CeJ+Hh/RDL4WxuEX/WlE6Ud+Q1D0QyIMU+fpCUE8jIkNx9R4g2P8Kp4wyik3I6wSVb0QYanzUUpheCPuwJacDPGkjIbKZMmhwiPFlcFd40fyBGJgExF+G+eLAAAAAElFTkSuQmCC);
}

.webpa .venue-list__pack-up__jIG2z[data-v-9c86c1e4] {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAh1BMVEUAAADQ5fXS1t/Z4+P////Lz9nLz9rLz9rLz9rLz9rS1N/Lz9rMz9rLz9rMz9rLz9rQ0d3Q0t3U1OzLztrLz9rLz9vN0dvO0dzO0dzP0d3P2N/////Mz9rLz9nKz9rLz9rL0NrL0dvMztnKz9rLz9rLz9rL0NnMztnNz9vMztnLz9rM0dzKztkvzfF+AAAALHRSTlMABQ8IAvPXy7WvF+nl3tHEIx0L9+2YPjMtKBMD8L+jnoo44byqppGAR7h5TbasA/sAAADlSURBVDjLzY5ZtoIwEESRCIRBJlGZcX5Prf2vz3CIHTDit/XVlXu7T4wfzH3/nf8B1+98bWGznOV7rB9baczwf8MQRvfZuPZc5FCjrXS83MDaDuOuxqWa4dLIcF688Q7WQdXchzsxqha14rqxuCDbyVPyuQjAGQkd8arljAyXBNvP5akzaDFehSSwVHIXWYATk230CeJ+Hh/RDL4WxuEX/WlE6Ud+Q1D0QyIMU+fpCUE8jIkNx9R4g2P8Kp4wyik3I6wSVb0QYanzUUpheCPuwJacDPGkjIbKZMmhwiPFlcFd40fyBGJgExF+G+eLAAAAAElFTkSuQmCC);
}

.venue-wallet__venue-container__10mlJ[data-v-9c86c1e4] {
  background: #fcfcff;
  border-radius: 4px;
  overflow: hidden;
  margin: 0.4rem 0.2rem 0;
}

.venue-wallet__venue-title__RBeZa[data-v-9c86c1e4] {
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 0.2rem;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  position: relative;
}

.venue-wallet__left__RLGzV[data-v-9c86c1e4],
.venue-wallet__venue-title__RBeZa[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  color: #383b43;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.venue-wallet__left__RLGzV[data-v-9c86c1e4] {
  font-size: 0.28rem;
}

.venue-wallet__right__3L3gN[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #4080ff;
  font-family: PingFang SC;
}

.venue-wallet__right__3L3gN>div[data-v-9c86c1e4] {
  font-family: PingFang SC;
}

.venue-wallet__venue-title-text__12qJ9[data-v-9c86c1e4] {
  font-size: 0.28rem;
  font-family: PingFang SC;
}

.venue-wallet__recycle-btn__2EzlA[data-v-9c86c1e4] {
  font-family: PingFang SC;
  border: 1px solid #4080ff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 0.5rem;
  color: #4080ff;
  font-size: 0.2rem;
  line-height: 0.38rem;
  height: 0.4rem;
  background: transparent;
  margin-left: 0.2rem;
}

.venue-wallet__expand-icon__1EFj3[data-v-9c86c1e4] {
  display: block;
  width: 0.24rem;
  height: 0.24rem;
  background-size: contain;
  margin-left: 4px;
  background-repeat: no-repeat;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAVCAYAAABc6S4mAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD4SURBVHgBrZMBEYMwDEWTKUACEpAAElCyOaA4mIPNARJAAg42CUwB+2XljgPaJoPchUKTvnfXC5yb8UVEA7LoDNv1cICZYGmQ6QWPNzJDtq5wBry1r8jBCkpkf4ZkAc8cs2BfQXtdPgbHGo7AbY2ljf/ANwKtRNLLeT1eaaQPCk/NwVjPxEVcADdYH9io5qJrLMgzXQJ4Be4deWM0Z645wYWZruI6BHKlGNyQ+3nnMdVISApHrV+OqVRCUrjdX49pTNK4z1IC3whikr0IwXcFGkkM7hVIJBJ4UBCSSOFRwZ5k2hTCRYKN5BciuFiwkpAUrg5IUpuaM1+PJgBFXItQDQAAAABJRU5ErkJggg==);
}

.webpa .venue-wallet__expand-icon__1EFj3[data-v-9c86c1e4] {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAVCAYAAABc6S4mAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD4SURBVHgBrZMBEYMwDEWTKUACEpAAElCyOaA4mIPNARJAAg42CUwB+2XljgPaJoPchUKTvnfXC5yb8UVEA7LoDNv1cICZYGmQ6QWPNzJDtq5wBry1r8jBCkpkf4ZkAc8cs2BfQXtdPgbHGo7AbY2ljf/ANwKtRNLLeT1eaaQPCk/NwVjPxEVcADdYH9io5qJrLMgzXQJ4Be4deWM0Z645wYWZruI6BHKlGNyQ+3nnMdVISApHrV+OqVRCUrjdX49pTNK4z1IC3whikr0IwXcFGkkM7hVIJBJ4UBCSSOFRwZ5k2hTCRYKN5BciuFiwkpAUrg5IUpuaM1+PJgBFXItQDQAAAABJRU5ErkJggg==);
}

.style__btnGroup__18JlG uni-button[data-v-9c86c1e4] {
  margin: 0.45rem 5% 0 5%;
  display: block;
  height: 0.96rem;
  line-height: 0.96rem;
  font-size: 0.32rem;
  background: #ede9e7;
  color: #fff;
  border-radius: 3px;
  text-align: center;
  width: 90%;
  opacity: 0.9;
}

.venue-wallet__expand-icon-shrink__2DDiM[data-v-9c86c1e4] {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.venue-wallet__venue-pack__2T6Ty[data-v-9c86c1e4] {
  height: 2rem;
}

.center-wallet__container__w4g5F[data-v-9c86c1e4] {
  padding: 0 0.28rem;
  margin-top: 0.28rem;
}

.center-wallet__links-wrapper__2NgV2[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-top: 0.4rem;
}

.center-wallet__center-wallet-wrapper__3YaTH[data-v-9c86c1e4] {
  padding-bottom: 0.54rem;
}

.virtual-currency-wallet__container__3EE5F[data-v-9c86c1e4] {
  padding: 0 0.28rem;
  margin-top: 0.4rem;
}

.virtual-currency-wallet__links-wrapper__3UBG6[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-top: 0.4rem;
}

.virtual-currency-wallet__virtual-wallet-wrapper__2Gf7L[data-v-9c86c1e4] {
  padding-bottom: 0.42rem;
}

.virtual-currency-wallet__virtual-wallet-wrapper__2Gf7L div[class*='wallet-balance-wrapper'] div[class*='unit'][data-v-9c86c1e4] {
  display: block;
  width: 0.24rem;
  height: 0.24rem;
  background-size: 80%;
  background-repeat: no-repeat;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADHSURBVHgB7VPBDcIwDHRQ/+0IZQNG6CbABjABXaETUCaADSgbZIR2g2wAZ7giE9FHlW9POjmJ7fhsJU6Iqn5WMg++q13ImFzC3GUe1mBYSSIys+4iX0kqAugjv56JkwmgrRZmy22Lfvf/4lyUVMIU4IbJlVHXjEp0eN8LOH0NHihzlFpbBeDRtKUFcvCiMzgzqcHN3qjpYXpuB1Z9F4BP7Qm8OgbvKDdnQmGSxZwVXKvvAd6Sh5j8DpYLfv9CjIN8HpMiTAW9ABSpPh9wCJt/AAAAAElFTkSuQmCC);
}

.webpa .virtual-currency-wallet__virtual-wallet-wrapper__2Gf7L div[class*='wallet-balance-wrapper'] div[class*='unit'][data-v-9c86c1e4] {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADHSURBVHgB7VPBDcIwDHRQ/+0IZQNG6CbABjABXaETUCaADSgbZIR2g2wAZ7giE9FHlW9POjmJ7fhsJU6Iqn5WMg++q13ImFzC3GUe1mBYSSIys+4iX0kqAugjv56JkwmgrRZmy22Lfvf/4lyUVMIU4IbJlVHXjEp0eN8LOH0NHihzlFpbBeDRtKUFcvCiMzgzqcHN3qjpYXpuB1Z9F4BP7Qm8OgbvKDdnQmGSxZwVXKvvAd6Sh5j8DpYLfv9CjIN8HpMiTAW9ABSpPh9wCJt/AAAAAElFTkSuQmCC);
}

.virtual-currency-wallet__divider__2R4DL[data-v-9c86c1e4] {
  width: 100%;
  height: 0.02rem;
  background: rgba(0, 0, 0, 0.05);
  -webkit-box-shadow: inset 0 0.5px 0 #eee;
  box-shadow: inset 0 0.5px 0 #eee;
  margin-top: 0.4rem;
  margin-bottom: 0.42rem;
}

.virtual-currency-wallet__tips-container__50obK[data-v-9c86c1e4] {
  padding-left: 0.5rem;
}

.virtual-currency-wallet__tips-item__3P96y[data-v-9c86c1e4] {
  position: relative;
  padding-left: 0.36rem;
  font-size: 0.24rem;
  line-height: 0.34rem;
  color: #999;
  font-family: PingFang SC;
}

.virtual-currency-wallet__tips-item__3P96y[data-v-9c86c1e4]:before {
  content: '';
  position: absolute;
  top: 0.64px;
  top: 0.04rem;
  left: 0;
  width: 4.16px;
  width: 0.26rem;
  height: 3.84px;
  height: 0.24rem;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAYCAYAAADkgu3FAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGnSURBVHgBvVbLccIwEF0bw3B0KoioIC4BKkl8YqgioYIkJwY4mFSQdAAl0EGUCuIjA9jOW4+cMUa2ZUPyZjy76LNPT7uSIGqI+Xz+vFgsAmoIq8ng2WwmbNv+ZD+O48FkMpGmc21qgE6n86jzTWCsKK8mQxNVxop0CtBmnCsjRTo1GaBqBFWbuhhGiqryYZqrUkVBEIgoijys2E2SpG6LplC8cRxH+r4vtUTL5XKIYB4G3sIKtHn4XPW1gmVZW5iQLWJ+IfbWgcOrFbB0LWAHPGWHbBFb2pxM+JL+DpI50hypqlrDFXRdSFWV8rcYmAwV9J7JvhScn263O0JxhOnvfCcqzT0cDutLyYokjJNzxB08AO4HtQS26q1IkpKXTcBzwDeBoGYIx+Pxja5DezPwFlK7wnDVXDOi4/HYOkfIsTAm4puC2sMzJkLVCfoPIhzeO9IjhNopPp/KbxPtXEfXqDlHTPDa7/dfcmW7wiF/wKL4mRAVc1OclTdXzX6//64gOAHfKDBMeJ8R9nq9QfG5OFOkqqaWIIP6z/AEwlVGuNvtOIbMj/sBkZrWb7e/OocAAAAASUVORK5CYII=);
  background-size: contain;
}

.virtual-currency-wallet__tips-item__3P96y+.virtual-currency-wallet__tips-item__3P96y[data-v-9c86c1e4] {
  margin-top: 0.12rem;
}

.wallet__transparent-header__3phb_[data-v-9c86c1e4] {
  background: transparent;
  border-color: transparent;
  color: #fff;
  font-size: 0.36rem;
}

.wallet__transparent-header__3phb_ div[class*='header-title'][data-v-9c86c1e4] {
  font-weight: 400;
}

.wallet__wallet-wrapper__2qKRH[data-v-9c86c1e4] {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(/static/img/bg_01.c00a1854e1446ef9fbd9f5b282da92f1.c00a1854.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
  overflow: auto;
  padding-top: 0.9rem;
  background-color: #f8f8f8;
  background-position-y: -0.86rem;
  font-family: PingFang SC;
}

.webpa .wallet__wallet-wrapper__2qKRH[data-v-9c86c1e4] {
  background-image: url(/static/img/bg_01.c00a1854e1446ef9fbd9f5b282da92f1.c00a1854.png);
}

.wallet__wallet-container__31xP8[data-v-9c86c1e4] {
  position: absolute;
  top: 0.94rem;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  overflow: auto;
  padding-bottom: 0.58rem;
}

.wallet__subtitle__x-udy[data-v-9c86c1e4] {
  position: absolute;
  right: 0.2rem;
  top: 50%;
  white-space: nowrap;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 0.28rem;
}

.style__withdrawal__3mnzf[data-v-9c86c1e4] {
  background: #f8f8f8;
  min-height: calc(100% - 0.9rem);
  position: relative;
}

.style__withdrawal__3mnzf[data-v-9c86c1e4]:after,
.style__withdrawal__3mnzf[data-v-9c86c1e4]:before {
  content: ' ';
  display: table;
  clear: both;
}

.style__withdrawal__3mnzf.style__yibo__K-qNG[data-v-9c86c1e4] {
  background: none;
}

.style__withdrawal__3mnzf .style__drawMaintenanceBg__3ExCC[data-v-9c86c1e4] {
  top: 0;
}

.style__hide__1DzA6[data-v-9c86c1e4] {
  display: none;
}

.style__show__3m5LZ[data-v-9c86c1e4] {
  display: block;
}

.style__show__3m5LZ[data-v-9c86c1e4]:after,
.style__show__3m5LZ[data-v-9c86c1e4]:before {
  content: ' ';
  display: table;
  clear: both;
}

.style__warmTipContent__2t0kS[data-v-9c86c1e4] {
  font-size: 0.28rem;
}

.style__yibo__K-qNG [class*='speedDrawProcessing'][data-v-9c86c1e4] {
  background: #222536 !important;
}

.style__tabs__3MccN[data-v-9c86c1e4] {
  height: 0.68rem;
  margin-top: 0.08rem;
}

.style__tabs__3MccN .style__tabbox__2mfom[data-v-9c86c1e4] {
  background: #f8f8f8;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.style__tabs__3MccN .style__tabbox__2mfom div[data-v-9c86c1e4] {
  height: 0.68rem;
}

.style__tabs__3MccN .style__tabbox__2mfom div[data-v-9c86c1e4]:first-child,
.style__tabs__3MccN .style__tabbox__2mfom div[data-v-9c86c1e4]:last-child,
.style__tabs__3MccN .style__tabbox__2mfom div[data-v-9c86c1e4]:nth-child(3) {
  width: 0.52rem;
  background: #fff;
}

.style__tabs__3MccN .style__tabbox__2mfom div:first-child>div[data-v-9c86c1e4],
.style__tabs__3MccN .style__tabbox__2mfom div:last-child>div[data-v-9c86c1e4],
.style__tabs__3MccN .style__tabbox__2mfom div:nth-child(3)>div[data-v-9c86c1e4] {
  background: #f8f8f8;
}

.style__tabs__3MccN .style__tabbox__2mfom div:first-child div[data-v-9c86c1e4] {
  border-radius: 0;
}

.style__tabs__3MccN .style__tabbox__2mfom div:first-child div.style__active__34lvf[data-v-9c86c1e4] {
  border-bottom-right-radius: 50%;
}

.style__tabs__3MccN .style__tabbox__2mfom div:last-child div[data-v-9c86c1e4] {
  border-radius: 0;
}

.style__tabs__3MccN .style__tabbox__2mfom div:last-child div.style__active__34lvf[data-v-9c86c1e4] {
  border-bottom-left-radius: 50%;
}

.style__tabs__3MccN .style__tabbox__2mfom div:nth-child(3) div[data-v-9c86c1e4] {
  border-radius: 0;
}

.style__tabs__3MccN .style__tabbox__2mfom div:nth-child(3) div.style__left__2slcI[data-v-9c86c1e4] {
  border-bottom-left-radius: 50%;
}

.style__tabs__3MccN .style__tabbox__2mfom div:nth-child(3) div.style__right__1CcmT[data-v-9c86c1e4] {
  border-bottom-right-radius: 50%;
}

.style__tabs__3MccN .style__tabbox__2mfom .style__tab__o2nNS[data-v-9c86c1e4] {
  border-top-right-radius: 0.2rem;
  border-top-left-radius: 0.2rem;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: center;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #a5a9b3;
  position: relative;
  font-family: PingFang SC;
  font-size: 12px;
  height: 0.68rem;
}

.style__tabs__3MccN .style__tabbox__2mfom .style__tab__o2nNS.style__active__34lvf[data-v-9c86c1e4] {
  background: #fff;
  color: #ede9e7;
}

.style__tabs__3MccN .style__tabbox__2mfom .style__tab__o2nNS.style__active__34lvf span[data-v-9c86c1e4] {
  position: absolute;
  width: 0.6rem;
  height: 0.04rem;
  left: 50%;
  margin-left: -0.3rem;
  bottom: 0.06rem;
  background: #ede9e7;
}

.style__tabs__3MccN.style__yibo__2PRGa .style__tabbox__2mfom[data-v-9c86c1e4] {
  background: #161a28;
}

.style__tabs__3MccN.style__yibo__2PRGa .style__tabbox__2mfom>div[data-v-9c86c1e4]:first-child,
.style__tabs__3MccN.style__yibo__2PRGa .style__tabbox__2mfom>div[data-v-9c86c1e4]:last-child,
.style__tabs__3MccN.style__yibo__2PRGa .style__tabbox__2mfom>div[data-v-9c86c1e4]:nth-child(3) {
  background: #222536;
}

.style__tabs__3MccN.style__yibo__2PRGa .style__tabbox__2mfom>div:first-child>div[data-v-9c86c1e4],
.style__tabs__3MccN.style__yibo__2PRGa .style__tabbox__2mfom>div:last-child>div[data-v-9c86c1e4],
.style__tabs__3MccN.style__yibo__2PRGa .style__tabbox__2mfom>div:nth-child(3)>div[data-v-9c86c1e4] {
  background: #161a28;
}

.style__tabs__3MccN.style__yibo__2PRGa .style__tabbox__2mfom .style__tab__o2nNS[data-v-9c86c1e4] {
  color: #6c6e82;
}

.style__tabs__3MccN.style__yibo__2PRGa .style__tabbox__2mfom .style__tab__o2nNS.style__active__34lvf[data-v-9c86c1e4] {
  background: #222536;
  color: #ede9e7;
}

.style__center__2kY1_ .style__refs__jDSGf[data-v-9c86c1e4] {
  background: #fff;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding: 0.2rem 0.28rem;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border-bottom: 0.02rem solid #eee;
}

.style__center__2kY1_ .style__refs__jDSGf div[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  font-family: PingFang SC;
  font-size: 0.28rem;
  line-height: 0.32rem;
  font-weight: 700;
}

.style__center__2kY1_ .style__refs__jDSGf div[data-v-9c86c1e4]:first-child {
  color: #414655;
}

.style__center__2kY1_ .style__refs__jDSGf div:first-child img[data-v-9c86c1e4] {
  margin-left: 0.2rem;
  width: 0.28rem;
  height: 0.28rem;
}

.style__center__2kY1_ .style__refs__jDSGf div[data-v-9c86c1e4]:last-child {
  color: #ede9e7;
}

.style__center__2kY1_ .style__wallet__2Zbxj[data-v-9c86c1e4] {
  padding: 0.28rem;
  background: #fff;
}

.style__center__2kY1_ .style__wallet__2Zbxj .style__usdt-balance-icon__3QUNc[data-v-9c86c1e4] {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALRSURBVHgBpVVRchJBEO2e3cXELzyB6wmSI8Rvg4KpionkA04QPEHwBElOAFaFAq1SqKDf5gaSE4g3yJdWwbLt65kFAZcNSbpqa3dnd7pfd79+w5RhjUY3n3vsH4vQDhOHxBImn26wNmBDPfJMr7z34tcqH5zquN0NA/YbzLRDa5iINDnw6mmBzPJC61P/OGf8H9Y5K1I5i0lKozh6Vn5TYL30WddIuGlRMlckigetTv84M4PWx/4JbvUEVnP0Z/KuWi3dUIa1kW3MwQnKV0mW6gDx/r8AipyEzpxzqpUPCud0B1sE92+/DaA117LgMb+M4E5BEpACErBvtrUntgeBpqjOUZb7Olcr7wM1+gLUeRnHTZtBgv6nvmz4JtybY8JFp//9Nibh+9Xb/cLz6XujC2qP4U8oP/odPTE5z39lvwD9Xgaf17VqqaTMa+qzzpAvMRWBgjzC0Cyj00EiGdr4xCGLy0aAmqfrzMOUfVcUU00H1MfLNnbTJPAGyz/amibWal9WyLANoHVGrz7QCjPR5Do2PsonIYNeYp1hgOZ/6nzpb03GVJxb2sbl3gWZOZRuVFPkYurXX4UiGknt6OBldSmDokuAe0f7u7MMLjqXDdyqaX6QwVcwCCIGBs2jcBMKAiRigsaFRlizAHAZQB5mE+4F1Dt4Xbhe2Atm6jz42DhEk0NvPNHNswCHh6Uhbgs9EEM192bQg92VPYh9b0vLZ5gGRnlsS0LrKec6JhPjShlTz4xykUMJRVT9pweaDi4nwrcRmJ5xg6G8pnyw6Z3SAy2Rndng2hZ6ElVV+1XX0zR9XVNFtejhawMHkK6ly/U9FHWV3K88cLKOwXnTvgWbwSnfduAsINEgYs8GF0h1ClIyDdb6/O0pgdbg+Y6WlVTqURZQs758UKUe+inHYKYp1R95ppKmxpy10QaCnOOnopAVxbzbBAVlGSr7oPnnWef2X8hCZUSGAnV9AAAAAElFTkSuQmCC);
}

.webpa .style__center__2kY1_ .style__wallet__2Zbxj .style__usdt-balance-icon__3QUNc[data-v-9c86c1e4] {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALRSURBVHgBpVVRchJBEO2e3cXELzyB6wmSI8Rvg4KpionkA04QPEHwBElOAFaFAq1SqKDf5gaSE4g3yJdWwbLt65kFAZcNSbpqa3dnd7pfd79+w5RhjUY3n3vsH4vQDhOHxBImn26wNmBDPfJMr7z34tcqH5zquN0NA/YbzLRDa5iINDnw6mmBzPJC61P/OGf8H9Y5K1I5i0lKozh6Vn5TYL30WddIuGlRMlckigetTv84M4PWx/4JbvUEVnP0Z/KuWi3dUIa1kW3MwQnKV0mW6gDx/r8AipyEzpxzqpUPCud0B1sE92+/DaA117LgMb+M4E5BEpACErBvtrUntgeBpqjOUZb7Olcr7wM1+gLUeRnHTZtBgv6nvmz4JtybY8JFp//9Nibh+9Xb/cLz6XujC2qP4U8oP/odPTE5z39lvwD9Xgaf17VqqaTMa+qzzpAvMRWBgjzC0Cyj00EiGdr4xCGLy0aAmqfrzMOUfVcUU00H1MfLNnbTJPAGyz/amibWal9WyLANoHVGrz7QCjPR5Do2PsonIYNeYp1hgOZ/6nzpb03GVJxb2sbl3gWZOZRuVFPkYurXX4UiGknt6OBldSmDokuAe0f7u7MMLjqXDdyqaX6QwVcwCCIGBs2jcBMKAiRigsaFRlizAHAZQB5mE+4F1Dt4Xbhe2Atm6jz42DhEk0NvPNHNswCHh6Uhbgs9EEM192bQg92VPYh9b0vLZ5gGRnlsS0LrKec6JhPjShlTz4xykUMJRVT9pweaDi4nwrcRmJ5xg6G8pnyw6Z3SAy2Rndng2hZ6ElVV+1XX0zR9XVNFtejhawMHkK6ly/U9FHWV3K88cLKOwXnTvgWbwSnfduAsINEgYs8GF0h1ClIyDdb6/O0pgdbg+Y6WlVTqURZQs758UKUe+inHYKYp1R95ppKmxpy10QaCnOOnopAVxbzbBAVlGSr7oPnnWef2X8hCZUSGAnV9AAAAAElFTkSuQmCC);
}

.style__center__2kY1_ .style__venueList__Zj9ar[data-v-9c86c1e4] {
  margin-top: 0.2rem;
}

.style__center__2kY1_ div[class*='venue-list__venue-item'][data-v-9c86c1e4] {
  padding: 0.2rem 0 0.24rem;
}

.style__center__2kY1_ .style__drawSubmit__1P9tF[data-v-9c86c1e4] {
  padding: 0.6rem 0.28rem 0;
}

.style__center__2kY1_ .style__drawSubmit__1P9tF>div[data-v-9c86c1e4] {
  height: 0.9rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background: #ede9e7;
  border-radius: 0.1rem;
  font-family: PingFang SC;
  font-size: 0.32rem;
  color: #fff;
}

.style__center__2kY1_ .style__drawSubmit__1P9tF>div.style__disabled__2pwUN[data-v-9c86c1e4] {
  opacity: 0.5;
}

.style__center__2kY1_ .style__helpTit__1sBZ2[data-v-9c86c1e4] {
  font-family: PingFang SC;
  font-size: 0.24rem;
  text-align: center;
  color: #414655;
  padding-top: 0.4rem;
  padding-bottom: 2.4rem;
}

.style__center__2kY1_ .style__helpTit__1sBZ2 span[data-v-9c86c1e4] {
  color: #ede9e7;
}

.style__center__2kY1_.style__yibo__fitG7 .style__refs__jDSGf[data-v-9c86c1e4] {
  background: #222536;
  border-bottom: 0.02rem solid rgba(0, 0, 0, 0.0001);
}

.style__center__2kY1_.style__yibo__fitG7 .style__refs__jDSGf div[data-v-9c86c1e4]:first-child {
  color: #dedede;
}

.style__center__2kY1_.style__yibo__fitG7 .style__wallet__2Zbxj[data-v-9c86c1e4] {
  background: #222536;
}

.style__center__2kY1_.style__yibo__fitG7 .yibo-color[data-v-9c86c1e4],
.style__center__2kY1_.style__yibo__fitG7 [class*='venue-item-title'][data-v-9c86c1e4] {
  color: #dedede !important;
}

.style__center__2kY1_.style__yibo__fitG7 [class*='expand'][data-v-9c86c1e4],
.style__center__2kY1_.style__yibo__fitG7 [class*='venue-item-status'][data-v-9c86c1e4] {
  color: #6c6e82 !important;
}

.style__center__2kY1_.style__yibo__fitG7 [class*='venue-list__venue-list'][data-v-9c86c1e4] {
  border-top: 0.02rem solid #373a4c !important;
}

.style__center__2kY1_.style__yibo__fitG7 [class*='venue-item'][data-v-9c86c1e4] {
  border-top: 0;
}

.style__center__2kY1_.style__yibo__fitG7 [class*='venue-item'][data-v-9c86c1e4]:after {
  background: #373a4c !important;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.style__center__2kY1_.style__yibo__fitG7 [class*='wallet-balance-container']+[class*='wallet-balance-container'][data-v-9c86c1e4]:before {
  border-left: 1px solid #373a4c;
}

.style__center__2kY1_.style__yibo__fitG7 .style__drawSubmit__1P9tF>div[data-v-9c86c1e4] {
  color: #79420d;
  background: -webkit-gradient(linear, right top, left top, from(#d9a76f), to(#f4d3b4));
  background: -webkit-linear-gradient(to left, #d9a76f, #f4d3b4);
  background: linear-gradient(270deg, #d9a76f, #f4d3b4);
}

.style__center__2kY1_.style__yibo__fitG7 .style__helpTit__1sBZ2[data-v-9c86c1e4] {
  color: #6c6e82;
}

.style__loading__1vwo7[data-v-9c86c1e4] {
  width: 0.3rem;
  -webkit-animation: style__loading__1vwo7-data-v-9c86c1e4 1s linear infinite;
  animation: style__loading__1vwo7-data-v-9c86c1e4 1s linear infinite;
  -webkit-transform-origin: center center;
  transform-origin: center center;
}

@-webkit-keyframes style__loading__1vwo7-data-v-9c86c1e4 {
  0% {
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }

  to {
    transform: rotate(-1turn);
    -ms-transform: rotate(-1turn);
    -webkit-transform: rotate(-1turn);
  }
}

@keyframes style__loading__1vwo7-data-v-9c86c1e4 {
  0% {
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }

  to {
    transform: rotate(-1turn);
    -ms-transform: rotate(-1turn);
    -webkit-transform: rotate(-1turn);
  }
}

.style__drawType__19ewn[data-v-9c86c1e4] {
  background: #fff;
  height: 1.3rem;
  padding: 0 0.28rem;
  font-family: PingFang SC;
  font-size: 0.28rem;
  font-weight: 700;
  color: #414655;
}

.style__drawType__19ewn[data-v-9c86c1e4],
.style__drawType__19ewn span[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.style__drawType__19ewn span[data-v-9c86c1e4] {
  font-size: 0.24rem;
  margin-left: 0.24rem;
  height: 0.7rem;
  width: 1.6rem;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: 0.02rem solid #eee;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 0.1rem;
  position: relative;
}

.style__drawType__19ewn span[data-v-9c86c1e4]:first-child {
  margin-left: 0.4rem;
}

.style__drawType__19ewn span.style__active__Mr8s9[data-v-9c86c1e4] {
  border-color: #ede9e7;
  color: #ede9e7;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAARVBMVEUAAAAAjv0Aj/0Ajv0Aj/4AkP4Ak/8Aj/wAj/0Alf4AlP8Aj/wAj/0AkP4Aj/0Aj/0AjvwAj/4AnP8AjvwAjv0Alf8Ajv3y6AqCAAAAFnRSTlMAgPzdVlEc1c8XEtliXPPopYoF2K4Oakr83AAAAIxJREFUOMul0EkOwzAMQ1E3tpvBbZpO//5HbVABdqCFuQi3jxAIBZGLcpSjHOUoRznKUY5ylKMc5ShHOcrp+fAAep6+I3T8Hq4Rej4XwPsnNn8DOJ/2s3+/hXkE4OA2zBrV16PXxu6LOcW5NXJYJiybdxhyaE5ybo3m8VXdv9iSnfs8z3ns3V/LlmzfDyYJJF+w5cW8AAAAAElFTkSuQmCC) no-repeat 1.24rem 0.36rem;
  background-size: 0.32rem;
}

.style__drawType__19ewn span>i[data-v-9c86c1e4] {
  position: absolute;
  top: -0.24rem;
  left: 0;
  height: 0.32rem;
  line-height: 0.32rem;
  border-radius: 0.18rem;
  padding: 0 0.08rem 0 0.4rem;
  color: #fff;
  opacity: 1;
  font-family: dinpro;
  font-size: 0.2rem;
  background: #db6372 url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAclBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9eWEHEAAAAJXRSTlMANvYJ5Mci/PHt1pEtEgTbuJppYVdRSUInGs/LwaymioSCbmQ6yKqOFQAAAJtJREFUGNNlkFcSgzAMBU3vBEJPb+/+V0wk2cGG/ZJ2RlVpqqZXe0Kc562rEyD9bOSIH1nsygbE1XEdhFkNgXGeD+FY+MYFITQ5kkBU+YDFwLKPMltGLG9w4b0OEFIzjKSeHC4nMIUlO1VJTUsy+vf3EoruJF/ckNu3FE78Slr9KZfR/uuRntwBZKUSyhwjBwsu8frid1FzzcTpF8VJGKGYNNAiAAAAAElFTkSuQmCC) no-repeat 0.14rem;
  background-size: 0.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.style__drawType__19ewn span.style__disabled__2pwUN[data-v-9c86c1e4] {
  opacity: 0.5;
}

.style__drawType__19ewn.style__yibo__fitG7[data-v-9c86c1e4] {
  background: #222536;
  color: #dedede;
}

.style__drawType__19ewn.style__yibo__fitG7 span[data-v-9c86c1e4] {
  border: 0.02rem solid #6c6e82;
  color: #a1a2a7;
}

.style__drawType__19ewn.style__yibo__fitG7 span.style__active__Mr8s9[data-v-9c86c1e4] {
  border-color: #ede9e7;
  color: #ede9e7;
}

.style__bankList__3Lqnw[data-v-9c86c1e4] {
  background: #fff;
  margin-top: 0.2rem;
  height: 1rem;
  padding: 0 0.28rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.style__bankList__3Lqnw>span[data-v-9c86c1e4] {
  font-family: PingFang SC;
  font-size: 0.28rem;
  font-weight: 700;
  color: #414655;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.style__bankList__3Lqnw .style__item__1QaF9[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  margin-left: 0.2rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.style__bankList__3Lqnw .style__item__1QaF9 img[data-v-9c86c1e4] {
  width: 0.4rem;
  height: 0.4rem;
}

.style__bankList__3Lqnw .style__item__1QaF9>span[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  margin-left: 0.14rem;
  font-family: PingFang SC;
  font-size: 0.28rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.style__bankList__3Lqnw .style__item__1QaF9>span span[data-v-9c86c1e4] {
  font-family: DINPro;
  font-size: 0.28rem;
  margin-left: 0.2rem;
}

.style__bankList__3Lqnw .style__item__1QaF9 .style__usdtItem__1AIlK[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.style__bankList__3Lqnw .style__item__1QaF9 .style__usdtItem__1AIlK>div[data-v-9c86c1e4] {
  font-family: PingFang SC;
  font-size: 0.28rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.style__bankList__3Lqnw .style__item__1QaF9 .style__usdtItem__1AIlK>div span[data-v-9c86c1e4] {
  font-family: DINPro;
  font-size: 0.28rem;
}

.style__bankList__3Lqnw .style__item__1QaF9 .style__usdtItem__1AIlK>div[data-v-9c86c1e4]:nth-child(2) {
  font-size: 0.24rem;
  color: #db6372;
}

.style__bankList__3Lqnw .style__noback__ehRSI[data-v-9c86c1e4] {
  margin-left: 1.4rem;
  color: #ede9e7;
  font-family: PingFang SC;
  font-size: 0.28rem;
  height: 1rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.style__bankList__3Lqnw .style__noback__ehRSI span[data-v-9c86c1e4] {
  font-size: 0.48rem;
  color: #ede9e7;
  margin: -0.1rem 0.1rem 0 0;
}

.style__bankList__3Lqnw.style__yibo__fitG7[data-v-9c86c1e4] {
  background: #222536;
}

.style__bankList__3Lqnw.style__yibo__fitG7>span[data-v-9c86c1e4] {
  color: #dedede;
}

.style__bankList__3Lqnw.style__yibo__fitG7 .style__item__1QaF9 .style__usdtItem__1AIlK>div[data-v-9c86c1e4],
.style__bankList__3Lqnw.style__yibo__fitG7 .style__item__1QaF9 span[data-v-9c86c1e4],
.style__bankList__3Lqnw.style__yibo__fitG7 .style__item__1QaF9 span span[data-v-9c86c1e4] {
  color: #6c6e82;
}

.style__bankList__3Lqnw.style__yibo__fitG7 .style__item__1QaF9 .style__usdtItem__1AIlK>div[data-v-9c86c1e4]:nth-child(2) {
  color: #db6372;
}

.style__bankList__3Lqnw.style__yibo__fitG7 .style__noback__ehRSI[data-v-9c86c1e4],
.style__bankList__3Lqnw.style__yibo__fitG7 .style__noback__ehRSI span[data-v-9c86c1e4] {
  color: #ede9e7;
}

.style__addback__2Z4VG[data-v-9c86c1e4] {
  background: #fff;
  padding: 0 0.28rem;
}

.style__addback__2Z4VG div[data-v-9c86c1e4] {
  height: 1rem;
  color: #ede9e7;
  font-family: PingFang SC;
  font-size: 0.28rem;
  border-top: 0.02rem solid #eee;
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.style__addback__2Z4VG div span[data-v-9c86c1e4] {
  font-size: 0.48rem;
  color: #ede9e7;
  margin: -0.12rem 0.1rem 0 0;
}

.style__addback__2Z4VG.style__yibo__fitG7[data-v-9c86c1e4] {
  background: #222536;
}

.style__addback__2Z4VG.style__yibo__fitG7 div[data-v-9c86c1e4] {
  border-top: 0.02rem solid #373a4c !important;
}

.style__noList__1sOCL[data-v-9c86c1e4] {
  padding: 0.2rem 0.28rem;
  font-family: PingFang SC;
  font-size: 0.24rem;
  color: #a5a9b3;
}

.style__noList__1sOCL.style__yibo__fitG7[data-v-9c86c1e4] {
  color: #6c6e82;
}

.style__modal__2ifxp .style__title__tEP54[data-v-9c86c1e4] {
  height: 1.44rem;
  padding: 0 0.28rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.style__modal__2ifxp .style__title__tEP54 span[data-v-9c86c1e4] {
  font-size: 0.32rem;
  font-family: PingFang SC;
  color: #414655;
}

.style__modal__2ifxp .style__title__tEP54 span[data-v-9c86c1e4]:first-child,
.style__modal__2ifxp .style__title__tEP54 span[data-v-9c86c1e4]:last-child {
  font-size: 0.28rem;
  color: #ede9e7;
  width: 1.6rem;
}

.style__modal__2ifxp .style__title__tEP54 span[data-v-9c86c1e4]:first-child {
  text-align: left;
}

.style__modal__2ifxp .style__title__tEP54 span[data-v-9c86c1e4]:last-child {
  text-align: right;
}

.style__modal__2ifxp .style__cardList__O-UKI[data-v-9c86c1e4] {
  background: #f8f8f8;
}

.style__modal__2ifxp .style__cardList__O-UKI[data-v-9c86c1e4]:after,
.style__modal__2ifxp .style__cardList__O-UKI[data-v-9c86c1e4]:before {
  content: ' ';
  display: table;
  clear: both;
}

.style__modal__2ifxp .style__cardList__O-UKI>div[data-v-9c86c1e4] {
  margin-top: 0.2rem;
  padding: 0 0.32rem 0.88rem;
  background: #fff;
}

.style__modal__2ifxp .style__cardList__O-UKI>div .style__cardItem__3o4Rc[data-v-9c86c1e4] {
  height: 1rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  border-top: 0.02rem solid #eee;
}

.style__modal__2ifxp .style__cardList__O-UKI>div .style__cardItem__3o4Rc.style__disabled__2pwUN[data-v-9c86c1e4] {
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.style__modal__2ifxp .style__cardList__O-UKI>div .style__cardItem__3o4Rc.style__disabled__2pwUN *[data-v-9c86c1e4] {
  opacity: 0.5;
}

.style__modal__2ifxp .style__cardList__O-UKI>div .style__cardItem__3o4Rc img[data-v-9c86c1e4] {
  width: 0.52rem;
  height: 0.52rem;
}

.style__modal__2ifxp .style__cardList__O-UKI>div .style__cardItem__3o4Rc img[data-v-9c86c1e4]:last-child {
  width: 0.3rem;
  height: 0.3rem;
}

.style__modal__2ifxp .style__cardList__O-UKI>div .style__cardItem__3o4Rc span[data-v-9c86c1e4] {
  margin: 0 0.2rem 0 0;
  font-family: PingFang SC;
  font-size: 0.28rem;
  color: #414655;
  text-align: left;
}

.style__modal__2ifxp .style__cardList__O-UKI>div .style__cardItem__3o4Rc span[data-v-9c86c1e4]:nth-child(2) {
  width: 1.8rem;
}

.style__modal__2ifxp .style__cardList__O-UKI>div .style__cardItem__3o4Rc span[data-v-9c86c1e4]:nth-child(3) {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.style__modal__2ifxp .style__cardList__O-UKI>div .style__cardItem__3o4Rc span[data-v-9c86c1e4]:first-child {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 1.6rem;
}

.style__modal__2ifxp .style__cardList__O-UKI>div .style__cardItem__3o4Rc i[data-v-9c86c1e4] {
  width: 0.3rem;
  height: 0.3rem;
}

.style__modal__2ifxp .style__cardList__O-UKI>div .style__cardItem__3o4Rc i[data-v-9c86c1e4]:nth-child(2) {
  width: 0;
}

.style__modal__2ifxp .style__cardList__O-UKI>div .style__cardItem__3o4Rc[data-v-9c86c1e4]:first-child {
  border: 0;
}

.style__modal__2ifxp .style__cardList__O-UKI>div .style__cardItem__3o4Rc p[data-v-9c86c1e4] {
  font-family: PingFang SC;
  font-size: 0.2rem;
  color: #db6372;
  margin-top: -0.3rem;
}

.style__modal__2ifxp .style__cardList__O-UKI>div .style__submit__JU1R4[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 0.8rem;
  background: #ede9e7;
  color: #fff;
  font-family: PingFang SC;
  font-size: 0.32rem;
  margin-top: 0.2rem;
  border-radius: 0.1rem;
}

.style__modal__2ifxp .style__cardList__O-UKI>div .style__submit__JU1R4.style__disabled__2pwUN[data-v-9c86c1e4] {
  opacity: 0.5;
}

.style__modal__2ifxp.style__yibo__fitG7 .am-modal-content[data-v-9c86c1e4] {
  background: #222536;
}

.style__modal__2ifxp.style__yibo__fitG7 .style__title__tEP54 span[data-v-9c86c1e4] {
  color: #dedede;
}

.style__modal__2ifxp.style__yibo__fitG7 .style__title__tEP54 span[data-v-9c86c1e4]:first-child,
.style__modal__2ifxp.style__yibo__fitG7 .style__title__tEP54 span[data-v-9c86c1e4]:last-child {
  color: #ede9e7;
}

.style__modal__2ifxp.style__yibo__fitG7 .style__cardList__O-UKI[data-v-9c86c1e4] {
  background: #161a28;
}

.style__modal__2ifxp.style__yibo__fitG7 .style__cardList__O-UKI>div[data-v-9c86c1e4] {
  background: #222536;
}

.style__modal__2ifxp.style__yibo__fitG7 .style__cardList__O-UKI>div .style__cardItem__3o4Rc[data-v-9c86c1e4] {
  border-top: 0.02rem solid #373a4c !important;
}

.style__modal__2ifxp.style__yibo__fitG7 .style__cardList__O-UKI>div .style__cardItem__3o4Rc[data-v-9c86c1e4]:first-child {
  border: 0 !important;
}

.style__modal__2ifxp.style__yibo__fitG7 .style__cardList__O-UKI>div .style__cardItem__3o4Rc span[data-v-9c86c1e4] {
  color: #dedede;
}

.style__modal__2ifxp.style__yibo__fitG7 .style__cardList__O-UKI>div .style__submit__JU1R4[data-v-9c86c1e4] {
  color: #79420d;
  background: -webkit-gradient(linear, right top, left top, from(#d9a76f), to(#f4d3b4));
  background: -webkit-linear-gradient(to left, #d9a76f, #f4d3b4);
  background: linear-gradient(270deg, #d9a76f, #f4d3b4);
}

.style__modal__2ifxp .am-modal-content[data-v-9c86c1e4] {
  border-radius: 0.2rem 0.2rem 0 0;
}

.style__fixedAmount__3TJX-[data-v-9c86c1e4] {
  padding: 0 0.28rem;
  background: #fff;
  margin-top: 0.2rem;
}

.style__fixedAmount__3TJX- .style__title__tEP54[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  font-family: PingFang SC;
  font-size: 0.28rem;
  font-weight: 700;
  height: 0.8rem;
  color: #414655;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.style__fixedAmount__3TJX- .style__amountList__1gPUQ[data-v-9c86c1e4],
.style__fixedAmount__3TJX- .style__title__tEP54[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  border-bottom: 0.02rem solid #eee;
}

.style__fixedAmount__3TJX- .style__amountList__1gPUQ[data-v-9c86c1e4] {
  padding-bottom: 0.2rem;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.style__fixedAmount__3TJX- .style__amountList__1gPUQ .style__amountItem__1uP6a[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  height: 0.7rem;
  width: 1.58rem;
  margin-top: 0.2rem;
  border: 0.02rem solid #eee;
  border-radius: 0.1rem;
  font-family: DINPro;
  font-size: 0.28rem;
  margin-right: 0.2rem;
}

.style__fixedAmount__3TJX- .style__amountList__1gPUQ .style__amountItem__1uP6a[data-v-9c86c1e4]:nth-child(4n) {
  margin-right: 0;
}

.style__fixedAmount__3TJX- .style__amountList__1gPUQ .style__amountItem__1uP6a.style__active__Mr8s9[data-v-9c86c1e4] {
  border-color: #ede9e7;
  color: #ede9e7;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAARVBMVEUAAAAAjv0Aj/0Ajv0Aj/4AkP4Ak/8Aj/wAj/0Alf4AlP8Aj/wAj/0AkP4Aj/0Aj/0AjvwAj/4AnP8AjvwAjv0Alf8Ajv3y6AqCAAAAFnRSTlMAgPzdVlEc1c8XEtliXPPopYoF2K4Oakr83AAAAIxJREFUOMul0EkOwzAMQ1E3tpvBbZpO//5HbVABdqCFuQi3jxAIBZGLcpSjHOUoRznKUY5ylKMc5ShHOcrp+fAAep6+I3T8Hq4Rej4XwPsnNn8DOJ/2s3+/hXkE4OA2zBrV16PXxu6LOcW5NXJYJiybdxhyaE5ybo3m8VXdv9iSnfs8z3ns3V/LlmzfDyYJJF+w5cW8AAAAAElFTkSuQmCC) no-repeat 1.24rem 0.36rem;
  background-size: 0.32rem;
}

.style__fixedAmount__3TJX- .style__margin__3TCyy[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 0.8rem;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.style__fixedAmount__3TJX- .style__margin__3TCyy span[data-v-9c86c1e4] {
  font-family: PingFang SC;
  font-size: 0.24rem;
}

.style__fixedAmount__3TJX- .style__margin__3TCyy span[data-v-9c86c1e4]:first-child {
  color: #394857;
}

.style__fixedAmount__3TJX- .style__margin__3TCyy span[data-v-9c86c1e4]:nth-child(2) {
  color: #db6372;
}

.style__fixedAmount__3TJX- .style__margin__3TCyy span[data-v-9c86c1e4]:nth-child(3) {
  margin-left: 0.2rem;
  color: #ede9e7;
}

.style__fixedAmount__3TJX- .style__margin__3TCyy span[data-v-9c86c1e4]:last-child {
  color: #a5a9b3;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: right;
}

.style__fixedAmount__3TJX- .style__margin__3TCyy span:last-child span[data-v-9c86c1e4] {
  color: #414655;
}

.style__fixedAmount__3TJX-.style__yibo__fitG7[data-v-9c86c1e4] {
  background: #222536;
}

.style__fixedAmount__3TJX-.style__yibo__fitG7 .style__title__tEP54[data-v-9c86c1e4] {
  color: #dedede;
  border-bottom: 0.02rem solid #373a4c;
}

.style__fixedAmount__3TJX-.style__yibo__fitG7 .style__amountList__1gPUQ[data-v-9c86c1e4] {
  border-bottom: 0.02rem solid #373a4c;
}

.style__fixedAmount__3TJX-.style__yibo__fitG7 .style__amountList__1gPUQ .style__amountItem__1uP6a[data-v-9c86c1e4] {
  border: 0.02rem solid #6c6e82;
  color: #a1a2a7;
}

.style__fixedAmount__3TJX-.style__yibo__fitG7 .style__amountList__1gPUQ .style__amountItem__1uP6a.style__active__Mr8s9[data-v-9c86c1e4] {
  border-color: #ede9e7;
  color: #ede9e7;
}

.style__fixedAmount__3TJX-.style__yibo__fitG7 .style__margin__3TCyy span[data-v-9c86c1e4]:first-child {
  color: #6c6e82;
}

.style__fixedAmount__3TJX-.style__yibo__fitG7 .style__margin__3TCyy span[data-v-9c86c1e4]:nth-child(2) {
  color: #db6372;
}

.style__fixedAmount__3TJX-.style__yibo__fitG7 .style__margin__3TCyy span[data-v-9c86c1e4]:nth-child(3) {
  color: #ede9e7;
}

.style__fixedAmount__3TJX-.style__yibo__fitG7 .style__margin__3TCyy span[data-v-9c86c1e4]:last-child {
  color: #6c6e82;
}

.style__fixedAmount__3TJX-.style__yibo__fitG7 .style__margin__3TCyy span:last-child span[data-v-9c86c1e4] {
  color: #dedede;
}

.style__inputAmount__3JFez[data-v-9c86c1e4] {
  padding: 0 0.28rem;
  background: #fff;
  margin-top: 0.2rem;
}

.style__inputAmount__3JFez .style__input__2zzgb[data-v-9c86c1e4],
.style__inputAmount__3JFez .style__prompt__2W-ta[data-v-9c86c1e4],
.style__inputAmount__3JFez .style__title__tEP54[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 0.8rem;
}

.style__inputAmount__3JFez .style__title__tEP54[data-v-9c86c1e4] {
  font-family: PingFang SC;
  font-size: 0.28rem;
  font-weight: 700;
  color: #414655;
}

.style__inputAmount__3JFez .style__input__2zzgb[data-v-9c86c1e4] {
  height: 1rem;
}

.style__inputAmount__3JFez .style__input__2zzgb img[data-v-9c86c1e4] {
  width: 0.36rem;
  height: 0.34rem;
}

.style__inputAmount__3JFez .style__input__2zzgb span[data-v-9c86c1e4] {
  font-family: DINPro;
  font-size: 0.48rem;
  color: #414655;
}

.style__inputAmount__3JFez .style__input__2zzgb span[data-v-9c86c1e4]:last-child {
  font-family: PingFang SC;
  font-size: 0.24rem;
  text-align: right;
  color: #ede9e7;
}

.style__inputAmount__3JFez .style__input__2zzgb .style__InputItem__bTxWJ[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding-left: 0.1rem;
}

.style__inputAmount__3JFez .style__input__2zzgb .style__InputItem__bTxWJ .fake-input[data-v-9c86c1e4] {
  font-family: DINPro;
  font-size: 0.48rem;
  color: #414655;
}

.style__inputAmount__3JFez .style__input__2zzgb .style__InputItem__bTxWJ .fake-input-placeholder[data-v-9c86c1e4] {
  font-family: PingFang SC;
  font-size: 0.36rem;
  color: #e0e3eb;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.style__inputAmount__3JFez .style__prompt__2W-ta[data-v-9c86c1e4] {
  border-top: 0.02rem solid #eee;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.style__inputAmount__3JFez .style__prompt__2W-ta span[data-v-9c86c1e4] {
  font-family: PingFang SC;
  font-size: 0.24rem;
  color: #a5a9b3;
}

.style__inputAmount__3JFez .style__prompt__2W-ta span span[data-v-9c86c1e4] {
  color: #414655;
}

.style__inputAmount__3JFez .style__prompt__2W-ta span.style__red__FDcQW[data-v-9c86c1e4] {
  color: #db6372;
}

.style__inputAmount__3JFez .am-input-clear[data-v-9c86c1e4] {
  background-color: initial;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAWlBMVEUAAABtboNtb4N8kZhsboNtboJucYVtcIRsboJ0dItucYRvc4Zuc4VsboJtboNtboJtb4Ntb4Ntb4JtcIN8fJttb4NzdIltboNvb4Rtb4Nsb4Jsb4Ntb4NsboKqh8QPAAAAHXRSTlMAyNcG7L0/cdoRMSch887Dt4iBVAhmGOo+qK6qinMF874AAADdSURBVCjPfZPbkoMgEESbWyCg68asJrub/v/fjIBxSh7oBynr1AxNM+BQnF0Yx+DmiFZ3zU2PR/7q+wkNipx8MoBJfiLVIOxiqZ7y+1S0l4ORN5x0I3c6WC5otNDWzqrWtbWq+KxLK8XsWdf2q7+iyPhUjWggctp3UYWab76QNTFipkfWj+PXNbO8ZHnOcEwQKgyJDoEGO92AMBgGjBYQKgywYxee2+o/6lXangzp1fwyrGJIjlKLNjp8jiIhFFbo/xEC2viwxD2+bvC9K+tedm9M+gPWH83+UHefwxtGghPEEBK9aAAAAABJRU5ErkJggg==);
  width: 0.28rem !important;
  height: 0.28rem !important;
  background-size: cover;
  background-position: 0 0;
}

.style__inputAmount__3JFez.style__yibo__fitG7[data-v-9c86c1e4] {
  background: #222536;
}

.style__inputAmount__3JFez.style__yibo__fitG7 .style__input__2zzgb span[data-v-9c86c1e4],
.style__inputAmount__3JFez.style__yibo__fitG7 .style__title__tEP54[data-v-9c86c1e4] {
  color: #dedede;
}

.style__inputAmount__3JFez.style__yibo__fitG7 .style__input__2zzgb span[data-v-9c86c1e4]:last-child {
  color: #ede9e7;
}

.style__inputAmount__3JFez.style__yibo__fitG7 .style__input__2zzgb .style__InputItem__bTxWJ[data-v-9c86c1e4] {
  background: #222536;
}

.style__inputAmount__3JFez.style__yibo__fitG7 .style__input__2zzgb .style__InputItem__bTxWJ .fake-input[data-v-9c86c1e4] {
  color: #dedede;
}

.style__inputAmount__3JFez.style__yibo__fitG7 .style__input__2zzgb .style__InputItem__bTxWJ .fake-input-placeholder[data-v-9c86c1e4] {
  color: #6c6e82;
}

.style__inputAmount__3JFez.style__yibo__fitG7 .style__prompt__2W-ta[data-v-9c86c1e4] {
  border-top: 0.02rem solid #373a4c;
}

.style__inputAmount__3JFez.style__yibo__fitG7 .style__prompt__2W-ta span[data-v-9c86c1e4] {
  color: #6c6e82;
}

.style__inputAmount__3JFez.style__yibo__fitG7 .style__prompt__2W-ta span span[data-v-9c86c1e4] {
  color: #dedede;
}

.style__inputAmount__3JFez.style__yibo__fitG7 .style__prompt__2W-ta span.style__red__FDcQW[data-v-9c86c1e4] {
  color: #db6372;
}

.style__showOrderSplit__3PJEd[data-v-9c86c1e4] {
  position: fixed;
  top: 0.9rem;
  left: 0;
  right: 0;
  height: calc(100% - 0.9rem);
  overflow-y: auto;
  background: #f8f8f8;
  z-index: 3;
}

.style__showOrderSplit__3PJEd.style__yibo__fitG7[data-v-9c86c1e4] {
  background: #161a28;
}

.style__virtualFee__2NmSk[data-v-9c86c1e4] {
  height: 0.6rem;
  font-family: PingFang SC;
  font-size: 0.24rem;
  line-height: 0.34rem;
  letter-spacing: 0;
  color: #a5a9b3;
}

.style__virtualFee__2NmSk .style__virtualFeeMount__2KLSL[data-v-9c86c1e4] {
  font-family: DIN Pro;
  line-height: 15px;
  letter-spacing: 0;
  color: #db6372;
}

.style__speedGuide__3SRQy[data-v-9c86c1e4] {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 99;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation: style__fain__1zR09 0.4s ease;
  animation: style__fain__1zR09 0.4s ease;
}

.style__speedGuide__3SRQy img[data-v-9c86c1e4] {
  position: absolute;
  width: 6.8rem;
  z-index: 100;
  pointer-events: none;
  right: 0;
  bottom: 0;
}

.style__mtop10__3FtAP[data-v-9c86c1e4] {
  margin-top: 0.2rem;
}

.style__SubscribeDraw__2GgWv[data-v-9c86c1e4] {
  margin-top: 0.2rem;
  background: #fff;
  padding: 0.2rem 0.28rem;
}

.style__SubscribeDraw__2GgWv .style__tab__Hxtuo[data-v-9c86c1e4] {
  background: #f8f8f8;
  border-radius: 0.16rem;
  padding: 0.02rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.style__SubscribeDraw__2GgWv .style__tab__Hxtuo>div[data-v-9c86c1e4] {
  background: #f8f8f8;
  border-radius: 0.16rem;
  height: 0.52rem;
  line-height: 0.52rem;
  text-align: center;
  color: #a5a9b3;
  width: 50%;
  font-family: PingFang SC;
  position: relative;
}

.style__SubscribeDraw__2GgWv .style__tab__Hxtuo>div i[data-v-9c86c1e4] {
  position: absolute;
  top: -0.2rem;
  left: 0;
  height: 0.32rem;
  border-radius: 0.18rem;
  padding: 0 0.14rem;
  color: #fff;
  font-family: DINPro;
  font-size: 0.2rem;
  background: #db6372;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.style__SubscribeDraw__2GgWv .style__tab__Hxtuo>div.style__active__Mr8s9[data-v-9c86c1e4] {
  background: #fff;
  color: #414655;
}

.style__SubscribeDraw__2GgWv .style__sBox__22Auq[data-v-9c86c1e4] {
  margin-top: 0.2rem;
}

.style__SubscribeDraw__2GgWv .style__sBox__22Auq .style__title__tEP54[data-v-9c86c1e4] {
  font-family: PingFang SC;
  font-size: 0.28rem;
  font-weight: 700;
  color: #414655;
}

.style__SubscribeDraw__2GgWv .style__sBox__22Auq .style__list__1Ne_C[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.style__SubscribeDraw__2GgWv .style__sBox__22Auq .style__list__1Ne_C .style__item__1QaF9[data-v-9c86c1e4] {
  width: 3.24rem;
  height: 0.7rem;
  padding: 0 0.2rem;
  text-align: center;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 0.2rem;
  border: 0.02rem solid #eee;
  border-radius: 0.12rem;
  font-family: PingFang SC;
  font-size: 0.24rem;
}

.style__SubscribeDraw__2GgWv .style__sBox__22Auq .style__list__1Ne_C .style__item__1QaF9.style__active__Mr8s9[data-v-9c86c1e4] {
  border-color: #ede9e7;
  color: #ede9e7;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAARVBMVEUAAAAAjv0Aj/0Ajv0Aj/4AkP4Ak/8Aj/wAj/0Alf4AlP8Aj/wAj/0AkP4Aj/0Aj/0AjvwAj/4AnP8AjvwAjv0Alf8Ajv3y6AqCAAAAFnRSTlMAgPzdVlEc1c8XEtliXPPopYoF2K4Oakr83AAAAIxJREFUOMul0EkOwzAMQ1E3tpvBbZpO//5HbVABdqCFuQi3jxAIBZGLcpSjHOUoRznKUY5ylKMc5ShHOcrp+fAAep6+I3T8Hq4Rej4XwPsnNn8DOJ/2s3+/hXkE4OA2zBrV16PXxu6LOcW5NXJYJiybdxhyaE5ybo3m8VXdv9iSnfs8z3ns3V/LlmzfDyYJJF+w5cW8AAAAAElFTkSuQmCC) no-repeat 2.88rem 0.36rem;
  background-size: 0.32rem;
}

.style__SubscribeDraw__2GgWv.style__yibo__fitG7[data-v-9c86c1e4] {
  background: #222536;
}

.style__SubscribeDraw__2GgWv.style__yibo__fitG7 .style__tab__Hxtuo[data-v-9c86c1e4] {
  background: #161a28;
}

.style__SubscribeDraw__2GgWv.style__yibo__fitG7 .style__tab__Hxtuo>div[data-v-9c86c1e4] {
  background: #161a28;
  color: #6c6e82;
}

.style__SubscribeDraw__2GgWv.style__yibo__fitG7 .style__tab__Hxtuo>div.style__active__Mr8s9[data-v-9c86c1e4] {
  background: #222536;
  color: #dedede;
}

.style__SubscribeDraw__2GgWv.style__yibo__fitG7 .style__sBox__22Auq .style__title__tEP54[data-v-9c86c1e4] {
  color: #dedede;
}

.style__SubscribeDraw__2GgWv.style__yibo__fitG7 .style__sBox__22Auq .style__list__1Ne_C .style__item__1QaF9[data-v-9c86c1e4] {
  border: 0.02rem solid #6c6e82;
  color: #a1a2a7;
}

.style__SubscribeDraw__2GgWv.style__yibo__fitG7 .style__sBox__22Auq .style__list__1Ne_C .style__item__1QaF9.style__active__Mr8s9[data-v-9c86c1e4] {
  border-color: #ede9e7;
  color: #ede9e7;
}

.Maintenance__bg__121TT[data-v-9c86c1e4] {
  background: #fff;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0.76rem;
}

.Maintenance__bg__121TT img[data-v-9c86c1e4] {
  width: 3.6rem;
  height: 3.6rem;
  margin: 3.44rem auto 0.4rem;
  display: block;
}

.Maintenance__bg__121TT p[data-v-9c86c1e4] {
  color: #626571;
  font-size: 0.36rem;
  margin: 0.2rem auto;
  text-align: center;
  width: 5.04rem;
}

.Maintenance__bg__121TT p[data-v-9c86c1e4]:nth-child(3) {
  font-size: 0.28rem;
}

.Maintenance__bg__121TT .Maintenance__btn__25tax[data-v-9c86c1e4] {
  text-align: center;
  font-size: 0.28rem;
  width: 2.88rem;
  height: 0.68rem;
  line-height: 0.68rem;
  margin: 0.4rem auto 0;
  font-family: PingFang SC;
  color: #414655;
  border: 0.02rem solid #eee;
  border-radius: 6px;
}

.Maintenance__bg__121TT.Maintenance__yibo__2N4uE[data-v-9c86c1e4] {
  background: #222536;
}

.Maintenance__bg__121TT.Maintenance__yibo__2N4uE p[data-v-9c86c1e4] {
  color: #6c6e82;
}

.Maintenance__bg__121TT.Maintenance__yibo__2N4uE .Maintenance__btn__25tax[data-v-9c86c1e4] {
  color: #a5a9b4;
  border: 0.02rem solid #cbced8;
}

.withDrawStyle__htxGuideMask__32BXe[data-v-9c86c1e4] {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 99;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation: withDrawStyle__fain__3zQFJ 0.4s ease;
  animation: withDrawStyle__fain__3zQFJ 0.4s ease;
}

.withDrawStyle__theGuidePic__1U2b7[data-v-9c86c1e4] {
  position: absolute;
  width: 6.8rem;
  z-index: 100;
  pointer-events: none;
}

.withDrawStyle__theGuidePic__1U2b7[data-v-9c86c1e4]:first-child {
  right: -0.7rem;
  bottom: -0.72rem;
}

.withDrawStyle__theGuidePic__1U2b7[data-v-9c86c1e4]:nth-child(2) {
  left: -0.35rem;
  right: 0;
  bottom: -1.4rem;
}

.withDrawStyle__box__1Mcwe[data-v-9c86c1e4] {
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  min-height: calc(100% - 0.9rem);
  background: #f8f8f8;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__remark__1feq8[data-v-9c86c1e4] {
  padding: 0 0.28rem;
  height: 0.6rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  font-size: 0.28rem;
  color: #ff4634;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__changeInput__1cnrq[data-v-9c86c1e4] {
  padding: 0 0.28rem;
  height: 1.2rem;
  background: #fff;
  margin-bottom: 0.02rem;
  font-family: DinPro;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__changeInput__1cnrq[data-v-9c86c1e4],
.withDrawStyle__box__1Mcwe .withDrawStyle__changeInput__1cnrq span[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__changeInput__1cnrq span[data-v-9c86c1e4] {
  font-size: 0.28rem;
  color: #414655;
  font-weight: 500;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__changeInput__1cnrq span[data-v-9c86c1e4]:first-child {
  margin-top: 0.06rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__changeInput__1cnrq span[data-v-9c86c1e4]:last-child {
  color: #a5a9b3;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__changeInput__1cnrq .withDrawStyle__input__3E_LM[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 1rem;
  padding: 0 0.1rem;
  background: #fff;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__changeInput__1cnrq .withDrawStyle__input__3E_LM .fake-input[data-v-9c86c1e4] {
  font-size: 0.46rem;
  font-family: DinPro;
  font-weight: 700;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__changeInput__1cnrq .withDrawStyle__input__3E_LM .fake-input-placeholder[data-v-9c86c1e4] {
  font-size: 0.28rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__changeInput__1cnrq img[data-v-9c86c1e4] {
  width: 0.28rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__changeInput__1cnrq.withDrawStyle__yibo__1O4eN span[data-v-9c86c1e4] {
  color: #dedede;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__changeInput__1cnrq.withDrawStyle__yibo__1O4eN span[data-v-9c86c1e4]:last-child {
  color: #a1a2a7;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__changeInput__1cnrq.withDrawStyle__yibo__1O4eN .withDrawStyle__input__3E_LM .fake-input[data-v-9c86c1e4] {
  color: #dedede;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__changeInput__1cnrq.withDrawStyle__yibo__1O4eN .withDrawStyle__input__3E_LM .fake-input-placeholder[data-v-9c86c1e4] {
  color: #6c6e82;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__changeInput__1cnrq.withDrawStyle__yibo__1O4eN .withDrawStyle__input__3E_LM .am-input-clear[data-v-9c86c1e4] {
  background-color: initial;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAWlBMVEUAAABtboNtb4N8kZhsboNtboJucYVtcIRsboJ0dItucYRvc4Zuc4VsboJtboNtboJtb4Ntb4Ntb4JtcIN8fJttb4NzdIltboNvb4Rtb4Nsb4Jsb4Ntb4NsboKqh8QPAAAAHXRSTlMAyNcG7L0/cdoRMSch887Dt4iBVAhmGOo+qK6qinMF874AAADdSURBVCjPfZPbkoMgEESbWyCg68asJrub/v/fjIBxSh7oBynr1AxNM+BQnF0Yx+DmiFZ3zU2PR/7q+wkNipx8MoBJfiLVIOxiqZ7y+1S0l4ORN5x0I3c6WC5otNDWzqrWtbWq+KxLK8XsWdf2q7+iyPhUjWggctp3UYWab76QNTFipkfWj+PXNbO8ZHnOcEwQKgyJDoEGO92AMBgGjBYQKgywYxee2+o/6lXangzp1fwyrGJIjlKLNjp8jiIhFFbo/xEC2viwxD2+bvC9K+tedm9M+gPWH83+UHefwxtGghPEEBK9aAAAAABJRU5ErkJggg==);
  width: 0.28rem !important;
  height: 0.28rem !important;
  background-size: cover;
  background-position: 0 0;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__immedBtn__2i3WS[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding: 0 0.28rem;
  opacity: 0.5;
  margin: 0.2rem 0;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__immedBtn__2i3WS span[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 0.9rem;
  border-radius: 0.1rem;
  background-color: #ede9e7;
  color: #fff;
  font-size: 0.32rem;
  font-weight: 700;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__immedBtn__2i3WS.withDrawStyle__active__GFH5L[data-v-9c86c1e4] {
  opacity: 1;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__immedBtn__2i3WS.withDrawStyle__yiboBtn__2Q1us span[data-v-9c86c1e4] {
  color: #79420d;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__tabWrapContainer__1BQXa[data-v-9c86c1e4] {
  height: 0.96rem;
  padding: 0.2rem 0.28rem;
  background: #fff;
  border-top: 0.2rem solid #f8f8f8;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__tabWrapContainer__1BQXa .withDrawStyle__tabWrap__2Q624[data-v-9c86c1e4] {
  position: relative;
  width: 100%;
  height: 0.56rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: #eee;
  border-radius: 0.16rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0;
  border: 0.02rem solid #eee;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__tabWrapContainer__1BQXa .withDrawStyle__tabWrap__2Q624 .withDrawStyle__tabBtn__3HPqn[data-v-9c86c1e4] {
  width: 100%;
  height: 0.52rem;
  line-height: 0.54rem;
  text-align: center;
  font-size: 0.24rem;
  color: #414655;
  opacity: 0.5;
  border-radius: 0.16rem;
  font-weight: 700;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__tabWrapContainer__1BQXa .withDrawStyle__tabWrap__2Q624 .withDrawStyle__tabBtn__3HPqn.withDrawStyle__active__GFH5L[data-v-9c86c1e4] {
  opacity: 1;
  background: #fff;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__tabWrapContainer__1BQXa .withDrawStyle__tabWrap__2Q624>span[data-v-9c86c1e4] {
  position: absolute;
  top: -0.22rem;
  left: 0.1rem;
  height: 0.32rem;
  line-height: 0.32rem;
  border-radius: 0.18rem;
  padding: 0 0.08rem 0 0.4rem;
  color: #fff;
  opacity: 1;
  font-family: dinpro;
  font-size: 0.2rem;
  background: #db6372 url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAclBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9eWEHEAAAAJXRSTlMANvYJ5Mci/PHt1pEtEgTbuJppYVdRSUInGs/LwaymioSCbmQ6yKqOFQAAAJtJREFUGNNlkFcSgzAMBU3vBEJPb+/+V0wk2cGG/ZJ2RlVpqqZXe0Kc562rEyD9bOSIH1nsygbE1XEdhFkNgXGeD+FY+MYFITQ5kkBU+YDFwLKPMltGLG9w4b0OEFIzjKSeHC4nMIUlO1VJTUsy+vf3EoruJF/ckNu3FE78Slr9KZfR/uuRntwBZKUSyhwjBwsu8frid1FzzcTpF8VJGKGYNNAiAAAAAElFTkSuQmCC) no-repeat 0.14rem;
  background-size: 0.2rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__tabWrapContainer__1BQXa.withDrawStyle__yibo__1O4eN[data-v-9c86c1e4] {
  border-top: none;
  margin-bottom: -0.2rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__virtualListInfo__WPTSx[data-v-9c86c1e4] {
  background: #fff;
  padding-left: 0.28rem;
  margin-top: 0.2rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__virtualListInfo__WPTSx>div[data-v-9c86c1e4] {
  padding: 0.2rem 0;
  color: #333;
  font-size: 0.28rem;
  border-bottom: 1px solid #eee;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__virtualListInfo__WPTSx>div.withDrawStyle__yibo__1O4eN[data-v-9c86c1e4] {
  border-bottom: 1px solid rgba(108, 110, 130, 0.4);
  color: #dedede;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__virtualListInfo__WPTSx>ul li[data-v-9c86c1e4] {
  height: 1rem;
  line-height: 1rem;
  color: #414655;
  font-size: 0.28rem;
  border-bottom: 1px solid #eee;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding-right: 0.28rem;
  position: relative;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__virtualListInfo__WPTSx>ul li .withDrawStyle__noSupport__1-ajv[data-v-9c86c1e4] {
  color: #db6372;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__virtualListInfo__WPTSx>ul li.withDrawStyle__yibo__1O4eN[data-v-9c86c1e4] {
  border-bottom: 1px solid rgba(108, 110, 130, 0.4);
  color: #dedede;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__virtualListInfo__WPTSx>ul li.withDrawStyle__yibo__1O4eN .withDrawStyle__noSupport__1-ajv[data-v-9c86c1e4] {
  color: #6c6e82;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__virtualListInfo__WPTSx>ul li i[data-v-9c86c1e4] {
  display: block;
  width: 0.32rem;
  height: 0.32rem;
  border-radius: 50%;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAtUExURUdwTNTU4szP2czP2czQ2s7Q2czP2czP2dHR3cvO2MzO2MzP2MvO2czP2cvO2NZr/64AAAAOdFJOUwAOvvg7V2nXIed9kKKh1pP95wAAAN1JREFUKM9jYCAViF4qNtcNRBULsnsHBI9VkcWc3hmlNEq4Kb9TQYhxv5smAKIZM99tgIkx6lkJQFmLH0FZDOIvHWDyLPMKoSy9CoRJ7Y+gJr5sQAhyzIOY6meC7BDnJxDdC5AFucD6WV8KIAsyzgsAkkzPUD2XpwAkhA1RBcH8OAVUQaanQOJcAqog2xuQ5Q6ogiwg6+saUAU5ngMJOwFUQcbHuASxasdq0T10J73F5Xis3sQaIFiDDmsgY48OrBGHNYqxJwasyQZrAsOeFLEnWmDyPlRsrhNIcq4AAB03TsMVRtc/AAAAAElFTkSuQmCC);
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: cover;
}

.webpa .withDrawStyle__box__1Mcwe .withDrawStyle__virtualListInfo__WPTSx>ul li i[data-v-9c86c1e4] {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAtUExURUdwTNTU4szP2czP2czQ2s7Q2czP2czP2dHR3cvO2MzO2MzP2MvO2czP2cvO2NZr/64AAAAOdFJOUwAOvvg7V2nXIed9kKKh1pP95wAAAN1JREFUKM9jYCAViF4qNtcNRBULsnsHBI9VkcWc3hmlNEq4Kb9TQYhxv5smAKIZM99tgIkx6lkJQFmLH0FZDOIvHWDyLPMKoSy9CoRJ7Y+gJr5sQAhyzIOY6meC7BDnJxDdC5AFucD6WV8KIAsyzgsAkkzPUD2XpwAkhA1RBcH8OAVUQaanQOJcAqog2xuQ5Q6ogiwg6+saUAU5ngMJOwFUQcbHuASxasdq0T10J73F5Xis3sQaIFiDDmsgY48OrBGHNYqxJwasyQZrAsOeFLEnWmDyPlRsrhNIcq4AAB03TsMVRtc/AAAAAElFTkSuQmCC);
}

.withDrawStyle__box__1Mcwe .withDrawStyle__virtualListInfo__WPTSx>ul li i.withDrawStyle__active__GFH5L[data-v-9c86c1e4] {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA/UExURUdwTFp/91p/+FmC+1l/+Kqq/1l/+Fl/+GCI/1qA+Vl+9////5qx+mOG9/T2/oeh+dfg/XKS+OPp/bPE+8LQ/Lr2QFkAAAAKdFJOUwChjTnXA/O9EFU1t8sqAAABBUlEQVQ4y7VV0Q6DIAwUhxYooOj+/1unOJViJbhk92AkXtrrtdSm+TOUFiD7XoLQqkDTYBKAvqG9CC1SXwytaw2DtruIA8MCMqlKmhtIwuzA3ALS7K0poE3qNUWctUOZCIfP7Gdnrf2+6lJANyGONKRiA74RfdgP0aKOzWwR0R6nLbdgeMEjvs+juJU4Ik4ur1se8qdx2F7nJXFI+xiJ/UX/QAQu6Clxd8T505mUeA5OWCLNW2RHRygvZjVliA+uiYJW630MSyAurV7lLc7kbulrC9eCfciJihmKOXMmnTPabDsYPvODwa2/CtWXq/66Vi+A+pVSv6Tq196DRfpgNVPRP/4GPkTaKUoMP5u7AAAAAElFTkSuQmCC);
}

.webpa .withDrawStyle__box__1Mcwe .withDrawStyle__virtualListInfo__WPTSx>ul li i.withDrawStyle__active__GFH5L[data-v-9c86c1e4] {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA/UExURUdwTFp/91p/+FmC+1l/+Kqq/1l/+Fl/+GCI/1qA+Vl+9////5qx+mOG9/T2/oeh+dfg/XKS+OPp/bPE+8LQ/Lr2QFkAAAAKdFJOUwChjTnXA/O9EFU1t8sqAAABBUlEQVQ4y7VV0Q6DIAwUhxYooOj+/1unOJViJbhk92AkXtrrtdSm+TOUFiD7XoLQqkDTYBKAvqG9CC1SXwytaw2DtruIA8MCMqlKmhtIwuzA3ALS7K0poE3qNUWctUOZCIfP7Gdnrf2+6lJANyGONKRiA74RfdgP0aKOzWwR0R6nLbdgeMEjvs+juJU4Ik4ur1se8qdx2F7nJXFI+xiJ/UX/QAQu6Clxd8T505mUeA5OWCLNW2RHRygvZjVliA+uiYJW630MSyAurV7lLc7kbulrC9eCfciJihmKOXMmnTPabDsYPvODwa2/CtWXq/66Vi+A+pVSv6Tq196DRfpgNVPRP/4GPkTaKUoMP5u7AAAAAElFTkSuQmCC);
}

.withDrawStyle__box__1Mcwe .withDrawStyle__noAmount__2CjsV[data-v-9c86c1e4] {
  width: 100%;
  height: calc(100% - 0.88rem);
  background: #f8f8f8;
  position: absolute;
  z-index: 999;
  top: 0.88rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__noAmount__2CjsV img[data-v-9c86c1e4] {
  width: 3.6rem;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -91%);
  transform: translate(-50%, -91%);
}

.withDrawStyle__box__1Mcwe .withDrawStyle__noAmount__2CjsV p[data-v-9c86c1e4] {
  display: block;
  width: 100%;
  text-align: center;
  font-size: 0.28rem;
  color: #a5a9b3;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, 50%);
  transform: translate(-50%, 50%);
}

.withDrawStyle__box__1Mcwe .withDrawStyle__container__28IaW[data-v-9c86c1e4] {
  width: 100%;
  background: #fff;
  padding: 0 0.28rem;
  margin-top: 0.2rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__container__28IaW h2[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding: 0.2rem 0;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border-bottom: 0.02rem solid #eee;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__container__28IaW h2 span[data-v-9c86c1e4]:first-of-type {
  color: #333;
  font-size: 0.28rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__container__28IaW h2 span:first-of-type img[data-v-9c86c1e4] {
  width: 0.28rem;
  margin-left: 0.1rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__container__28IaW h2 span[data-v-9c86c1e4]:last-of-type {
  color: #697b8c;
  font-size: 0.28rem;
  font-weight: 400;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__container__28IaW .withDrawStyle__walletList__1liqX[data-v-9c86c1e4] {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding: 0.22rem 0;
  border-bottom: 0.02rem solid #eee;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__container__28IaW .withDrawStyle__walletList__1liqX li[data-v-9c86c1e4] {
  width: 50%;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__container__28IaW .withDrawStyle__walletList__1liqX li[data-v-9c86c1e4]:first-of-type {
  position: relative;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__container__28IaW .withDrawStyle__walletList__1liqX li[data-v-9c86c1e4]:first-of-type:after {
  content: '';
  width: 0.32px;
  width: 0.02rem;
  height: 6.08px;
  height: 0.38rem;
  position: absolute;
  top: 50%;
  right: 0;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #eee;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__container__28IaW .withDrawStyle__walletList__1liqX li span[data-v-9c86c1e4]:first-of-type {
  color: #333;
  font-size: 0.24rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__container__28IaW .withDrawStyle__walletList__1liqX li span:first-of-type img[data-v-9c86c1e4] {
  width: 0.28rem;
  margin-right: 0.1rem;
  margin-left: -0.1rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__container__28IaW .withDrawStyle__walletList__1liqX li span[data-v-9c86c1e4]:last-of-type {
  color: #158bf4;
  font-size: 0.32rem;
  text-align: center;
  display: block;
  margin-top: 0.1rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__container__28IaW .withDrawStyle__venueList__3Kxmt[data-v-9c86c1e4] {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__container__28IaW .withDrawStyle__venueList__3Kxmt li[data-v-9c86c1e4] {
  padding: 0.22rem 0;
  width: 25%;
  position: relative;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__container__28IaW .withDrawStyle__venueList__3Kxmt li[data-v-9c86c1e4]:after {
  content: '';
  width: 0.32px;
  width: 0.02rem;
  height: 6.08px;
  height: 0.38rem;
  position: absolute;
  top: 50%;
  right: 0;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #eee;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__container__28IaW .withDrawStyle__venueList__3Kxmt li span[data-v-9c86c1e4]:first-of-type {
  display: block;
  text-align: center;
  color: #333;
  font-size: 0.24rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__container__28IaW .withDrawStyle__venueList__3Kxmt li span[data-v-9c86c1e4]:last-of-type {
  display: block;
  text-align: center;
  color: #a5a9b3;
  font-size: 0.24rem;
  margin-top: 0.1rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__container__28IaW .withDrawStyle__venueList__3Kxmt .withDrawStyle__more__1cr0X[data-v-9c86c1e4] {
  padding: 0.22rem 0;
  width: 25%;
  text-align: center;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__container__28IaW .withDrawStyle__venueList__3Kxmt .withDrawStyle__more__1cr0X span[data-v-9c86c1e4] {
  margin-top: 0 !important;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__container__28IaW .withDrawStyle__venueList__3Kxmt .withDrawStyle__more__1cr0X img[data-v-9c86c1e4] {
  height: 0.32rem;
  margin-top: 0.06rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__infoContainer__3m7KA[data-v-9c86c1e4] {
  margin-top: 0.2rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__bankListInfo__3p8dS[data-v-9c86c1e4] {
  width: 100%;
  background: #fff;
  padding: 0 0.28rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__bankListInfo__3p8dS .withDrawStyle__bankList__3M54S[data-v-9c86c1e4] {
  width: 100%;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__bankListInfo__3p8dS .withDrawStyle__bankList__3M54S li[data-v-9c86c1e4] {
  width: 100%;
  padding: 0.3rem 0;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border-bottom: 0.02rem solid #eee;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__bankListInfo__3p8dS .withDrawStyle__bankList__3M54S li[data-v-9c86c1e4],
.withDrawStyle__box__1Mcwe .withDrawStyle__bankListInfo__3p8dS .withDrawStyle__bankList__3M54S li div[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__bankListInfo__3p8dS .withDrawStyle__bankList__3M54S li div img[data-v-9c86c1e4] {
  width: 0.4rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__bankListInfo__3p8dS .withDrawStyle__bankList__3M54S li div span[data-v-9c86c1e4]:first-of-type {
  font-size: 0.28rem;
  color: #414655;
  margin-left: 0.14rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__bankListInfo__3p8dS .withDrawStyle__bankList__3M54S li div span[data-v-9c86c1e4]:last-of-type {
  font-size: 0.28rem;
  color: #a5a9b3;
  margin-left: 0.2rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__bankListInfo__3p8dS .withDrawStyle__bankList__3M54S li i[data-v-9c86c1e4] {
  display: block;
  width: 0.32rem;
  height: 0.32rem;
  border-radius: 50%;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__bankListInfo__3p8dS .withDrawStyle__bankList__3M54S li i.withDrawStyle__active__GFH5L[data-v-9c86c1e4] {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAilBMVEUAAAAAj/wAlv8Aj/0Aj/wAj/0Aj/wAj/4Aj/wAj/4Akf4Akv4orP8AjvwAjvz////7/f4AkfzZ7/8Ak/y/5P/3+/5kwP5avP4orf4AmP0Anvzy+f/O6v/G5/+24P+c1v/i8/6v3f5Ruf49sv0xr/0Ap/2o2v+n2f+Jzv90xf5wxP5Itf1Gtf0Vq/0jxKrXAAAADnRSTlMAvxDz2cW6opBcUTsD1g9zB3oAAAEPSURBVDjLlZRZcoMwDEBlYzAmRGrolqZbuqR773+9OhCExmNj+r7EzAPZQhJItLPKFIVR1mmI0ygUqCairEoMKFeB0tYYoW6loyuMUmnhrDHBmq22wiTVmLHGGerTvXCW4Y7lvFT2NcQUn90OPceqqpTzRdT1tQfQKeeKiD76SINLONfeeRxCBzbuPE8O2ulIh3PhfJ8RvXFDgOHP30/Wi3eeNuOTgeIU7YkuRuvVOw/sYMHS9tJbGxkKyWD4+q93htScToUHOdwS3UkHlSzBj7fet0fnBiUWXFAcT8fOWEwdlpkdRgOo4Iftd4GjuFXY6kIHm4VNl2/fxYOQH6n8cC4c8/zCyK+e/y6x/Dr8A+dvOm3xaBBuAAAAAElFTkSuQmCC);
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: cover;
}

.webpa .withDrawStyle__box__1Mcwe .withDrawStyle__bankListInfo__3p8dS .withDrawStyle__bankList__3M54S li i.withDrawStyle__active__GFH5L[data-v-9c86c1e4] {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAilBMVEUAAAAAj/wAlv8Aj/0Aj/wAj/0Aj/wAj/4Aj/wAj/4Akf4Akv4orP8AjvwAjvz////7/f4AkfzZ7/8Ak/y/5P/3+/5kwP5avP4orf4AmP0Anvzy+f/O6v/G5/+24P+c1v/i8/6v3f5Ruf49sv0xr/0Ap/2o2v+n2f+Jzv90xf5wxP5Itf1Gtf0Vq/0jxKrXAAAADnRSTlMAvxDz2cW6opBcUTsD1g9zB3oAAAEPSURBVDjLlZRZcoMwDEBlYzAmRGrolqZbuqR773+9OhCExmNj+r7EzAPZQhJItLPKFIVR1mmI0ygUqCairEoMKFeB0tYYoW6loyuMUmnhrDHBmq22wiTVmLHGGerTvXCW4Y7lvFT2NcQUn90OPceqqpTzRdT1tQfQKeeKiD76SINLONfeeRxCBzbuPE8O2ulIh3PhfJ8RvXFDgOHP30/Wi3eeNuOTgeIU7YkuRuvVOw/sYMHS9tJbGxkKyWD4+q93htScToUHOdwS3UkHlSzBj7fet0fnBiUWXFAcT8fOWEwdlpkdRgOo4Iftd4GjuFXY6kIHm4VNl2/fxYOQH6n8cC4c8/zCyK+e/y6x/Dr8A+dvOm3xaBBuAAAAAElFTkSuQmCC);
}

.withDrawStyle__box__1Mcwe .withDrawStyle__bankListInfo__3p8dS h2[data-v-9c86c1e4] {
  color: #333;
  font-weight: 700;
  border-bottom: 0.02rem solid #eee;
  padding: 0.2rem 0;
  font-size: 0.28rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__bankListInfo__3p8dS .withDrawStyle__addButton__3Lunp[data-v-9c86c1e4] {
  width: 100%;
  background: #fff;
  color: #4080ff;
  font-size: 0.28rem;
  font-weight: 500;
  padding: 0.3rem 0;
  text-align: center;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__bankListInfo__3p8dS .withDrawStyle__addButton__3Lunp span[data-v-9c86c1e4] {
  font-size: 0.5rem;
  -webkit-transform: translateY(-0.06rem);
  transform: translateY(-0.06rem);
  margin-right: 0.1rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__bankListInfo__3p8dS .withDrawStyle__buttonFontNormal__1cBNf[data-v-9c86c1e4] {
  font-weight: 400;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__amount__16XU6[data-v-9c86c1e4] {
  width: 100%;
  background: #fff;
  padding: 0 0.28rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__amount__16XU6.withDrawStyle__usdtIcon__3zlet div[data-v-9c86c1e4] {
  padding-left: 0;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__amount__16XU6.withDrawStyle__usdtIcon__3zlet div section[data-v-9c86c1e4]:before {
  width: auto !important;
  background-image: none !important;
  content: 'USDT' !important;
  margin-left: 0.04rem !important;
  margin-top: 0.04rem !important;
  font-family: DINPro !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #414655 !important;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__amount__16XU6.withDrawStyle__usdtIcon__3zlet div section .fake-input[data-v-9c86c1e4],
.withDrawStyle__box__1Mcwe .withDrawStyle__amount__16XU6.withDrawStyle__usdtIcon__3zlet div section .fake-input-placeholder[data-v-9c86c1e4] {
  padding-left: 0.76rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__amount__16XU6.withDrawStyle__usdtIcon__3zlet div section .fake-input-placeholder[data-v-9c86c1e4] {
  margin-top: 0.04rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__virtualFee__huTH0[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: 12px;
  color: #a5a9b3;
  margin-top: 0.26rem;
  line-height: 0.34rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__virtualFee__huTH0 span[data-v-9c86c1e4] {
  font-family: DINPro;
  font-weight: 500;
  color: #ede9e7;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__usdtContainer__3h6jE[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding: 0 0.28rem;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin: 0.2rem 0;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__usdtContainer__3h6jE.withDrawStyle__yibo__1O4eN>div[data-v-9c86c1e4] {
  color: #a1a2a7 !important;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__usdtContainer__3h6jE span[data-v-9c86c1e4] {
  color: #ede9e7;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__withdraw_wrapper__2R7jl[data-v-9c86c1e4] {
  margin-top: 0.2rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__usdtRatio__1Aws-[data-v-9c86c1e4] {
  padding: 0 0.28rem;
  font-size: 0.24rem;
  color: #a5a9b3;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__notice__2Ftl8[data-v-9c86c1e4] {
  width: 100%;
  padding: 0.2rem 0.28rem;
  font-size: 0.24rem;
  color: #a5a9b3;
  word-break: break-all;
}

.withDrawStyle__box__1Mcwe p[data-v-9c86c1e4] {
  text-align: left;
  color: #a5a9b3;
  font-size: 0.24rem;
  line-height: 0.4rem;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__helpTitNYB__3P2fB[data-v-9c86c1e4] {
  padding-top: 0.4rem;
  padding-bottom: 0.8rem;
  padding-left: 0;
  line-height: 0.38rem;
  font-size: 0.28rem;
  text-align: center;
  color: #a5a9b3;
}

.withDrawStyle__box__1Mcwe .withDrawStyle__helpTitNYB__3P2fB span[data-v-9c86c1e4] {
  font-size: 0.28rem;
  color: #ede9e7;
}

.withDrawStyle__tipBox__2E5Zd[data-v-9c86c1e4] {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
}

.withDrawStyle__tipBox__2E5Zd .withDrawStyle__tipWrapper__8Oc5o[data-v-9c86c1e4] {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 80%;
  border-radius: 8px;
  background: #fff;
}

.withDrawStyle__tipBox__2E5Zd .withDrawStyle__tipWrapper__8Oc5o h3[data-v-9c86c1e4] {
  font-size: 0.4rem;
  text-align: center;
  padding: 0.52rem 0;
  letter-spacing: 1px;
}

.withDrawStyle__tipBox__2E5Zd .withDrawStyle__tipWrapper__8Oc5o .withDrawStyle__tipTxt__5mDy_[data-v-9c86c1e4] {
  text-align: center;
  font-size: 0.24rem;
  margin-bottom: 0.4rem;
}

.withDrawStyle__tipBox__2E5Zd .withDrawStyle__tipWrapper__8Oc5o .withDrawStyle__btns__2Btw5[data-v-9c86c1e4] {
  height: 1rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.withDrawStyle__tipBox__2E5Zd .withDrawStyle__tipWrapper__8Oc5o .withDrawStyle__btns__2Btw5 span[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  color: #02a7f0;
  font-size: 0.28rem;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  border-top: 1px solid #cdcdcd;
  border-right: 1px solid #cdcdcd;
}

.withDrawStyle__tipBox__2E5Zd .withDrawStyle__tipWrapper__8Oc5o .withDrawStyle__btns__2Btw5 span[data-v-9c86c1e4]:last-child {
  border-right: none;
}

.withDrawStyle__loading__ypeHg[data-v-9c86c1e4] {
  width: 0.3rem;
  -webkit-animation: withDrawStyle__loading__ypeHg-data-v-9c86c1e4 1s linear infinite;
  animation: withDrawStyle__loading__ypeHg-data-v-9c86c1e4 1s linear infinite;
  -webkit-transform-origin: center center;
  transform-origin: center center;
}

@-webkit-keyframes withDrawStyle__loading__ypeHg-data-v-9c86c1e4 {
  0% {
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }

  to {
    transform: rotate(-1turn);
    -ms-transform: rotate(-1turn);
    -webkit-transform: rotate(-1turn);
  }
}

@keyframes withDrawStyle__loading__ypeHg-data-v-9c86c1e4 {
  0% {
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }

  to {
    transform: rotate(-1turn);
    -ms-transform: rotate(-1turn);
    -webkit-transform: rotate(-1turn);
  }
}

.withDrawStyle__speedDrawOpreation__3mipe .withDrawStyle__limitTimes__5nQ3O[data-v-9c86c1e4] {
  padding: 0 0.28rem;
  height: 0.74rem;
  line-height: 0.74rem;
  font-size: 0.24rem;
  font-family: dinpro;
  color: #a5a9b3;
}

.withDrawStyle__speedDrawOpreation__3mipe .withDrawStyle__unLimitTimes__1ZBoC[data-v-9c86c1e4] {
  height: 0.2rem;
}

.withDrawStyle__speedDrawOpreation__3mipe .withDrawStyle__amounts__xckBW[data-v-9c86c1e4] {
  padding: 0.2rem 0.28rem 0;
  background: #fff;
}

.withDrawStyle__speedDrawOpreation__3mipe .withDrawStyle__amounts__xckBW .withDrawStyle__amount__16XU6[data-v-9c86c1e4] {
  float: left;
  width: 1.58rem;
  height: 0.7rem;
  line-height: 0.7rem;
  font-size: 0.2rem;
  text-align: center;
  color: #414655;
  border-radius: 0.1rem;
  border: 0.02rem solid #eee;
  margin-left: 0.2rem;
  margin-bottom: 0.2rem;
}

.withDrawStyle__speedDrawOpreation__3mipe .withDrawStyle__amounts__xckBW .withDrawStyle__amount__16XU6>span[data-v-9c86c1e4] {
  font-size: 0.28rem;
  font-family: dinpro;
  font-weight: 700;
}

.withDrawStyle__speedDrawOpreation__3mipe .withDrawStyle__amounts__xckBW .withDrawStyle__amount__16XU6[data-v-9c86c1e4]:nth-child(4n + 1) {
  margin-left: 0;
}

.withDrawStyle__speedDrawOpreation__3mipe .withDrawStyle__amounts__xckBW .withDrawStyle__amount__16XU6.withDrawStyle__active__GFH5L[data-v-9c86c1e4] {
  color: #ede9e7;
  border: 0.02rem solid #ede9e7;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAARVBMVEUAAAAAjv0Aj/0Ajv0Aj/4AkP4Ak/8Aj/wAj/0Alf4AlP8Aj/wAj/0AkP4Aj/0Aj/0AjvwAj/4AnP8AjvwAjv0Alf8Ajv3y6AqCAAAAFnRSTlMAgPzdVlEc1c8XEtliXPPopYoF2K4Oakr83AAAAIxJREFUOMul0EkOwzAMQ1E3tpvBbZpO//5HbVABdqCFuQi3jxAIBZGLcpSjHOUoRznKUY5ylKMc5ShHOcrp+fAAep6+I3T8Hq4Rej4XwPsnNn8DOJ/2s3+/hXkE4OA2zBrV16PXxu6LOcW5NXJYJiybdxhyaE5ybo3m8VXdv9iSnfs8z3ns3V/LlmzfDyYJJF+w5cW8AAAAAElFTkSuQmCC) no-repeat 1.22rem 0.36rem;
  background-size: 0.32rem;
}

.withDrawStyle__speedDrawOpreation__3mipe .withDrawStyle__amounts__xckBW[data-v-9c86c1e4]:after {
  content: '';
  display: block;
  visibility: hidden;
  clear: both;
}

.withDrawStyle__speedDrawOpreation__3mipe .withDrawStyle__margin__3jurR[data-v-9c86c1e4] {
  padding: 0 0.28rem 0.2rem;
}

.withDrawStyle__speedDrawOpreation__3mipe .withDrawStyle__margin__3jurR .withDrawStyle__marginNumber__3HTqJ[data-v-9c86c1e4] {
  height: 0.74rem;
  line-height: 0.74rem;
  font-size: 0.24rem;
  color: #414655;
}

.withDrawStyle__speedDrawOpreation__3mipe .withDrawStyle__margin__3jurR .withDrawStyle__marginNumber__3HTqJ>span[data-v-9c86c1e4] {
  color: #db6372;
  font-family: dinpro;
  font-weight: 700;
}

.withDrawStyle__speedDrawOpreation__3mipe .withDrawStyle__margin__3jurR .withDrawStyle__marginTip__3tQGZ[data-v-9c86c1e4] {
  font-size: 0.24rem;
  line-height: 0.4rem;
  color: #a5a9b3;
}

.withDrawStyle__speedDrawOpreation__3mipe .withDrawStyle__margin__3jurR .withDrawStyle__marginTip__3tQGZ>span[data-v-9c86c1e4] {
  color: #db6372;
}

.withDrawStyle__speedDrawOpreation__3mipe p[data-v-9c86c1e4] {
  text-align: center;
}

.withDrawStyle__speedDrawProcessing__9j-DN[data-v-9c86c1e4] {
  width: 6.94rem;
  margin: 0.2rem auto auto;
  background: #fff;
  border-radius: 0.2rem;
  padding-top: 0.6rem;
  padding-bottom: 0.4rem;
  text-align: center;
  font-size: 0.24rem;
}

.withDrawStyle__speedDrawProcessing__9j-DN .withDrawStyle__statusText__1rHGP[data-v-9c86c1e4] {
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.28rem;
  color: #414655;
  font-weight: 700;
}

.withDrawStyle__speedDrawProcessing__9j-DN .withDrawStyle__countDownWrapper__1kQP0[data-v-9c86c1e4] {
  height: 0.4rem;
  margin-top: 0.2rem;
}

.withDrawStyle__speedDrawProcessing__9j-DN .withDrawStyle__countDownWrapper__1kQP0 .withDrawStyle__countdown__3NfgZ[data-v-9c86c1e4] {
  line-height: 0.4rem;
  color: #a5a9b3;
}

.withDrawStyle__speedDrawProcessing__9j-DN .withDrawStyle__countDownWrapper__1kQP0 .withDrawStyle__countdown__3NfgZ>span[data-v-9c86c1e4] {
  color: #ede9e7;
  font-family: dinpro;
  font-weight: 700;
}

.withDrawStyle__speedDrawProcessing__9j-DN>img[data-v-9c86c1e4] {
  display: block;
  width: 3rem;
  height: 3rem;
  margin: 0.2rem auto auto;
}

.withDrawStyle__speedDrawProcessing__9j-DN>p[data-v-9c86c1e4] {
  margin-top: 0.4rem;
  line-height: 0.34rem;
  padding: 0 0.4rem;
  text-align: center;
  color: #414655;
}

.withDrawStyle__speedDrawProcessing__9j-DN>p>span[data-v-9c86c1e4] {
  color: #ede9e7;
}

.withDrawStyle__speedDrawProcessing__9j-DN>p>span.withDrawStyle__money___2z6qJ[data-v-9c86c1e4] {
  color: #db6372 !important;
  font-weight: 700;
}

.withDrawStyle__speedDrawProcessing__9j-DN .withDrawStyle__buttonWrapper__19sKj[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-top: 0.28rem;
  padding-bottom: 0.4rem;
  background: #fff;
  -webkit-box-shadow: 0 -2px 15px rgba(0, 0, 0, 0.05);
  box-shadow: 0 -2px 15px rgba(0, 0, 0, 0.05);
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.withDrawStyle__speedDrawProcessing__9j-DN .withDrawStyle__buttonWrapper__19sKj .withDrawStyle__htxCuiDanButton__3TMMw[data-v-9c86c1e4],
.withDrawStyle__speedDrawProcessing__9j-DN .withDrawStyle__buttonWrapper__19sKj .withDrawStyle__htxDaoZhang__Q0y_x[data-v-9c86c1e4] {
  font-size: 0.28rem;
  width: 2.96rem;
  height: 0.8rem;
  font-family: DINPro;
  text-align: center;
  border-radius: 0.08rem;
  line-height: 0.75rem;
}

.withDrawStyle__speedDrawProcessing__9j-DN .withDrawStyle__buttonWrapper__19sKj .withDrawStyle__htxDaoZhang__Q0y_x[data-v-9c86c1e4] {
  background-image: -webkit-gradient(linear, left top, right top, from(#8ba6fe), to(#567cf7));
  background-image: -webkit-linear-gradient(left, #8ba6fe, #567cf7);
  background-image: linear-gradient(90deg, #8ba6fe, #567cf7);
  color: #fff;
  border: 0.04rem solid #fff;
}

.withDrawStyle__speedDrawProcessing__9j-DN .withDrawStyle__buttonWrapper__19sKj .withDrawStyle__htxCuiDanButton__3TMMw[data-v-9c86c1e4] {
  color: #ede9e7;
  border: 0.04rem solid #ede9e7;
}

.withDrawStyle__speedDrawProcessing__9j-DN .withDrawStyle__buttonWrapper__19sKj .withDrawStyle__buttons__3UONl[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 0.8rem;
  width: 6.14rem;
}

.withDrawStyle__speedDrawProcessing__9j-DN .withDrawStyle__buttonWrapper__19sKj .withDrawStyle__discountText__3MUpo[data-v-9c86c1e4] {
  margin-top: 0.2rem;
  color: #a5a9b3;
  text-align: left;
  height: 0.34rem;
  line-height: 0.34rem;
  padding-left: 0.42rem;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAGAAAAADiNXWtAAACrElEQVRIDbWWz2sTQRTH5003jYg95hLFSwU9eOw/kItoUk1L6WqCl/wDUsEfeBJP4g/wR/8AL9rYldJEmyJ6yD/QowcFe5NchF4qxSSbfb7vxAnrdiJtSAeWmXnzfZ83OzvzZkn9p6ytbZ7qhFyMKCoQ07Qizho5U4uJtzXrxqRH9YWF/I9hGHINVOufsvy7/UCRqjCrCZfG2ohUT7F6RcfS90vFCy1rt/W+ANVg40qk+LU4TSlFXQlS04pq5KktHR43gMjby3KoZkQ3J7o5pTglul3RXS/5s+8tHPU/AaqrjRuRip6JXctATU9O3Lo2n9+OOyTbb9c3p6NO7ykrBFKRVvpm6WrhpdUNAmDmIqqxFNLqXnnx8mMrsnUQsFku36eetdl65d2HOxyph+hronn7JiYA1jxqt79iWQR+1wVvNpte6+evLwBkMyfO53K5EO14+RvkkVmudPocvomGwHxQwOUNXHBodnb2TsoEzuIxbRgTBb5gYKKGKeMaW1EiVvBBPUrdTvgcuttnmM1RAVtjn2Mrynar+/7F74cmJhzAAAtMsDUOETRycGoJ7chdywJbmxMqqBR7WyMTE46WBbacjf7xT6en9p3ChN+BuwOWsM0uOrDnCEIti29m3m7v9hPZEEjHS3XtULxtbfF6wBK2RlbEYJfCmbgo2cahIdIvSNFzV1KL6y0LbA8pV/LPJfkgyCVv4sJku+wXlpI2Vx8sltMGtkY+R8qVfVsMgo9nXA7WtrK60cBj+64aDLDABFuby0LyOVJuyN0nLifYguDzaZlVHg/aw3R9hqRvYYJtdhEuCyQopFwkLJdzJuO1RPMNj2k7RCbZIW0LyzBFY7IptOaiYV5He+zpGlCUcVw4pGmpvDi73CfG3sAajvTKHAQ5ykvfBkE9jt+WP19xdrEk7CASAAAAAElFTkSuQmCC);
  background-repeat: no-repeat;
  background-size: 0.24rem;
  background-position: 0.08rem;
}

.webpa .withDrawStyle__speedDrawProcessing__9j-DN .withDrawStyle__buttonWrapper__19sKj .withDrawStyle__discountText__3MUpo[data-v-9c86c1e4] {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAGAAAAADiNXWtAAACrElEQVRIDbWWz2sTQRTH5003jYg95hLFSwU9eOw/kItoUk1L6WqCl/wDUsEfeBJP4g/wR/8AL9rYldJEmyJ6yD/QowcFe5NchF4qxSSbfb7vxAnrdiJtSAeWmXnzfZ83OzvzZkn9p6ytbZ7qhFyMKCoQ07Qizho5U4uJtzXrxqRH9YWF/I9hGHINVOufsvy7/UCRqjCrCZfG2ohUT7F6RcfS90vFCy1rt/W+ANVg40qk+LU4TSlFXQlS04pq5KktHR43gMjby3KoZkQ3J7o5pTglul3RXS/5s+8tHPU/AaqrjRuRip6JXctATU9O3Lo2n9+OOyTbb9c3p6NO7ykrBFKRVvpm6WrhpdUNAmDmIqqxFNLqXnnx8mMrsnUQsFku36eetdl65d2HOxyph+hronn7JiYA1jxqt79iWQR+1wVvNpte6+evLwBkMyfO53K5EO14+RvkkVmudPocvomGwHxQwOUNXHBodnb2TsoEzuIxbRgTBb5gYKKGKeMaW1EiVvBBPUrdTvgcuttnmM1RAVtjn2Mrynar+/7F74cmJhzAAAtMsDUOETRycGoJ7chdywJbmxMqqBR7WyMTE46WBbacjf7xT6en9p3ChN+BuwOWsM0uOrDnCEIti29m3m7v9hPZEEjHS3XtULxtbfF6wBK2RlbEYJfCmbgo2cahIdIvSNFzV1KL6y0LbA8pV/LPJfkgyCVv4sJku+wXlpI2Vx8sltMGtkY+R8qVfVsMgo9nXA7WtrK60cBj+64aDLDABFuby0LyOVJuyN0nLifYguDzaZlVHg/aw3R9hqRvYYJtdhEuCyQopFwkLJdzJuO1RPMNj2k7RCbZIW0LyzBFY7IptOaiYV5He+zpGlCUcVw4pGmpvDi73CfG3sAajvTKHAQ5ykvfBkE9jt+WP19xdrEk7CASAAAAAElFTkSuQmCC);
}

.withDrawStyle__speedDrawProcessing__9j-DN .withDrawStyle__buttonWrapper__19sKj .withDrawStyle__discountText__3MUpo>span[data-v-9c86c1e4] {
  color: #db6372;
  font-family: dinpro;
  font-weight: 700;
}

p.withDrawStyle__jumpKf__1aZ9k[data-v-9c86c1e4] {
  text-align: center;
  margin-top: 0.4rem;
  color: #a5a9b3;
  line-height: 0.4rem;
  padding-bottom: 0.6rem;
}

p.withDrawStyle__jumpKf__1aZ9k>span[data-v-9c86c1e4] {
  color: #ede9e7;
}

p.withDrawStyle__warmTipContent__149Zr[data-v-9c86c1e4] {
  font-size: 0.28rem;
}

.withDrawStyle__withdrawalWrapper__DWXqZ[data-v-9c86c1e4] {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
}

.withDrawStyle__withdrawalWrapper__DWXqZ .withDrawStyle__withdrawContainer__23UPw[data-v-9c86c1e4] {
  position: absolute;
  left: 0;
  right: 0;
  top: 10%;
  width: 80%;
  margin: auto;
  border-radius: 8px;
  background: #fff;
}

.withDrawStyle__withdrawalWrapper__DWXqZ .withDrawStyle__withdrawContainer__23UPw h3[data-v-9c86c1e4] {
  font-size: 0.4rem;
  text-align: center;
  padding: 0.52rem 0;
  letter-spacing: 1px;
}

.withDrawStyle__withdrawalWrapper__DWXqZ .withDrawStyle__withdrawContainer__23UPw .withDrawStyle__extremBox__3N3Tw .withDrawStyle__headerTxt__zB6Eh[data-v-9c86c1e4] {
  text-align: center;
  height: 100px;
  padding: 10px 20px;
}

.withDrawStyle__withdrawalWrapper__DWXqZ .withDrawStyle__withdrawContainer__23UPw .withDrawStyle__extremBox__3N3Tw .withDrawStyle__headerTxt__zB6Eh span[data-v-9c86c1e4] {
  display: inline-block;
  line-height: 20px;
  font-size: 14px;
}

.withDrawStyle__withdrawalWrapper__DWXqZ .withDrawStyle__withdrawContainer__23UPw .withDrawStyle__extremBox__3N3Tw .withDrawStyle__sureBtn__2cXhy[data-v-9c86c1e4] {
  display: block;
  height: 45px;
  line-height: 45px;
  text-align: center;
  color: #169bd5;
  letter-spacing: 1px;
  font-size: 18px;
  border-top: 1px solid #cdcdcd;
}

.withDrawStyle__withdrawalWrapper__DWXqZ .withDrawStyle__withdrawContainer__23UPw .withDrawStyle__tipTxt__5mDy_[data-v-9c86c1e4] {
  text-align: center;
  font-size: 0.24rem;
}

.withDrawStyle__withdrawalWrapper__DWXqZ .withDrawStyle__withdrawContainer__23UPw .withDrawStyle__inputGroup__31CeR[data-v-9c86c1e4] {
  margin: 0.4rem auto;
  width: 76%;
}

.withDrawStyle__withdrawalWrapper__DWXqZ .withDrawStyle__withdrawContainer__23UPw .withDrawStyle__wrongTip__a2tCT[data-v-9c86c1e4] {
  color: #d9001b;
  text-align: center;
  font-size: 0.24rem;
  margin: auto;
}

.withDrawStyle__withdrawalWrapper__DWXqZ .withDrawStyle__withdrawContainer__23UPw .withDrawStyle__forgetPwd__BNkUS[data-v-9c86c1e4] {
  margin: 0.2rem auto;
  text-align: center;
  color: #02a7f0;
  font-size: 0.24rem;
  text-decoration: underline;
}

.withDrawStyle__withdrawalWrapper__DWXqZ .withDrawStyle__withdrawContainer__23UPw .withDrawStyle__btnGroup__zrYb2[data-v-9c86c1e4] {
  width: 75%;
  text-align: center;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin: 0 auto 0.24rem;
}

.withDrawStyle__withdrawalWrapper__DWXqZ .withDrawStyle__withdrawContainer__23UPw .withDrawStyle__btnGroup__zrYb2 uni-button[data-v-9c86c1e4] {
  padding: 0.28rem 0.72rem;
  background: transparent;
  border: 1px solid #ede9e7;
  border-radius: 5px;
  letter-spacing: 1px;
  color: #ede9e7;
}

.withDrawStyle__withdrawalWrapper__DWXqZ .withDrawStyle__withdrawContainer__23UPw .withDrawStyle__btnGroup__zrYb2 uni-button.withDrawStyle__btnConfirm__1I5eq[data-v-9c86c1e4] {
  background-color: #ede9e7;
  color: #fff;
  border-color: #ede9e7;
}

.index__progressBarContainer__232Zt[data-v-9c86c1e4] {
  margin: 0 0.24rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.index__progressBarContainer__232Zt .index__part__1_yOJ[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.index__progressBarContainer__232Zt .index__part__1_yOJ .index__text__4beZM[data-v-9c86c1e4] {
  margin-bottom: 0.16rem;
  color: #a5a9b3;
  text-align: center;
}

.index__progressBarContainer__232Zt .index__part__1_yOJ .index__visual__3Tovx[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 0.48rem;
}

.index__progressBarContainer__232Zt .index__part__1_yOJ .index__visual__3Tovx .index__line__2KNYW[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 0.007rem;
  background: #cbced8;
}

.index__progressBarContainer__232Zt .index__part__1_yOJ.index__highlight__1UMDz .index__text__4beZM[data-v-9c86c1e4] {
  color: #ede9e7;
}

.index__progressBarContainer__232Zt .index__part__1_yOJ.index__highlight__1UMDz .index__line__2KNYW[data-v-9c86c1e4],
.index__progressBarContainer__232Zt .index__part__1_yOJ.index__highlightNext__ExqAc .index__line__2KNYW[data-v-9c86c1e4]:first-child {
  background: #ede9e7;
}

.index__progressBarContainer__232Zt .index__part__1_yOJ:first-child .index__visual__3Tovx .index__line__2KNYW[data-v-9c86c1e4]:first-child,
.index__progressBarContainer__232Zt .index__part__1_yOJ:last-child .index__visual__3Tovx .index__line__2KNYW[data-v-9c86c1e4]:last-child {
  background: transparent;
}

.ConfirmAccountModal__modal__3tszh[data-v-9c86c1e4] {
  width: 5.6rem;
}

.ConfirmAccountModal__modal__3tszh .am-modal-body[data-v-9c86c1e4] {
  padding: 0 0.4rem 0.4rem !important;
}

.ConfirmAccountModal__modal__3tszh.ConfirmAccountModal__yibo__3na8F .am-modal-content[data-v-9c86c1e4] {
  background: #222536 !important;
}

.ConfirmAccountModal__container__2ivgr[data-v-9c86c1e4] {
  width: 100%;
  color: #414655;
  text-align: left;
}

.ConfirmAccountModal__container__2ivgr *[data-v-9c86c1e4] {
  font-size: 0.28rem;
}

.ConfirmAccountModal__container__2ivgr .ConfirmAccountModal__title__mYzMO[data-v-9c86c1e4] {
  color: #414655;
  font-size: 0.36rem;
  margin: 0.1rem 0;
  text-align: center;
  height: 0.5rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
}

.ConfirmAccountModal__container__2ivgr .ConfirmAccountModal__title__mYzMO img[data-v-9c86c1e4] {
  width: 0.48rem;
  height: 0.48rem;
  position: absolute;
  right: 0;
}

.ConfirmAccountModal__container__2ivgr .ConfirmAccountModal__subTitle__2slvE[data-v-9c86c1e4] {
  color: #414655;
  margin: 0.1rem 0;
}

.ConfirmAccountModal__container__2ivgr .ConfirmAccountModal__subTitle2__1pHUw[data-v-9c86c1e4] {
  color: #414655;
  text-align: center;
  margin: 0.1rem 0 0.4rem;
}

.ConfirmAccountModal__container__2ivgr .ConfirmAccountModal__list__2t1gw[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin: 0.24rem 0;
}

.ConfirmAccountModal__container__2ivgr .ConfirmAccountModal__list__2t1gw span[data-v-9c86c1e4] {
  font-family: DINPro-Medium !important;
  width: 1.08rem;
  height: 0.64rem;
  font-size: 0.28rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #414655;
  border: 0.02rem solid #eee;
  border-radius: 0.1rem;
  font-weight: 700;
}

.ConfirmAccountModal__container__2ivgr .ConfirmAccountModal__list__2t1gw span[data-v-9c86c1e4]:last-child {
  font-size: 0.2rem;
  font-weight: 400;
}

.ConfirmAccountModal__container__2ivgr .ConfirmAccountModal__list__2t1gw span.ConfirmAccountModal__active__10Rah[data-v-9c86c1e4] {
  color: #ede9e7 !important;
  border: 0.02rem solid #ede9e7 !important;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAARVBMVEUAAAAAjv0Aj/0Ajv0Aj/4AkP4Ak/8Aj/wAj/0Alf4AlP8Aj/wAj/0AkP4Aj/0Aj/0AjvwAj/4AnP8AjvwAjv0Alf8Ajv3y6AqCAAAAFnRSTlMAgPzdVlEc1c8XEtliXPPopYoF2K4Oakr83AAAAIxJREFUOMul0EkOwzAMQ1E3tpvBbZpO//5HbVABdqCFuQi3jxAIBZGLcpSjHOUoRznKUY5ylKMc5ShHOcrp+fAAep6+I3T8Hq4Rej4XwPsnNn8DOJ/2s3+/hXkE4OA2zBrV16PXxu6LOcW5NXJYJiybdxhyaE5ybo3m8VXdv9iSnfs8z3ns3V/LlmzfDyYJJF+w5cW8AAAAAElFTkSuQmCC) no-repeat 100% 100%;
  background-size: 0.32rem;
}

.ConfirmAccountModal__container__2ivgr .ConfirmAccountModal__msg__sEBSE[data-v-9c86c1e4] {
  color: #a5a9b3;
  font-size: 0.24rem;
  margin: 0.24rem 0 0.32rem;
}

.ConfirmAccountModal__container__2ivgr .ConfirmAccountModal__btn__3p6Qv[data-v-9c86c1e4] {
  height: 0.8rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background: #ede9e7;
  color: #fff;
  opacity: 0.5;
  border-radius: 0.1rem;
}

.ConfirmAccountModal__container__2ivgr .ConfirmAccountModal__btn__3p6Qv.ConfirmAccountModal__active__10Rah[data-v-9c86c1e4] {
  opacity: 1;
}

.ConfirmAccountModal__container__2ivgr .ConfirmAccountModal__btn2__1mkNe[data-v-9c86c1e4] {
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.ConfirmAccountModal__container__2ivgr .ConfirmAccountModal__btn2__1mkNe[data-v-9c86c1e4],
.ConfirmAccountModal__container__2ivgr .ConfirmAccountModal__btn2__1mkNe>div[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.ConfirmAccountModal__container__2ivgr .ConfirmAccountModal__btn2__1mkNe>div[data-v-9c86c1e4] {
  height: 0.8rem;
  width: 2.24rem;
  border-radius: 0.1rem;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.ConfirmAccountModal__container__2ivgr .ConfirmAccountModal__btn2__1mkNe>div[data-v-9c86c1e4]:first-child {
  color: #ede9e7;
  border: 0.02rem solid #ede9e7;
}

.ConfirmAccountModal__container__2ivgr .ConfirmAccountModal__btn2__1mkNe>div[data-v-9c86c1e4]:last-child {
  color: #fff;
  background: #ede9e7;
}

.ConfirmAccountModal__container__2ivgr.ConfirmAccountModal__yibo__3na8F[data-v-9c86c1e4] {
  color: #a1a2a7;
}

.ConfirmAccountModal__container__2ivgr.ConfirmAccountModal__yibo__3na8F .ConfirmAccountModal__title__mYzMO[data-v-9c86c1e4] {
  color: #deb489;
}

.ConfirmAccountModal__container__2ivgr.ConfirmAccountModal__yibo__3na8F .ConfirmAccountModal__subTitle2__1pHUw[data-v-9c86c1e4],
.ConfirmAccountModal__container__2ivgr.ConfirmAccountModal__yibo__3na8F .ConfirmAccountModal__subTitle__2slvE[data-v-9c86c1e4] {
  color: #a1a2a7;
}

.ConfirmAccountModal__container__2ivgr.ConfirmAccountModal__yibo__3na8F .ConfirmAccountModal__list__2t1gw span[data-v-9c86c1e4] {
  color: #a1a2a7;
  border-color: rgba(102, 108, 110, 0.5098);
}

.ConfirmAccountModal__container__2ivgr.ConfirmAccountModal__yibo__3na8F .ConfirmAccountModal__msg__sEBSE[data-v-9c86c1e4] {
  color: #a1a2a7;
}

.ConfirmAccountModal__container__2ivgr.ConfirmAccountModal__yibo__3na8F .ConfirmAccountModal__btn2__1mkNe>div[data-v-9c86c1e4]:last-child,
.ConfirmAccountModal__container__2ivgr.ConfirmAccountModal__yibo__3na8F .ConfirmAccountModal__btn__3p6Qv[data-v-9c86c1e4] {
  color: #79420d;
}

.ImgStyle__main__2Py64[data-v-9c86c1e4] {
  padding: 0.2rem 0.28rem;
  position: relative;
}

.ImgStyle__main__2Py64 uni-input[data-v-9c86c1e4] {
  display: none;
}

.ImgStyle__main__2Py64 .ImgStyle__box__3bYui[data-v-9c86c1e4],
.ImgStyle__main__2Py64 .ImgStyle__box__3bYui>div[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.ImgStyle__main__2Py64 .ImgStyle__box__3bYui>div[data-v-9c86c1e4] {
  margin-top: 0.24rem;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.ImgStyle__main__2Py64 .ImgStyle__box__3bYui>div>div[data-v-9c86c1e4],
.ImgStyle__main__2Py64 .ImgStyle__box__3bYui>div img[data-v-9c86c1e4] {
  height: 1rem;
  width: 1rem;
}

.ImgStyle__main__2Py64 .ImgStyle__box__3bYui>div>div[data-v-9c86c1e4] {
  position: relative;
}

.ImgStyle__main__2Py64 .ImgStyle__box__3bYui>div>div[data-v-9c86c1e4]:last-child {
  margin: 0;
}

.ImgStyle__main__2Py64 .ImgStyle__box__3bYui>div>div p[data-v-9c86c1e4] {
  position: absolute;
  font-size: 0.24rem;
  width: 0.26rem;
  height: 0.26rem;
  border-radius: 50%;
  background: #db6372;
  color: #fff;
  text-align: center;
  line-height: 0.22rem;
  top: -0.12rem;
  right: -0.12rem;
}

.ImgStyle__main__2Py64 .ImgStyle__box__3bYui i[data-v-9c86c1e4] {
  width: 0.36rem;
  margin-left: 0.16rem;
  color: #cbced8;
  font-size: 0.24rem;
}

.ImgStyle__main__2Py64.ImgStyle__yibo__2OXwA .ImgStyle__box__3bYui>div>div p[data-v-9c86c1e4] {
  background: #deb489;
}

.ImgStyle__main__2Py64.ImgStyle__yibo__2OXwA .ImgStyle__box__3bYui i[data-v-9c86c1e4] {
  color: #6c6e82;
}

.NotAccountModalStyle__modal__1CYZD.NotAccountModalStyle__yibo__2We7m .am-modal-content[data-v-9c86c1e4] {
  background: #263350;
}

.NotAccountModalStyle__modal__1CYZD .am-modal-content[data-v-9c86c1e4] {
  border-radius: 0.2rem 0.2rem 0 0;
}

.NotAccountModalStyle__main__32FcP[data-v-9c86c1e4] {
  background: #fff;
  text-align: left;
  border-radius: 0.2rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.NotAccountModalStyle__main__32FcP *[data-v-9c86c1e4] {
  font-family: PingFangSC;
}

.NotAccountModalStyle__main__32FcP .NotAccountModalStyle__head__1PZLD[data-v-9c86c1e4] {
  height: 1rem;
  padding: 0 0.28rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.NotAccountModalStyle__main__32FcP .NotAccountModalStyle__head__1PZLD span[data-v-9c86c1e4] {
  color: #ede9e7;
  font-size: 0.32rem;
}

.NotAccountModalStyle__main__32FcP .NotAccountModalStyle__msg__3lnWA[data-v-9c86c1e4] {
  background: #f8f8f8;
  padding: 0.2rem 0.28rem;
  font-size: 0.28rem;
  line-height: 0.4rem;
  color: #414655;
}

.NotAccountModalStyle__main__32FcP .NotAccountModalStyle__msg__3lnWA span[data-v-9c86c1e4] {
  font-size: 0.24rem;
  line-height: 0.34rem;
  color: #cbced8;
}

.NotAccountModalStyle__main__32FcP .NotAccountModalStyle__content__2ssjb uni-textarea[data-v-9c86c1e4] {
  height: 4rem;
  width: 100%;
  padding: 0.3rem;
  font-size: 0.28rem;
  line-height: 0.4rem;
  color: #626571;
  font-weight: 400;
  border: none;
}

.NotAccountModalStyle__main__32FcP .NotAccountModalStyle__content__2ssjb uni-textarea[data-v-9c86c1e4]::-webkit-input-placeholder {
  color: #a5a9b3;
  font-family: DINPro;
}

.NotAccountModalStyle__main__32FcP .NotAccountModalStyle__content__2ssjb p[data-v-9c86c1e4] {
  padding: 0 0.28rem;
  text-align: right;
  font-family: DINPro;
  font-size: 0.24rem;
  line-height: 0.28rem;
  color: #cbced8;
}

.NotAccountModalStyle__main__32FcP .NotAccountModalStyle__pr__aDqec[data-v-9c86c1e4] {
  margin: 0.16rem 0.28rem 0;
  height: 0.02rem;
  background: #eee;
}

.NotAccountModalStyle__main__32FcP .NotAccountModalStyle__tip__3QvA_[data-v-9c86c1e4] {
  padding: 0 0.28rem;
  font-family: DINPro;
  font-size: 0.24rem;
  line-height: 0.28rem;
  color: #cbced8;
  margin: 0.2rem 0 0.24rem;
}

.NotAccountModalStyle__main__32FcP .NotAccountModalStyle__split__DOhXE[data-v-9c86c1e4] {
  height: 0.2rem;
  background: #f8f8f8;
}

.NotAccountModalStyle__main__32FcP .NotAccountModalStyle__foot__2PkUX[data-v-9c86c1e4] {
  padding: 0.36rem 0.28rem 0.72rem;
}

.NotAccountModalStyle__main__32FcP .NotAccountModalStyle__foot__2PkUX>div[data-v-9c86c1e4] {
  font-size: 0.36rem;
  color: #fff;
  background: #4080ff;
  border-radius: 0.1rem;
  height: 1.12rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  opacity: 0.5;
}

.NotAccountModalStyle__main__32FcP .NotAccountModalStyle__foot__2PkUX>div.NotAccountModalStyle__active__2IUWV[data-v-9c86c1e4] {
  opacity: 1;
}

.NotAccountModalStyle__main__32FcP.NotAccountModalStyle__yibo__2We7m[data-v-9c86c1e4] {
  background: #263350;
}

.NotAccountModalStyle__main__32FcP.NotAccountModalStyle__yibo__2We7m .NotAccountModalStyle__msg__3lnWA[data-v-9c86c1e4] {
  background: #1c263d;
  color: #848da4;
}

.NotAccountModalStyle__main__32FcP.NotAccountModalStyle__yibo__2We7m .NotAccountModalStyle__msg__3lnWA span[data-v-9c86c1e4] {
  color: #848da4;
}

.NotAccountModalStyle__main__32FcP.NotAccountModalStyle__yibo__2We7m .NotAccountModalStyle__content__2ssjb uni-textarea[data-v-9c86c1e4] {
  background: #263350;
  color: #e8e8e8;
}

.NotAccountModalStyle__main__32FcP.NotAccountModalStyle__yibo__2We7m .NotAccountModalStyle__content__2ssjb uni-textarea[data-v-9c86c1e4]::-webkit-input-placeholder {
  color: #848da4;
  font-family: DINPro;
}

.NotAccountModalStyle__main__32FcP.NotAccountModalStyle__yibo__2We7m .NotAccountModalStyle__content__2ssjb p[data-v-9c86c1e4] {
  color: #6c6e82;
}

.NotAccountModalStyle__main__32FcP.NotAccountModalStyle__yibo__2We7m .NotAccountModalStyle__pr__aDqec[data-v-9c86c1e4] {
  background: rgba(0, 0, 0, 0.0001);
  -webkit-box-shadow: inset 0 0.5px 0 #35446d;
  box-shadow: inset 0 0.5px 0 #35446d;
}

.NotAccountModalStyle__main__32FcP.NotAccountModalStyle__yibo__2We7m .NotAccountModalStyle__tip__3QvA_[data-v-9c86c1e4] {
  color: #848da4;
}

.NotAccountModalStyle__main__32FcP.NotAccountModalStyle__yibo__2We7m .NotAccountModalStyle__split__DOhXE[data-v-9c86c1e4] {
  background: #1c263d;
}

.NotAccountModalStyle__main__32FcP.NotAccountModalStyle__yibo__2We7m .NotAccountModalStyle__foot__2PkUX>div[data-v-9c86c1e4] {
  background: -webkit-gradient(linear, right top, left top, from(#e9b57b), to(#ffdbb9));
  background: -webkit-linear-gradient(to left, #e9b57b, #ffdbb9);
  background: linear-gradient(270deg, #e9b57b, #ffdbb9);
  color: #79420d;
}

.NotAccountModalStyle__mask__YPDEL[data-v-9c86c1e4] {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #000;
}

.NotAccountModalStyle__mask__YPDEL .NotAccountModalStyle__carousel__3L2mf[data-v-9c86c1e4] {
  height: 100% !important;
}

.NotAccountModalStyle__mask__YPDEL .NotAccountModalStyle__carousel__3L2mf>div[data-v-9c86c1e4] {
  width: 100%;
  height: 100% !important;
}

.NotAccountModalStyle__mask__YPDEL .NotAccountModalStyle__carousel__3L2mf>div ul[data-v-9c86c1e4],
.NotAccountModalStyle__mask__YPDEL .NotAccountModalStyle__carousel__3L2mf>div ul li[data-v-9c86c1e4] {
  height: 100% !important;
}

.NotAccountModalStyle__mask__YPDEL .NotAccountModalStyle__carousel__3L2mf>div ul div[data-v-9c86c1e4] {
  width: 100%;
  height: 100% !important;
  position: relative;
}

.NotAccountModalStyle__mask__YPDEL .NotAccountModalStyle__carousel__3L2mf>div ul div img[data-v-9c86c1e4] {
  max-width: 100%;
  max-height: 80%;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
}

.OrderSplit__bg__2-Amr[data-v-9c86c1e4] {
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  min-height: calc(100vh - 0.88rem);
}

.OrderSplit__bg__2-Amr .OrderSplit__mask__3qU-I[data-v-9c86c1e4] {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 100;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: end;
  -webkit-align-items: end;
  -ms-flex-align: end;
  align-items: end;
}

.OrderSplit__bg__2-Amr .OrderSplit__mask__3qU-I img[data-v-9c86c1e4]:first-child {
  width: 7rem;
  height: 4.3rem;
  margin-top: 3.1rem;
  -webkit-align-self: center;
  -ms-flex-item-align: center;
  align-self: center;
}

.OrderSplit__bg__2-Amr .OrderSplit__mask__3qU-I img:first-child.OrderSplit__step2__1GBNF[data-v-9c86c1e4] {
  margin-top: 6.68rem;
  -webkit-align-self: end;
  -ms-flex-item-align: end;
  align-self: end;
}

.OrderSplit__bg__2-Amr .OrderSplit__mask__3qU-I img[data-v-9c86c1e4]:last-child {
  width: 2.2rem;
  height: 0.8rem;
  margin-top: 0.8rem;
  margin-right: 0.64rem;
}

.OrderSplit__bg__2-Amr .OrderSplit__mask__3qU-I>div[data-v-9c86c1e4] {
  height: 2rem;
}

.OrderSplit__bg__2-Amr .OrderSplit__topTip__1SrIB[data-v-9c86c1e4] {
  padding: 0.1rem 0;
  background: #f8f8f8;
}

.OrderSplit__bg__2-Amr .OrderSplit__topTip__1SrIB .OrderSplit__timeout__Q8e1m[data-v-9c86c1e4] {
  text-align: center;
  color: #db6372;
  font-size: 0.24rem;
  height: 0.4rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  line-height: 0.4rem;
}

.OrderSplit__bg__2-Amr .OrderSplit__topTip__1SrIB .OrderSplit__timeout__Q8e1m img[data-v-9c86c1e4] {
  width: 0.24rem;
  height: 0.24rem;
  margin-right: 0.1rem;
}

.OrderSplit__bg__2-Amr *[data-v-9c86c1e4] {
  font-family: PingFangSC !important;
}

.OrderSplit__bg__2-Amr .OrderSplit__info__1kz8C[data-v-9c86c1e4] {
  padding: 0.4rem;
  background: #fff;
}

.OrderSplit__bg__2-Amr .OrderSplit__info__1kz8C p[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  height: 0.7rem;
  font-family: PingFangSC;
}

.OrderSplit__bg__2-Amr .OrderSplit__info__1kz8C p[data-v-9c86c1e4]:last-child {
  margin: 0;
}

.OrderSplit__bg__2-Amr .OrderSplit__info__1kz8C p span[data-v-9c86c1e4] {
  font-size: 0.28rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #a5a9b3;
}

.OrderSplit__bg__2-Amr .OrderSplit__info__1kz8C p span[data-v-9c86c1e4]:last-child {
  color: #333;
  font-family: DINPro;
}

.OrderSplit__bg__2-Amr .OrderSplit__info__1kz8C p span.OrderSplit__money__3rA6p[data-v-9c86c1e4] {
  color: #ede9e7;
  font-family: DINPro-Medium !important;
}

.OrderSplit__bg__2-Amr .OrderSplit__info__1kz8C p span b[data-v-9c86c1e4] {
  margin-left: 0.1rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.OrderSplit__bg__2-Amr .OrderSplit__info__1kz8C p span>img[data-v-9c86c1e4] {
  width: 0.42rem;
  height: 0.42rem;
  margin-right: 0.2rem;
}

.OrderSplit__bg__2-Amr .OrderSplit__info__1kz8C .OrderSplit__red__34SlB[data-v-9c86c1e4] {
  color: #db6372;
  font-size: 0.24rem;
  margin-top: -0.1rem;
}

.OrderSplit__bg__2-Amr .OrderSplit__msg__1NAuF[data-v-9c86c1e4] {
  color: #414655;
  font-size: 0.28rem;
  background: #f8f8f8;
  padding: 0.2rem 0.4rem;
  text-align: center;
  font-family: PingFangSC-Medium !important;
  line-height: 0.4rem;
}

.OrderSplit__bg__2-Amr .OrderSplit__msg__1NAuF span[data-v-9c86c1e4] {
  color: #ede9e7;
  font-size: 0.28rem;
}

.OrderSplit__bg__2-Amr .OrderSplit__tip__1abzM[data-v-9c86c1e4] {
  background: #fff;
  padding: 0.2rem 0.4rem;
}

.OrderSplit__bg__2-Amr .OrderSplit__tip__1abzM .OrderSplit__progressBarWrapper__3UDgg[data-v-9c86c1e4] {
  margin: 0.32rem 0 0.36rem;
}

.OrderSplit__bg__2-Amr .OrderSplit__tip__1abzM p[data-v-9c86c1e4] {
  background: #f8f8f8;
  border-radius: 0.35rem;
  text-align: center;
  color: #414655;
  font-size: 0.24rem;
  height: 0.64rem;
  line-height: 0.24rem;
  margin: 0;
  padding: 0.2rem 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.OrderSplit__bg__2-Amr .OrderSplit__tip__1abzM p span[data-v-9c86c1e4] {
  color: #db6372;
}

.OrderSplit__bg__2-Amr .OrderSplit__tip__1abzM p img[data-v-9c86c1e4] {
  width: 0.24rem;
  height: 0.24rem;
  margin-right: 0.08rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y[data-v-9c86c1e4] {
  background: #fff;
  padding: 0 0.4rem;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border-bottom: 0.02rem solid #eee;
  height: 2.24rem;
  padding: 0.6rem 0 0;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__left__1RWQR .OrderSplit__money__3rA6p[data-v-9c86c1e4],
.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__left__1RWQR .OrderSplit__money___UQHpW[data-v-9c86c1e4] {
  font-family: DINPro-Medium !important;
  font-size: 0.56rem;
  color: #414655;
  height: 0.72rem;
  line-height: 0.72rem;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__left__1RWQR .OrderSplit__money__3rA6p span[data-v-9c86c1e4],
.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__left__1RWQR .OrderSplit__money___UQHpW span[data-v-9c86c1e4] {
  margin-left: 0.1rem;
  font-size: 0.28rem;
  font-family: PingFangSC;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__left__1RWQR .OrderSplit__money___UQHpW[data-v-9c86c1e4] {
  color: #ede9e7;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__left__1RWQR .OrderSplit__dzje__1ipsM[data-v-9c86c1e4] {
  font-size: 0.24rem;
  color: #a5a9b3;
  margin-top: 0.1rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 0.48rem;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__left__1RWQR .OrderSplit__dzje__1ipsM span[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 0.24rem;
  height: 0.48rem;
  line-height: 0.48rem;
  width: 1.36rem;
  margin-left: 0.2rem;
  text-align: center;
  border-radius: 0.24rem;
  border: 0.02rem solid #eee;
  color: #414655;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__left__1RWQR .OrderSplit__dzje__1ipsM span.OrderSplit__active__3cbGT[data-v-9c86c1e4] {
  color: #a5a9b3;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm>div[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: end;
  -webkit-align-items: flex-end;
  -ms-flex-align: end;
  align-items: flex-end;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__btn__22BGR[data-v-9c86c1e4] {
  width: 2.72rem;
  height: 0.8rem;
  border-radius: 0.08rem;
  font-size: 0.28rem;
  position: relative;
  background: #fff;
  color: #ede9e7;
  border: 0.04rem solid #ede9e7;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__btn__22BGR[data-v-9c86c1e4],
.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__btn__22BGR span[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__btn__22BGR span[data-v-9c86c1e4] {
  position: absolute;
  top: -0.2rem;
  left: 0.1rem;
  height: 0.32rem;
  line-height: 0.32rem;
  padding: 0 0.1rem;
  border-radius: 0.18rem;
  background-color: #db6372;
  font-family: DINPro;
  font-size: 0.2rem;
  color: #fff;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__btn__22BGR span img[data-v-9c86c1e4] {
  width: 0.2rem;
  height: 0.2rem;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__time__lIlZy[data-v-9c86c1e4] {
  text-align: right;
  font-family: DINPro;
  font-size: 0.24rem;
  color: #a5a9b3;
  margin-top: 0.1rem;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__time__lIlZy span[data-v-9c86c1e4] {
  color: #ede9e7;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__time__lIlZy span[data-v-9c86c1e4]:first-child {
  margin-right: 0.16rem;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__success__2kKep .OrderSplit__btn__22BGR[data-v-9c86c1e4] {
  background-color: #ede9e7;
  color: #fff;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__big__3vFvi[data-v-9c86c1e4] {
  font-size: 0.28rem;
  color: #333;
  height: 0.72rem;
  line-height: 0.72rem;
  font-weight: 700;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__blur__111q- .OrderSplit__title__38HEF[data-v-9c86c1e4],
.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__red__34SlB .OrderSplit__title__38HEF[data-v-9c86c1e4] {
  height: 0.72rem;
  line-height: 0.72rem;
  font-weight: 700;
  color: #db6372;
  font-size: 0.28rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__blur__111q- .OrderSplit__title__38HEF img[data-v-9c86c1e4],
.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__red__34SlB .OrderSplit__title__38HEF img[data-v-9c86c1e4] {
  width: 0.32rem;
  height: 0.32rem;
  margin-right: 0.08rem;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__blur__111q- .OrderSplit__subtitle__3NZ3u[data-v-9c86c1e4],
.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__blur__111q- .OrderSplit__subtitle___1AIUi[data-v-9c86c1e4],
.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__red__34SlB .OrderSplit__subtitle__3NZ3u[data-v-9c86c1e4],
.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__red__34SlB .OrderSplit__subtitle___1AIUi[data-v-9c86c1e4] {
  font-size: 0.24rem;
  color: #a5a9b3;
  width: 3.12rem;
  text-align: right;
  margin-top: -0.06rem;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__blur__111q- .OrderSplit__subtitle___1AIUi[data-v-9c86c1e4],
.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__red__34SlB .OrderSplit__subtitle___1AIUi[data-v-9c86c1e4] {
  width: auto;
  margin-top: 0.1rem;
  height: 0.48rem;
  line-height: 0.48rem;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__blur__111q- .OrderSplit__title__38HEF[data-v-9c86c1e4] {
  color: #333;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__blur__111q- .OrderSplit__subtitle__3NZ3u[data-v-9c86c1e4] {
  width: auto;
  margin-top: 0.1rem;
  height: 0.48rem;
  line-height: 0.48rem;
}

.OrderSplit__bg__2-Amr .OrderSplit__list__xBE7y .OrderSplit__item__3InZN[data-v-9c86c1e4]:last-child {
  border: 0;
}

.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__topTip__1SrIB[data-v-9c86c1e4] {
  background: #161a28;
}

.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__info__1kz8C[data-v-9c86c1e4] {
  background: #222536;
}

.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__info__1kz8C p span[data-v-9c86c1e4] {
  color: #6c6e82;
}

.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__info__1kz8C p span[data-v-9c86c1e4]:last-child {
  color: #dedede;
}

.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__info__1kz8C p span.OrderSplit__money__3rA6p[data-v-9c86c1e4] {
  color: #ede9e7;
}

.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__msg__1NAuF[data-v-9c86c1e4] {
  color: #dedede;
  background: #161a28;
}

.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__tip__1abzM[data-v-9c86c1e4] {
  background: #222536;
}

.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__tip__1abzM p[data-v-9c86c1e4] {
  background: #161a28;
  color: #6c6e82;
}

.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__list__xBE7y[data-v-9c86c1e4] {
  background: #222536;
}

.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__list__xBE7y .OrderSplit__item__3InZN[data-v-9c86c1e4] {
  border-bottom: 0.02rem solid #373a4c;
}

.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__left__1RWQR .OrderSplit__money__3rA6p[data-v-9c86c1e4] {
  color: #dedede;
}

.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__left__1RWQR .OrderSplit__dzje__1ipsM[data-v-9c86c1e4] {
  color: #6c6e82;
}

.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__left__1RWQR .OrderSplit__dzje__1ipsM span[data-v-9c86c1e4] {
  border: 0.02rem solid #6c6e82;
  color: #dedede;
}

.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__left__1RWQR .OrderSplit__dzje__1ipsM span.OrderSplit__active__3cbGT[data-v-9c86c1e4] {
  color: #6c6e82;
}

.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__btn__22BGR[data-v-9c86c1e4] {
  background: #222536;
  border: 0.02rem solid #ede9e7;
}

.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__time__lIlZy[data-v-9c86c1e4] {
  color: #6c6e82;
}

.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__success__2kKep .OrderSplit__btn__22BGR[data-v-9c86c1e4] {
  background-color: #ede9e7;
  color: #79420d;
}

.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__big__3vFvi[data-v-9c86c1e4] {
  color: #ede9e7;
}

.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__blur__111q- .OrderSplit__title__38HEF[data-v-9c86c1e4],
.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__red__34SlB .OrderSplit__title__38HEF[data-v-9c86c1e4] {
  color: #db6372;
}

.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__blur__111q- .OrderSplit__subtitle__3NZ3u[data-v-9c86c1e4],
.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__blur__111q- .OrderSplit__subtitle___1AIUi[data-v-9c86c1e4],
.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__red__34SlB .OrderSplit__subtitle__3NZ3u[data-v-9c86c1e4],
.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__red__34SlB .OrderSplit__subtitle___1AIUi[data-v-9c86c1e4] {
  color: #6a6c80;
}

.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__list__xBE7y .OrderSplit__item__3InZN .OrderSplit__right__3Uuqm .OrderSplit__blur__111q- .OrderSplit__title__38HEF[data-v-9c86c1e4] {
  color: #ede9e7;
}

.OrderSplit__bg__2-Amr.OrderSplit__yibo__2Jqdg .OrderSplit__list__xBE7y .OrderSplit__item__3InZN[data-v-9c86c1e4]:last-child {
  border: 0;
}

.OrderSplit__bg__2-Amr .OrderSplit__help__cvy-5[data-v-9c86c1e4] {
  padding-top: 0.4rem;
  padding-bottom: 0.8rem;
  line-height: 0.4rem;
  text-align: center;
  font-size: 0.24rem;
  color: #a5a9b3;
}

.OrderSplit__bg__2-Amr .OrderSplit__help__cvy-5 span[data-v-9c86c1e4] {
  color: #ede9e7;
}

.inputGroupStyle__container__1C8Xy[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  border: 1px solid #cdcdcd;
  position: relative;
  width: 100%;
}

.inputGroupStyle__container__1C8Xy .inputGroupStyle__input__10dU0[data-v-9c86c1e4] {
  height: 1rem;
  opacity: 0;
}

.inputGroupStyle__container__1C8Xy .inputGroupStyle__inputContent__1TtJr[data-v-9c86c1e4] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: space-around;
  -ms-flex-pack: distribute;
  justify-content: space-around;
}

.inputGroupStyle__container__1C8Xy .inputGroupStyle__inputContent__1TtJr .inputGroupStyle__inputItem__1jbsY[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 1rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: 0.2rem;
  color: #363636;
  border-right: 1px solid #cdcdcd;
}

.inputGroupStyle__container__1C8Xy .inputGroupStyle__inputContent__1TtJr .inputGroupStyle__inputItem__1jbsY[data-v-9c86c1e4]:last-child {
  border-right: none;
}

.inputGroupStyle__shake__1T8Gg[data-v-9c86c1e4] {
  color: #696969;
  font-size: 0.46rem;
  animation: inputGroupStyle__shake__1T8Gg-data-v-9c86c1e4 1s infinite;
  -webkit-animation: inputGroupStyle__shake__1T8Gg-data-v-9c86c1e4 2.2s infinite;
}

@-webkit-keyframes inputGroupStyle__shake__1T8Gg-data-v-9c86c1e4 {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.4;
  }

  to {
    opacity: 0.8;
  }
}

@keyframes inputGroupStyle__shake__1T8Gg-data-v-9c86c1e4 {
  0% {
    opacity: 0.8;
  }

  25% {
    opacity: 0.6;
  }

  50% {
    opacity: 0.2;
  }

  75% {
    opacity: 0.6;
  }

  to {
    opacity: 0.8;
  }
}

.WarmPromptCountdownModal__modal__19x1I[data-v-9c86c1e4] {
  width: 5.6rem;
}

.WarmPromptCountdownModal__modal__19x1I .am-modal-body[data-v-9c86c1e4] {
  padding: 0 0.4rem 0.4rem !important;
}

.WarmPromptCountdownModal__modal__19x1I.WarmPromptCountdownModal__yibo__2c_05 .am-modal-content[data-v-9c86c1e4] {
  background: #222536 !important;
}

.WarmPromptCountdownModal__container__3mhJx[data-v-9c86c1e4] {
  width: 100%;
  color: #414655;
  text-align: left;
}

.WarmPromptCountdownModal__container__3mhJx *[data-v-9c86c1e4] {
  font-size: 0.32rem;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__title__2A372[data-v-9c86c1e4] {
  color: #414655;
  font-size: 0.36rem;
  margin: 0.1rem 0;
  text-align: center;
  height: 0.5rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__msg__3bT1b[data-v-9c86c1e4] {
  max-height: 3.48rem !important;
  min-height: 1.6rem;
  font-size: 0.28rem;
  line-height: 0.4rem;
  overflow: auto !important;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__radio__1nX90[data-v-9c86c1e4] {
  color: #626571;
  margin: 0.36rem 0;
  height: 0.4rem;
  font-size: 0.28rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  line-height: normal;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__radio__1nX90 img[data-v-9c86c1e4] {
  width: 0.32rem;
  height: 0.32rem;
  margin-right: 5px;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__radio__1nX90.WarmPromptCountdownModal__active__1qBFP[data-v-9c86c1e4] {
  color: #db6372;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__btn__25I7H[data-v-9c86c1e4] {
  height: 0.8rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background: #ede9e7;
  color: #fff;
  opacity: 0.5;
  border-radius: 0.1rem;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__btn__25I7H.WarmPromptCountdownModal__active__1qBFP[data-v-9c86c1e4] {
  opacity: 1;
}

.WarmPromptCountdownModal__container__3mhJx.WarmPromptCountdownModal__yibo__2c_05[data-v-9c86c1e4] {
  color: #a1a2a7;
}

.WarmPromptCountdownModal__container__3mhJx.WarmPromptCountdownModal__yibo__2c_05 .WarmPromptCountdownModal__title__2A372[data-v-9c86c1e4] {
  color: #deb489;
}

.WarmPromptCountdownModal__container__3mhJx.WarmPromptCountdownModal__yibo__2c_05 .WarmPromptCountdownModal__radio__1nX90[data-v-9c86c1e4] {
  color: #a1a2a7;
}

.WarmPromptCountdownModal__container__3mhJx.WarmPromptCountdownModal__yibo__2c_05 .WarmPromptCountdownModal__radio__1nX90.WarmPromptCountdownModal__active__1qBFP[data-v-9c86c1e4] {
  color: #db6372;
}

.WarmPromptCountdownModal__container__3mhJx.WarmPromptCountdownModal__yibo__2c_05 .WarmPromptCountdownModal__btn__25I7H[data-v-9c86c1e4] {
  color: #79420d;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB[data-v-9c86c1e4] {
  -webkit-animation: none 0s ease 0s 1 normal none running;
  animation: none 0s ease 0s 1 normal none running;
  -webkit-backface-visibility: visible;
  backface-visibility: visible;
  background: transparent none repeat 0 0 / auto auto padding-box border-box scroll;
  border: none;
  border-collapse: initial;
  -webkit-border-image: none;
  -o-border-image: none;
  border-image: none;
  border-radius: 0;
  border-spacing: 0;
  bottom: auto;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: content-box;
  box-sizing: initial;
  caption-side: top;
  clear: none;
  clip: auto;
  color: #000;
  -webkit-columns: auto;
  -moz-columns: auto;
  -webkit-column-count: auto;
  -moz-column-count: auto;
  -webkit-column-fill: balance;
  -moz-column-fill: balance;
  column-fill: balance;
  -webkit-column-gap: normal;
  -moz-column-gap: normal;
  column-gap: normal;
  -webkit-column-rule: medium none currentColor;
  -moz-column-rule: medium none currentColor;
  column-rule: medium none currentColor;
  -webkit-column-span: 1;
  -moz-column-span: 1;
  column-span: 1;
  -webkit-column-width: auto;
  -moz-column-width: auto;
  columns: auto;
  content: normal;
  counter-increment: none;
  counter-reset: none;
  cursor: auto;
  direction: ltr;
  display: inline;
  empty-cells: show;
  float: none;
  font-family: serif;
  font-size: medium;
  font-style: normal;
  font-variant: normal;
  font-weight: 400;
  font-stretch: normal;
  line-height: normal;
  height: auto;
  -webkit-hyphens: none;
  -ms-hyphens: none;
  hyphens: none;
  left: auto;
  letter-spacing: normal;
  list-style: disc outside none;
  margin: 0;
  max-height: none;
  max-width: none;
  min-height: 0;
  min-width: 0;
  opacity: 1;
  orphans: 2;
  outline: medium none invert;
  overflow: visible;
  overflow-x: visible;
  overflow-y: visible;
  padding: 0;
  page-break-after: auto;
  page-break-before: auto;
  page-break-inside: auto;
  -webkit-perspective: none;
  perspective: none;
  -webkit-perspective-origin: 50% 50%;
  perspective-origin: 50% 50%;
  position: static;
  right: auto;
  -moz-tab-size: 8;
  -o-tab-size: 8;
  tab-size: 8;
  table-layout: auto;
  text-align: left;
  -moz-text-align-last: auto;
  text-align-last: auto;
  text-decoration: none;
  text-indent: 0;
  text-shadow: none;
  text-transform: none;
  top: auto;
  -webkit-transform: none;
  transform: none;
  -webkit-transform-origin: 50% 50% 0;
  transform-origin: initial;
  -webkit-transform-style: flat;
  transform-style: flat;
  -webkit-transition: none 0s ease 0s;
  transition: none 0s ease 0s;
  unicode-bidi: normal;
  vertical-align: initial;
  visibility: visible;
  white-space: normal;
  widows: 2;
  width: auto;
  word-spacing: normal;
  z-index: auto;
  all: initial;
  color: #333;
  display: block;
  word-break: break-word;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB *[data-v-9c86c1e4] {
  font-size: inherit;
  line-height: normal;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB li[data-v-9c86c1e4],
.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB ol[data-v-9c86c1e4],
.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB ul[data-v-9c86c1e4] {
  list-style-type: disc;
  list-style-position: inside;
  -webkit-padding-start: 1em;
  padding-inline-start: 1em;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB ul[data-v-9c86c1e4] {
  list-style-type: disc;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB ul ul[data-v-9c86c1e4] {
  list-style-type: circle;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB ul ul ul[data-v-9c86c1e4] {
  list-style-type: square;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB ol[data-v-9c86c1e4] {
  list-style-type: decimal;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB ol li[data-v-9c86c1e4] {
  list-style: inherit;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB li[data-v-9c86c1e4],
.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB p[data-v-9c86c1e4] {
  color: inherit;
  font-size: medium;
  margin-top: 0;
  text-align: left;
  text-align: initial;
  list-style-type: inherit;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB h1[data-v-9c86c1e4] {
  font-size: 2em;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB h2[data-v-9c86c1e4] {
  font-size: 1.8em;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB h3[data-v-9c86c1e4] {
  font-size: 1.6em;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB h4[data-v-9c86c1e4] {
  line-height: 1.4em;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB h5[data-v-9c86c1e4] {
  font-size: 1.2em;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB h6[data-v-9c86c1e4] {
  font-size: 1em;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB h1[data-v-9c86c1e4],
.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB h2[data-v-9c86c1e4],
.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB h3[data-v-9c86c1e4],
.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB h4[data-v-9c86c1e4],
.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB h5[data-v-9c86c1e4],
.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB h6[data-v-9c86c1e4] {
  line-height: 1;
  height: auto;
  color: inherit;
  padding: inherit;
  font-weight: 400;
  font-weight: 700;
}

.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB em[data-v-9c86c1e4],
.WarmPromptCountdownModal__container__3mhJx .WarmPromptCountdownModal__dangerously-html__34vwB i[data-v-9c86c1e4] {
  font-style: italic;
}

.noticeStyle__container__2aZkj[data-v-9c86c1e4] {
  height: 0.26rem;
  width: 100%;
  position: relative;
  overflow: hidden;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.noticeStyle__container__2aZkj span[data-v-9c86c1e4] {
  font-size: 0.22rem;
  padding-right: 1rem;
}

.noticeStyle__line__3rA8u[data-v-9c86c1e4] {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  white-space: nowrap;
  font-family: PingFangSC;
}

#noticeStyle__homePageNotice__10Pd3[data-v-9c86c1e4] {
  z-index: 1001;
}

#noticeStyle__homePageNotice__10Pd3 div h3[data-v-9c86c1e4] {
  word-break: break-all;
  padding: 0;
  margin-bottom: 0.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

#noticeStyle__homePageNotice__10Pd3 div h3>div[data-v-9c86c1e4] {
  color: #000;
  font-size: 0.32rem;
}

#noticeStyle__homePageNotice__10Pd3 div h3>p[data-v-9c86c1e4] {
  color: #98a7b5;
  font-size: 0.28rem;
}

#noticeStyle__homePageNotice__10Pd3 div p[data-v-9c86c1e4] {
  word-break: break-all;
}

#noticeStyle__homePageNotice__10Pd3 div p>span[data-v-9c86c1e4] {
  display: block;
  color: #333;
}

#noticeStyle__homePageNotice__10Pd3 div p>span>code[data-v-9c86c1e4] {
  font-size: 0.28rem;
  color: #98a5b3;
}

#noticeStyle__homePageNotice__10Pd3 div p>span[data-v-9c86c1e4]:nth-child(2) {
  color: #bf9551;
}

.styles__box__3u22G[data-v-9c86c1e4] {
  position: relative;
  width: 6.12rem;
  word-break: break-word;
  white-space: normal;
  border-radius: 0.2rem;
  background-color: #fff;
  line-height: 1.4;
  overflow: hidden;
}

.styles__box__3u22G .styles__headerImg__3W5x_[data-v-9c86c1e4] {
  position: absolute;
  left: 0;
  top: -0.28rem;
  width: 100%;
}

.styles__box__3u22G .styles__closeIcon__2X9s7[data-v-9c86c1e4] {
  position: absolute;
  top: -0.92rem;
  right: 0;
  width: 0.56rem;
  height: 0.56rem;
}

.styles__box__3u22G h3[data-v-9c86c1e4] {
  font-size: 0.3rem;
  color: #6d7278;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}

.styles__box__3u22G .styles__content_wrapper__29KkZ[data-v-9c86c1e4],
.styles__box__3u22G p[data-v-9c86c1e4] {
  overflow: auto;
  text-align: left;
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 0.28rem;
  color: #878787;
  margin: 0.4rem 0;
}

.styles__box__3u22G .styles__content_wrapper__29KkZ[data-v-9c86c1e4] {
  overflow: auto;
  max-height: 6.24rem;
  position: relative;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 0.64rem;
}

.styles__box_wallet__3ujrs[data-v-9c86c1e4] {
  background-color: initial !important;
  text-align: left !important;
}

.styles__box_wallet__3ujrs h3[data-v-9c86c1e4] {
  text-align: inherit !important;
}

.styles__commonNoticeWrap__sH2rA p[data-v-9c86c1e4] {
  max-height: 6rem;
  overflow: auto;
  margin-bottom: 1em;
  white-space: pre-wrap;
}

.styles__commonNoticeWrap__sH2rA p img[data-v-9c86c1e4] {
  max-width: 100%;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
}

.styles__btn__2PZcw[data-v-9c86c1e4] {
  display: inline-block;
  height: 0.68rem;
  padding: 0.14rem 0.4rem;
  font-size: 0.28rem;
  color: #fff;
  background-color: #ede9e7;
  border-radius: 0.1rem;
  position: relative;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  text-align: center;
}

.styles__boxHeader__39ho7[data-v-9c86c1e4] {
  position: relative;
  width: 100%;
  height: 1rem;
  border-radius: 0.2rem 0.2rem 0 0;
  background-image: -webkit-gradient(linear, right top, left top, from(#ede9e7), to(#8ca7ff));
  background-image: -webkit-linear-gradient(to left, #ede9e7, #8ca7ff);
  background-image: linear-gradient(270deg, #ede9e7, #8ca7ff);
}

.styles__boxHeader__39ho7 .styles__closeIcon__2X9s7[data-v-9c86c1e4] {
  z-index: 30;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  right: 0.32rem;
  width: 0.4rem;
  height: 0.4rem;
}

.styles__boxHeader__39ho7 .styles__titleBox__jwPKP[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  position: absolute;
  top: 50%;
  left: 0.32rem;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  width: 3rem;
  height: 0.5rem;
  background-size: cover;
}

.styles__boxHeader__39ho7 .styles__titleBox__jwPKP i[data-v-9c86c1e4] {
  margin-top: -0.08rem;
  width: 1.66rem;
  height: 0.64rem;
}

.styles__boxHeader__39ho7 .styles__titleWarpper__Xsqp4[data-v-9c86c1e4] {
  position: absolute;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  top: 0.2rem;
  height: 0.5rem;
  left: 0.32rem;
}

.styles__boxHeader__39ho7 .styles__titleWarpper__Xsqp4 .styles__line__3NpU0[data-v-9c86c1e4] {
  color: #fff;
  font-size: 0.38rem;
  font-weight: 500;
  text-indent: 0.1rem;
  letter-spacing: 0.1rem;
  font-family: HYYakuHei-HEW, PingFangSC-Bold;
}

.styles__boxHeader__39ho7 .styles__titleWarpper__Xsqp4 .styles__title__3DyTy[data-v-9c86c1e4] {
  font-size: 0.26rem;
  color: #fff;
  line-height: 0.65rem;
  font-family: HYYakuHei-HEW, PingFangSC-Bold;
  letter-spacing: 1px;
}

.styles__boxHeader__39ho7 .styles__titleWarpper__Xsqp4 .styles__title__3DyTy.styles__currentSelect__45owm[data-v-9c86c1e4] {
  font-size: 0.38rem !important;
  color: #fff !important;
  font-weight: 700;
  line-height: 0.5rem;
}

.styles__boxHeader__39ho7 .styles__oneTitleImg__3QIpd[data-v-9c86c1e4] {
  position: absolute;
  left: 0.32rem;
  top: 50%;
  height: 0.5rem;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}

.styles__boxHeader__39ho7 .styles__oneTitletext__3YzpH[data-v-9c86c1e4] {
  display: block;
  position: absolute;
  left: 0.32rem;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 0.36rem;
  font-weight: 600;
  color: #fff;
}

.styles__boxContainer__Y8pCF[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 200%;
  height: 6.6rem;
  -webkit-transition: -webkit-transform 0.3s linear;
  transition: -webkit-transform 0.3s linear;
  transition: transform 0.3s linear;
  transition: transform 0.3s linear, -webkit-transform 0.3s linear;
  background-color: #fff;
}

.styles__boxContainer__Y8pCF .styles__activity__3zopu[data-v-9c86c1e4] {
  width: 100%;
  min-width: 6.12rem;
}

.styles__boxContainer__Y8pCF .styles__activity__3zopu img[data-v-9c86c1e4] {
  max-height: 6.64rem;
  width: 6.12rem;
}

.styles__boxContainer__Y8pCF .styles__notice__rD2sl[data-v-9c86c1e4] {
  width: 100%;
  background-color: #fff;
  overflow-y: auto;
  padding: 0.4rem 0.32rem;
}

.styles__boxContainer__Y8pCF .styles__notice__rD2sl .styles__item__1MI6e[data-v-9c86c1e4] {
  margin-bottom: 0.46rem;
}

.styles__boxContainer__Y8pCF .styles__notice__rD2sl .styles__item__1MI6e[data-v-9c86c1e4]:last-child {
  margin-bottom: none;
}

.styles__boxContainer__Y8pCF .styles__notice__rD2sl .styles__item__1MI6e h3.styles__title__3DyTy[data-v-9c86c1e4] {
  margin: 0 0 0.12rem;
  font-size: 0.32rem;
  font-weight: 400;
  color: #6d7278;
}

.styles__boxContainer__Y8pCF .styles__notice__rD2sl .styles__item__1MI6e span[data-v-9c86c1e4] {
  font-size: 0.28rem;
  line-height: 0.4rem;
  word-break: break-word;
  color: #878787;
}

.styles__boxContainer__Y8pCF .styles__notice__rD2sl .styles__item__1MI6e span.styles__view__2t5fQ[data-v-9c86c1e4] {
  color: #ede9e7;
}

.styles__boxFooter__1b8r7[data-v-9c86c1e4] {
  width: 100%;
  height: 0.84rem;
  border-radius: 0 0 0.2rem 0.2rem;
  background-color: #fff;
}

.styles__boxFooter__1b8r7[data-v-9c86c1e4],
.styles__boxFooter__1b8r7 .styles__noRemind__3fHvk[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.styles__boxFooter__1b8r7 .styles__noRemind__3fHvk[data-v-9c86c1e4] {
  line-height: 0.34rem;
  margin-left: 0.4rem;
  color: #d5d5d5;
}

.styles__boxFooter__1b8r7 .styles__noRemind__3fHvk span[data-v-9c86c1e4] {
  font-size: 0.28rem;
}

.styles__boxFooter__1b8r7 .styles__noRemind__3fHvk i.styles__radio__3KG1D[data-v-9c86c1e4] {
  position: relative;
  display: block;
  border-radius: 50%;
  margin-right: 0.2rem;
  width: 0.24rem;
  height: 0.24rem;
  border: 1px solid #d5d5d5;
}

.styles__boxFooter__1b8r7 .styles__noRemind__3fHvk i.styles__radio__3KG1D[data-v-9c86c1e4]:after,
.styles__boxFooter__1b8r7 .styles__noRemind__3fHvk i.styles__radio__3KG1D[data-v-9c86c1e4]:before {
  content: '';
  position: absolute;
  top: 55.5%;
  left: 20%;
  display: block;
  height: 0.32px;
  height: 0.02rem;
  background: #fff;
  opacity: 0;
  -webkit-transition: background-color 0.3s linear, opacity 0.2s linear;
  transition: background-color 0.3s linear, opacity 0.2s linear;
}

.styles__boxFooter__1b8r7 .styles__noRemind__3fHvk i.styles__radio__3KG1D[data-v-9c86c1e4]:before {
  width: 1.92px;
  width: 0.12rem;
  -webkit-transform: rotate(-45deg) translateX(20%);
  transform: rotate(-45deg) translateX(20%);
}

.styles__boxFooter__1b8r7 .styles__noRemind__3fHvk i.styles__radio__3KG1D[data-v-9c86c1e4]:after {
  width: 0.64px;
  width: 0.04rem;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}

.styles__boxFooter__1b8r7 .styles__noRemind__3fHvk i.styles__radio__3KG1D.styles__radioCheck__20zT7[data-v-9c86c1e4] {
  background-color: #ede9e7;
  border-color: #ede9e7;
}

.styles__boxFooter__1b8r7 .styles__noRemind__3fHvk i.styles__radio__3KG1D.styles__radioCheck__20zT7[data-v-9c86c1e4]:after,
.styles__boxFooter__1b8r7 .styles__noRemind__3fHvk i.styles__radio__3KG1D.styles__radioCheck__20zT7[data-v-9c86c1e4]:before {
  opacity: 1;
}

.styles__boxDoot__1XPEw[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.styles__boxDoot__1XPEw i[data-v-9c86c1e4] {
  display: block;
  background: #fff;
  opacity: 0.5;
  border-radius: 50%;
  margin: 0.4rem 0.15rem 0;
  width: 0.16rem;
  height: 0.16rem;
}

.styles__boxDoot__1XPEw i.styles__dootSelect__24cR7[data-v-9c86c1e4] {
  opacity: 1;
}

.index__usdtDeposit__1Wcze[data-v-9c86c1e4] {
  background: #f8f8f8;
}

.index__usdtDeposit__1Wcze .index__protoLink__2-23v[data-v-9c86c1e4] {
  padding: 0.28rem;
  background: #fff;
}

.index__usdtDeposit__1Wcze .index__protoLink__2-23v .index__content__35nE4[data-v-9c86c1e4] {
  padding: 0.2rem 0;
  background: #f8f8f8;
  border-radius: 0.12rem;
}

.index__usdtDeposit__1Wcze .index__protoLink__2-23v .index__content__35nE4 .index__topWrap__35qGR[data-v-9c86c1e4] {
  padding: 0 0.28rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.index__usdtDeposit__1Wcze .index__protoLink__2-23v .index__content__35nE4 .index__topWrap__35qGR span[data-v-9c86c1e4] {
  color: #414655;
  font-size: 0.28rem;
  font-weight: 700;
}

.index__usdtDeposit__1Wcze .index__protoLink__2-23v .index__content__35nE4 .index__topWrap__35qGR a[data-v-9c86c1e4] {
  color: #a5a9b3;
  font-size: 0.24rem;
}

.index__usdtDeposit__1Wcze .index__protoLink__2-23v .index__content__35nE4 .index__botWrap__1mC3q[data-v-9c86c1e4] {
  padding: 0.2rem 0.2rem 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.index__usdtDeposit__1Wcze .index__protoLink__2-23v .index__content__35nE4 .index__botWrap__1mC3q .index__stepWrap__300CI[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.index__usdtDeposit__1Wcze .index__protoLink__2-23v .index__content__35nE4 .index__botWrap__1mC3q .index__stepWrap__300CI>span[data-v-9c86c1e4] {
  width: 1.5rem;
  height: 0.56rem;
  line-height: 0.56rem;
  color: #a5a9b3;
  font-size: 0.2rem;
  text-align: center;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIwAAAA0CAYAAABYWdAmAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJXSURBVHgB7Z2xUsJAFEUf29LrT8hPYE8tvbV+hdr7E7HGGnprrOnFmhr34SazCbvZl3Rw75nJACHp7tw9SXZhcjweX0RkJgSFg98eJ5PJQUbg/PYlBImp35YyEg3MWv5TR3BY+JFl1KjiQjWthaDxICNw4ZXDEh4z3zL3MpBTYHzLbP3LVggaSx+a6ZATXPT+UwgaN35bDDkhDow2DOUXDxXgW+vBTWCC/K6EoKFD0pP1YNf5zMBgMrNeZrcCE1qG8ovJs0WAXWLfhxBETAJ8FphwiU35xaQowC6zny6DSfE5EwNDusz7BDgZGMovPNnnTK7nJMovLnqZnRTgbGAov/AknzO5wkl0GVySAmwJDFsGl7OJVr2BCfL7LQSZlgCXGkbhsIRNa6JVMTCcXEUkEmBLwyicwolN85zJGhiuLCCn50ymwHBlAZEw0craMPUJBJtfU2B8FekYNnhJArk6KmvDcO01qbya/FgDM2qVHLka9hLuxxUDE24Nm5chkKukqn/twdIwcyHI7HxYmivk3sBQdonnLf5QahjKLjYbFd14RykwlF1cVHSr7s5sYCi78FTddlH6Goayi8s+Ft2YZGAou/C85r7INQzDgouK7i73ZS4wHI4w0ZtzVd8BZ4EJ0/Eou5isUqIbk2oYtgsmKrpV6aBWYILs8mYdJsWwKN2GGf0L0eSi2eQuo7t0A3MnBBFTuyhNYCi7sFQl0Y2JG4ayi4dJdGNOgaHswjIoLErdMJRdPLZW0Y2pA0PZxeNdRuAou5BshohujDbMoD8nIBdPcmKUlT/eI6F1zcYyHAAAAABJRU5ErkJggg==);
  background-size: cover;
}

.index__usdtDeposit__1Wcze .index__protoLink__2-23v .index__content__35nE4 .index__botWrap__1mC3q .index__stepWrap__300CI>span[data-v-9c86c1e4]:nth-of-type(3) {
  width: 1.72rem;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAAA0CAYAAAANODN4AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJCSURBVHgB7d09UsMwEMXxtVp6OAU9NfTUcAoOQM0BOEWo00NNzymghzZIHiuDHVmWdrfj/5vJ5IOhe/PeOHaS4XA4PInIpQB9vuLtYRiGbzEI8fYiQL/zeLsXoxAT/BHvPwTodxsX1LSeYbp/E0DnIYbwTJTGAMYWfI13pi3Hv2Wa4vDn8V4AHfUULwNIC0JLNcXHAE6H07QgtFRTHBbPaUFYdE/xLIC0IBx0TXEovEYAYdE1xScBnFrwVQC95ikOK6/zxjSsmqa4GEBOz8FB0xSHyt+4SAFWm1O8GkBaEE6qU1xrwIQWhFV1iqsBpAXhZHWKtxow4YgYHopTvBlALtWCk+IUtzRgwtkReDiZ4p4A0oLwMJvipgBykQIczaa4tQETWhBe0hRfpQfNAaQF4Wyc4qHnP6bt3gng471nghP1x++Agp/eAJo/CQ9M0ld77JoDGOc3Hb3cCOBjF48rPnsakPDBy9t0hq3rbZhrAezG6c1PmgIY5ze134UAduP05ietDXgngN1xerPNANJ+cDKb3qylAWk/eJhNb1YNIO0HJ/vl9GZbDciRL6yK05utBnC6cJAvL4fVc+2LzGsNSPvBaj99sG1VMYCcdoOD6vRmaw3IRQewem75DZGTANJ+cLA5vVmpAWk/WDRNbzYLIO0HB489P9+1bEDCB4vi2Y6aZQB56wVaXzF83Z8XOgaQ024wehSFvw3IRQfQ6p7ebAwg7QcD1fRmuQFpP2ippjcLtB8M1NObpQbkyBcapunNfgHsS7OqqbCCfgAAAABJRU5ErkJggg==);
}

.index__usdtDeposit__1Wcze .index__protoLink__2-23v .index__content__35nE4 .index__botWrap__1mC3q .index__closeWrap__2DQIl[data-v-9c86c1e4] {
  padding: 0.08rem;
  line-height: 1;
}

.index__usdtDeposit__1Wcze .index__protoLink__2-23v .index__content__35nE4 .index__botWrap__1mC3q .index__closeWrap__2DQIl .index__close__2NUy6[data-v-9c86c1e4] {
  width: 0.24rem;
  height: 0.24rem;
}

.index__usdtDeposit__1Wcze .index__protoPicker__2ITKw[data-v-9c86c1e4] {
  padding: 0.2rem 0.28rem 0.28rem;
  background: #fff;
}

.index__usdtDeposit__1Wcze .index__protoPicker__2ITKw[data-v-9c86c1e4],
.index__usdtDeposit__1Wcze .index__protoPicker__2ITKw .index__actionArea__2bpLa[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.index__usdtDeposit__1Wcze .index__protoPicker__2ITKw .index__actionArea__2bpLa>span[data-v-9c86c1e4] {
  color: #414655;
  font-size: 0.28rem;
  font-weight: 700;
  margin-right: 0.28rem;
}

.index__usdtDeposit__1Wcze .index__protoPicker__2ITKw .index__actionArea__2bpLa .index__protoContainer__1pLT6[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.index__usdtDeposit__1Wcze .index__protoPicker__2ITKw .index__actionArea__2bpLa .index__protoContainer__1pLT6>div[data-v-9c86c1e4] {
  width: 1.58rem;
  height: 0.7rem;
  border-radius: 0.1rem;
  border: 1px solid #eee;
  text-align: center;
  line-height: 0.7rem;
  color: #414655;
  font-size: 0.28rem;
  margin-right: 0.2rem;
  position: relative;
  overflow: hidden;
}

.index__usdtDeposit__1Wcze .index__protoPicker__2ITKw .index__actionArea__2bpLa .index__protoContainer__1pLT6>div .index__jiaoBiao___zcej[data-v-9c86c1e4] {
  position: absolute;
  right: -0.02rem;
  height: 0.32rem;
  bottom: -0.02rem;
}

.index__usdtDeposit__1Wcze .index__protoPicker__2ITKw .index__actionArea__2bpLa .index__protoContainer__1pLT6>div span[data-v-9c86c1e4] {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 0.42rem;
  width: 0.42rem;
  color: #fff;
  text-indent: 0.1rem;
}

.index__usdtDeposit__1Wcze .index__protoPicker__2ITKw .index__actionArea__2bpLa .index__protoContainer__1pLT6>div.index__active__2M5n9[data-v-9c86c1e4] {
  color: #ede9e7;
  border: 1px solid #ede9e7;
}

.index__usdtDeposit__1Wcze .index__protoPicker__2ITKw>a[data-v-9c86c1e4] {
  color: #414655;
}

.index__usdtDeposit__1Wcze .index__qrcodeWrap__1doDl[data-v-9c86c1e4] {
  margin-top: 0.2rem;
  padding: 0.2rem 0.28rem 0.32rem;
  background: #fff;
}

.index__usdtDeposit__1Wcze .index__qrcodeWrap__1doDl .index__head__3Jeny[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.index__usdtDeposit__1Wcze .index__qrcodeWrap__1doDl .index__head__3Jeny .index__title__39Tof[data-v-9c86c1e4] {
  color: #414655;
  font-size: 0.28rem;
  font-weight: 700;
  margin-right: 0.28rem;
}

.index__usdtDeposit__1Wcze .index__qrcodeWrap__1doDl .index__head__3Jeny .index__tips__3mPWq[data-v-9c86c1e4] {
  color: #414655;
  font-size: 0.24rem;
}

.index__usdtDeposit__1Wcze .index__qrcodeWrap__1doDl .index__head__3Jeny .index__tips__3mPWq .index__minUsdtAmount__Ii6-7[data-v-9c86c1e4] {
  color: #db6372;
  font-family: DINPro;
}

.index__usdtDeposit__1Wcze .index__qrcodeWrap__1doDl .index__walletAddress__2aef2[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-top: 0.28rem;
}

.index__usdtDeposit__1Wcze .index__qrcodeWrap__1doDl .index__walletAddress__2aef2 .index__address__1LfSZ[data-v-9c86c1e4] {
  font-size: 0.24rem;
  color: #000;
  line-height: 0.32rem;
  word-break: break-all;
}

.index__usdtDeposit__1Wcze .index__qrcodeWrap__1doDl .index__walletAddress__2aef2 .index__copy__3y1Bw[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  width: 0.68rem;
  height: 0.3rem;
  margin-left: 0.2rem;
  margin-top: 0.02rem;
  border-radius: 0.04rem;
  border: 0.01rem solid #ede9e7;
  color: #ede9e7;
  font-size: 0.24rem;
  min-width: 0.68rem;
}

.index__usdtDeposit__1Wcze .index__qrcodeWrap__1doDl .index__qrcode__3s6w9[data-v-9c86c1e4],
.index__usdtDeposit__1Wcze .index__qrcodeWrap__1doDl .index__qrcodeImg__31527[data-v-9c86c1e4] {
  margin: 0.2rem auto;
  width: 2.08rem;
  height: 2.08rem;
  padding: 0.04rem;
  display: none;
}

.index__usdtDeposit__1Wcze .index__qrcodeWrap__1doDl .index__qrcodeImg__31527[data-v-9c86c1e4] {
  display: block;
}

.index__usdtDeposit__1Wcze .index__qrcodeWrap__1doDl .index__qrcodeImg__31527.index__qrcodeImgNone__1nAqz[data-v-9c86c1e4] {
  opacity: 0;
}

.index__usdtDeposit__1Wcze .index__qrcodeWrap__1doDl .index__saveBtn__1MUfv[data-v-9c86c1e4] {
  margin: 0.2rem auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  width: 2.56rem;
  height: 0.9rem;
  font-size: 0.32rem;
  font-weight: 700;
  color: #626571;
  border-radius: 0.12rem;
  border: 0.02rem solid #eee;
}

.index__usdtDeposit__1Wcze .index__qrcodeWrap__1doDl .index__addressTip__3I2TH[data-v-9c86c1e4] {
  text-align: center;
  line-height: 0.32rem;
}

.index__usdtDeposit__1Wcze .index__qrcodeWrap__1doDl .index__addressTip__3I2TH>h3[data-v-9c86c1e4] {
  color: #414655;
  font-size: 0.28rem;
  margin: 0.6rem 0 0.28rem;
}

.index__usdtDeposit__1Wcze .index__qrcodeWrap__1doDl .index__addressTip__3I2TH>p[data-v-9c86c1e4] {
  color: #a5a9b3;
  font-size: 0.24rem;
}

.index__usdtDeposit__1Wcze .index__helpTit__kOOa5[data-v-9c86c1e4] {
  width: 100%;
  text-align: center;
  color: #414655;
  font-size: 0.24rem;
  font-weight: 400;
  padding: 0.4rem 0;
}

.index__usdtDeposit__1Wcze .index__helpTit__kOOa5 span[data-v-9c86c1e4] {
  color: #ede9e7;
  margin: 0 0.1rem;
}

.index__usdtDeposit__1Wcze.index__yibo__2opbT[data-v-9c86c1e4] {
  background-color: #161a28;
}

.index__usdtDeposit__1Wcze.index__yibo__2opbT .index__protoLink__2-23v[data-v-9c86c1e4] {
  background: #222536;
}

.index__usdtDeposit__1Wcze.index__yibo__2opbT .index__protoLink__2-23v .index__content__35nE4[data-v-9c86c1e4] {
  background: #161a28;
}

.index__usdtDeposit__1Wcze.index__yibo__2opbT .index__protoLink__2-23v .index__content__35nE4 .index__topWrap__35qGR span[data-v-9c86c1e4] {
  color: #dedede;
}

.index__usdtDeposit__1Wcze.index__yibo__2opbT .index__protoLink__2-23v .index__content__35nE4 .index__topWrap__35qGR a[data-v-9c86c1e4] {
  color: #6c6e82;
}

.index__usdtDeposit__1Wcze.index__yibo__2opbT .index__protoLink__2-23v .index__content__35nE4 .index__botWrap__1mC3q .index__stepWrap__300CI>span[data-v-9c86c1e4] {
  color: #6c6e82;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIwAAAA0CAYAAABYWdAmAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALvSURBVHgB7Z09b9NAGMef51zaIQssrRiZutRZWoTEWCQGBEFsdGeGTwHsfAWGMCeUAanZo8DiZKV7wpyBOLnDL21iO345e2ue/2+omvPd9tfd73LPOdw+e/WRyLgEpDCnxeKd5/2cUwMUkR4SkESL7h1cUEMULfwrClMH5MCm456+brSqqGhqMnxFQBTM+i01QIV/DK2wLInDuO3HL59RTaLAjH//GAeZGxOQhTEX7fbzVp0hav2fXvYJCIMPaf+gU2fEJjDLVTjDQH7FYTonTzpHtr3XgYn35bpHQBottTLvbTur1KfFEoERiXFtt9mpwMSzDORXIszLDzYCrLINxqy+ERCInQBvBSbeYkN+ZVItwCq/GfIrlECAV6XnTPmBgfwKhs/LBDg3MJBf2ZSdM6miB5BfyQTnTGedXAEuDAzkVzo695xJVQyCy8glt9CqPDCx/GKWkUpOoVVpYG7kd0JALFkBVlUDAvnFsiSadKFVZWBQXAWShVaVgYnBzQLZbM6Z7AKDmwXg5pzJsek6nf7xjx4ePyCmYwJS2WdDjyyXpABlahULg11E/7UKTPvpm0MyVPtKAtgttON07WYY38fda/FwdzLsTW2XpEa35MCuwDNa3I++j6sMjHv6wg2WI+trCGAHYdP1vK/RLrkyMKzUOQG5GLr2Rt/Xd+9LAwPZBXpPfU5+Lp9hILvCMYNQdJMtexUjILti4Zl2VDfbWhgYyK5wAtGdDPvTbHPhkgTZlQzPkqKbJDcwkF3ZGNafip4V3Ev6h7CIxQzGo8vroqf5gWEsR0KZh+dFZR22AhOV40F2hcK97DY6y/YMYxizi0gC0f3V71b1SgUmkl28FVwmwTbaplv6exjfb/yGaHCXMQNvdGn1rubsknRCQBxVoptkHRjIrlTiwijb3psZBrIrEDvRTRIFBrIrFEvRTRLPMJBdgfC46LyojNslCbIrDO3wF2qAguxKZLswyhZFmmr9OAG464SFUU5td7nlP58dBnQiOaueAAAAAElFTkSuQmCC);
}

.index__usdtDeposit__1Wcze.index__yibo__2opbT .index__protoLink__2-23v .index__content__35nE4 .index__botWrap__1mC3q .index__stepWrap__300CI>span[data-v-9c86c1e4]:nth-of-type(3) {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAAA0CAYAAAANODN4AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALrSURBVHgB7dy/bhNBEMfx2T1IilBQRLYIDSBEhIRdJCAhSiJRIAKig6fIA1DzADwDhakTQAgp6RHQ2GkQoo58PUjEyS13NpvEf863t7tdvp8mvrPP1Wh+mfPYqn1387WIaQlQi0nlcLDV7X7+LQG0McfvBKhNNeTi4ksJlKQHP9Pmyuqd/HFTgDqUrDau3N5PD36k4kmP3sjsCeBBqaOtdvvRkngaFmD36/vd/E9QluO8Cotiffow2xbAhzJPW+vPvAbZ0wI8PCoKkC4IL75RfFKAo3GaLghfflGsx47oggjhEcXJ2YN+/9eguXJzIX8nbkzDi1JZq7l8fbeoJZfX66kzoy4IeKoXxcnkiWEXvHqrkT+8IYCPGjeo9ayTJsu4MY0grlPxzALsff/Yy9+iJ4A3tyjWZU+wpIBgDlNxUvYESwqIoWoq1vMupgsi3PwoTuZdShdEFHOmYl19MataCFc2FVcWIKtaiGN2FFd3wCGWFBDBjKnYrQBZUkAkk1HsVICsaiGe8Sh2jGChCyKePIrba5v3i4eJ6zWsaiEqJWvN5Wuf3DtggVUtxLMkC4tb9Qrw0pL31++AadmfC7VePxgEfxMeGFFpluiOcwdsP3jeECMbAsSgTGf/y3a/xhT8l+JDJGbv/ydsNW7DKP1QgGBF9CYde+T0P2D73pONPH7ZiEG4YfTu9O2h6xDyQoBgRfR+2D17prIA6X6IYzT1Tp516YB0P4SbiF5r7hBC90MURm3bqXeSrriQyReBVCqDy52yZ0sjuLX+uMWPlyOUMcdvet23pVtUpR1Qae77IVAevaMfOSg3swD52A3h5kevNTuCWTpAoKrotaY6IN0PwRyi15qOYLofgrhFrzVWgHQ/hMoS9arrEL3WxG9Es3KFEGq441fnivECZOUK3lTa/bbjHL3WSQHysRtCFNErHs52QJYO4Kl+9FrDAqT7wZ9f9Fq2A9L94MU3ei1N94M//+i1NCtX8BMWvdY/l5Ej50qv/XUAAAAASUVORK5CYII=);
}

.index__usdtDeposit__1Wcze.index__yibo__2opbT .index__protoPicker__2ITKw[data-v-9c86c1e4] {
  background: #222536;
}

.index__usdtDeposit__1Wcze.index__yibo__2opbT .index__protoPicker__2ITKw .index__actionArea__2bpLa>span[data-v-9c86c1e4] {
  color: #dedede;
}

.index__usdtDeposit__1Wcze.index__yibo__2opbT .index__protoPicker__2ITKw .index__actionArea__2bpLa .index__protoContainer__1pLT6>div[data-v-9c86c1e4] {
  color: #a1a2a7;
  border: 1px solid #6c6e82;
}

.index__usdtDeposit__1Wcze.index__yibo__2opbT .index__protoPicker__2ITKw .index__actionArea__2bpLa .index__protoContainer__1pLT6>div.index__active__2M5n9[data-v-9c86c1e4] {
  color: #ede9e7;
  border: 1px solid #ede9e7;
}

.index__usdtDeposit__1Wcze.index__yibo__2opbT .index__protoPicker__2ITKw>a[data-v-9c86c1e4] {
  color: #dedede;
}

.index__usdtDeposit__1Wcze.index__yibo__2opbT .index__qrcodeWrap__1doDl[data-v-9c86c1e4] {
  background: #222536;
}

.index__usdtDeposit__1Wcze.index__yibo__2opbT .index__qrcodeWrap__1doDl .index__head__3Jeny .index__tips__3mPWq[data-v-9c86c1e4],
.index__usdtDeposit__1Wcze.index__yibo__2opbT .index__qrcodeWrap__1doDl .index__head__3Jeny .index__title__39Tof[data-v-9c86c1e4],
.index__usdtDeposit__1Wcze.index__yibo__2opbT .index__qrcodeWrap__1doDl .index__walletAddress__2aef2 .index__address__1LfSZ[data-v-9c86c1e4] {
  color: #dedede;
}

.index__usdtDeposit__1Wcze.index__yibo__2opbT .index__qrcodeWrap__1doDl .index__saveBtn__1MUfv[data-v-9c86c1e4] {
  color: #cbced8;
  border: 0.02rem solid #cbced8;
}

.index__usdtDeposit__1Wcze.index__yibo__2opbT .index__qrcodeWrap__1doDl .index__addressTip__3I2TH>h3[data-v-9c86c1e4] {
  color: #dedede;
}

.index__usdtDeposit__1Wcze.index__yibo__2opbT .index__helpTit__kOOa5[data-v-9c86c1e4],
.index__usdtDeposit__1Wcze.index__yibo__2opbT .index__qrcodeWrap__1doDl .index__addressTip__3I2TH>p[data-v-9c86c1e4] {
  color: #6c6e82;
}

.index__alertCont__2aXrU[data-v-9c86c1e4] {
  font-family: PingFang SC;
  font-size: 0.36rem;
  line-height: 0.5rem;
  text-align: center;
  color: #414655;
  padding: 0.8rem 1rem 0.4rem;
}

.index__alertCont__2aXrU.index__yibo__2opbT[data-v-9c86c1e4] {
  color: #dedede;
}

.style__usdtDefault__2SF9Q[data-v-9c86c1e4] {
  min-height: calc(100vh - 104px);
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background: #fff;
}

.style__usdtDefault__2SF9Q .style__tips__3138c[data-v-9c86c1e4] {
  margin-top: 0.4rem;
}

.style__usdtDefault__2SF9Q .style__tips__3138c p[data-v-9c86c1e4] {
  color: #626571;
  text-align: center;
  line-height: 0.32rem;
}

.style__usdtDefault__2SF9Q .style__tips__3138c p.style__title__1Y-LN[data-v-9c86c1e4] {
  font-size: 0.28rem;
  line-height: 0.4rem;
  margin-bottom: 0.2rem;
}

.style__usdtDefault__2SF9Q .style__tips__3138c .style__contactService__7UkPh[data-v-9c86c1e4] {
  margin-top: 0.4rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  width: 2.88rem;
  height: 0.68rem;
  font-size: 0.28rem;
  font-weight: 700;
  color: #414655;
  border-radius: 0.12rem;
  border: 0.02rem solid #eee;
}

.style__usdtDefault__2SF9Q.style__yibo__3ptu9[data-v-9c86c1e4] {
  background: #222536;
}

.style__usdtDefault__2SF9Q.style__yibo__3ptu9 .style__tips__3138c p[data-v-9c86c1e4] {
  color: #6c6e82;
}

.style__usdtDefault__2SF9Q.style__yibo__3ptu9 .style__tips__3138c .style__contactService__7UkPh[data-v-9c86c1e4] {
  color: #a5a9b4;
  border: 0.02rem solid #cbced8;
}

.style__tabs__3G59q[data-v-9c86c1e4] {
  width: 100%;
  height: 0.78rem;
  padding-top: 0.1rem;
  background: #f5f5f9;
}

.style__tabs__3G59q .style__tabbox__28w4V[data-v-9c86c1e4] {
  background: #f5f5f9;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.style__tabs__3G59q .style__tabbox__28w4V div[data-v-9c86c1e4] {
  height: 0.68rem;
}

.style__tabs__3G59q .style__tabbox__28w4V div[data-v-9c86c1e4]:first-child,
.style__tabs__3G59q .style__tabbox__28w4V div[data-v-9c86c1e4]:last-child,
.style__tabs__3G59q .style__tabbox__28w4V div[data-v-9c86c1e4]:nth-child(3) {
  width: 0.52rem;
  background: #fff;
}

.style__tabs__3G59q .style__tabbox__28w4V div:first-child>div[data-v-9c86c1e4],
.style__tabs__3G59q .style__tabbox__28w4V div:last-child>div[data-v-9c86c1e4],
.style__tabs__3G59q .style__tabbox__28w4V div:nth-child(3)>div[data-v-9c86c1e4] {
  background: #f5f5f9;
}

.style__tabs__3G59q .style__tabbox__28w4V div:first-child div[data-v-9c86c1e4] {
  border-radius: 0;
}

.style__tabs__3G59q .style__tabbox__28w4V div:first-child div.style__active__2iKE0[data-v-9c86c1e4] {
  border-bottom-right-radius: 50%;
}

.style__tabs__3G59q .style__tabbox__28w4V div:last-child div[data-v-9c86c1e4] {
  border-radius: 0;
}

.style__tabs__3G59q .style__tabbox__28w4V div:last-child div.style__active__2iKE0[data-v-9c86c1e4] {
  border-bottom-left-radius: 50%;
}

.style__tabs__3G59q .style__tabbox__28w4V div:nth-child(3) div[data-v-9c86c1e4] {
  border-radius: 0;
}

.style__tabs__3G59q .style__tabbox__28w4V div:nth-child(3) div.style__left__2hBZO[data-v-9c86c1e4] {
  border-bottom-left-radius: 50%;
}

.style__tabs__3G59q .style__tabbox__28w4V div:nth-child(3) div.style__right__2uGu0[data-v-9c86c1e4] {
  border-bottom-right-radius: 50%;
}

.style__tabs__3G59q .style__tabbox__28w4V .style__tab__muKEa[data-v-9c86c1e4] {
  border-top-right-radius: 0.2rem;
  border-top-left-radius: 0.2rem;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: center;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #a5a9b3;
  position: relative;
  font-family: PingFang SC;
  font-size: 12px;
}

.style__tabs__3G59q .style__tabbox__28w4V .style__tab__muKEa.style__active__2iKE0[data-v-9c86c1e4] {
  background: #fff;
  color: #ede9e7;
}

.style__tabs__3G59q .style__tabbox__28w4V .style__tab__muKEa.style__active__2iKE0 span[data-v-9c86c1e4] {
  position: absolute;
  width: 0.6rem;
  height: 0.04rem;
  left: 50%;
  margin-left: -0.3rem;
  bottom: 0.06rem;
  background: #ede9e7;
}

.style__tabs__3G59q.style__yibo__1HqQr[data-v-9c86c1e4],
.style__tabs__3G59q.style__yibo__1HqQr .style__tabbox__28w4V[data-v-9c86c1e4] {
  background: #161a28;
}

.style__tabs__3G59q.style__yibo__1HqQr .style__tabbox__28w4V>div[data-v-9c86c1e4]:first-child,
.style__tabs__3G59q.style__yibo__1HqQr .style__tabbox__28w4V>div[data-v-9c86c1e4]:last-child,
.style__tabs__3G59q.style__yibo__1HqQr .style__tabbox__28w4V>div[data-v-9c86c1e4]:nth-child(3) {
  background: #222536;
}

.style__tabs__3G59q.style__yibo__1HqQr .style__tabbox__28w4V>div:first-child>div[data-v-9c86c1e4],
.style__tabs__3G59q.style__yibo__1HqQr .style__tabbox__28w4V>div:last-child>div[data-v-9c86c1e4],
.style__tabs__3G59q.style__yibo__1HqQr .style__tabbox__28w4V>div:nth-child(3)>div[data-v-9c86c1e4] {
  background: #161a28;
}

.style__tabs__3G59q.style__yibo__1HqQr .style__tabbox__28w4V .style__tab__muKEa[data-v-9c86c1e4] {
  color: #6c6e82;
}

.style__tabs__3G59q.style__yibo__1HqQr .style__tabbox__28w4V .style__tab__muKEa.style__active__2iKE0[data-v-9c86c1e4] {
  background: #222536;
  color: #ede9e7;
}

.myDeposit__box__397uk[data-v-9c86c1e4] {
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  /* min-height: calc(100vh - 50px); */
  background: #f8f8f8;
  -webkit-transition: -webkit-transform 0.3s ease-in-out;
  transition: -webkit-transform 0.3s ease-in-out;
  transition: transform 0.3s ease-in-out;
  transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;
}

.myDeposit__box__397uk .myDeposit__fixedWrapper__15AIt[data-v-9c86c1e4] {
  width: 100%;
  height: 0.78rem;
}

.myDeposit__box__397uk .myDeposit__fixedWrapper__15AIt.myDeposit__hasNotice__2zsvv[data-v-9c86c1e4] {
  height: 1.2rem;
}

.myDeposit__box__397uk .myDeposit__fixedWrapper__15AIt .myDeposit__fixedCont__cUHL2[data-v-9c86c1e4] {
  width: 100%;
  position: fixed;
  top: 0.9rem;
  z-index: 20;
}

.myDeposit__box__397uk .myDeposit__fixedWrapper__15AIt .myDeposit__fixedContApp__YOceH[data-v-9c86c1e4] {
  top: 0;
}

.myDeposit__box__397uk .myDeposit__protoLink__1RJOx[data-v-9c86c1e4] {
  padding: 0 0.28rem 0.28rem;
  background: #fff;
}

.myDeposit__box__397uk .myDeposit__protoLink__1RJOx.myDeposit__yibo__2Q4DE[data-v-9c86c1e4] {
  background: #222536;
}

.myDeposit__box__397uk .myDeposit__protoLink__1RJOx.myDeposit__yibo__2Q4DE .myDeposit__content__2vKJV[data-v-9c86c1e4] {
  background: #161a28;
}

.myDeposit__box__397uk .myDeposit__protoLink__1RJOx.myDeposit__yibo__2Q4DE .myDeposit__content__2vKJV .myDeposit__topWrap__1jhxh span[data-v-9c86c1e4] {
  color: #dedede;
}

.myDeposit__box__397uk .myDeposit__protoLink__1RJOx.myDeposit__yibo__2Q4DE .myDeposit__content__2vKJV .myDeposit__topWrap__1jhxh a[data-v-9c86c1e4] {
  color: #6c6e82;
}

.myDeposit__box__397uk .myDeposit__protoLink__1RJOx.myDeposit__yibo__2Q4DE .myDeposit__content__2vKJV .myDeposit__botWrap__C8_PP .myDeposit__stepWrap__2RzGu>span[data-v-9c86c1e4] {
  color: #6c6e82;
  background-image: url(/static/img/button_step_large_dark.d5d5e1bf3dd214ee5e1f959d806f4c4c.d5d5e1bf.png);
}

.myDeposit__box__397uk .myDeposit__protoLink__1RJOx.myDeposit__yibo__2Q4DE .myDeposit__content__2vKJV .myDeposit__botWrap__C8_PP .myDeposit__stepWrap__2RzGu>span[data-v-9c86c1e4]:nth-of-type(3) {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIwAAAA0CAYAAABYWdAmAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALvSURBVHgB7Z09b9NAGMef51zaIQssrRiZutRZWoTEWCQGBEFsdGeGTwHsfAWGMCeUAanZo8DiZKV7wpyBOLnDL21iO345e2ue/2+omvPd9tfd73LPOdw+e/WRyLgEpDCnxeKd5/2cUwMUkR4SkESL7h1cUEMULfwrClMH5MCm456+brSqqGhqMnxFQBTM+i01QIV/DK2wLInDuO3HL59RTaLAjH//GAeZGxOQhTEX7fbzVp0hav2fXvYJCIMPaf+gU2fEJjDLVTjDQH7FYTonTzpHtr3XgYn35bpHQBottTLvbTur1KfFEoERiXFtt9mpwMSzDORXIszLDzYCrLINxqy+ERCInQBvBSbeYkN+ZVItwCq/GfIrlECAV6XnTPmBgfwKhs/LBDg3MJBf2ZSdM6miB5BfyQTnTGedXAEuDAzkVzo695xJVQyCy8glt9CqPDCx/GKWkUpOoVVpYG7kd0JALFkBVlUDAvnFsiSadKFVZWBQXAWShVaVgYnBzQLZbM6Z7AKDmwXg5pzJsek6nf7xjx4ePyCmYwJS2WdDjyyXpABlahULg11E/7UKTPvpm0MyVPtKAtgttON07WYY38fda/FwdzLsTW2XpEa35MCuwDNa3I++j6sMjHv6wg2WI+trCGAHYdP1vK/RLrkyMKzUOQG5GLr2Rt/Xd+9LAwPZBXpPfU5+Lp9hILvCMYNQdJMtexUjILti4Zl2VDfbWhgYyK5wAtGdDPvTbHPhkgTZlQzPkqKbJDcwkF3ZGNafip4V3Ev6h7CIxQzGo8vroqf5gWEsR0KZh+dFZR22AhOV40F2hcK97DY6y/YMYxizi0gC0f3V71b1SgUmkl28FVwmwTbaplv6exjfb/yGaHCXMQNvdGn1rubsknRCQBxVoptkHRjIrlTiwijb3psZBrIrEDvRTRIFBrIrFEvRTRLPMJBdgfC46LyojNslCbIrDO3wF2qAguxKZLswyhZFmmr9OAG464SFUU5td7nlP58dBnQiOaueAAAAAElFTkSuQmCC);
}

.myDeposit__box__397uk .myDeposit__protoLink__1RJOx .myDeposit__content__2vKJV[data-v-9c86c1e4] {
  padding: 0.2rem 0;
  background: #f8f8f8;
  border-radius: 0.12rem;
}

.myDeposit__box__397uk .myDeposit__protoLink__1RJOx .myDeposit__content__2vKJV .myDeposit__topWrap__1jhxh[data-v-9c86c1e4] {
  padding: 0 0.28rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.myDeposit__box__397uk .myDeposit__protoLink__1RJOx .myDeposit__content__2vKJV .myDeposit__topWrap__1jhxh span[data-v-9c86c1e4] {
  color: #414655;
  font-size: 0.28rem;
  font-weight: 700;
}

.myDeposit__box__397uk .myDeposit__protoLink__1RJOx .myDeposit__content__2vKJV .myDeposit__topWrap__1jhxh a[data-v-9c86c1e4] {
  color: #a5a9b3;
  font-size: 0.24rem;
}

.myDeposit__box__397uk .myDeposit__protoLink__1RJOx .myDeposit__content__2vKJV .myDeposit__botWrap__C8_PP[data-v-9c86c1e4] {
  padding: 0.2rem 0.2rem 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.myDeposit__box__397uk .myDeposit__protoLink__1RJOx .myDeposit__content__2vKJV .myDeposit__botWrap__C8_PP .myDeposit__stepWrap__2RzGu[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.myDeposit__box__397uk .myDeposit__protoLink__1RJOx .myDeposit__content__2vKJV .myDeposit__botWrap__C8_PP .myDeposit__stepWrap__2RzGu>span[data-v-9c86c1e4] {
  width: 2.2rem;
  height: 0.56rem;
  line-height: 0.56rem;
  color: #a5a9b3;
  font-size: 0.2rem;
  text-align: center;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAAA0CAYAAADPCHf8AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALCSURBVHgB7d0hcNtAEIXhtWh4y8vDixseXHPz4ibYKW2Kw1UsHt7g8vCWB7u7mYsnss7S3elmam3+b8bjxM6Evaz1tFJWu91uKyLnAixbt1qt7qSyRh+3Aizfpf6xv5TKGk3dX31uBVi+jYak6qehJjx3+ngSYPmuNCTvpZLngOgUsXBU//wG/Adn+thqSM6kgpcJYiG516ffAizfO31cSQXNwfc/BfDhXKfIRmbqBUSniE2QewF8sGZrLTM0kdfsWIQDdnix1pB8lEKDgIQD9k4AP75oSD5IgdgEsZDYeZE/AvhgjVZR/duMvPdDAD+s2fqaW/8eDUg4YKf2hSf2MSur2Wom3mdPC95c5DRbowFhTwtOWbN1kfKDUxPEsKcFjzYpzdZkQNjTglNJzVbKBGFPC15NNltJAQnY04JHo81WckDY04JjR5utnAli2NOCV+vYJbtZAWFPC84Nmq3cCWIsIOxpwavt62YrOyBhirCnBa96l+yWTBD2tODd/pLdlRTShNkv4QQiPOuKJgjwRjzNCcisa32BE/dgFw4WBSRsQiZtQwILZFvs3+2L0gnyWQCfLBzXoa3ND0g4JV/t1o7AibnRcOzP82UFJDRX1e+gDZyIOw3H4+sXcieITY8q9zwFTkyr4RisUSUHJEwPDszh0UO41dVAzgTZCuDPvrGKSQpIqHU5MIc3vcYqZjIg4aMVtS68sVD0GquYlAlirRXTA960h41VzGhAqHXhVLSxipmaIOxbwZvuWGMVczQg7FvBocfc/6U+NkE4MIcn1lh9k0zRgLBvBWessbqeaqxiBgEJB+afBPDjtiQcJjZBmB7wxBqrX1KoFxD2reBMVmMVczhB2LeCF9mNVcw+IOxbwZGixirmOSDsW8GR4sYq5mWCMD3gxU2tcJgmTA9WSuBBG+76WY1NEMIBD9q5jVXMPzyG0oj5jr9QAAAAAElFTkSuQmCC);
  background-size: cover;
}

.myDeposit__box__397uk .myDeposit__protoLink__1RJOx .myDeposit__content__2vKJV .myDeposit__botWrap__C8_PP .myDeposit__stepWrap__2RzGu>span[data-v-9c86c1e4]:nth-of-type(3) {
  width: 1.5rem;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIwAAAA0CAYAAABYWdAmAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJXSURBVHgB7Z2xUsJAFEUf29LrT8hPYE8tvbV+hdr7E7HGGnprrOnFmhr34SazCbvZl3Rw75nJACHp7tw9SXZhcjweX0RkJgSFg98eJ5PJQUbg/PYlBImp35YyEg3MWv5TR3BY+JFl1KjiQjWthaDxICNw4ZXDEh4z3zL3MpBTYHzLbP3LVggaSx+a6ZATXPT+UwgaN35bDDkhDow2DOUXDxXgW+vBTWCC/K6EoKFD0pP1YNf5zMBgMrNeZrcCE1qG8ovJs0WAXWLfhxBETAJ8FphwiU35xaQowC6zny6DSfE5EwNDusz7BDgZGMovPNnnTK7nJMovLnqZnRTgbGAov/AknzO5wkl0GVySAmwJDFsGl7OJVr2BCfL7LQSZlgCXGkbhsIRNa6JVMTCcXEUkEmBLwyicwolN85zJGhiuLCCn50ymwHBlAZEw0craMPUJBJtfU2B8FekYNnhJArk6KmvDcO01qbya/FgDM2qVHLka9hLuxxUDE24Nm5chkKukqn/twdIwcyHI7HxYmivk3sBQdonnLf5QahjKLjYbFd14RykwlF1cVHSr7s5sYCi78FTddlH6Goayi8s+Ft2YZGAou/C85r7INQzDgouK7i73ZS4wHI4w0ZtzVd8BZ4EJ0/Eou5isUqIbk2oYtgsmKrpV6aBWYILs8mYdJsWwKN2GGf0L0eSi2eQuo7t0A3MnBBFTuyhNYCi7sFQl0Y2JG4ayi4dJdGNOgaHswjIoLErdMJRdPLZW0Y2pA0PZxeNdRuAou5BshohujDbMoD8nIBdPcmKUlT/eI6F1zcYyHAAAAABJRU5ErkJggg==);
}

.myDeposit__box__397uk .myDeposit__protoLink__1RJOx .myDeposit__content__2vKJV .myDeposit__botWrap__C8_PP .myDeposit__closeWrap__3NhCj[data-v-9c86c1e4] {
  padding: 0.08rem;
  line-height: 1;
}

.myDeposit__box__397uk .myDeposit__protoLink__1RJOx .myDeposit__content__2vKJV .myDeposit__botWrap__C8_PP .myDeposit__closeWrap__3NhCj .myDeposit__close__28QtJ[data-v-9c86c1e4] {
  width: 0.24rem;
  height: 0.24rem;
}

.myDeposit__box__397uk .myDeposit__protoPicker__1X5TJ[data-v-9c86c1e4] {
  padding: 0.2rem 0.28rem 0.28rem;
  background: #fff;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.myDeposit__box__397uk .myDeposit__protoPicker__1X5TJ.myDeposit__yibo__2Q4DE[data-v-9c86c1e4] {
  background: #222536;
}

.myDeposit__box__397uk .myDeposit__protoPicker__1X5TJ.myDeposit__yibo__2Q4DE .myDeposit__actionArea__39cuv>span[data-v-9c86c1e4] {
  color: #dedede;
}

.myDeposit__box__397uk .myDeposit__protoPicker__1X5TJ.myDeposit__yibo__2Q4DE .myDeposit__actionArea__39cuv .myDeposit__protoContainer__HAGtk>div[data-v-9c86c1e4] {
  color: #a1a2a7;
  border: 1px solid #6c6e82;
}

.myDeposit__box__397uk .myDeposit__protoPicker__1X5TJ.myDeposit__yibo__2Q4DE>a[data-v-9c86c1e4] {
  color: #dedede;
}

.myDeposit__box__397uk .myDeposit__protoPicker__1X5TJ .myDeposit__actionArea__39cuv[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.myDeposit__box__397uk .myDeposit__protoPicker__1X5TJ .myDeposit__actionArea__39cuv>span[data-v-9c86c1e4] {
  color: #414655;
  font-size: 0.28rem;
  font-weight: 700;
  margin-right: 0.28rem;
}

.myDeposit__box__397uk .myDeposit__protoPicker__1X5TJ .myDeposit__actionArea__39cuv .myDeposit__protoContainer__HAGtk[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.myDeposit__box__397uk .myDeposit__protoPicker__1X5TJ .myDeposit__actionArea__39cuv .myDeposit__protoContainer__HAGtk .divbox[data-v-9c86c1e4] {
  width: 1.58rem;
  height: 0.7rem;
  border-radius: 0.1rem;
  border: 1px solid #eee;
  text-align: center;
  line-height: 0.7rem;
  color: #414655;
  font-size: 0.28rem;
  margin-right: 0.2rem;
  position: relative;
  overflow: hidden;
}

.myDeposit__box__397uk .myDeposit__protoPicker__1X5TJ .myDeposit__actionArea__39cuv .myDeposit__protoContainer__HAGtk>div .myDeposit__jiaoBiao__30T-f[data-v-9c86c1e4] {
  position: absolute;
  right: -0.02rem;
  height: 0.32rem;
  bottom: -0.02rem;
}

.myDeposit__box__397uk .myDeposit__protoPicker__1X5TJ .myDeposit__actionArea__39cuv .myDeposit__protoContainer__HAGtk>div span[data-v-9c86c1e4] {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 0.42rem;
  width: 0.42rem;
  color: #fff;
  text-indent: 0.1rem;
}

.myDeposit__box__397uk .myDeposit__protoPicker__1X5TJ .myDeposit__actionArea__39cuv .myDeposit__protoContainer__HAGtk .myDeposit__active__2Ckr3[data-v-9c86c1e4] {
  color: #ede9e7;
  border: 1px solid #ede9e7;
}

.myDeposit__box__397uk .myDeposit__protoPicker__1X5TJ>a[data-v-9c86c1e4] {
  color: #414655;
}

.myDeposit__box__397uk .myDeposit__usdtContainer__ogKin[data-v-9c86c1e4] {
  padding-left: 0.28rem;
  background: #fff;
  color: #414655;
  font-size: 0.24rem;
  padding-bottom: 0.2rem;
}

.myDeposit__box__397uk .myDeposit__usdtContainer__ogKin.myDeposit__yibo__2Q4DE[data-v-9c86c1e4] {
  background: #222536;
  color: #dedede;
}

.myDeposit__box__397uk .myDeposit__usdtContainer__ogKin>div[data-v-9c86c1e4] {
  margin-bottom: 0.2rem;
}

.myDeposit__box__397uk .myDeposit__usdtContainer__ogKin>div span[data-v-9c86c1e4] {
  color: #ede9e7;
}

.myDeposit__box__397uk .myDeposit__menu_li__1tbSW[data-v-9c86c1e4] {
  position: fixed;
  z-index: 5;
}

.myDeposit__box__397uk .myDeposit__bankList__2Jd9c[data-v-9c86c1e4],
.myDeposit__box__397uk .myDeposit__bankSelect__jBn4Y[data-v-9c86c1e4],
.myDeposit__box__397uk .myDeposit__menu_li__1tbSW[data-v-9c86c1e4] {
  width: 100%;
  height: 1rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border-bottom: 0.02rem solid #f2f2f2;
  background: #fff;
  margin-bottom: 0.2rem;
}

.myDeposit__box__397uk .myDeposit__bankList__2Jd9c[data-v-9c86c1e4],
.myDeposit__box__397uk .myDeposit__bankSelect__jBn4Y[data-v-9c86c1e4] {
  margin-top: 0.2rem;
}

.myDeposit__box__397uk .myDeposit__bankList__2Jd9c .myDeposit__menu_icon__2QBRD[data-v-9c86c1e4],
.myDeposit__box__397uk .myDeposit__bankSelect__jBn4Y .myDeposit__menu_icon__2QBRD[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.myDeposit__box__397uk .myDeposit__bankList__2Jd9c .myDeposit__menu_name__2V2xz[data-v-9c86c1e4],
.myDeposit__box__397uk .myDeposit__bankSelect__jBn4Y .myDeposit__menu_name__2V2xz[data-v-9c86c1e4] {
  font-size: 0.28rem;
  padding-left: 0.24rem;
  font-weight: 600;
}

.myDeposit__box__397uk .myDeposit__bankList__2Jd9c .myDeposit__menu_name__2V2xz .myDeposit__asterisk__1jCB3[data-v-9c86c1e4],
.myDeposit__box__397uk .myDeposit__bankSelect__jBn4Y .myDeposit__menu_name__2V2xz .myDeposit__asterisk__1jCB3[data-v-9c86c1e4] {
  color: #db6372;
}

.myDeposit__box__397uk .myDeposit__bankList__2Jd9c .myDeposit__menu_short_title__W90aS[data-v-9c86c1e4],
.myDeposit__box__397uk .myDeposit__bankSelect__jBn4Y .myDeposit__menu_short_title__W90aS[data-v-9c86c1e4] {
  padding-right: 10px;
  font-size: 0.24rem;
  color: #a5a9b3;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.myDeposit__box__397uk .myDeposit__bankList__2Jd9c .myDeposit__menu_name_after__zCs67[data-v-9c86c1e4],
.myDeposit__box__397uk .myDeposit__bankSelect__jBn4Y .myDeposit__menu_name_after__zCs67[data-v-9c86c1e4] {
  margin-left: 0.2rem;
  color: #ccc;
}

.myDeposit__box__397uk .myDeposit__bankList__2Jd9c .myDeposit__menu_name_after_arrive__Teu8_[data-v-9c86c1e4],
.myDeposit__box__397uk .myDeposit__bankSelect__jBn4Y .myDeposit__menu_name_after_arrive__Teu8_[data-v-9c86c1e4] {
  margin-left: 0.2rem;
}

.myDeposit__box__397uk .myDeposit__bankList__2Jd9c .myDeposit__iconArrow__2EgN6[data-v-9c86c1e4],
.myDeposit__box__397uk .myDeposit__bankSelect__jBn4Y .myDeposit__iconArrow__2EgN6[data-v-9c86c1e4] {
  display: inline-block;
  width: 0.28rem;
  height: 0.28rem;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAMFBMVEUAAACbm5ufn5+ZmZmZmZmampqZmZmampqZmZmbm5ucnJyZmZmZmZmZmZmcnJyZmZmmdE9kAAAAD3RSTlMAFgj11brmJkFVHaB2ZDHFBCV6AAAARElEQVQ4y2MYDGC2AHZx9v+O2CUY87/g0FKGSwv7qJaB1HL//wSs4hz2XxWwSjT/DxrVQD8NXDANmBIQDZjgjQID/QEA7Vs72qbVoBQAAAAASUVORK5CYII=);
  background-repeat: no-repeat;
  background-size: contain;
}

.webpa .myDeposit__box__397uk .myDeposit__bankList__2Jd9c .myDeposit__iconArrow__2EgN6[data-v-9c86c1e4],
.webpa .myDeposit__box__397uk .myDeposit__bankSelect__jBn4Y .myDeposit__iconArrow__2EgN6[data-v-9c86c1e4] {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAMFBMVEUAAACbm5ufn5+ZmZmZmZmampqZmZmampqZmZmbm5ucnJyZmZmZmZmZmZmcnJyZmZmmdE9kAAAAD3RSTlMAFgj11brmJkFVHaB2ZDHFBCV6AAAARElEQVQ4y2MYDGC2AHZx9v+O2CUY87/g0FKGSwv7qJaB1HL//wSs4hz2XxWwSjT/DxrVQD8NXDANmBIQDZjgjQID/QEA7Vs72qbVoBQAAAAASUVORK5CYII=);
}

.myDeposit__box__397uk .myDeposit__virtualCurrency__1zmtY[data-v-9c86c1e4] {
  text-align: right;
  color: #158bf4;
  line-height: 0.72rem;
  border-top: 1px solid #eee;
  font-size: 0.24rem;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_[data-v-9c86c1e4] {
  width: 100%;
  background: #fff;
  padding: 0 0.28rem;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ h2[data-v-9c86c1e4] {
  width: 100%;
  height: 0.8rem;
  border-bottom: 0.02rem solid #eee;
  line-height: 0.8rem;
  font-size: 0.28rem;
  color: #414655;
  font-weight: 700;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__depositAmount__3ymes[data-v-9c86c1e4] {
  height: 0.8rem;
  line-height: 0.8rem;
  font-size: 0.28rem;
  color: #414655;
  font-weight: 700;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__depositAmount__3ymes .myDeposit__discountCont__2RvNJ[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #db6372;
  font-size: 0.2rem;
  font-weight: 400;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__depositAmount__3ymes .myDeposit__discountCont__2RvNJ .myDeposit__IconTip__1lwO2[data-v-9c86c1e4] {
  margin-left: 0.04rem;
  width: 0.28rem;
  height: 0.28rem;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__depositAmount__3ymes .myDeposit__displayNone__nRH29[data-v-9c86c1e4] {
  display: none;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_.myDeposit__yibo__2Q4DE .myDeposit__depositAmount__3ymes[data-v-9c86c1e4] {
  padding-right: 0.28rem;
  color: #dedede;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__depositAmountInput__hTSxI[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__depositAmountInput__hTSxI div[class*='amountInput'][data-v-9c86c1e4] {
  width: 90%;
  padding-left: 0;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__depositAmountInput__hTSxI div[class*='amountInput']>section[data-v-9c86c1e4]:before {
  background: none !important;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__depositAmountInput__hTSxI div[class*='amountInput']>section .am-list-item.am-input-item[data-v-9c86c1e4] {
  padding-left: 0;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__depositAmountInput__hTSxI div[class*='amountInput']>section .fake-input[data-v-9c86c1e4] {
  font-size: 0.48rem !important;
  color: #414655 !important;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__depositAmountInput__hTSxI div[class*='amountInput']>section .fake-input-placeholder[data-v-9c86c1e4] {
  font-family: PingFang SC !important;
  font-size: 0.36rem !important;
  color: #e0e3eb !important;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__depositAmountInput__hTSxI div[class*='amountInput']>section .am-input-clear[data-v-9c86c1e4] {
  background-color: initial;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAWlBMVEUAAABtboNtb4N8kZhsboNtboJucYVtcIRsboJ0dItucYRvc4Zuc4VsboJtboNtboJtb4Ntb4Ntb4JtcIN8fJttb4NzdIltboNvb4Rtb4Nsb4Jsb4Ntb4NsboKqh8QPAAAAHXRSTlMAyNcG7L0/cdoRMSch887Dt4iBVAhmGOo+qK6qinMF874AAADdSURBVCjPfZPbkoMgEESbWyCg68asJrub/v/fjIBxSh7oBynr1AxNM+BQnF0Yx+DmiFZ3zU2PR/7q+wkNipx8MoBJfiLVIOxiqZ7y+1S0l4ORN5x0I3c6WC5otNDWzqrWtbWq+KxLK8XsWdf2q7+iyPhUjWggctp3UYWab76QNTFipkfWj+PXNbO8ZHnOcEwQKgyJDoEGO92AMBgGjBYQKgywYxee2+o/6lXangzp1fwyrGJIjlKLNjp8jiIhFFbo/xEC2viwxD2+bvC9K+tedm9M+gPWH83+UHefwxtGghPEEBK9aAAAAABJRU5ErkJggg==);
  width: 0.28rem !important;
  height: 0.28rem !important;
  background-size: cover;
  background-position: 0 0;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__depositAmountInput__hTSxI .myDeposit__unit__1W8i5[data-v-9c86c1e4] {
  font-size: 0.28rem;
  color: #414655;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_.myDeposit__yibo__2Q4DE .myDeposit__depositAmountInput__hTSxI[data-v-9c86c1e4] {
  padding-right: 0.28rem;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_.myDeposit__yibo__2Q4DE .myDeposit__depositAmountInput__hTSxI div[class*='amountInput']>section>div[data-v-9c86c1e4] {
  background: #222536 !important;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_.myDeposit__yibo__2Q4DE .myDeposit__depositAmountInput__hTSxI div[class*='amountInput']>section .fake-input[data-v-9c86c1e4] {
  color: #dedede !important;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_.myDeposit__yibo__2Q4DE .myDeposit__depositAmountInput__hTSxI div[class*='amountInput']>section .fake-input-placeholder[data-v-9c86c1e4] {
  color: #6c6e82 !important;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_.myDeposit__yibo__2Q4DE .myDeposit__depositAmountInput__hTSxI .myDeposit__unit__1W8i5[data-v-9c86c1e4] {
  color: #dedede;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__depositAmountLine__2H_IP[data-v-9c86c1e4] {
  height: 0.02rem;
  background: rgba(0, 0, 0, 0.0001);
  -webkit-box-shadow: inset 0 0.5px 0 #eee;
  box-shadow: inset 0 0.5px 0 #eee;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_.myDeposit__yibo__2Q4DE .myDeposit__depositAmountLine__2H_IP[data-v-9c86c1e4] {
  padding-right: 0.28rem;
  -webkit-box-shadow: inset 0 0.5px 0 #373a4c;
  box-shadow: inset 0 0.5px 0 #373a4c;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__depositExchangeRate__3_OsU[data-v-9c86c1e4],
.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__depositRemark__2u3s8[data-v-9c86c1e4] {
  color: #db6372;
  font-size: 0.24rem;
  font-family: DINPro;
  line-height: 0.28rem;
  padding: 0.12rem 0;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__depositExchangeRate__3_OsU[data-v-9c86c1e4] {
  color: #a5a9b3;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__depositExchangeRate__3_OsU>i[data-v-9c86c1e4] {
  color: #ede9e7;
  font-size: 0.24rem;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__depositExchangeRate__3_OsU>span[data-v-9c86c1e4] {
  font-size: 0.24rem;
  position: relative;
  left: -6px;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_.myDeposit__yibo__2Q4DE .myDeposit__depositExchangeRate__3_OsU[data-v-9c86c1e4] {
  color: #6c6e82;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__payList__g3StX[data-v-9c86c1e4] {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 0.2rem 0;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__payList__g3StX.myDeposit__amountList__AVuL1[data-v-9c86c1e4] {
  padding-bottom: 0;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__payList__g3StX li[data-v-9c86c1e4] {
  width: 1.58rem;
  height: 1.4rem;
  border: 0.02rem solid #eee;
  margin-bottom: 0.2rem;
  border-radius: 0.1rem;
  position: relative;
  overflow: hidden;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__payList__g3StX li .myDeposit__depositRate__XvFye[data-v-9c86c1e4] {
  font-size: 0.2rem;
  color: #ec5343;
  -webkit-transform: scale(0.8);
  transform: scale(0.8);
  margin-top: 0;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__payList__g3StX li.myDeposit__mr__3m6l1[data-v-9c86c1e4] {
  margin-left: 0;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__payList__g3StX li.myDeposit__active__2Ckr3[data-v-9c86c1e4] {
  border: 0.02rem solid #ede9e7;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__payList__g3StX li.myDeposit__active__2Ckr3 span[data-v-9c86c1e4] {
  color: #ede9e7;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__payList__g3StX li.myDeposit__active__2Ckr3 .myDeposit__depositRate__XvFye[data-v-9c86c1e4] {
  color: #ec5343;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__payList__g3StX li.myDeposit__disable__tK1lg[data-v-9c86c1e4] {
  background: #f5f5f5;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__payList__g3StX li img.myDeposit__recommend__2wYbc[data-v-9c86c1e4] {
  position: absolute;
  width: 0.6rem;
  height: auto;
  right: 0;
  top: 0;
  margin: 0;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__payList__g3StX li img[data-v-9c86c1e4] {
  display: block;
  height: 0.48rem;
  margin: 0.2rem auto 0;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__payList__g3StX li .myDeposit__jiaoBiao__30T-f[data-v-9c86c1e4] {
  position: absolute;
  right: -0.02rem;
  height: 0.32rem;
  bottom: -0.02rem;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__payList__g3StX li span[data-v-9c86c1e4] {
  display: block;
  text-align: center;
  font-size: 0.24rem;
  color: #414655;
  overflow: hidden;
  word-break: break-all;
  margin-top: 0.1rem;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__payList__g3StX .myDeposit__amount__3HrsW[data-v-9c86c1e4] {
  width: 1.58rem;
  height: 0.7rem;
  text-align: center;
  margin-left: 0.2rem;
  font-weight: 500;
  line-height: 0.7rem;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__payList__g3StX .myDeposit__amount__3HrsW span[data-v-9c86c1e4]:first-of-type {
  font-size: 0.24rem;
  -webkit-transform: scale(0.7);
  transform: scale(0.7);
  display: inline;
  font-family: DINPro-Medium;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__payList__g3StX .myDeposit__amount__3HrsW span[data-v-9c86c1e4]:last-of-type {
  font-size: 0.28rem;
  display: inline;
  font-family: DINPro-Medium;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__payList__g3StX .myDeposit__otherAmount__1cjRK[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__payList__g3StX .myDeposit__otherAmount__1cjRK span[data-v-9c86c1e4] {
  display: block !important;
  font-size: 0.18rem !important;
  color: #9a9a9a;
  text-align: center;
  margin-top: 0;
  line-height: normal;
  display: block;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__payList__g3StX .myDeposit__otherAmount__1cjRK span[data-v-9c86c1e4]:first-child {
  font-size: 0.24rem !important;
  color: #414655;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__payList__g3StX .myDeposit__otherAmount__1cjRK span[data-v-9c86c1e4]:last-child {
  font-family: DINPro;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__payList__g3StX .myDeposit__otherAmount__1cjRK.myDeposit__active__2Ckr3 span[data-v-9c86c1e4] {
  color: #ede9e7;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__fastTab__3_4pe[data-v-9c86c1e4] {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding-bottom: 0.4rem;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__fastTab__3_4pe span[data-v-9c86c1e4] {
  display: block;
  width: 3.1rem;
  height: 0.7rem;
  text-align: center;
  line-height: 0.7rem;
  color: #333;
  font-size: 0.28rem;
  border-radius: 0.1rem;
  border: 1px solid #eee;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__fastTab__3_4pe span.myDeposit__active__2Ckr3[data-v-9c86c1e4] {
  background: #ede9e7;
  color: #fff;
  border: none;
}

.myDeposit__box__397uk .myDeposit__container__2DsA_ .myDeposit__rechageNotice__2-ScQ[data-v-9c86c1e4] {
  padding: 0.2rem 0;
  line-height: 1.5;
  font-size: 0.24rem;
  color: #a5a9b3;
}

.myDeposit__box__397uk .myDeposit__depositName__32j_X[data-v-9c86c1e4] {
  width: 100%;
  background: #fff;
  margin-top: 0.2rem;
  overflow: hidden;
  padding: 0 0.28rem;
}

.myDeposit__box__397uk .myDeposit__depositName__32j_X h2[data-v-9c86c1e4] {
  width: 100%;
  height: 0.8rem;
  line-height: 0.8rem;
  font-size: 0.28rem;
  color: #414655;
  font-weight: 700;
}

.myDeposit__box__397uk .myDeposit__depositName__32j_X h2 .myDeposit__asterisk__1jCB3[data-v-9c86c1e4] {
  color: #db6372;
}

.myDeposit__box__397uk .myDeposit__depositName__32j_X>div[data-v-9c86c1e4] {
  padding: 0.2rem 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
}

.myDeposit__box__397uk .myDeposit__depositName__32j_X>div uni-input[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  border: none;
  color: #414655;
  font-size: 0.36rem;
  font-weight: 700;
}

.myDeposit__box__397uk .myDeposit__depositName__32j_X>div uni-input[data-v-9c86c1e4]::-webkit-input-placeholder {
  color: #e0e3eb;
  font-weight: 400;
}

.myDeposit__box__397uk .myDeposit__depositName__32j_X>div .myDeposit__arrowWrap__3RELw[data-v-9c86c1e4] {
  padding-left: 0.6rem;
}

.myDeposit__box__397uk .myDeposit__depositName__32j_X>div .myDeposit__arrowWrap__3RELw .myDeposit__arrow__3Ip2x[data-v-9c86c1e4] {
  width: 0.16rem;
}

.myDeposit__box__397uk .myDeposit__depositName__32j_X .myDeposit__depositNameLine__2rwFl[data-v-9c86c1e4] {
  padding: 0;
  height: 0.02rem;
  background: rgba(0, 0, 0, 0.0001);
  -webkit-box-shadow: inset 0 0.5px 0 #eee;
  box-shadow: inset 0 0.5px 0 #eee;
}

.myDeposit__box__397uk .myDeposit__depositName__32j_X p[data-v-9c86c1e4] {
  color: #a5a9b3;
  font-size: 0.24rem;
  line-height: 0.32rem;
  padding: 0.24rem 0;
}

.myDeposit__box__397uk .myDeposit__depositName__32j_X.myDeposit__yibo__2Q4DE[data-v-9c86c1e4] {
  background: #222536;
}

.myDeposit__box__397uk .myDeposit__depositName__32j_X.myDeposit__yibo__2Q4DE h2[data-v-9c86c1e4] {
  color: #dedede;
}

.myDeposit__box__397uk .myDeposit__depositName__32j_X.myDeposit__yibo__2Q4DE>div uni-input[data-v-9c86c1e4] {
  color: #dedede !important;
}

.myDeposit__box__397uk .myDeposit__depositName__32j_X.myDeposit__yibo__2Q4DE>div uni-input[data-v-9c86c1e4]::-webkit-input-placeholder {
  color: #6c6e82 !important;
}

.myDeposit__box__397uk .myDeposit__depositName__32j_X.myDeposit__yibo__2Q4DE .myDeposit__depositNameLine__2rwFl[data-v-9c86c1e4] {
  -webkit-box-shadow: inset 0 0.5px 0 #373a4c;
  box-shadow: inset 0 0.5px 0 #373a4c;
}

.myDeposit__box__397uk .myDeposit__depositName__32j_X.myDeposit__yibo__2Q4DE p[data-v-9c86c1e4] {
  color: #6c6e82;
}

.myDeposit__box__397uk .myDeposit__depositBank__2438-[data-v-9c86c1e4] {
  width: 100%;
  background: #fff;
  margin-top: 0.2rem;
  overflow: hidden;
  padding: 0 0.28rem;
}

.myDeposit__box__397uk .myDeposit__depositBank__2438- h2[data-v-9c86c1e4] {
  width: 100%;
  height: 0.8rem;
  line-height: 0.8rem;
  font-size: 0.28rem;
  color: #414655;
  font-weight: 700;
}

.myDeposit__box__397uk .myDeposit__depositBank__2438- h2 .myDeposit__asterisk__1jCB3[data-v-9c86c1e4] {
  color: #db6372;
}

.myDeposit__box__397uk .myDeposit__depositBank__2438->div[data-v-9c86c1e4] {
  padding: 0.2rem 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
}

.myDeposit__box__397uk .myDeposit__depositBank__2438->div .myDeposit__bank__wso2F[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  color: #e0e3eb;
  font-size: 0.36rem;
}

.myDeposit__box__397uk .myDeposit__depositBank__2438->div .myDeposit__bank__wso2F.myDeposit__active__2Ckr3[data-v-9c86c1e4] {
  color: #414655;
}

.myDeposit__box__397uk .myDeposit__depositBank__2438->div .myDeposit__arrow__3Ip2x[data-v-9c86c1e4] {
  width: 0.16rem;
}

.myDeposit__box__397uk .myDeposit__depositBank__2438-.myDeposit__yibo__2Q4DE[data-v-9c86c1e4] {
  background: #222536;
}

.myDeposit__box__397uk .myDeposit__depositBank__2438-.myDeposit__yibo__2Q4DE h2[data-v-9c86c1e4] {
  color: #dedede;
}

.myDeposit__box__397uk .myDeposit__depositBank__2438-.myDeposit__yibo__2Q4DE>div .myDeposit__bank__wso2F[data-v-9c86c1e4] {
  color: #6c6e82;
}

.myDeposit__box__397uk .myDeposit__depositBank__2438-.myDeposit__yibo__2Q4DE>div .myDeposit__bank__wso2F.myDeposit__active__2Ckr3[data-v-9c86c1e4] {
  color: #dedede;
}

.myDeposit__box__397uk .myDeposit__helpTit__3n-VD[data-v-9c86c1e4] {
  width: 100%;
  text-align: center;
  color: #999;
  font-size: 0.24rem;
  font-weight: 400;
  margin-bottom: 0.8rem;
  padding-bottom: 0.2rem;
}

.myDeposit__box__397uk .myDeposit__helpTit__3n-VD span[data-v-9c86c1e4] {
  color: #ede9e7;
  margin: 0 0.1rem;
}

.myDeposit__box__397uk .myDeposit__DiscountListTitle__2Ul2p[data-v-9c86c1e4] {
  text-align: center;
}

.myDeposit__DiscountListWrap__TE4_s[data-v-9c86c1e4] {
  width: 90%;
}

.myDeposit__DiscountListWrap__TE4_s .myDeposit__DiscountTable__2K4tL[data-v-9c86c1e4] {
  border-collapse: collapse;
  border-spacing: 0;
  margin: auto;
  width: 100%;
}

.myDeposit__DiscountListWrap__TE4_s .myDeposit__DiscountTable__2K4tL tr[data-v-9c86c1e4] {
  height: 0.68rem;
}

.myDeposit__DiscountListWrap__TE4_s .myDeposit__DiscountTable__2K4tL tr th[data-v-9c86c1e4] {
  font-size: 0.24rem;
  line-height: 0.56rem;
  width: 38%;
  color: #000;
  border: 1px solid #ebedf0;
}

.myDeposit__DiscountListWrap__TE4_s .myDeposit__DiscountTable__2K4tL tr th[data-v-9c86c1e4]:first-child {
  width: 28%;
}

.myDeposit__DiscountListWrap__TE4_s .myDeposit__DiscountTable__2K4tL tr td[data-v-9c86c1e4] {
  font-size: 0.28rem;
  line-height: 0.56rem;
  width: 38%;
  color: #000;
  border-bottom: 1px solid #ebedf0;
  border-right: 1px solid #ebedf0;
}

.myDeposit__DiscountListWrap__TE4_s .myDeposit__DiscountTable__2K4tL tr td[data-v-9c86c1e4]:first-child {
  font-weight: 700;
  width: 28%;
  border: 1px solid #ebedf0;
  border-top: none;
}

.myDeposit__DiscountListWrap__TE4_s .myDeposit__discountBtn__A7GHB[data-v-9c86c1e4] {
  display: block;
  width: 3.6rem;
  margin: 0.4rem auto auto;
  font-size: 0.32rem;
  line-height: 0.9rem;
  color: #fff;
  background: #ede9e7;
  border-radius: 0.1rem;
}

.myDeposit__DiscountListWrap__TE4_s .myDeposit__discountListTip__1iOxy[data-v-9c86c1e4] {
  line-height: 0.64rem;
  height: 0.52rem;
  color: #ec5343;
  text-align: left;
}

.myDeposit__DiscountListWrap__TE4_s .myDeposit__DiscountListTitle__2Ul2p[data-v-9c86c1e4] {
  font-size: 0.48rem;
  color: #000;
  font-weight: 600;
}

.myDeposit__container__2DsA_[data-v-9c86c1e4] {
  text-align: left;
  color: red;
  padding: 0.1rem;
  font-size: 0.24rem;
}

.myDeposit__container__2DsA_ *[data-v-9c86c1e4] {
  font-size: 0.28rem;
}

.myDeposit__container__2DsA_ .myDeposit__title__3HRGU[data-v-9c86c1e4] {
  color: #000;
  font-size: 0.32rem;
  font-weight: 700;
  text-align: left;
  margin-bottom: 0.2rem;
}

.myDeposit__container__2DsA_ .myDeposit__title__3HRGU span[data-v-9c86c1e4] {
  color: #ede9e7;
  font-size: 0.28rem;
}

.myDeposit__container__2DsA_ .myDeposit__name__1stWM[data-v-9c86c1e4] {
  color: #000;
  font-size: 0.28rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 0.1rem;
}

.myDeposit__container__2DsA_ .myDeposit__info__2YWLw[data-v-9c86c1e4] {
  color: #ff4d4f;
  line-height: 0.4rem;
  font-size: 0.24rem;
}

.myDeposit__container__2DsA_ .myDeposit__modelBtnBox__qyL-4[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-top: 0.48rem;
}

.myDeposit__container__2DsA_ .myDeposit__modelBtnBox__qyL-4 div[data-v-9c86c1e4] {
  width: 34vw;
  height: 0.8rem;
  font-size: 0.32rem;
  line-height: 0.8rem;
  border-radius: 0.1rem;
  border: 1px solid #ede9e7;
  text-align: center;
}

.myDeposit__container__2DsA_ .myDeposit__modelBtnBox__qyL-4 .myDeposit__close__28QtJ[data-v-9c86c1e4] {
  color: #ede9e7;
}

.myDeposit__container__2DsA_ .myDeposit__modelBtnBox__qyL-4 .myDeposit__comfim__1xz-i[data-v-9c86c1e4] {
  color: #fff;
  background-color: #ede9e7;
}

.abnormalModel[data-v-9c86c1e4],
.bankModel[data-v-9c86c1e4] {
  width: 80vw;
}

.abnormalModel[data-v-9c86c1e4] {
  width: 5.6rem;
}

.abnormalModel .am-modal-content[data-v-9c86c1e4] {
  border-radius: 0.2rem;
}

.myDeposit__abnormalContainer__1dJJs[data-v-9c86c1e4] {
  padding: 0.1rem;
}

.myDeposit__abnormalContainer__1dJJs .myDeposit__tipsTitle__3yKGB[data-v-9c86c1e4] {
  color: #333;
  font-size: 0.36rem;
  text-align: center;
  margin-bottom: 0.2rem;
}

.myDeposit__abnormalContainer__1dJJs .myDeposit__info__2YWLw[data-v-9c86c1e4] {
  color: #a5a9b3;
  font-size: 0.28rem;
  line-height: 0.44rem;
}

.myDeposit__abnormalContainer__1dJJs .myDeposit__info__2YWLw .myDeposit__payName__2qsM3[data-v-9c86c1e4] {
  color: #db6372;
  font-size: 0.28rem;
}

.myDeposit__abnormalContainer__1dJJs .myDeposit__modelBtnBox__qyL-4[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-top: 0.48rem;
}

.myDeposit__abnormalContainer__1dJJs .myDeposit__modelBtnBox__qyL-4 div[data-v-9c86c1e4] {
  width: 2.24rem;
  height: 0.8rem;
  font-size: 0.32rem;
  line-height: 0.8rem;
  border-radius: 0.1rem;
  border: 1px solid #4080ff;
  text-align: center;
}

.myDeposit__abnormalContainer__1dJJs .myDeposit__modelBtnBox__qyL-4 div.myDeposit__single__E-Q3m[data-v-9c86c1e4] {
  width: 64vw;
}

.myDeposit__abnormalContainer__1dJJs .myDeposit__modelBtnBox__qyL-4 .myDeposit__close__28QtJ[data-v-9c86c1e4] {
  color: #4080ff;
}

.myDeposit__abnormalContainer__1dJJs .myDeposit__modelBtnBox__qyL-4 .myDeposit__comfim__1xz-i[data-v-9c86c1e4] {
  color: #fff;
  background-color: #4080ff;
}

.myDeposit__abnormalContainer__1dJJs.myDeposit__yibo__2Q4DE .myDeposit__tipsTitle__3yKGB[data-v-9c86c1e4] {
  color: #deb489;
  font-weight: 700;
}

.myDeposit__abnormalContainer__1dJJs.myDeposit__yibo__2Q4DE .myDeposit__info__2YWLw[data-v-9c86c1e4] {
  color: #a1a2a7;
}

.myDeposit__abnormalContainer__1dJJs.myDeposit__yibo__2Q4DE .myDeposit__btn___1m2jO[data-v-9c86c1e4] {
  background-color: #ede9e7;
  color: #79420d !important;
  border: none !important;
  height: 0.72rem !important;
  line-height: 0.72rem !important;
  width: 2.24rem;
}

.myDeposit__rechargeWrap__249HE[data-v-9c86c1e4] {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.7);
}

.myDeposit__rechargeWrap__249HE .myDeposit__rechargeContent__WPQkj[data-v-9c86c1e4] {
  position: relative;
  padding: 0.4rem;
  width: 5.6rem;
  height: 7.5rem;
  background-color: #fff;
  border-radius: 0.2rem;
  text-align: center;
}

.myDeposit__rechargeWrap__249HE .myDeposit__rechargeContent__WPQkj img[data-v-9c86c1e4] {
  position: absolute;
  width: 0.56rem;
  height: 0.56rem;
  top: -0.76rem;
  right: -0.2rem;
}

.myDeposit__rechargeWrap__249HE .myDeposit__rechargeContent__WPQkj .myDeposit__title__3HRGU[data-v-9c86c1e4] {
  font-size: 0.36rem;
  font-weight: 700;
  color: #333;
  letter-spacing: 0.02rem;
  margin-right: -0.02rem;
}

.myDeposit__rechargeWrap__249HE .myDeposit__rechargeContent__WPQkj .myDeposit__code__1ZU7d[data-v-9c86c1e4] {
  margin-top: 0.32rem;
  color: #ede9e7;
  font-size: 0.48rem;
  letter-spacing: 0.6rem;
  margin-right: -0.6rem;
}

.myDeposit__rechargeWrap__249HE .myDeposit__rechargeContent__WPQkj .myDeposit__tips__2ZZR-[data-v-9c86c1e4] {
  margin-top: 0.46rem;
  text-align: justify;
}

.myDeposit__rechargeWrap__249HE .myDeposit__rechargeContent__WPQkj .myDeposit__tips__2ZZR- h5[data-v-9c86c1e4] {
  margin-bottom: 0.06rem;
  font-size: 0.28rem;
  color: #333;
}

.myDeposit__rechargeWrap__249HE .myDeposit__rechargeContent__WPQkj .myDeposit__tips__2ZZR- p[data-v-9c86c1e4] {
  font-size: 0.28rem;
  color: #666;
  line-height: 1.6;
}

.myDeposit__rechargeWrap__249HE .myDeposit__rechargeContent__WPQkj .myDeposit__tips__2ZZR- span[data-v-9c86c1e4] {
  font-size: 0.28rem;
  color: #ff4634;
}

.myDeposit__rechargeWrap__249HE .myDeposit__rechargeContent__WPQkj uni-button[data-v-9c86c1e4] {
  margin-top: 0.4rem;
  width: 4.8rem;
  height: 0.72rem;
  border-radius: 0.12rem;
  color: #fff;
  background-color: #ede9e7;
  font-size: 0.28rem;
  border: none;
  outline: none;
}

.myDeposit__unusualContainer__2m-ks[data-v-9c86c1e4] {
  padding: 0.1rem;
}

.myDeposit__unusualContainer__2m-ks .myDeposit__tipsTitle__3yKGB[data-v-9c86c1e4] {
  color: #333;
  font-size: 0.36rem;
  text-align: center;
  margin-bottom: 0.2rem;
}

.myDeposit__unusualContainer__2m-ks .myDeposit__info__2YWLw[data-v-9c86c1e4] {
  color: #a5a9b3;
  font-size: 0.28rem;
  line-height: 0.44rem;
}

.myDeposit__unusualContainer__2m-ks .myDeposit__info__2YWLw .myDeposit__payName__2qsM3[data-v-9c86c1e4] {
  color: #db6372;
  font-size: 0.28rem;
}

.myDeposit__unusualContainer__2m-ks .myDeposit__modelBtnBox__qyL-4[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-top: 0.48rem;
}

.myDeposit__unusualContainer__2m-ks .myDeposit__modelBtnBox__qyL-4 div[data-v-9c86c1e4] {
  width: 2.24rem;
  height: 0.8rem;
  font-size: 0.32rem;
  line-height: 0.8rem;
  border-radius: 0.1rem;
  border: 1px solid #4080ff;
  text-align: center;
}

.myDeposit__unusualContainer__2m-ks .myDeposit__modelBtnBox__qyL-4 div.myDeposit__single__E-Q3m[data-v-9c86c1e4] {
  width: 64vw;
}

.myDeposit__unusualContainer__2m-ks .myDeposit__modelBtnBox__qyL-4 .myDeposit__close__28QtJ[data-v-9c86c1e4] {
  color: #4080ff;
}

.myDeposit__unusualContainer__2m-ks .myDeposit__modelBtnBox__qyL-4 .myDeposit__comfim__1xz-i[data-v-9c86c1e4] {
  color: #fff;
  background-color: #4080ff;
}

.myDeposit__unusualContainer__2m-ks.myDeposit__yibo__2Q4DE .myDeposit__tipsTitle__3yKGB[data-v-9c86c1e4] {
  color: #deb489;
  font-weight: 700;
}

.myDeposit__unusualContainer__2m-ks.myDeposit__yibo__2Q4DE .myDeposit__info__2YWLw[data-v-9c86c1e4] {
  color: #a1a2a7;
}

.myDeposit__unusualContainer__2m-ks.myDeposit__yibo__2Q4DE .myDeposit__btn___1m2jO[data-v-9c86c1e4] {
  background-color: #ede9e7;
  color: #79420d !important;
  border: none !important;
  height: 0.72rem !important;
  line-height: 0.72rem !important;
  width: 2.24rem;
}

.myDeposit__mT10__1qfLD[data-v-9c86c1e4] {
  margin-top: 0.2rem !important;
}

.myDeposit__rechargeChat__1f3-n .myDeposit__codetip__3NWro[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 0.5rem;
  width: 100%;
  background-color: #f4f1ee;
  color: #666;
  font-size: 0.24rem;
  padding-left: 0.14rem;
}

.myDeposit__rechargeChat__1f3-n .myDeposit__codetip__3NWro img[data-v-9c86c1e4] {
  margin-right: 0.05rem;
  width: 0.48rem;
  height: 0.48rem;
}

.myDeposit__rechargeChat__1f3-n .myDeposit__scrollWrapper__PW-jy[data-v-9c86c1e4] {
  position: absolute;
  top: 1.52rem;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: scroll;
}

.myDeposit__rechargeChat__1f3-n .myDeposit__scrollWrapper__PW-jy iframe[data-v-9c86c1e4] {
  position: absolute;
  top: 0;
  bottom: 0;
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
  width: 100% !important;
  height: auto;
  border: none;
}

.myDeposit__yibo__2Q4DE .myDeposit__virtualCurrency__1zmtY[data-v-9c86c1e4] {
  color: #deb489;
  padding-right: 0.28rem;
  border-top: 1px solid #161a28;
}

.myDeposit__modalBoxNYB__20wSp[data-v-9c86c1e4] {
  position: relative;
}

.myDeposit__modalBoxNYB__20wSp .myDeposit__modalHeader__jhSue[data-v-9c86c1e4] {
  padding-bottom: 0.25rem;
  margin: 0;
  font-size: 0.36rem;
  line-height: 1;
  color: #000;
  text-align: center;
}

.myDeposit__modalBoxNYB__20wSp .myDeposit__modalContent__ZLs91[data-v-9c86c1e4] {
  padding: 0 0.1rem 1rem;
}

.myDeposit__modalBoxNYB__20wSp .myDeposit__modalFooter__3j9ab[data-v-9c86c1e4] {
  position: absolute;
  bottom: -0.3rem;
  left: -0.3rem;
  right: -0.3rem;
  color: #d2b79c;
  font-size: 0.36rem;
  height: 1rem;
  padding-top: 0.26rem;
}

.myDeposit__modalBoxNYB__20wSp .myDeposit__modalFooter__3j9ab[data-v-9c86c1e4]:after {
  content: ' ';
  position: absolute;
  background-color: #eee;
  display: block;
  z-index: 1;
  top: 0;
  right: auto;
  bottom: auto;
  left: 0;
  width: 100%;
  height: 1px;
  -webkit-transform: scaleY(0.33);
  transform: scaleY(0.33);
}

.my-deposit-page .am-modal-button-group-h .am-modal-button[data-v-9c86c1e4] {
  color: #ede9e7;
}

.my-deposit-page .am-modal-button-group-h .am-modal-button[data-v-9c86c1e4]:first-child {
  color: #000;
}

.myDeposit__speedPayDiscount__1x8sk[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  line-height: 0.4rem;
  padding: 0.48rem 0.28rem 0;
  font-size: 0.24rem;
  color: #a5a9b3;
}

.myDeposit__speedPayDiscount__1x8sk .myDeposit__times__RSlc3[data-v-9c86c1e4] {
  color: #ede9e7;
}

.myDeposit__yibo__2Q4DE .myDeposit__speedPayDiscount__1x8sk[data-v-9c86c1e4] {
  color: #6c6e82;
}

.myDeposit__btnWrap__101GA[data-v-9c86c1e4] {
  padding: 0 0.24rem;
}

.myDeposit__btnWrap__101GA>div[data-v-9c86c1e4] {
  padding-left: 0;
  padding-right: 0;
}

p.myDeposit__warmTipContent__xNOMx[data-v-9c86c1e4] {
  font-size: 0.28rem;
}

#noticeDiv[data-v-9c86c1e4] {
  padding: 0.30003rem;
}

.myDeposit__notice__2R6Nb[data-v-9c86c1e4] {
  background: #f8f8f8;
  padding: 0.1rem 0.28rem 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.myDeposit__notice__2R6Nb .myDeposit__noticeicon__lboq2[data-v-9c86c1e4] {
  display: inline-block;
  margin-right: 0.08rem;
  height: 0.32rem;
  width: 0.32rem;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAI6UExURUxpcVi7+m3b/1m8/GHC/////2LE/1m8/06x/4D//1W//0ir9kaq9Uap9kSm9Fq9/EGk9Duf8kSn9k6x/0So9Tug8jyf80Wo9kKo9Uiq9kao9kKm80Gm81mx/0Kl9ESn9U2y90Kl9Vm5+kyu90ap9kGj+EKm9FCz+WbM/1O0+Euu91e2/02x+FO3+lC0+VS4+le4+lO4+Va5+mPF/1O4+lO2+WLH/VO2+Ve8+le6/FS4+mHD/Fu2/1W4+lW5+WHK/1W4+la5+li8+lq/+1W7+li9/Fa5+lu+/Fq9/Fq8/GLH/2HF/le7+1a5+2PF/2HE/F25/3HG/1m7+1u+/Fi9/Fu++1i8+2XJ/1q9/GDE/lm8+2PG/lrD/17C/2DD/V6//IDV/2TI/2TH/13A/ar//2LG/V3B/F7B+1/B/WHE/l3A/GHF/mDC/V/C/UOm9Eap9Uqt9kWo9Uir9U2w906x90eq9Ums9kuu9kGk80Sn9FO2+UWp9Uir9kKl9D+i8z2g8kmt9kyw90yv91Cz+FG0+ESo9UCk80Cj80er9kqu9lO3+U+y+FK1+Va6+kis9Ueq9kSn9UKl8z6h80Ck9D6i80So9Eer9VK2+U6y91W4+U+z91C0+Fe6+lq9+0is9kuu90ap9D+j81a6+UGl80Km9D2h8kuv90Wo9EWp9Fe7+jyf8j2h80yv9k+z+FW4+lW5+lS4+VG1+E2x91a5+k+y92LF/Vi8+li7+mDE/GHE/Vq++2DE/Vy//F/C/KJF4voAAABudFJOUwDiB1AVAQ0XFwIMpOZu2rX39ogN9Yv4qjL9/cUrF5D5Ifpfh/0ncPIFIvcjtspclC8rcUvQs56qNVX+yBzwhB3195naaWCdnfyUeunyeftfCwl1WpN55Cb61IatETZ3XAYcKacDa+PJ587ssOf9Tls1OgAAAcBJREFUOMtjYBh8QImRH5+0hv763pVsuOW1davWbV7EDuUZm6HL66m3VHXN7IUpsN7qhSKtqTOjeXYPUAVMgb23XzhCWkFZq7i4ZFbLxq4NYAVMQOy/IxosJyQipSJZU9ZZ3liyZXbL9CqQAmZnFgYGzsidiSAFArWVlfkdRQ0FTY0lM5p7poMUOM11B5Jxu1NBCtpq8yYU5k8rKytvKi5Z29wDUsDG6AE0ImlvNkhBXcXEvNb8/KK+gvI1JSXNLWA3eG4LZmBIyc0EK5hcUZs3Nb+0pqygqXhT9yywAtftoUAyIwfEngRUkQdUAXRGZ3lxSTdYgcucICCZlQZi10+qgzijtKygs6kYosCtl5mBIWFPOoi9avWU9rbFeZXV/dOKCsobi2WBYja2DgEMDLG7kkEKBOvrp7RXLKlsrS4F+nVZIwdQzLzKDkhGzY0HKRAVq1+6sB3olcIVpUUFBeUgBQamwKAMDIuIAQclKycnp6qcYl7lcpBD53PAgt93TghyZMlI57UW5gP9ClNg4ejDghKdrGryhdX9NX0wBSZWlugJQoKvsLp0HkyBoRFmkhIWL1xQyoU30fLycDMMQwAAmkKK2W5F3bYAAAAASUVORK5CYII=);
}

.webpa .myDeposit__notice__2R6Nb .myDeposit__noticeicon__lboq2[data-v-9c86c1e4] {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAI6UExURUxpcVi7+m3b/1m8/GHC/////2LE/1m8/06x/4D//1W//0ir9kaq9Uap9kSm9Fq9/EGk9Duf8kSn9k6x/0So9Tug8jyf80Wo9kKo9Uiq9kao9kKm80Gm81mx/0Kl9ESn9U2y90Kl9Vm5+kyu90ap9kGj+EKm9FCz+WbM/1O0+Euu91e2/02x+FO3+lC0+VS4+le4+lO4+Va5+mPF/1O4+lO2+WLH/VO2+Ve8+le6/FS4+mHD/Fu2/1W4+lW5+WHK/1W4+la5+li8+lq/+1W7+li9/Fa5+lu+/Fq9/Fq8/GLH/2HF/le7+1a5+2PF/2HE/F25/3HG/1m7+1u+/Fi9/Fu++1i8+2XJ/1q9/GDE/lm8+2PG/lrD/17C/2DD/V6//IDV/2TI/2TH/13A/ar//2LG/V3B/F7B+1/B/WHE/l3A/GHF/mDC/V/C/UOm9Eap9Uqt9kWo9Uir9U2w906x90eq9Ums9kuu9kGk80Sn9FO2+UWp9Uir9kKl9D+i8z2g8kmt9kyw90yv91Cz+FG0+ESo9UCk80Cj80er9kqu9lO3+U+y+FK1+Va6+kis9Ueq9kSn9UKl8z6h80Ck9D6i80So9Eer9VK2+U6y91W4+U+z91C0+Fe6+lq9+0is9kuu90ap9D+j81a6+UGl80Km9D2h8kuv90Wo9EWp9Fe7+jyf8j2h80yv9k+z+FW4+lW5+lS4+VG1+E2x91a5+k+y92LF/Vi8+li7+mDE/GHE/Vq++2DE/Vy//F/C/KJF4voAAABudFJOUwDiB1AVAQ0XFwIMpOZu2rX39ogN9Yv4qjL9/cUrF5D5Ifpfh/0ncPIFIvcjtspclC8rcUvQs56qNVX+yBzwhB3195naaWCdnfyUeunyeftfCwl1WpN55Cb61IatETZ3XAYcKacDa+PJ587ssOf9Tls1OgAAAcBJREFUOMtjYBh8QImRH5+0hv763pVsuOW1davWbV7EDuUZm6HL66m3VHXN7IUpsN7qhSKtqTOjeXYPUAVMgb23XzhCWkFZq7i4ZFbLxq4NYAVMQOy/IxosJyQipSJZU9ZZ3liyZXbL9CqQAmZnFgYGzsidiSAFArWVlfkdRQ0FTY0lM5p7poMUOM11B5Jxu1NBCtpq8yYU5k8rKytvKi5Z29wDUsDG6AE0ImlvNkhBXcXEvNb8/KK+gvI1JSXNLWA3eG4LZmBIyc0EK5hcUZs3Nb+0pqygqXhT9yywAtftoUAyIwfEngRUkQdUAXRGZ3lxSTdYgcucICCZlQZi10+qgzijtKygs6kYosCtl5mBIWFPOoi9avWU9rbFeZXV/dOKCsobi2WBYja2DgEMDLG7kkEKBOvrp7RXLKlsrS4F+nVZIwdQzLzKDkhGzY0HKRAVq1+6sB3olcIVpUUFBeUgBQamwKAMDIuIAQclKycnp6qcYl7lcpBD53PAgt93TghyZMlI57UW5gP9ClNg4ejDghKdrGryhdX9NX0wBSZWlugJQoKvsLp0HkyBoRFmkhIWL1xQyoU30fLycDMMQwAAmkKK2W5F3bYAAAAASUVORK5CYII=);
}

.myDeposit__notice__2R6Nb.myDeposit__yibo__2Q4DE[data-v-9c86c1e4] {
  background: #161a28;
}

.myDeposit__notice__2R6Nb.myDeposit__yibo__2Q4DE span[data-v-9c86c1e4] {
  color: #6c6e82 !important;
}

.myDeposit__tabBox__3s0Jp[data-v-9c86c1e4] {
  padding: 0.2rem 0.28rem 0;
  background-color: #fff;
}

.myDeposit__tabBox__3s0Jp .myDeposit__tabs__2W0xi[data-v-9c86c1e4] {
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  height: 0.56rem;
  background-color: #eee;
  border-radius: 0.16rem;
}

.myDeposit__tabBox__3s0Jp .myDeposit__tabs__2W0xi[data-v-9c86c1e4],
.myDeposit__tabBox__3s0Jp .myDeposit__tabs__2W0xi li[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.myDeposit__tabBox__3s0Jp .myDeposit__tabs__2W0xi li[data-v-9c86c1e4] {
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 50%;
  height: calc(100% - 0.04rem);
  color: #a5a9b3;
  font-size: 0.24rem;
}

.myDeposit__tabBox__3s0Jp .myDeposit__tabs__2W0xi li.myDeposit__activeTab__2l-Dx[data-v-9c86c1e4] {
  background-color: #fff;
  color: #333;
  border-radius: 0.16rem;
  margin: 0.02rem;
}

.myDeposit__yiboTabs__3QSk3[data-v-9c86c1e4] {
  background-color: #222536;
  border-top-color: #161a28;
}

.myDeposit__yiboTabs__3QSk3 .myDeposit__tabs__2W0xi[data-v-9c86c1e4] {
  background-color: #161a28;
}

.myDeposit__yiboTabs__3QSk3 .myDeposit__tabs__2W0xi li[data-v-9c86c1e4] {
  color: #6c6e82;
}

.myDeposit__yiboTabs__3QSk3 .myDeposit__tabs__2W0xi li.myDeposit__activeTab__2l-Dx[data-v-9c86c1e4] {
  background-color: #222536;
  color: #dedede;
}

.myDeposit__payNamePicker__B0uaB .am-picker-col-item[data-v-9c86c1e4] {
  font-size: 0.4rem !important;
}

.myDeposit__payNamePicker__B0uaB .am-picker-col-item-selected[data-v-9c86c1e4] {
  font-size: 0.44rem !important;
}

.myDeposit__payNamePicker__B0uaB.myDeposit__yibo__2Q4DE .am-picker-col-mask[data-v-9c86c1e4] {
  background-image: none !important;
  background-color: #101829 !important;
}

.myDeposit__payNamePicker__B0uaB.myDeposit__yibo__2Q4DE .am-picker-popup-header[data-v-9c86c1e4] {
  background: #222536 !important;
  border-bottom: none !important;
}

.myDeposit__payNamePicker__B0uaB.myDeposit__yibo__2Q4DE .am-picker-popup-header .am-picker-popup-item[data-v-9c86c1e4] {
  color: #deb489 !important;
  font-size: 0.32rem !important;
}

.myDeposit__payNamePicker__B0uaB.myDeposit__yibo__2Q4DE .am-picker-popup-header .am-picker-popup-title[data-v-9c86c1e4] {
  color: #a1a2a7 !important;
}

.myDeposit__payNamePicker__B0uaB.myDeposit__yibo__2Q4DE .am-picker-popup-header[data-v-9c86c1e4]:after {
  content: none !important;
}

.myDeposit__payNamePicker__B0uaB.myDeposit__yibo__2Q4DE .am-picker-col-content[data-v-9c86c1e4] {
  z-index: 5 !important;
}

.myDeposit__payNamePicker__B0uaB.myDeposit__yibo__2Q4DE .am-picker-col-content .am-picker-col-item[data-v-9c86c1e4] {
  color: hsla(0, 0%, 87.1%, 0.8) !important;
}

.myDeposit__payNamePicker__B0uaB.myDeposit__yibo__2Q4DE .am-picker-col-content .am-picker-col-item-selected[data-v-9c86c1e4] {
  color: #dedede !important;
}

.myDeposit__payNamePicker__B0uaB.myDeposit__yibo__2Q4DE .am-picker-col-indicator[data-v-9c86c1e4]:after,
.myDeposit__payNamePicker__B0uaB.myDeposit__yibo__2Q4DE .am-picker-col-indicator[data-v-9c86c1e4]:before {
  background-color: #373a4c !important;
}

.myDeposit__alertCont__3Riw_[data-v-9c86c1e4] {
  font-family: PingFang SC;
  font-size: 0.36rem;
  line-height: 0.5rem;
  text-align: center;
  color: #414655;
  padding: 0.8rem 1rem 0.4rem;
}

.myDeposit__alertCont__3Riw_.myDeposit__yibo__2Q4DE[data-v-9c86c1e4] {
  color: #dedede;
}

.style__LooseChangeList__1t1Uz[data-v-9c86c1e4] {
  background: #fff;
  padding: 0 0.28rem;
}

.style__LooseChangeList__1t1Uz .style__title__2c-Mv[data-v-9c86c1e4] {
  height: 0.8rem;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border-bottom: 0.02rem solid #eee;
}

.style__LooseChangeList__1t1Uz .style__title__2c-Mv[data-v-9c86c1e4],
.style__LooseChangeList__1t1Uz .style__title__2c-Mv>div[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.style__LooseChangeList__1t1Uz .style__title__2c-Mv>div[data-v-9c86c1e4]:first-child {
  font-family: PingFang SC;
  font-size: 0.28rem;
  color: #414655;
}

.style__LooseChangeList__1t1Uz .style__title__2c-Mv>div:first-child span[data-v-9c86c1e4] {
  font-family: PingFang SC;
  font-size: 0.28rem;
  color: #ede9e7;
  margin-left: 0.06rem;
}

.style__LooseChangeList__1t1Uz .style__title__2c-Mv>div:last-child img[data-v-9c86c1e4] {
  width: 0.24rem;
  height: 0.24rem;
}

.style__LooseChangeList__1t1Uz .style__title__2c-Mv>div:last-child span[data-v-9c86c1e4] {
  margin-left: 0.06rem;
  margin-top: -0.02rem;
  font-family: PingFang SC;
  font-size: 0.24rem;
  color: #ede9e7;
}

.style__LooseChangeList__1t1Uz .style__title__2c-Mv>div.style__disable__1ReZH[data-v-9c86c1e4] {
  opacity: 0.5;
}

.style__LooseChangeList__1t1Uz .style__title__2c-Mv>div.style__reload__2yjWm img[data-v-9c86c1e4] {
  -webkit-animation: style__loading__3RE3l-data-v-9c86c1e4 1s linear infinite;
  animation: style__loading__3RE3l-data-v-9c86c1e4 1s linear infinite;
  -webkit-transform-origin: center center;
  transform-origin: center center;
}

@-webkit-keyframes style__loading__3RE3l-data-v-9c86c1e4 {
  0% {
    transform: rotate(-1turn);
    -ms-transform: rotate(-1turn);
    -webkit-transform: rotate(-1turn);
  }

  to {
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }
}

@keyframes style__loading__3RE3l-data-v-9c86c1e4 {
  0% {
    transform: rotate(-1turn);
    -ms-transform: rotate(-1turn);
    -webkit-transform: rotate(-1turn);
  }

  to {
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }
}

.style__LooseChangeList__1t1Uz .style__list__2MOwh .style__item__VkJNf[data-v-9c86c1e4] {
  height: 1rem;
  border-bottom: 0.02rem solid #eee;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.style__LooseChangeList__1t1Uz .style__list__2MOwh .style__item__VkJNf .style__item_1__2zlXW[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  font-family: DINPro;
  font-size: 0.4rem;
  font-weight: 700;
  color: #414655;
}

.style__LooseChangeList__1t1Uz .style__list__2MOwh .style__item__VkJNf .style__item_1__2zlXW span[data-v-9c86c1e4] {
  font-family: PingFang SC;
  font-size: 0.28rem;
  color: #414655;
}

.style__LooseChangeList__1t1Uz .style__list__2MOwh .style__item__VkJNf .style__item_2__27vrV[data-v-9c86c1e4] {
  margin-right: 0.4rem;
}

.style__LooseChangeList__1t1Uz .style__list__2MOwh .style__item__VkJNf .style__item_2__27vrV img[data-v-9c86c1e4] {
  width: 0.28rem;
  height: 0.28rem;
}

.style__LooseChangeList__1t1Uz .style__list__2MOwh .style__item__VkJNf .style__item_2__27vrV span[data-v-9c86c1e4] {
  font-size: 0.24rem;
  font-family: PingFang SC;
  color: #414655;
}

.style__LooseChangeList__1t1Uz .style__list__2MOwh .style__item__VkJNf .style__item_2__27vrV span[data-v-9c86c1e4]:last-child {
  font-family: DINPro;
  font-size: 0.28rem;
}

.style__LooseChangeList__1t1Uz .style__list__2MOwh .style__item__VkJNf .style__item_3__2X-ja[data-v-9c86c1e4] {
  width: 1.84rem;
  height: 0.6rem;
  background: #ede9e7;
  border-radius: 0.12rem;
  color: #fff;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  font-family: PingFang SC;
  font-size: 0.24rem;
}

.style__LooseChangeList__1t1Uz .style__list__2MOwh .style__item__VkJNf .style__item_3__2X-ja.style__disable__1ReZH[data-v-9c86c1e4] {
  opacity: 0.5;
}

.style__LooseChangeList__1t1Uz .style__tip__2kJOx[data-v-9c86c1e4] {
  height: 0.8rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #db6372;
  font-family: PingFang SC;
  font-size: 0.24rem;
}

.style__LooseChangeList__1t1Uz.style__yibo__38M9o[data-v-9c86c1e4] {
  background: #222536;
}

.style__LooseChangeList__1t1Uz.style__yibo__38M9o .style__title__2c-Mv[data-v-9c86c1e4] {
  border-bottom: 0.02rem solid #373a4c;
}

.style__LooseChangeList__1t1Uz.style__yibo__38M9o .style__title__2c-Mv>div[data-v-9c86c1e4]:first-child {
  color: #dedede;
}

.style__LooseChangeList__1t1Uz.style__yibo__38M9o .style__title__2c-Mv>div:first-child span[data-v-9c86c1e4],
.style__LooseChangeList__1t1Uz.style__yibo__38M9o .style__title__2c-Mv>div:last-child span[data-v-9c86c1e4] {
  color: #ede9e7;
}

.style__LooseChangeList__1t1Uz.style__yibo__38M9o .style__list__2MOwh .style__item__VkJNf[data-v-9c86c1e4] {
  border-bottom: 0.02rem solid #373a4c;
}

.style__LooseChangeList__1t1Uz.style__yibo__38M9o .style__list__2MOwh .style__item__VkJNf .style__item_1__2zlXW[data-v-9c86c1e4],
.style__LooseChangeList__1t1Uz.style__yibo__38M9o .style__list__2MOwh .style__item__VkJNf .style__item_1__2zlXW span[data-v-9c86c1e4],
.style__LooseChangeList__1t1Uz.style__yibo__38M9o .style__list__2MOwh .style__item__VkJNf .style__item_2__27vrV span[data-v-9c86c1e4] {
  color: #dedede;
}

.style__LooseChangeList__1t1Uz.style__yibo__38M9o .style__list__2MOwh .style__item__VkJNf .style__item_3__2X-ja[data-v-9c86c1e4] {
  background: #ede9e7;
  color: #79420d;
}

.style__LooseChangeList__1t1Uz.style__yibo__38M9o .style__tip__2kJOx[data-v-9c86c1e4] {
  color: #db6372;
}

.WarmPromptCountdownModal__modal__26ARX[data-v-9c86c1e4] {
  width: 5.6rem;
}

.WarmPromptCountdownModal__modal__26ARX .am-modal-body[data-v-9c86c1e4] {
  padding: 0 0.4rem 0.4rem !important;
}

.WarmPromptCountdownModal__modal__26ARX.WarmPromptCountdownModal__yibo__1IOVb .am-modal-content[data-v-9c86c1e4] {
  background: #222536 !important;
}

.WarmPromptCountdownModal__container__3DT5g[data-v-9c86c1e4] {
  width: 100%;
  color: #414655;
  text-align: left;
}

.WarmPromptCountdownModal__container__3DT5g *[data-v-9c86c1e4] {
  font-size: 0.32rem;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__title__3kNfb[data-v-9c86c1e4] {
  color: #414655;
  font-size: 0.36rem;
  margin: 0.1rem 0;
  text-align: center;
  height: 0.5rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__msg__1O2Rf[data-v-9c86c1e4] {
  max-height: 3.48rem !important;
  min-height: 1.6rem;
  font-size: 0.28rem;
  line-height: 0.4rem;
  overflow: auto !important;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__radio__3KRJU[data-v-9c86c1e4] {
  color: #626571;
  margin: 0.36rem 0;
  height: 0.4rem;
  font-size: 0.28rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  line-height: normal;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__radio__3KRJU img[data-v-9c86c1e4] {
  width: 0.32rem;
  height: 0.32rem;
  margin-right: 5px;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__radio__3KRJU.WarmPromptCountdownModal__active__GSI1B[data-v-9c86c1e4] {
  color: #db6372;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__btn__3V6aY[data-v-9c86c1e4] {
  height: 0.8rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background: #ede9e7;
  color: #fff;
  opacity: 0.5;
  border-radius: 0.1rem;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__btn__3V6aY.WarmPromptCountdownModal__active__GSI1B[data-v-9c86c1e4] {
  opacity: 1;
}

.WarmPromptCountdownModal__container__3DT5g.WarmPromptCountdownModal__yibo__1IOVb[data-v-9c86c1e4] {
  color: #a1a2a7;
}

.WarmPromptCountdownModal__container__3DT5g.WarmPromptCountdownModal__yibo__1IOVb .WarmPromptCountdownModal__title__3kNfb[data-v-9c86c1e4] {
  color: #deb489;
}

.WarmPromptCountdownModal__container__3DT5g.WarmPromptCountdownModal__yibo__1IOVb .WarmPromptCountdownModal__radio__3KRJU[data-v-9c86c1e4] {
  color: #a1a2a7;
}

.WarmPromptCountdownModal__container__3DT5g.WarmPromptCountdownModal__yibo__1IOVb .WarmPromptCountdownModal__radio__3KRJU.WarmPromptCountdownModal__active__GSI1B[data-v-9c86c1e4] {
  color: #db6372;
}

.WarmPromptCountdownModal__container__3DT5g.WarmPromptCountdownModal__yibo__1IOVb .WarmPromptCountdownModal__btn__3V6aY[data-v-9c86c1e4] {
  color: #79420d;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP[data-v-9c86c1e4] {
  -webkit-animation: none 0s ease 0s 1 normal none running;
  animation: none 0s ease 0s 1 normal none running;
  -webkit-backface-visibility: visible;
  backface-visibility: visible;
  background: transparent none repeat 0 0 / auto auto padding-box border-box scroll;
  border: none;
  border-collapse: initial;
  -webkit-border-image: none;
  -o-border-image: none;
  border-image: none;
  border-radius: 0;
  border-spacing: 0;
  bottom: auto;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: content-box;
  box-sizing: initial;
  caption-side: top;
  clear: none;
  clip: auto;
  color: #000;
  -webkit-columns: auto;
  -moz-columns: auto;
  -webkit-column-count: auto;
  -moz-column-count: auto;
  -webkit-column-fill: balance;
  -moz-column-fill: balance;
  column-fill: balance;
  -webkit-column-gap: normal;
  -moz-column-gap: normal;
  column-gap: normal;
  -webkit-column-rule: medium none currentColor;
  -moz-column-rule: medium none currentColor;
  column-rule: medium none currentColor;
  -webkit-column-span: 1;
  -moz-column-span: 1;
  column-span: 1;
  -webkit-column-width: auto;
  -moz-column-width: auto;
  columns: auto;
  content: normal;
  counter-increment: none;
  counter-reset: none;
  cursor: auto;
  direction: ltr;
  display: inline;
  empty-cells: show;
  float: none;
  font-family: serif;
  font-size: medium;
  font-style: normal;
  font-variant: normal;
  font-weight: 400;
  font-stretch: normal;
  line-height: normal;
  height: auto;
  -webkit-hyphens: none;
  -ms-hyphens: none;
  hyphens: none;
  left: auto;
  letter-spacing: normal;
  list-style: disc outside none;
  margin: 0;
  max-height: none;
  max-width: none;
  min-height: 0;
  min-width: 0;
  opacity: 1;
  orphans: 2;
  outline: medium none invert;
  overflow: visible;
  overflow-x: visible;
  overflow-y: visible;
  padding: 0;
  page-break-after: auto;
  page-break-before: auto;
  page-break-inside: auto;
  -webkit-perspective: none;
  perspective: none;
  -webkit-perspective-origin: 50% 50%;
  perspective-origin: 50% 50%;
  position: static;
  right: auto;
  -moz-tab-size: 8;
  -o-tab-size: 8;
  tab-size: 8;
  table-layout: auto;
  text-align: left;
  -moz-text-align-last: auto;
  text-align-last: auto;
  text-decoration: none;
  text-indent: 0;
  text-shadow: none;
  text-transform: none;
  top: auto;
  -webkit-transform: none;
  transform: none;
  -webkit-transform-origin: 50% 50% 0;
  transform-origin: initial;
  -webkit-transform-style: flat;
  transform-style: flat;
  -webkit-transition: none 0s ease 0s;
  transition: none 0s ease 0s;
  unicode-bidi: normal;
  vertical-align: initial;
  visibility: visible;
  white-space: normal;
  widows: 2;
  width: auto;
  word-spacing: normal;
  z-index: auto;
  all: initial;
  color: #333;
  display: block;
  word-break: break-word;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP *[data-v-9c86c1e4] {
  font-size: inherit;
  line-height: normal;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP li[data-v-9c86c1e4],
.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP ol[data-v-9c86c1e4],
.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP ul[data-v-9c86c1e4] {
  list-style-type: disc;
  list-style-position: inside;
  -webkit-padding-start: 1em;
  padding-inline-start: 1em;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP ul[data-v-9c86c1e4] {
  list-style-type: disc;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP ul ul[data-v-9c86c1e4] {
  list-style-type: circle;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP ul ul ul[data-v-9c86c1e4] {
  list-style-type: square;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP ol[data-v-9c86c1e4] {
  list-style-type: decimal;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP ol li[data-v-9c86c1e4] {
  list-style: inherit;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP li[data-v-9c86c1e4],
.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP p[data-v-9c86c1e4] {
  color: inherit;
  font-size: medium;
  margin-top: 0;
  text-align: left;
  text-align: initial;
  list-style-type: inherit;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP h1[data-v-9c86c1e4] {
  font-size: 2em;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP h2[data-v-9c86c1e4] {
  font-size: 1.8em;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP h3[data-v-9c86c1e4] {
  font-size: 1.6em;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP h4[data-v-9c86c1e4] {
  line-height: 1.4em;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP h5[data-v-9c86c1e4] {
  font-size: 1.2em;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP h6[data-v-9c86c1e4] {
  font-size: 1em;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP h1[data-v-9c86c1e4],
.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP h2[data-v-9c86c1e4],
.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP h3[data-v-9c86c1e4],
.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP h4[data-v-9c86c1e4],
.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP h5[data-v-9c86c1e4],
.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP h6[data-v-9c86c1e4] {
  line-height: 1;
  height: auto;
  color: inherit;
  padding: inherit;
  font-weight: 400;
  font-weight: 700;
}

.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP em[data-v-9c86c1e4],
.WarmPromptCountdownModal__container__3DT5g .WarmPromptCountdownModal__dangerously-html__3hbtP i[data-v-9c86c1e4] {
  font-style: italic;
}

.virtualCurrency__virtualCurrency__jOAFR[data-v-9c86c1e4] {
  color: #666;
  background: #f8f8f8;
  padding-top: 0.2rem;
}

.virtualCurrency__virtualCurrency__jOAFR h1[data-v-9c86c1e4] {
  font-size: 0.32rem;
  line-height: 0.32rem;
  color: #4080ff;
  margin: 0 0.2rem;
  display: inline-block;
}

.virtualCurrency__virtualCurrency__jOAFR h2[data-v-9c86c1e4] {
  font-size: 0.28rem;
  line-height: 0.28rem;
  color: #333;
  margin: 0 0 0.1rem;
}

.virtualCurrency__virtualCurrency__jOAFR h3[data-v-9c86c1e4] {
  font-size: 0.32rem;
  line-height: 0.32rem;
  color: #333;
  margin: 0.1rem 0 0.3rem;
}

.virtualCurrency__virtualCurrency__jOAFR p[data-v-9c86c1e4] {
  padding: 0 0.4rem;
  margin-bottom: 0.2rem;
  font-size: 0.28rem;
  line-height: 0.44rem;
  text-align: justify;
}

.virtualCurrency__virtualCurrency__jOAFR ol[data-v-9c86c1e4] {
  list-style-type: disc;
  padding-left: 0.16rem;
}

.virtualCurrency__virtualCurrency__jOAFR li[data-v-9c86c1e4] {
  padding: 0;
  text-align: left;
  font-size: 0.24rem;
  line-height: 0.36rem;
  margin-bottom: 0.16rem;
}

.virtualCurrency__virtualCurrency__jOAFR span[data-v-9c86c1e4] {
  color: #999;
  font-size: 0.24rem;
  line-height: 0.32rem;
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__block__3lUYD[data-v-9c86c1e4] {
  margin-top: 0.2rem;
  background-color: #fff;
  padding: 1.04rem 0 0.2rem;
  position: relative;
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__block__3lUYD .virtualCurrency__ol__OjzoX[data-v-9c86c1e4] {
  list-style-type: disc !important;
  padding: 0 0.4rem 0 0.8rem !important;
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__block__3lUYD .virtualCurrency__ol__OjzoX li[data-v-9c86c1e4] {
  margin-bottom: 0.2rem;
  font-size: 0.28rem;
  line-height: 0.44rem;
  text-align: justify;
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__block__3lUYD .virtualCurrency__top_img__3wa9G[data-v-9c86c1e4] {
  background-size: 100% 100% !important;
  position: absolute;
  left: calc(50% - 103px);
  top: -0.08rem;
  width: 206px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  color: #fff;
  font-size: 0.32rem;
  font-weight: 700;
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__block__3lUYD .virtualCurrency__iconContainer__6Vt15[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__block__3lUYD .virtualCurrency__iconContainer__6Vt15 .virtualCurrency__iconNewWrap__3Pcny[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: 0 0.2rem;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: 0.16rem;
  width: 2.16rem;
  height: 5.02rem;
  border: 0.01rem solid #dfdfdf;
  margin: 0 auto 0.24rem;
  -webkit-box-shadow: 0 4px 8px 0 hsla(0, 0%, 40%, 0.08);
  box-shadow: 0 4px 8px 0 hsla(0, 0%, 40%, 0.08);
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__block__3lUYD .virtualCurrency__iconContainer__6Vt15 .virtualCurrency__iconNewWrap__3Pcny img[data-v-9c86c1e4] {
  width: 1.44rem;
  height: 1.44rem;
  margin-top: 0.16rem;
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__block__3lUYD .virtualCurrency__iconContainer__6Vt15 .virtualCurrency__iconNewWrap__3Pcny div[data-v-9c86c1e4] {
  font-size: 0.24rem;
  line-height: 0.36rem;
  text-align: justify;
  margin-top: 0.2rem;
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__block__3lUYD .virtualCurrency__iconContainer__6Vt15 .virtualCurrency__iconNewWrap__3Pcny div h2[data-v-9c86c1e4] {
  text-align: center;
  margin-bottom: 0.16rem;
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__block__3lUYD[data-v-9c86c1e4]:first-child {
  margin-top: 0;
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__block__3lUYD[data-v-9c86c1e4]:last-child {
  padding: 0.4rem 0 0.8rem;
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__title__3EI7L[data-v-9c86c1e4] {
  margin-bottom: 0.3rem;
  text-align: center;
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__title__3EI7L img[data-v-9c86c1e4] {
  width: 1.12rem;
  display: inline-block;
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__iconWrap__y_Rmh[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding: 0 0.16rem;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: 0.16rem;
  background: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#f8faff));
  background: -webkit-linear-gradient(top, #fff, #f8faff);
  background: linear-gradient(top, #fff, #f8faff);
  width: 6.7rem;
  height: 1.96rem;
  border: 0.01rem solid #dfdfdf;
  margin: 0 auto 0.24rem;
  -webkit-box-shadow: 0 4px 8px 0 hsla(0, 0%, 40%, 0.08);
  box-shadow: 0 4px 8px 0 hsla(0, 0%, 40%, 0.08);
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__iconWrap__y_Rmh .virtualCurrency__img1__2COtg[data-v-9c86c1e4] {
  width: 1.68rem;
  height: 1.68rem;
  background-image: url(/static/img/icon-guibi.d63a3306343188ae0c6491c44850b7b7.d63a3306.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 0;
}

.webpa .virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__iconWrap__y_Rmh .virtualCurrency__img1__2COtg[data-v-9c86c1e4] {
  background-image: url(/static/img/icon-guibi.d63a3306343188ae0c6491c44850b7b7.d63a3306.png);
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__iconWrap__y_Rmh .virtualCurrency__img2__3Rjzi[data-v-9c86c1e4] {
  width: 1.68rem;
  height: 1.68rem;
  background-image: url(data:image/png;base64,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);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 0;
}

.webpa .virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__iconWrap__y_Rmh .virtualCurrency__img2__3Rjzi[data-v-9c86c1e4] {
  background-image: url(data:image/png;base64,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);
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__iconWrap__y_Rmh .virtualCurrency__img3__1IYDO[data-v-9c86c1e4] {
  width: 1.68rem;
  height: 1.68rem;
  background-image: url(data:image/png;base64,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);
  background-size: 100% 100%;
  padding: 0;
}

.webpa .virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__iconWrap__y_Rmh .virtualCurrency__img3__1IYDO[data-v-9c86c1e4] {
  background-image: url(data:image/png;base64,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);
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__iconWrap__y_Rmh div[data-v-9c86c1e4] {
  width: 4.5rem;
  padding: 0 0.1rem 0 0.16rem;
  font-size: 0.24rem;
  line-height: 0.36rem;
  text-align: justify;
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__cardWrap__1gX7Y[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding: 0.56rem 0.4rem 0;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__card__n5Lw6[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#f8faff));
  background: -webkit-linear-gradient(top, #fff, #f8faff);
  background: linear-gradient(top, #fff, #f8faff);
  border-radius: 0.16rem;
  border: 0.5px solid #dfdfdf;
  padding: 0.3rem 0.4rem 0.18rem;
  -webkit-box-shadow: 0 0.08rem 0.16rem 0 hsla(0, 0%, 40%, 0.08);
  box-shadow: 0 0.08rem 0.16rem 0 hsla(0, 0%, 40%, 0.08);
  margin-bottom: 0.4rem;
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__card__n5Lw6 img[data-v-9c86c1e4] {
  width: 1.6rem;
  height: 1.2rem;
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__transaction__124P_[data-v-9c86c1e4] {
  padding-left: 0 !important;
  list-style: none !important;
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__transaction__124P_ li[data-v-9c86c1e4] {
  position: relative;
  padding-left: 0.28rem;
}

.virtualCurrency__virtualCurrency__jOAFR .virtualCurrency__transaction__124P_ li .virtualCurrency__dot__Xf7LD[data-v-9c86c1e4] {
  position: absolute;
  left: 0;
  top: 0.1rem;
  width: 0.12rem;
  height: 0.12rem;
  background: #666;
  border-radius: 50%;
}

.virtualCurrency__yibo__3oB1n[data-v-9c86c1e4] {
  color: #a1a2a7;
  background: #161a28;
}

.virtualCurrency__yibo__3oB1n h1[data-v-9c86c1e4] {
  color: #deb489;
}

.virtualCurrency__yibo__3oB1n h2[data-v-9c86c1e4],
.virtualCurrency__yibo__3oB1n h3[data-v-9c86c1e4] {
  color: #dedede;
}

.virtualCurrency__yibo__3oB1n p[data-v-9c86c1e4] {
  padding: 0 0.4rem;
  margin-bottom: 0.2rem;
  font-size: 0.28rem;
  line-height: 0.44rem;
  text-align: justify;
  color: #6c6e82;
}

.virtualCurrency__yibo__3oB1n .virtualCurrency__iconNewWrap__3Pcny[data-v-9c86c1e4],
.virtualCurrency__yibo__3oB1n .virtualCurrency__iconWrap__y_Rmh[data-v-9c86c1e4] {
  border: none !important;
  background: -webkit-gradient(linear, left top, left bottom, from(#2c304a), to(#25293c)) !important;
  background: -webkit-linear-gradient(top, #2c304a, #25293c) !important;
  background: linear-gradient(top, #2c304a, #25293c) !important;
}

.virtualCurrency__yibo__3oB1n .virtualCurrency__iconNewWrap__3Pcny[data-v-9c86c1e4] {
  -webkit-box-shadow: 0 0.08rem 0.16rem 0 rgba(22, 26, 40, 0.4);
  box-shadow: 0 0.08rem 0.16rem 0 rgba(22, 26, 40, 0.4);
}

.virtualCurrency__yibo__3oB1n span[data-v-9c86c1e4] {
  color: #6c6e82;
}

.virtualCurrency__yibo__3oB1n .virtualCurrency__block__3lUYD[data-v-9c86c1e4] {
  background-color: #222536;
}

.virtualCurrency__yibo__3oB1n .virtualCurrency__card__n5Lw6[data-v-9c86c1e4] {
  background: -webkit-gradient(linear, left top, left bottom, from(#353951), to(#26293a));
  background: -webkit-linear-gradient(top, #353951, #26293a);
  background: linear-gradient(top, #353951, #26293a);
  border: none;
  -webkit-box-shadow: 0 0.08rem 0.16rem 0 rgba(22, 26, 40, 0.4);
  box-shadow: 0 0.08rem 0.16rem 0 rgba(22, 26, 40, 0.4);
}

.virtualCurrency__yibo__3oB1n .virtualCurrency__dot__Xf7LD[data-v-9c86c1e4] {
  background: #a1a2a7 !important;
}

.virtualProto__virtualCurrency__b7CGB[data-v-9c86c1e4] {
  color: #666;
  background: #f8f8f8;
  padding-top: 0.2rem;
}

.virtualProto__virtualCurrency__b7CGB h1[data-v-9c86c1e4] {
  font-size: 0.32rem;
  line-height: 0.32rem;
  color: #4080ff;
  margin: 0 0.2rem;
  display: inline-block;
}

.virtualProto__virtualCurrency__b7CGB h2[data-v-9c86c1e4] {
  font-size: 0.28rem;
  line-height: 0.28rem;
  color: #333;
  margin: 0 0 0.1rem;
}

.virtualProto__virtualCurrency__b7CGB h3[data-v-9c86c1e4] {
  font-size: 0.32rem;
  line-height: 0.32rem;
  color: #333;
  margin: 0.1rem 0 0.3rem;
}

.virtualProto__virtualCurrency__b7CGB p[data-v-9c86c1e4] {
  padding: 0 0.4rem;
  margin-bottom: 0.2rem;
  font-size: 0.28rem;
  line-height: 0.44rem;
  text-align: justify;
}

.virtualProto__virtualCurrency__b7CGB p.virtualProto__bot__1w1K_[data-v-9c86c1e4] {
  margin-top: 0.2rem;
  padding: 0;
  color: rgba(255, 70, 52, 0.75);
  font-size: 0.24rem;
  line-height: 0.36rem;
}

.virtualProto__virtualCurrency__b7CGB ol[data-v-9c86c1e4] {
  list-style-type: disc;
  padding-left: 0.16rem;
}

.virtualProto__virtualCurrency__b7CGB li[data-v-9c86c1e4] {
  padding: 0;
  text-align: left;
  font-size: 0.24rem;
  line-height: 0.32rem;
  margin-bottom: 0.16rem;
}

.virtualProto__virtualCurrency__b7CGB span[data-v-9c86c1e4] {
  color: #999;
  font-size: 0.24rem;
  line-height: 0.32rem;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__block__3o4T3[data-v-9c86c1e4] {
  margin-top: 0.2rem;
  background-color: #fff;
  padding: 1rem 0 0.2rem;
  position: relative;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__block__3o4T3 .virtualProto__top_img__2l2NV[data-v-9c86c1e4] {
  background-size: 100% 100% !important;
  position: absolute;
  left: calc(50% - 103px);
  top: -0.08rem;
  width: 206px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  color: #fff;
  font-size: 0.32rem;
  font-weight: 700;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__block__3o4T3[data-v-9c86c1e4]:nth-of-type(2),
.virtualProto__virtualCurrency__b7CGB .virtualProto__block__3o4T3[data-v-9c86c1e4]:nth-of-type(3) {
  padding: 1rem 0.4rem 0.2rem;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__block__3o4T3 .virtualProto__firstPart__1A0Z-[data-v-9c86c1e4] {
  margin-bottom: 0.3rem;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__block__3o4T3 .virtualProto__firstPart__1A0Z- span[data-v-9c86c1e4] {
  padding: 0 0.4rem;
  margin-bottom: 0.3rem;
  font-size: 0.28rem;
  color: #000;
  line-height: 0.44rem;
  text-align: justify;
  font-weight: 700;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__block__3o4T3 table[data-v-9c86c1e4] {
  padding: 0 0.4rem;
  width: 100%;
  border: 0.01rem solid #ebebeb;
  border-collapse: collapse;
  font-size: 0.24rem;
  line-height: 0.36rem;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__block__3o4T3 table thead[data-v-9c86c1e4] {
  background: rgba(64, 128, 255, 0.15);
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__block__3o4T3 table thead th[data-v-9c86c1e4] {
  padding: 0.18rem 0.08rem;
  border-right: solid #ebebeb;
  border-width: 0.01rem;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__block__3o4T3 table tbody tr[data-v-9c86c1e4] {
  border-bottom: 1px solid #ebebeb;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__block__3o4T3 table tbody tr[data-v-9c86c1e4]:nth-of-type(2n) {
  background: #f9fbfe;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__block__3o4T3 table tbody tr td[data-v-9c86c1e4] {
  padding: 0.2rem 0.08rem;
  border-right: solid #ebebeb;
  border-width: 0.01rem;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__block__3o4T3 table tbody tr td[data-v-9c86c1e4]:first-of-type {
  width: 1.2rem;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__block__3o4T3 .virtualProto__container__3gv6Q[data-v-9c86c1e4] {
  border-radius: 0.16rem;
  padding: 0.2rem;
  border: 1px solid #dfdfdf;
  height: 1.6rem;
  margin-bottom: 0.24rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-shadow: 0 4px 8px 0 hsla(0, 0%, 40%, 0.08);
  box-shadow: 0 4px 8px 0 hsla(0, 0%, 40%, 0.08);
  background-image: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#f8faff));
  background-image: -webkit-linear-gradient(top, #fff, #f8faff);
  background-image: linear-gradient(180deg, #fff, #f8faff);
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__block__3o4T3 .virtualProto__container__3gv6Q[data-v-9c86c1e4]:nth-of-type(4) {
  margin-bottom: 0;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__block__3o4T3 .virtualProto__container__3gv6Q img[data-v-9c86c1e4] {
  margin-right: 10px;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__block__3o4T3 .virtualProto__container__3gv6Q .virtualProto__rightContent__3OhXd span[data-v-9c86c1e4] {
  font-size: 0.28rem;
  line-height: 0.4rem;
  color: #414655;
  font-weight: 700;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__block__3o4T3 .virtualProto__container__3gv6Q .virtualProto__rightContent__3OhXd div[data-v-9c86c1e4] {
  font-size: 0.24rem;
  line-height: 0.36rem;
  color: #666;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__block__3o4T3[data-v-9c86c1e4]:first-child {
  margin-top: 0;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__title__wdm1l[data-v-9c86c1e4] {
  margin-bottom: 0.3rem;
  text-align: center;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__title__wdm1l img[data-v-9c86c1e4] {
  width: 1.12rem;
  display: inline-block;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__iconWrap__2Clzg[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding: 0 0.16rem;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__iconWrap__2Clzg img[data-v-9c86c1e4] {
  width: 1.68rem;
  height: 1.68rem;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__iconWrap__2Clzg div[data-v-9c86c1e4] {
  width: 5.5rem;
  padding: 0 0.24rem 0 0.16rem;
  font-size: 0.24rem;
  line-height: 0.36rem;
  text-align: justify;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__cardWrap__1-kgs[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding: 0.2rem 0.4rem 0;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__card__1Anj-[data-v-9c86c1e4] {
  width: 3.16rem;
  background: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#f6f6f6));
  background: -webkit-linear-gradient(top, #fff, #f6f6f6);
  background: linear-gradient(top, #fff, #f6f6f6);
  border-radius: 0.16rem;
  border: 0.5px solid #dfdfdf;
  text-align: center;
  padding: 0.3rem 0.4rem 0.18rem;
  -webkit-box-shadow: 0 0.08rem 0.16rem 0 hsla(0, 0%, 40%, 0.08);
  box-shadow: 0 0.08rem 0.16rem 0 hsla(0, 0%, 40%, 0.08);
  margin-bottom: 0.4rem;
}

.virtualProto__virtualCurrency__b7CGB .virtualProto__card__1Anj- img[data-v-9c86c1e4] {
  width: 1.6rem;
  height: 1.2rem;
}

.virtualProto__yibo__1e4Wm[data-v-9c86c1e4] {
  color: #a1a2a7;
  background: #161a28;
}

.virtualProto__yibo__1e4Wm h1[data-v-9c86c1e4] {
  color: #deb489;
}

.virtualProto__yibo__1e4Wm h2[data-v-9c86c1e4],
.virtualProto__yibo__1e4Wm h3[data-v-9c86c1e4] {
  color: #dedede;
}

.virtualProto__yibo__1e4Wm p[data-v-9c86c1e4] {
  padding: 0 0.4rem 0.4rem;
  margin-bottom: 0;
  font-size: 0.28rem;
  line-height: 0.44rem;
  text-align: justify;
}

.virtualProto__yibo__1e4Wm span[data-v-9c86c1e4] {
  color: #6c6e82;
}

.virtualProto__yibo__1e4Wm .virtualProto__block__3o4T3[data-v-9c86c1e4] {
  background-color: #222536;
}

.virtualProto__yibo__1e4Wm .virtualProto__block__3o4T3 .virtualProto__container__3gv6Q[data-v-9c86c1e4] {
  border: none;
  background: -webkit-gradient(linear, left top, left bottom, from(#2c304a), to(#25293c));
  background: -webkit-linear-gradient(top, #2c304a, #25293c);
  background: linear-gradient(top, #2c304a, #25293c);
  -webkit-box-shadow: 0 4px 8px 0 rgba(22, 26, 40, 0.4);
  box-shadow: 0 4px 8px 0 rgba(22, 26, 40, 0.4);
}

.virtualProto__yibo__1e4Wm .virtualProto__block__3o4T3 .virtualProto__container__3gv6Q .virtualProto__rightContent__3OhXd span[data-v-9c86c1e4] {
  color: #a1a2a7;
}

.virtualProto__yibo__1e4Wm .virtualProto__block__3o4T3 .virtualProto__container__3gv6Q .virtualProto__rightContent__3OhXd div[data-v-9c86c1e4] {
  color: #6c6e82;
}

.virtualProto__yibo__1e4Wm .virtualProto__block__3o4T3 .virtualProto__firstPart__1A0Z-[data-v-9c86c1e4] {
  margin-bottom: 0.3rem;
}

.virtualProto__yibo__1e4Wm .virtualProto__block__3o4T3 .virtualProto__firstPart__1A0Z- span[data-v-9c86c1e4] {
  padding: 0 0.4rem;
  margin-bottom: 0.3rem;
  font-size: 0.28rem;
  color: #a1a2a7;
  line-height: 0.44rem;
  text-align: justify;
  font-weight: 700;
}

.virtualProto__yibo__1e4Wm .virtualProto__block__3o4T3 .virtualProto__firstPart__1A0Z- p[data-v-9c86c1e4] {
  color: #6c6e82;
}

.virtualProto__yibo__1e4Wm .virtualProto__block__3o4T3 table[data-v-9c86c1e4] {
  border: 1px solid rgba(161, 162, 167, 0.2);
}

.virtualProto__yibo__1e4Wm .virtualProto__block__3o4T3 table thead[data-v-9c86c1e4] {
  background: #222536;
  color: #a1a2a7 !important;
}

.virtualProto__yibo__1e4Wm .virtualProto__block__3o4T3 table thead th[data-v-9c86c1e4] {
  padding: 0.18rem 0.08rem !important;
  border-right: 1px solid rgba(161, 162, 167, 0.2);
}

.virtualProto__yibo__1e4Wm .virtualProto__block__3o4T3 table tbody tr[data-v-9c86c1e4] {
  border-bottom: 1px solid rgba(161, 162, 167, 0.2);
  background: #222536 !important;
}

.virtualProto__yibo__1e4Wm .virtualProto__block__3o4T3 table tbody tr td[data-v-9c86c1e4] {
  color: #6c6e82;
  border-right: 1px solid rgba(161, 162, 167, 0.2);
}

.virtualProto__yibo__1e4Wm .virtualProto__block__3o4T3 table tbody tr[data-v-9c86c1e4]:nth-of-type(odd) {
  background: #161a28 !important;
}

.virtualProto__yibo__1e4Wm .virtualProto__card__1Anj-[data-v-9c86c1e4] {
  background: -webkit-gradient(linear, left top, left bottom, from(#353951), to(#26293a));
  background: -webkit-linear-gradient(top, #353951, #26293a);
  background: linear-gradient(top, #353951, #26293a);
  border: none;
  -webkit-box-shadow: 0 0.08rem 0.16rem 0 rgba(22, 26, 40, 0.4);
  box-shadow: 0 0.08rem 0.16rem 0 rgba(22, 26, 40, 0.4);
}

@-webkit-keyframes information__fain__3xskh-data-v-9c86c1e4 {
  0% {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes information__fain__3xskh-data-v-9c86c1e4 {
  0% {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.information__speedTip__-arGa[data-v-9c86c1e4] {
  font-family: PingFangSC-Regular, sans-serif;
  color: #db6372 !important;
}

.information__htxGuideMask__y8cRH[data-v-9c86c1e4] {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 99;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation: information__fain__3xskh-data-v-9c86c1e4 0.4s ease;
  animation: information__fain__3xskh-data-v-9c86c1e4 0.4s ease;
}

.information__theGuidePic__301Jh[data-v-9c86c1e4] {
  position: fixed;
  width: 6.8rem;
  z-index: 100;
  pointer-events: none;
}

.information__theGuidePic__301Jh[data-v-9c86c1e4]:first-child {
  top: 2rem;
  left: 0;
  right: 0;
  margin: auto;
}

.information__theGuidePic__301Jh[data-v-9c86c1e4]:nth-child(2) {
  top: 3.2rem;
  left: 0;
  right: 0;
  margin: auto;
}

.information__theGuidePic__301Jh[data-v-9c86c1e4]:nth-child(3) {
  bottom: 1.2rem;
  right: 0;
}

.information__theGuidePic__301Jh[data-v-9c86c1e4]:nth-child(4) {
  bottom: 0.8rem;
  left: 0;
}

.information__box__3wMSm[data-v-9c86c1e4] {
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  min-height: calc(100vh - 50px);
  background: #f7f9fe;
  position: relative;
}

.information__box__3wMSm>div[data-v-9c86c1e4] {
  padding-bottom: 2.8rem;
}

.information__box__3wMSm .information__amount__2PNAb[data-v-9c86c1e4] {
  width: 100%;
  height: 3.04rem;
  background: #fff;
  overflow: hidden;
}

.information__box__3wMSm .information__amount__2PNAb.information__speedPayAmount__2hoAC[data-v-9c86c1e4] {
  height: 3.72rem !important;
}

.information__box__3wMSm .information__amount__2PNAb .information__progressBarWrapper__sjbIZ[data-v-9c86c1e4] {
  margin: 0.28rem 0 0;
}

.information__box__3wMSm .information__amount__2PNAb h1[data-v-9c86c1e4] {
  text-align: center;
  font-size: 0.64rem;
  color: #0d1a26;
  margin: 0.24rem 0 0;
  font-family: DINPro;
}

.information__box__3wMSm .information__amount__2PNAb h1 span[data-v-9c86c1e4] {
  color: #0d1a26;
  font-size: 0.28rem;
}

.information__box__3wMSm .information__amount__2PNAb .information__line__2vLrl[data-v-9c86c1e4] {
  width: 100%;
  color: #999;
  font-size: 0.24rem;
  text-align: center;
  margin-top: 0.24rem;
}

.information__box__3wMSm .information__amount__2PNAb .information__line__2vLrl[data-v-9c86c1e4]:nth-of-type(2) {
  margin-top: 0.08rem;
  line-height: 0.4rem;
}

.information__box__3wMSm .information__amount__2PNAb .information__line__2vLrl .information__time__2sqku[data-v-9c86c1e4] {
  color: #313c46;
}

.information__box__3wMSm .information__amount__2PNAb .information__line__2vLrl .information__call__cQJYM[data-v-9c86c1e4] {
  color: #ede9e7;
  margin-top: 0.24rem;
}

.information__box__3wMSm .information__amount__2PNAb .information__line__2vLrl>span span[data-v-9c86c1e4] {
  color: #313c46;
}

.information__box__3wMSm .information__amount__2PNAb .information__line__2vLrl>span.information__yibo__2cC7X span[data-v-9c86c1e4] {
  color: #dedede;
}

.information__box__3wMSm .information__amount__2PNAb .information__line__2vLrl span.information__redNumber__3Uptq[data-v-9c86c1e4] {
  font-family: dinpro;
  font-weight: 700;
  color: #db6372;
}

.information__box__3wMSm .information__amount__2PNAb .information__line__2vLrl .information__count-down__1Op6X>span[data-v-9c86c1e4] {
  color: #ede9e7;
}

.information__box__3wMSm .information__container__lqjCm[data-v-9c86c1e4] {
  width: 6.94rem;
  padding: 0.48rem 0.4rem 0.4rem;
  background: #fff;
  margin: 0.2rem auto auto;
  border-radius: 0.2rem;
}

.information__box__3wMSm .information__container__lqjCm .information__bankLogo__3gbTr[data-v-9c86c1e4] {
  width: 0.48rem;
  vertical-align: middle;
}

.information__box__3wMSm .information__container__lqjCm.information__containerP__3OBoT[data-v-9c86c1e4] {
  padding: 0.3rem 0.24rem;
}

.information__box__3wMSm .information__container__lqjCm h1[data-v-9c86c1e4] {
  height: 0.48rem;
  line-height: 0.48rem;
  color: #414655;
  font-size: 0.28rem;
  padding-left: 0.08rem;
  margin: 0;
  font-weight: 400;
}

.information__box__3wMSm .information__container__lqjCm h1.information__yibo__2cC7X[data-v-9c86c1e4] {
  color: #dedede;
}

.information__box__3wMSm .information__container__lqjCm .information__info__2kk1T[data-v-9c86c1e4] {
  width: 100%;
  margin-top: 0.34rem;
}

.information__box__3wMSm .information__container__lqjCm .information__info__2kk1T li[data-v-9c86c1e4] {
  width: 100%;
  position: relative;
  margin-top: 0.2rem;
  line-height: 1.42857;
}

.information__box__3wMSm .information__container__lqjCm .information__info__2kk1T li span[data-v-9c86c1e4]:first-of-type {
  font-size: 0.28rem;
  color: #a5a9b3;
  line-height: 1;
}

.information__box__3wMSm .information__container__lqjCm .information__info__2kk1T li span[data-v-9c86c1e4]:last-of-type {
  font-size: 0.28rem;
  color: #333;
  font-family: PingFang SC;
  line-height: 1;
}

.information__box__3wMSm .information__container__lqjCm .information__info__2kk1T li span.information__number__1sDhf[data-v-9c86c1e4] {
  font-family: DINPro;
  font-weight: 700;
}

.information__box__3wMSm .information__container__lqjCm .information__info__2kk1T li p[data-v-9c86c1e4] {
  color: #ff4634;
  height: 0.34rem;
}

.information__box__3wMSm .information__container__lqjCm .information__info__2kk1T li i[data-v-9c86c1e4],
.information__box__3wMSm .information__container__lqjCm .information__info__2kk1T li p[data-v-9c86c1e4] {
  font-size: 0.24rem;
  line-height: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  font-family: PingFang SC;
}

.information__box__3wMSm .information__container__lqjCm .information__info__2kk1T li i[data-v-9c86c1e4] {
  position: absolute;
  right: 0;
  top: 0.08rem;
  width: 0.68rem;
  height: 0.32rem;
  color: #4080ff;
  text-align: center;
  border: 0.02rem solid #4080ff;
  border-radius: 0.04rem;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.information__box__3wMSm .information__container__lqjCm .information__info__2kk1T li b[data-v-9c86c1e4] {
  font-family: dinpro;
  font-weight: 700;
}

.information__box__3wMSm .information__container__lqjCm .information__info__2kk1T li .information__mr__1odMn[data-v-9c86c1e4] {
  margin-left: 0.1rem;
}

.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 li[data-v-9c86c1e4],
.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 p[data-v-9c86c1e4] {
  color: #a5a9b3;
  font-size: 0.24rem;
  margin-top: 0.1rem;
  text-align: justify;
}

.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 li[data-v-9c86c1e4] {
  line-height: 0.34rem;
  height: 0.34rem;
  font-family: PingFang SC;
}

.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 li>span[data-v-9c86c1e4] {
  font-size: 0.24rem;
  font-family: PingFang SC;
}

.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw[data-v-9c86c1e4] {
  -webkit-animation: none 0s ease 0s 1 normal none running;
  animation: none 0s ease 0s 1 normal none running;
  -webkit-backface-visibility: visible;
  backface-visibility: visible;
  background: transparent none repeat 0 0 / auto auto padding-box border-box scroll;
  border: none;
  border-collapse: initial;
  -webkit-border-image: none;
  -o-border-image: none;
  border-image: none;
  border-radius: 0;
  border-spacing: 0;
  bottom: auto;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: content-box;
  box-sizing: initial;
  caption-side: top;
  clear: none;
  clip: auto;
  color: #000;
  -webkit-columns: auto;
  -moz-columns: auto;
  -webkit-column-count: auto;
  -moz-column-count: auto;
  -webkit-column-fill: balance;
  -moz-column-fill: balance;
  column-fill: balance;
  -webkit-column-gap: normal;
  -moz-column-gap: normal;
  column-gap: normal;
  -webkit-column-rule: medium none currentColor;
  -moz-column-rule: medium none currentColor;
  column-rule: medium none currentColor;
  -webkit-column-span: 1;
  -moz-column-span: 1;
  column-span: 1;
  -webkit-column-width: auto;
  -moz-column-width: auto;
  columns: auto;
  content: normal;
  counter-increment: none;
  counter-reset: none;
  cursor: auto;
  direction: ltr;
  display: inline;
  empty-cells: show;
  float: none;
  font-family: serif;
  font-size: medium;
  font-style: normal;
  font-variant: normal;
  font-weight: 400;
  font-stretch: normal;
  line-height: normal;
  height: auto;
  -webkit-hyphens: none;
  -ms-hyphens: none;
  hyphens: none;
  left: auto;
  letter-spacing: normal;
  list-style: disc outside none;
  margin: 0;
  max-height: none;
  max-width: none;
  min-height: 0;
  min-width: 0;
  opacity: 1;
  orphans: 2;
  outline: medium none invert;
  overflow: visible;
  overflow-x: visible;
  overflow-y: visible;
  padding: 0;
  page-break-after: auto;
  page-break-before: auto;
  page-break-inside: auto;
  -webkit-perspective: none;
  perspective: none;
  -webkit-perspective-origin: 50% 50%;
  perspective-origin: 50% 50%;
  position: static;
  right: auto;
  -moz-tab-size: 8;
  -o-tab-size: 8;
  tab-size: 8;
  table-layout: auto;
  text-align: left;
  -moz-text-align-last: auto;
  text-align-last: auto;
  text-decoration: none;
  text-indent: 0;
  text-shadow: none;
  text-transform: none;
  top: auto;
  -webkit-transform: none;
  transform: none;
  -webkit-transform-origin: 50% 50% 0;
  transform-origin: initial;
  -webkit-transform-style: flat;
  transform-style: flat;
  -webkit-transition: none 0s ease 0s;
  transition: none 0s ease 0s;
  unicode-bidi: normal;
  vertical-align: initial;
  visibility: visible;
  white-space: normal;
  widows: 2;
  width: auto;
  word-spacing: normal;
  z-index: auto;
  all: initial;
  color: #333;
  display: block;
  word-break: break-word;
}

.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw *[data-v-9c86c1e4] {
  font-size: inherit;
  line-height: normal;
}

.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw li[data-v-9c86c1e4],
.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw ol[data-v-9c86c1e4],
.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw ul[data-v-9c86c1e4] {
  list-style-type: disc;
  list-style-position: inside;
  -webkit-padding-start: 1em;
  padding-inline-start: 1em;
}

.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw ul[data-v-9c86c1e4] {
  list-style-type: disc;
}

.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw ul ul[data-v-9c86c1e4] {
  list-style-type: circle;
}

.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw ul ul ul[data-v-9c86c1e4] {
  list-style-type: square;
}

.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw ol[data-v-9c86c1e4] {
  list-style-type: decimal;
}

.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw ol li[data-v-9c86c1e4] {
  list-style: inherit;
}

.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw li[data-v-9c86c1e4],
.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw p[data-v-9c86c1e4] {
  color: inherit;
  font-size: medium;
  margin-top: 0;
  text-align: left;
  text-align: initial;
  list-style-type: inherit;
  height: auto;
}

.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw h1[data-v-9c86c1e4] {
  font-size: 2em;
}

.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw h2[data-v-9c86c1e4] {
  font-size: 1.8em;
}

.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw h3[data-v-9c86c1e4] {
  font-size: 1.6em;
}

.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw h4[data-v-9c86c1e4] {
  line-height: 1.4em;
}

.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw h5[data-v-9c86c1e4] {
  font-size: 1.2em;
}

.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw h6[data-v-9c86c1e4] {
  font-size: 1em;
}

.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw h1[data-v-9c86c1e4],
.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw h2[data-v-9c86c1e4],
.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw h3[data-v-9c86c1e4],
.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw h4[data-v-9c86c1e4],
.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw h5[data-v-9c86c1e4],
.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw h6[data-v-9c86c1e4] {
  line-height: 1;
  height: auto;
  color: inherit;
  padding: inherit;
  font-weight: 400;
  font-weight: 700;
}

.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw em[data-v-9c86c1e4],
.information__box__3wMSm .information__container__lqjCm .information__noticeList__15BU3 .information__dangerously-html__3tJMw i[data-v-9c86c1e4] {
  font-style: italic;
}

.information__box__3wMSm .information__container__lqjCm .information__aliPay__184TV[data-v-9c86c1e4] {
  width: 100%;
}

.information__box__3wMSm .information__container__lqjCm .information__aliPay__184TV li[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-top: 0.3rem;
}

.information__box__3wMSm .information__container__lqjCm .information__aliPay__184TV li.information__fist-of-type__1YBM4[data-v-9c86c1e4] {
  margin-top: 0;
}

.information__box__3wMSm .information__container__lqjCm .information__aliPay__184TV li span.information__billNo__17v4q[data-v-9c86c1e4] {
  font-family: DINPro-Regular;
}

.information__box__3wMSm .information__container__lqjCm .information__aliPay__184TV li span[data-v-9c86c1e4]:first-of-type {
  color: #a5a9b3;
  font-size: 0.28rem;
}

.information__box__3wMSm .information__container__lqjCm .information__aliPay__184TV li span[data-v-9c86c1e4]:last-of-type {
  color: #333;
  font-size: 0.28rem;
}

.information__box__3wMSm .information__waitingContainer__1K-D8[data-v-9c86c1e4] {
  width: 6.94rem;
  height: 4.8rem;
  padding-top: 0.4rem;
  margin: 0.2rem auto auto;
  background: #fff;
  border-radius: 0.2rem;
}

.information__box__3wMSm .information__waitingContainer__1K-D8 p[data-v-9c86c1e4] {
  width: 6.14rem;
  margin: auto;
  line-height: 0.4rem;
  font-size: 0.28rem;
  text-align: center;
  color: #414655;
}

.information__box__3wMSm .information__waitingContainer__1K-D8 img[data-v-9c86c1e4] {
  display: block;
  width: 3rem;
  height: 3rem;
  margin: 0.2rem auto auto;
}

.information__box__3wMSm .information__close__213Q9[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: space-around;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  margin-top: 0.2rem;
  width: 100%;
  color: #ede9e7;
  padding: 0 0.28rem;
  position: relative;
}

.information__box__3wMSm .information__close__213Q9.information__close101__1nf2E[data-v-9c86c1e4] {
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.information__box__3wMSm .information__close__213Q9 span[data-v-9c86c1e4] {
  font-size: 0.28rem;
  width: 3.4rem;
  height: 0.8rem;
  font-family: PingFang SC;
  text-align: center;
  border-radius: 0.1rem;
  line-height: 0.75rem;
}

.information__box__3wMSm .information__close__213Q9 span[data-v-9c86c1e4]:first-child {
  color: #ede9e7;
  border: 0.02rem solid #ede9e7;
}

.information__box__3wMSm .information__close__213Q9 span[data-v-9c86c1e4]:nth-child(2) {
  background-image: -webkit-gradient(linear, left top, right top, from(#8ba6fe), to(#567cf7));
  background-image: -webkit-linear-gradient(left, #8ba6fe, #567cf7);
  background-image: linear-gradient(90deg, #8ba6fe, #567cf7);
  color: #fff;
  border: 0.04rem solid #fff;
  background: #ede9e7;
}

.information__box__3wMSm .information__close__213Q9 span.information__deposit-operation-button__2RBMU[data-v-9c86c1e4] {
  background: #ede9e7;
  border-radius: 5px;
  color: #fff;
  width: 100%;
}

.information__box__3wMSm .information__close__213Q9 span.information__disabled__1YP_9[data-v-9c86c1e4] {
  opacity: 0.5;
}

.information__box__3wMSm .information__matchMemberTip__1dtxE[data-v-9c86c1e4] {
  margin-top: 0.38rem;
  height: 0.36rem;
  line-height: 0.36rem;
  font-size: 0.24rem;
  padding-left: 1.16rem;
  color: #a5a9b3;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAGAAAAADiNXWtAAACrElEQVRIDbWWz2sTQRTH5003jYg95hLFSwU9eOw/kItoUk1L6WqCl/wDUsEfeBJP4g/wR/8AL9rYldJEmyJ6yD/QowcFe5NchF4qxSSbfb7vxAnrdiJtSAeWmXnzfZ83OzvzZkn9p6ytbZ7qhFyMKCoQ07Qizho5U4uJtzXrxqRH9YWF/I9hGHINVOufsvy7/UCRqjCrCZfG2ohUT7F6RcfS90vFCy1rt/W+ANVg40qk+LU4TSlFXQlS04pq5KktHR43gMjby3KoZkQ3J7o5pTglul3RXS/5s+8tHPU/AaqrjRuRip6JXctATU9O3Lo2n9+OOyTbb9c3p6NO7ykrBFKRVvpm6WrhpdUNAmDmIqqxFNLqXnnx8mMrsnUQsFku36eetdl65d2HOxyph+hronn7JiYA1jxqt79iWQR+1wVvNpte6+evLwBkMyfO53K5EO14+RvkkVmudPocvomGwHxQwOUNXHBodnb2TsoEzuIxbRgTBb5gYKKGKeMaW1EiVvBBPUrdTvgcuttnmM1RAVtjn2Mrynar+/7F74cmJhzAAAtMsDUOETRycGoJ7chdywJbmxMqqBR7WyMTE46WBbacjf7xT6en9p3ChN+BuwOWsM0uOrDnCEIti29m3m7v9hPZEEjHS3XtULxtbfF6wBK2RlbEYJfCmbgo2cahIdIvSNFzV1KL6y0LbA8pV/LPJfkgyCVv4sJku+wXlpI2Vx8sltMGtkY+R8qVfVsMgo9nXA7WtrK60cBj+64aDLDABFuby0LyOVJuyN0nLifYguDzaZlVHg/aw3R9hqRvYYJtdhEuCyQopFwkLJdzJuO1RPMNj2k7RCbZIW0LyzBFY7IptOaiYV5He+zpGlCUcVw4pGmpvDi73CfG3sAajvTKHAQ5ykvfBkE9jt+WP19xdrEk7CASAAAAAElFTkSuQmCC);
  background-repeat: no-repeat;
  background-size: 0.24rem;
  background-position: 0.82rem;
}

.webpa .information__box__3wMSm .information__matchMemberTip__1dtxE[data-v-9c86c1e4] {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAGAAAAADiNXWtAAACrElEQVRIDbWWz2sTQRTH5003jYg95hLFSwU9eOw/kItoUk1L6WqCl/wDUsEfeBJP4g/wR/8AL9rYldJEmyJ6yD/QowcFe5NchF4qxSSbfb7vxAnrdiJtSAeWmXnzfZ83OzvzZkn9p6ytbZ7qhFyMKCoQ07Qizho5U4uJtzXrxqRH9YWF/I9hGHINVOufsvy7/UCRqjCrCZfG2ohUT7F6RcfS90vFCy1rt/W+ANVg40qk+LU4TSlFXQlS04pq5KktHR43gMjby3KoZkQ3J7o5pTglul3RXS/5s+8tHPU/AaqrjRuRip6JXctATU9O3Lo2n9+OOyTbb9c3p6NO7ykrBFKRVvpm6WrhpdUNAmDmIqqxFNLqXnnx8mMrsnUQsFku36eetdl65d2HOxyph+hronn7JiYA1jxqt79iWQR+1wVvNpte6+evLwBkMyfO53K5EO14+RvkkVmudPocvomGwHxQwOUNXHBodnb2TsoEzuIxbRgTBb5gYKKGKeMaW1EiVvBBPUrdTvgcuttnmM1RAVtjn2Mrynar+/7F74cmJhzAAAtMsDUOETRycGoJ7chdywJbmxMqqBR7WyMTE46WBbacjf7xT6en9p3ChN+BuwOWsM0uOrDnCEIti29m3m7v9hPZEEjHS3XtULxtbfF6wBK2RlbEYJfCmbgo2cahIdIvSNFzV1KL6y0LbA8pV/LPJfkgyCVv4sJku+wXlpI2Vx8sltMGtkY+R8qVfVsMgo9nXA7WtrK60cBj+64aDLDABFuby0LyOVJuyN0nLifYguDzaZlVHg/aw3R9hqRvYYJtdhEuCyQopFwkLJdzJuO1RPMNj2k7RCbZIW0LyzBFY7IptOaiYV5He+zpGlCUcVw4pGmpvDi73CfG3sAajvTKHAQ5ykvfBkE9jt+WP19xdrEk7CASAAAAAElFTkSuQmCC);
}

.information__box__3wMSm .information__matchMemberTip__1dtxE span[data-v-9c86c1e4] {
  color: #db6372;
}

.information__box__3wMSm .information__fixed-operation__3vtQ7[data-v-9c86c1e4] {
  position: fixed;
  background: #fff;
  left: 0;
  right: 0;
  bottom: 0;
  padding-bottom: 0.8rem;
  -webkit-box-shadow: 0 -2px 15px rgba(0, 0, 0, 0.05);
  box-shadow: 0 -2px 15px rgba(0, 0, 0, 0.05);
}

.information__withBox__39jd0[data-v-9c86c1e4] {
  min-height: calc(100vh - 0.9rem);
  background: #f8f8f8;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.information__withBox__39jd0[data-v-9c86c1e4],
.information__withBox__39jd0 .information__notice__1vMZj[data-v-9c86c1e4] {
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.information__withBox__39jd0 .information__notice__1vMZj[data-v-9c86c1e4] {
  background: #fff;
  padding: 0.18rem 0 0.18rem 0.4rem;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.information__withBox__39jd0 .information__notice__1vMZj span img[data-v-9c86c1e4] {
  width: 0.36rem;
}

.information__withBox__39jd0 .information__notice__1vMZj p[data-v-9c86c1e4] {
  margin-left: 0.1rem;
  font-size: 0.24rem;
  color: #999;
}

.information__withBox__39jd0 .information__withInfo__2b5pe[data-v-9c86c1e4] {
  width: 100%;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  background: #fff;
  margin-top: 0.4rem;
}

.information__withBox__39jd0 .information__withInfo__2b5pe ul[data-v-9c86c1e4] {
  padding: 0 0.546rem;
  overflow: hidden;
}

.information__withBox__39jd0 .information__withInfo__2b5pe ul li[data-v-9c86c1e4] {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 0.34rem;
}

.information__withBox__39jd0 .information__withInfo__2b5pe ul li span[data-v-9c86c1e4]:first-of-type {
  font-size: 0.28rem;
  color: #a5a9b3;
}

.information__withBox__39jd0 .information__withInfo__2b5pe ul li span[data-v-9c86c1e4]:last-of-type {
  font-size: 0.28rem;
  color: #333;
}

.information__withBox__39jd0 .information__withInfo__2b5pe ul li[data-v-9c86c1e4]:last-child {
  position: relative;
}

.information__withBox__39jd0 .information__withInfo__2b5pe ul li:last-child span[data-v-9c86c1e4]:last-of-type {
  margin-right: 0.4rem;
}

.information__withBox__39jd0 .information__withInfo__2b5pe ul li:last-child img[data-v-9c86c1e4] {
  position: absolute;
  width: 0.24rem;
  height: 0.24rem;
  right: 0;
  top: 0;
}

.information__withBox__39jd0 .information__withInfo__2b5pe p[data-v-9c86c1e4] {
  text-align: center;
  margin-top: 1.28rem;
}

.information__container__lqjCm[data-v-9c86c1e4] {
  text-align: left;
  color: red;
  padding: 0.25rem;
  font-size: 0.24rem;
}

.information__container__lqjCm *[data-v-9c86c1e4] {
  font-size: 0.28rem;
  line-height: 0.5rem;
}

.information__container__lqjCm .information__title__36ZHe[data-v-9c86c1e4] {
  color: #000;
  font-size: 0.32rem;
  font-weight: 700;
  text-align: left;
  margin-bottom: 0.24rem;
}

.information__container__lqjCm .information__name__k0Vcv[data-v-9c86c1e4] {
  color: #98a5b3;
  font-size: 0.24rem;
  font-weight: 700;
  text-align: left;
  margin-bottom: 0.1rem;
}

.information__container__lqjCm .information__name__k0Vcv span[data-v-9c86c1e4] {
  color: #ede9e7;
  font-size: 0.28rem;
}

.information__container__lqjCm .information__comfim__1KhgC[data-v-9c86c1e4] {
  width: 100%;
  height: 0.8rem;
  line-height: 0.8rem;
  text-align: center;
  color: #fff;
  font-size: 0.32rem;
  background-color: #ede9e7;
  margin-top: 0.24rem;
  border-radius: 0.1rem;
}

.information__noticeBox__3S1cy .information__withBox__39jd0[data-v-9c86c1e4] {
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  min-height: calc(100vh - 0.9rem);
  background: #f8f8f8;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.information__noticeBox__3S1cy .information__withBox__39jd0 .information__notice__1vMZj[data-v-9c86c1e4] {
  width: 100%;
  background: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0.18rem 0 0.18rem 0.4rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.information__noticeBox__3S1cy .information__withBox__39jd0 .information__notice__1vMZj span img[data-v-9c86c1e4] {
  width: 0.36rem;
}

.information__noticeBox__3S1cy .information__withBox__39jd0 .information__notice__1vMZj p[data-v-9c86c1e4] {
  margin-left: 0.1rem;
  font-size: 0.24rem;
  color: #999;
}

.information__noticeBox__3S1cy .information__withBox__39jd0 .information__withInfo__2b5pe[data-v-9c86c1e4] {
  width: 100%;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  background: #fff;
  margin-top: 0.4rem;
}

.information__noticeBox__3S1cy .information__withBox__39jd0 .information__withInfo__2b5pe ul[data-v-9c86c1e4] {
  padding: 0 0.546rem;
  overflow: hidden;
}

.information__noticeBox__3S1cy .information__withBox__39jd0 .information__withInfo__2b5pe ul li[data-v-9c86c1e4] {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 0.34rem;
}

.information__noticeBox__3S1cy .information__withBox__39jd0 .information__withInfo__2b5pe ul li span[data-v-9c86c1e4]:first-of-type {
  font-size: 0.28rem;
  color: #a5a9b3;
}

.information__noticeBox__3S1cy .information__withBox__39jd0 .information__withInfo__2b5pe ul li span[data-v-9c86c1e4]:last-of-type {
  font-size: 0.28rem;
  color: #333;
}

.information__noticeBox__3S1cy .information__withBox__39jd0 .information__withInfo__2b5pe ul li[data-v-9c86c1e4]:last-child {
  position: relative;
}

.information__noticeBox__3S1cy .information__withBox__39jd0 .information__withInfo__2b5pe ul li:last-child span[data-v-9c86c1e4]:last-of-type {
  margin-right: 0.4rem;
}

.information__noticeBox__3S1cy .information__withBox__39jd0 .information__withInfo__2b5pe ul li:last-child img[data-v-9c86c1e4] {
  position: absolute;
  width: 0.24rem;
  height: 0.24rem;
  right: 0;
  top: 0;
}

.information__noticeBox__3S1cy .information__withBox__39jd0 .information__withInfo__2b5pe p[data-v-9c86c1e4] {
  text-align: center;
  margin-top: 1.28rem;
}

.information__payBtn__XbD-M[data-v-9c86c1e4] {
  opacity: 0.5;
  background-image: none;
  background: #ede9e7;
}

.bankModel[data-v-9c86c1e4] {
  width: 80vw;
}

.bankModel .am-modal-transparent .am-modal-content .am-modal-body[data-v-9c86c1e4] {
  padding: 0 0.4rem 0.4rem;
}

.information__boxNYB__3YzPZ[data-v-9c86c1e4] {
  margin-top: 0.2rem;
  font-family: DinPro, dinpro, PingFangSC-Regular, sans-serif;
}

.information__boxNYB__3YzPZ .information__warns__f7hW6[data-v-9c86c1e4] {
  padding: 0.3rem 0.28rem;
  background-color: #fff;
}

.information__boxNYB__3YzPZ .information__warns__f7hW6 h1[data-v-9c86c1e4] {
  margin: 0;
  font-size: 0.28rem;
  color: #414655;
}

.information__boxNYB__3YzPZ .information__warns__f7hW6 p[data-v-9c86c1e4] {
  margin-top: 0.1rem;
  color: #a5a9b3;
  width: 100%;
  font-size: 0.24rem;
  line-height: 0.34rem;
}

.information__boxNYB__3YzPZ .information__warns__f7hW6 p[data-v-9c86c1e4]:nth-child(4) {
  color: #db6372;
}

.information__boxNYB__3YzPZ .information__warns__f7hW6 p:nth-child(5) span[data-v-9c86c1e4] {
  color: #6aaaf5;
}

.information__boxNYB__3YzPZ .information__moneyCard__oBoGX[data-v-9c86c1e4] {
  margin: 0.3rem 0.28rem;
  padding: 0.3rem 0;
  background-color: #fff;
  border-radius: 0.2rem;
  -webkit-box-shadow: 0 0 0.3rem 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 0.3rem 0 rgba(0, 0, 0, 0.1);
}

.information__boxNYB__3YzPZ .information__moneyCard__oBoGX .information__topLine__1aEDH[data-v-9c86c1e4] {
  font-size: 0.56rem;
  color: #414655;
  font-weight: 700;
  font-family: DinPro, dinpro, PingFangSC-Regular, sans-serif;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.information__boxNYB__3YzPZ .information__moneyCard__oBoGX .information__topLine__1aEDH i[data-v-9c86c1e4] {
  background: none;
  font-size: 0.24rem;
  color: #6aaaf5;
  border: 0.02rem solid #6aaaf5;
  border-radius: 0.04rem;
  padding: 0.02rem 0.12rem;
  margin-left: 0.2rem;
}

.information__boxNYB__3YzPZ .information__moneyCard__oBoGX p[data-v-9c86c1e4] {
  font-size: 0.24rem;
  color: #db6372;
  text-align: center;
}

.information__boxNYB__3YzPZ .information__content__3_Bn-[data-v-9c86c1e4] {
  margin: 0.3rem 0.28rem;
  background-color: #fff;
  padding: 0.4rem 0.4rem 0.6rem;
  border-radius: 0.2rem;
  -webkit-box-shadow: 0 0 0.3rem 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 0.3rem 0 rgba(0, 0, 0, 0.1);
}

.information__boxNYB__3YzPZ .information__content__3_Bn- .information__bankInfo__3HPq3 li[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-bottom: 0.3rem;
}

.information__boxNYB__3YzPZ .information__content__3_Bn- .information__bankInfo__3HPq3 li[data-v-9c86c1e4]:nth-last-child(2) {
  margin-bottom: 0;
}

.information__boxNYB__3YzPZ .information__content__3_Bn- .information__bankInfo__3HPq3 li:nth-last-child(2) span[data-v-9c86c1e4]:nth-child(2) {
  color: #db6372;
}

.information__boxNYB__3YzPZ .information__content__3_Bn- .information__bankInfo__3HPq3 li span[data-v-9c86c1e4] {
  display: block;
  text-align: left;
  line-height: 0.4rem;
  color: #a5a9b3;
  font-size: 0.28rem;
}

.information__boxNYB__3YzPZ .information__content__3_Bn- .information__bankInfo__3HPq3 li span[data-v-9c86c1e4]:nth-child(2) {
  color: #414655;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.information__boxNYB__3YzPZ .information__content__3_Bn- .information__bankInfo__3HPq3 li span:nth-child(2) b[data-v-9c86c1e4] {
  color: #414655;
  font-weight: 400;
}

.information__boxNYB__3YzPZ .information__content__3_Bn- .information__bankInfo__3HPq3 li i[data-v-9c86c1e4] {
  line-height: 0.4rem;
  font-size: 0.24rem;
  color: #6aaaf5;
  border: 0.02rem solid #6aaaf5;
  border-radius: 0.04rem;
  padding: 0.02rem 0.12rem;
}

.information__boxNYB__3YzPZ .information__content__3_Bn- .information__bankInfo__3HPq3 p[data-v-9c86c1e4] {
  color: #db6372;
}

.information__boxNYB__3YzPZ .information__endTime__1x27h[data-v-9c86c1e4] {
  text-align: left;
  color: #a5a9b3;
  font-size: 0.24rem;
  padding: 0.1rem 0.28rem 0.6rem;
}

.information__boxNYB__3YzPZ .information__endTime__1x27h span[data-v-9c86c1e4] {
  color: #6aaaf5;
}

.information__speedUploadfile__10Usv[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0;
}

.information__speedUploadfile__10Usv .information__speedPicTip__31Jol[data-v-9c86c1e4] {
  color: #db6372;
  font-size: 0.24rem;
  display: inline-block;
}

.information__speedUploadfile__10Usv .information__uploadFileWrap__1bAYe[data-v-9c86c1e4] {
  font-size: 0.24rem;
  width: 1.6rem;
  height: 0.8rem;
  font-family: DINPro;
  text-align: center;
  border-radius: 0.08rem;
  display: inline-block;
  line-height: 0.75rem;
  background-image: -webkit-gradient(linear, left top, right top, from(#91abff), to(#ede9e7));
  background-image: -webkit-linear-gradient(left, #91abff, #ede9e7);
  background-image: linear-gradient(90deg, #91abff, #ede9e7);
  -webkit-box-shadow: 0 size(2) size(8) rgba(89, 126, 247, 0.3);
  box-shadow: 0 size(2) size(8) rgba(89, 126, 247, 0.3);
  color: #fff;
  border: 0.035rem solid #fff;
}

.information__speedUploadfile__10Usv .information__uploadFileWrap__1bAYe.information__finish__ZJdmO[data-v-9c86c1e4] {
  opacity: 0.5;
  background-image: none;
  background: #ede9e7;
}

.information__confirm-pormp-message__2eOTU[data-v-9c86c1e4] {
  font-size: 0.28rem;
  font-weight: 400;
  line-height: 0.4rem;
  letter-spacing: 0;
  text-align: center;
  color: #414655;
}

.index__progressBarContainer__3iwNk[data-v-9c86c1e4] {
  margin: 0 0.24rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.index__progressBarContainer__3iwNk .index__part__nkU0W[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.index__progressBarContainer__3iwNk .index__part__nkU0W .index__text__3exOu[data-v-9c86c1e4] {
  margin-bottom: 0.16rem;
  color: #a5a9b3;
  text-align: center;
}

.index__progressBarContainer__3iwNk .index__part__nkU0W .index__visual__3gmni[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 0.48rem;
}

.index__progressBarContainer__3iwNk .index__part__nkU0W .index__visual__3gmni .index__line__1vsSu[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 0.007rem;
  background: #cbced8;
}

.index__progressBarContainer__3iwNk .index__part__nkU0W.index__highlight__3TS9_ .index__text__3exOu[data-v-9c86c1e4] {
  color: #ede9e7;
}

.index__progressBarContainer__3iwNk .index__part__nkU0W.index__highlight__3TS9_ .index__line__1vsSu[data-v-9c86c1e4],
.index__progressBarContainer__3iwNk .index__part__nkU0W.index__highlightNext__3gQqd .index__line__1vsSu[data-v-9c86c1e4]:first-child {
  background: #ede9e7;
}

.index__progressBarContainer__3iwNk .index__part__nkU0W:first-child .index__visual__3gmni .index__line__1vsSu[data-v-9c86c1e4]:first-child,
.index__progressBarContainer__3iwNk .index__part__nkU0W:last-child .index__visual__3gmni .index__line__1vsSu[data-v-9c86c1e4]:last-child {
  background: transparent;
}

.open-file-modal__open-file-modal__2QSTi[data-v-9c86c1e4] {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 11;
}

.open-file-modal__open-file-modal__2QSTi .open-file-modal__mask__N2Rlk[data-v-9c86c1e4] {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 1;
  background: rgba(0, 0, 0, 0.6);
}

.open-file-modal__open-file-modal__2QSTi .open-file-modal__open-file-wrapper__3EfSK[data-v-9c86c1e4] {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 11;
  border-radius: 10px 10px 0 0;
  background: #f8f8f8;
  padding: 0 0.28rem;
  overflow: hidden;
}

.open-file-modal__open-file-modal__2QSTi .open-file-modal__open-file-picker__3wpVq[data-v-9c86c1e4] {
  margin: 0 -0.28rem;
}

.open-file-modal__open-file-modal__2QSTi .open-file-modal__button__Jx-G1[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  height: 1rem;
  font-size: 0.36rem;
  color: var(--commonNormalColor);
  letter-spacing: 0.34px;
  background: #fff;
  position: relative;
}

.open-file-modal__open-file-modal__2QSTi .open-file-modal__button-top__ZDlKX[data-v-9c86c1e4] {
  margin-top: 0.2rem;
}

.open-file-modal__open-file-modal__2QSTi .open-file-modal__file-input__xgwje[data-v-9c86c1e4] {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
  z-index: 11;
}

.deposit-upload-modal__deposit-upload-modal__3cl2a[data-v-9c86c1e4] {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 11;
}

.deposit-upload-modal__deposit-upload-modal__3cl2a .deposit-upload-modal__mask__pCCn1[data-v-9c86c1e4] {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 1;
  background: rgba(0, 0, 0, 0.6);
}

.deposit-upload-modal__deposit-upload-modal__3cl2a .deposit-upload-modal__deposit-upload-wrapper__1iGFi[data-v-9c86c1e4] {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 11;
  border-radius: 10px 10px 0 0;
  background: #fff;
  padding: 0 0.28rem;
}

.deposit-upload-modal__deposit-upload-modal__3cl2a .deposit-upload-modal__image-box__30nU2[data-v-9c86c1e4] {
  display: block;
  position: relative;
  width: 1rem;
  height: 1rem;
  border-radius: 0.06rem;
}

.deposit-upload-modal__deposit-upload-modal__3cl2a .deposit-upload-modal__close-upload-file__3Hugy[data-v-9c86c1e4] {
  content: '';
  position: absolute;
  width: 0.32rem;
  height: 0.32rem;
  top: 0;
  right: 0;
  -webkit-transform: translate(50%, -50%);
  transform: translate(50%, -50%);
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALzSURBVHgB7ZfPTxNBFMffmy6JAoeK3LxsE9QYLvAHGCExepNy8yakHoin1h+JN8sZgZ7URKvl5o3CTUNCo/8AN9OIttHACWu9WKCzM87btHV/TreknuSTbPbH7L733ffezrwF+N9BOAGVhbTJuWFKIUyJWGdqM4aHdxK5bB16JLKAz3cfTgGIGSkgiQhmiLGq2pViA2Ix8SJXjWK3q4DKwmPTah6vSoAk9IAyXIgiRCugnHqQZCDfqMM4nACKiAWYuZxfLmruCWY3lbkjAQvQBxBwbiy/vBY8FkDrzdehjwjA2aBI+AS0cr6tcm5Cf6kbA2LSWxPMe5dy/uQfOCfivBlb9V50RYDenjePKxojYJw/B/zHz8AxNnjG3ovfh+EGkE1ffPW01LHnHKO3Bw2jt5MQv34Vmgc12Ft65hIycuum2m4o5w177Oj7fqANKS36nEsd0Z7xKdAwNDFu7wdGR+DCo3t2NJzObYODZ8FQ42EwwBn3eYvKXDreLfe/tj52jtsiKCpt5wRF5+jbfqgN8kFTuU8AN4wJ6EJ96wPUNt+5RFBKnM73lp6r1NS0dmgd8QlAKSPNdrXN9y4RvTq3faEwfQJERAEtEyHXJUTBElj3CUDGqlEedhacE29h6qDl2yeAc17t9qDXOYWd6sIrgr4EHQYf3vEJuFLIVaW01/NQhibHXc4p5wdvN3yF2f5cgyAfiULWHwH7BOUGaGiUv7ictwvOWZg0ETXKX0NtMPw7CRGuarK7Him2QQPlWDQObUc+463QB4214ZZIULQDBRC7qfvrvXY/UaEuaSy/Mu+85lsNm5bIqEz13Fx2g3KvbC96r/sEUHgQ2Dz0WwBixhn6UAGEap+KSnHfRCAT82F9IQt76NLrlYLq5Wa7fZpaJNSpFRt7mSuE3cJ0z1MkLCGmJcg16BFVcEUuxKSuI27dF41Pc2kzFsOsSua1sB8TO1pqLkGMFZ1dT18EOKHegZZvWkFpEaN1xDB4Nerf0ClO/gDwjk2FNUAFngAAAABJRU5ErkJggg==);
  background-size: contain;
}

.deposit-upload-modal__deposit-upload-modal__3cl2a .deposit-upload-modal__image__kAyOM[data-v-9c86c1e4] {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 0.06rem;
}

.deposit-upload-modal__deposit-upload-modal__3cl2a .deposit-upload-modal__file-input__351k3[data-v-9c86c1e4] {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
  z-index: 11;
}

.deposit-upload-modal__deposit-upload-modal__3cl2a .deposit-upload-modal__deposit-upload-header__3E83N[data-v-9c86c1e4] {
  height: 1rem;
  font-size: 0.32rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: start;
  -ms-flex-pack: start;
  justify-content: start;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.deposit-upload-modal__deposit-upload-modal__3cl2a .deposit-upload-modal__cancel-button__3SpSk[data-v-9c86c1e4] {
  font-size: 0.32rem;
  color: #6aaaf5;
}

.deposit-upload-modal__deposit-upload-modal__3cl2a .deposit-upload-modal__image-box__30nU2+.deposit-upload-modal__image-box__30nU2[data-v-9c86c1e4] {
  margin-left: 0.36rem;
}

.deposit-upload-modal__deposit-upload-modal__3cl2a .deposit-upload-modal__deposit-upload-title__1DDSP[data-v-9c86c1e4] {
  margin: 0 -0.28rem;
  padding: 0 0.28rem;
  background: #f8f8f8;
  height: 0.8rem;
  color: #414655;
  font-size: 0.28rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.deposit-upload-modal__deposit-upload-modal__3cl2a .deposit-upload-modal__content__eUzQi[data-v-9c86c1e4] {
  padding-top: 0.3rem;
  padding-bottom: 0.24rem;
}

.deposit-upload-modal__deposit-upload-modal__3cl2a .deposit-upload-modal__content-tip__r4fbZ[data-v-9c86c1e4] {
  line-height: 0.4rem;
  font-size: 0.28rem;
  color: #a5a9b3;
}

.deposit-upload-modal__deposit-upload-modal__3cl2a .deposit-upload-modal__file-tip__38XlH[data-v-9c86c1e4] {
  line-height: 0.28rem;
  color: #cbced8;
  font-family: DINPro;
  font-size: 0.24rem;
}

.deposit-upload-modal__deposit-upload-modal__3cl2a .deposit-upload-modal__image-list__3-t7V[data-v-9c86c1e4] {
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: start;
  -ms-flex-pack: start;
  justify-content: start;
}

.deposit-upload-modal__deposit-upload-modal__3cl2a .deposit-upload-modal__deposit-upload-button-wrapper__34l6-[data-v-9c86c1e4] {
  padding-top: 0.2rem;
  padding-bottom: 0.88rem;
}

.deposit-upload-modal__deposit-upload-modal__3cl2a .deposit-upload-modal__button__RKRGv[data-v-9c86c1e4] {
  background: #4080ff;
  border-radius: 5px;
  height: 0.8rem;
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-family: PingFang SC;
  font-size: 0.36rem;
  color: #fff;
  border: 0;
}

.deposit-upload-modal__deposit-upload-modal__3cl2a .deposit-upload-modal__button__RKRGv[data-v-9c86c1e4]:disabled {
  opacity: 0.5;
}

.deposit-upload-modal__deposit-upload-modal__3cl2a .deposit-upload-modal__driver__2z8hM[data-v-9c86c1e4] {
  margin: 0 -0.28rem;
  height: 0;
  border-bottom: 0.2rem solid #f8f8f8;
}

.cancel-deposit__cancel-deposit__1DCn6[data-v-9c86c1e4] {
  width: 5.6rem;
}

.cancel-deposit__cancel-deposit__1DCn6 .am-modal-content[data-v-9c86c1e4],
.cancel-deposit__cancel-deposit__1DCn6 .am-modal-content .am-modal-body[data-v-9c86c1e4] {
  padding: 0;
}

.cancel-deposit__cancel-deposit-container__3F7QU[data-v-9c86c1e4] {
  padding: 20px;
}

.cancel-deposit__cancel-deposit-title__2MDIZ[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 0.48rem;
  font-family: PingFang SC;
  font-size: 0.36rem;
  color: #414655;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.cancel-deposit__cancel-tip__2oMjn[data-v-9c86c1e4] {
  font-family: PingFang SC;
  font-size: 0.28rem;
  color: #414655;
  line-height: 0.4rem;
  text-align: left;
  margin-top: 0.24rem;
}

.cancel-deposit__cancel-count__1B3WS[data-v-9c86c1e4] {
  font-family: PingFang SC;
  font-size: 0.28rem;
  color: #394857;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-top: 0.24rem;
  border-radius: 0.04rem;
  height: 0.56rem;
  background: #fafcff;
  border: 0.01rem solid #e9edf8;
}

.cancel-deposit__count-text__1_ZUa[data-v-9c86c1e4] {
  color: #ede9e7;
  font-weight: 700;
}

.cancel-deposit__content-title__Efp7L[data-v-9c86c1e4] {
  font-family: PingFang SC;
  font-size: 0.28rem;
  line-height: 0.28rem;
  color: #db6372;
  margin-top: 0.24rem;
  text-align: left;
}

.cancel-deposit__content-reason__3zOv2[data-v-9c86c1e4] {
  margin-top: 0.24rem;
}

.cancel-deposit__reason-item__1yQlr[data-v-9c86c1e4] {
  position: relative;
  background: #fff;
  border: 0.02rem solid #eee;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 0.1rem;
  font-family: PingFang SC;
  font-size: 14;
  color: #414655;
  height: 0.64rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.cancel-deposit__reason-item__1yQlr.cancel-deposit__action__2ACWj[data-v-9c86c1e4] {
  color: #ede9e7;
  border-color: #ede9e7;
}

.cancel-deposit__reason-item__1yQlr.cancel-deposit__action__2ACWj[data-v-9c86c1e4]:after {
  content: '';
  position: absolute;
  width: 5.12px;
  width: 0.32rem;
  height: 5.12px;
  height: 0.32rem;
  right: 0;
  bottom: 0;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAARVBMVEUAAAAAjv0Aj/0Ajv0Aj/4AkP4Ak/8Aj/wAj/0Alf4AlP8Aj/wAj/0AkP4Aj/0Aj/0AjvwAj/4AnP8AjvwAjv0Alf8Ajv3y6AqCAAAAFnRSTlMAgPzdVlEc1c8XEtliXPPopYoF2K4Oakr83AAAAIxJREFUOMul0EkOwzAMQ1E3tpvBbZpO//5HbVABdqCFuQi3jxAIBZGLcpSjHOUoRznKUY5ylKMc5ShHOcrp+fAAep6+I3T8Hq4Rej4XwPsnNn8DOJ/2s3+/hXkE4OA2zBrV16PXxu6LOcW5NXJYJiybdxhyaE5ybo3m8VXdv9iSnfs8z3ns3V/LlmzfDyYJJF+w5cW8AAAAAElFTkSuQmCC);
  background-size: cover;
  background-repeat: no-repeat;
}

.webpa .cancel-deposit__reason-item__1yQlr.cancel-deposit__action__2ACWj[data-v-9c86c1e4]:after {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAARVBMVEUAAAAAjv0Aj/0Ajv0Aj/4AkP4Ak/8Aj/wAj/0Alf4AlP8Aj/wAj/0AkP4Aj/0Aj/0AjvwAj/4AnP8AjvwAjv0Alf8Ajv3y6AqCAAAAFnRSTlMAgPzdVlEc1c8XEtliXPPopYoF2K4Oakr83AAAAIxJREFUOMul0EkOwzAMQ1E3tpvBbZpO//5HbVABdqCFuQi3jxAIBZGLcpSjHOUoRznKUY5ylKMc5ShHOcrp+fAAep6+I3T8Hq4Rej4XwPsnNn8DOJ/2s3+/hXkE4OA2zBrV16PXxu6LOcW5NXJYJiybdxhyaE5ybo3m8VXdv9iSnfs8z3ns3V/LlmzfDyYJJF+w5cW8AAAAAElFTkSuQmCC);
}

.cancel-deposit__reason-item__1yQlr+.cancel-deposit__reason-item__1yQlr[data-v-9c86c1e4] {
  margin-top: 0.24rem;
}

.cancel-deposit__cancel-deposit-footer__3UYBa[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-top: 0.4rem;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.cancel-deposit__cancel-deposit-footer__3UYBa>uni-button[data-v-9c86c1e4] {
  width: 2.24rem;
  height: 0.8rem;
  border-radius: 0.1rem;
  border: none;
  font-size: 0.32rem;
  font-family: PingFang SC;
}

.cancel-deposit__cancel-deposit-footer__3UYBa>uni-button[disabled][data-v-9c86c1e4] {
  opacity: 0.5;
}

.cancel-deposit__cancel-deposit-footer__3UYBa .cancel-deposit__cancel__1BQTb[data-v-9c86c1e4] {
  background: transparent;
  color: #ede9e7;
  border: 0.02rem solid #ede9e7;
}

.cancel-deposit__cancel-deposit-footer__3UYBa .cancel-deposit__confirm__35Q_Z[data-v-9c86c1e4] {
  color: #fff;
  background: #ede9e7;
}

.transacitonDetailStyle__main__2fu33[data-v-9c86c1e4] {
  padding: 0.6rem 0.5rem 0;
  position: relative;
  z-index: 2;
}

.transacitonDetailStyle__main__2fu33 h2[data-v-9c86c1e4] {
  font-size: 0.52rem;
  font-weight: 700;
  text-align: center;
  margin: 0 0 0.42rem;
  color: #0d1a26;
}

.transacitonDetailStyle__main__2fu33 h2 img[data-v-9c86c1e4] {
  width: 0.32rem;
  margin-right: 0.1rem;
}

.transacitonDetailStyle__main__2fu33>p[data-v-9c86c1e4] {
  min-height: 0.8rem;
  line-height: 0.8rem;
  font-size: 0.28rem;
  color: #a5a9b3;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.transacitonDetailStyle__main__2fu33>p span[data-v-9c86c1e4] {
  font-size: 0.26rem;
  color: #414655;
  font-family: dinpro;
  text-align: right;
  margin-left: 0.2rem;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  word-break: break-all;
}

.transacitonDetailStyle__main__2fu33>p .transacitonDetailStyle__row__2Q1ix[data-v-9c86c1e4] {
  color: #00a870 !important;
}

.transacitonDetailStyle__main__2fu33>p .transacitonDetailStyle__color3__5FbQV[data-v-9c86c1e4] {
  color: #ff4634;
  border-color: #ff4634;
}

.transacitonDetailStyle__main__2fu33>p b[data-v-9c86c1e4] {
  font-size: 0.26rem;
  font-weight: 400;
  height: 0.8rem;
  line-height: 0.8rem;
  -webkit-box-ordinal-group: 4;
  -webkit-order: 3;
  -ms-flex-order: 3;
  order: 3;
  margin-left: 0.08rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #6aaaf5;
}

.transacitonDetailStyle__main__2fu33>p b.transacitonDetailStyle__color失败__1_K1T[data-v-9c86c1e4] {
  color: #db6372;
}

.transacitonDetailStyle__main__2fu33>p b.transacitonDetailStyle__color成功__1HG-H[data-v-9c86c1e4] {
  color: #00a870;
}

.transacitonDetailStyle__speedJumpBtn__Wo9KV[data-v-9c86c1e4] {
  width: 6.34rem;
  height: 0.9rem;
  margin: 0.6rem auto auto;
  line-height: 0.9rem;
  text-align: center;
  color: #fff;
  font-size: 0.32rem;
  font-family: dinpro;
  border-radius: 0.1rem;
  background: #ede9e7;
}

.transacitonDetailStyle__speedCancelBtnWrapper__k4ScM[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  padding: 0 0.28rem;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.transacitonDetailStyle__speedCancelBtnWrapper__k4ScM .transacitonDetailStyle__immedBtn__2sCDZ[data-v-9c86c1e4],
.transacitonDetailStyle__speedCancelBtnWrapper__k4ScM .transacitonDetailStyle__speedJumpBtn__Wo9KV[data-v-9c86c1e4] {
  width: 3.36rem;
  margin-left: 0;
  margin-right: 0;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.transacitonDetailStyle__speedCancelBtnWrapper__k4ScM .transacitonDetailStyle__immedBtn__2sCDZ[data-v-9c86c1e4] {
  border: 1px solid #ede9e7;
  color: #ede9e7;
  background: #fff;
  font-weight: 500;
  margin-right: 0.22rem;
}

.transacitonDetailStyle__redTips__3fGwv[data-v-9c86c1e4] {
  margin-top: 0.2rem;
  font-size: 0.24rem;
  color: #db6372;
  text-align: center;
}

.transacitonDetailStyle__tips__3zE2l[data-v-9c86c1e4] {
  margin-top: 0.4rem;
  width: 100%;
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.28rem;
  text-align: center;
  color: #999;
}

.transacitonDetailStyle__tips__3zE2l span[data-v-9c86c1e4] {
  font-size: 0.28rem;
  color: #ede9e7;
}

.transacitonDetailStyle__bg__I_2ny[data-v-9c86c1e4] {
  position: fixed;
  top: 1.1rem;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  padding-bottom: 1.4rem;
  z-index: 1;
  background: #fff;
  overflow-y: scroll;
}

.transacitonDetailStyle__bg___3ZRP2[data-v-9c86c1e4] {
  top: 0.9rem;
}

.transacitonDetailStyle__bg___3ZRP2 p>span[data-v-9c86c1e4] {
  font-family: PingFang SC !important;
}

.transacitonDetailStyle__noMarginTopBg__25C6D[data-v-9c86c1e4] {
  margin-top: 0;
  top: 0.9rem;
}

.transacitonDetailStyle__notice__36CIB[data-v-9c86c1e4] {
  height: 35px;
  background-color: #eceef2;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 0.28rem;
  top: 0;
  width: 100%;
  color: #a5a9b3;
  font-family: PingFangSC;
  font-size: 0.24rem;
}

.transacitonDetailStyle__notice__36CIB img[data-v-9c86c1e4] {
  margin-right: 0.12rem;
  width: 0.4rem;
  height: 0.4rem;
}

.transacitonDetailStyle__notice__36CIB.transacitonDetailStyle__yibo__38M1s[data-v-9c86c1e4] {
  top: 0;
  background: #2d3148;
  color: #a5a9b3;
}

.transacitonDetailStyle__immedBtn__2sCDZ[data-v-9c86c1e4] {
  margin: 0.6rem 0.28rem 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 0.9rem;
  border-radius: 0.1rem;
  background-image: -webkit-gradient(linear, left top, right top, from(#62b3ff), color-stop(#3d72fa), to(#3d72fa));
  background-image: -webkit-linear-gradient(left, #62b3ff, #3d72fa, #3d72fa);
  background-image: linear-gradient(90deg, #62b3ff, #3d72fa, #3d72fa);
  color: #fff;
  font-size: 0.32rem;
  font-weight: 700;
}

.transacitonDetailStyle__immedBtn__2sCDZ.transacitonDetailStyle__yibo__38M1s[data-v-9c86c1e4] {
  color: #79420d;
  background-image: -webkit-gradient(linear, left top, right top, from(#f4d3b4), to(#d9a76f));
  background-image: -webkit-linear-gradient(left, #f4d3b4, #d9a76f);
  background-image: linear-gradient(90deg, #f4d3b4, #d9a76f);
}

.transacitonDetailStyle__tip__3xnGh[data-v-9c86c1e4] {
  font-family: PingFangSC;
  font-size: 0.24rem;
  color: #db6372;
  text-align: center;
  margin-top: 0.3rem;
}

.transacitonDetailStyle__yibo__38M1s[data-v-9c86c1e4] {
  background: #222536;
}

.transacitonDetailStyle__yibo__38M1s .transacitonDetailStyle__notice__36CIB[data-v-9c86c1e4] {
  background: #2d3148;
  color: #a5a9b3;
}

.transacitonDetailStyle__yibo__38M1s .transacitonDetailStyle__main__2fu33>p[data-v-9c86c1e4] {
  color: #6c6e82;
}

.transacitonDetailStyle__yibo__38M1s .transacitonDetailStyle__main__2fu33>p span[data-v-9c86c1e4] {
  color: #dedede;
}

.transacitonDetailStyle__yibo__38M1s .transacitonDetailStyle__tips__3zE2l[data-v-9c86c1e4] {
  color: #626571;
}

.transacitonDetailStyle__splitOrderWrapper__sDitD[data-v-9c86c1e4] {
  width: auto;
  margin: 0.28rem 0.3rem 0;
  padding: 0 0.2rem;
  border-radius: 0.12rem;
  background-color: #f8f8f8;
}

.transacitonDetailStyle__splitOrderWrapper__sDitD .transacitonDetailStyle__head__17iJ9[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  border-bottom: 0.01rem solid #cbced8;
  overflow: hidden;
}

.transacitonDetailStyle__splitOrderWrapper__sDitD .transacitonDetailStyle__head__17iJ9 .transacitonDetailStyle__fixedTips__o8IEg[data-v-9c86c1e4] {
  width: 1.6rem;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  padding: 0.28rem 0;
  color: #a5a9b3;
  font-size: 0.28rem;
  line-height: 0.4rem;
}

.transacitonDetailStyle__splitOrderWrapper__sDitD .transacitonDetailStyle__head__17iJ9 .transacitonDetailStyle__tabWapper__2PZs1[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  overflow-x: scroll;
}

.transacitonDetailStyle__splitOrderWrapper__sDitD .transacitonDetailStyle__head__17iJ9 .transacitonDetailStyle__tabWapper__2PZs1 .transacitonDetailStyle__tab__IXJx8[data-v-9c86c1e4] {
  position: relative;
  width: 1.6rem;
  padding: 0.28rem 0;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  color: #333;
  text-align: center;
  font-size: 0.28rem;
  font-family: dinpro;
  line-height: 0.4rem;
}

.transacitonDetailStyle__splitOrderWrapper__sDitD .transacitonDetailStyle__head__17iJ9 .transacitonDetailStyle__tabWapper__2PZs1 .transacitonDetailStyle__bottomLine__dvnJB[data-v-9c86c1e4] {
  position: absolute;
  left: 0.5rem;
  bottom: 0;
  width: 0.6rem;
  height: 0.04rem;
  background: #6aaaf5;
  -webkit-transition: all 0.2s linear;
  transition: all 0.2s linear;
}

.transacitonDetailStyle__splitOrderWrapper__sDitD .transacitonDetailStyle__content__3RRUS[data-v-9c86c1e4] {
  overflow: hidden;
}

.transacitonDetailStyle__splitOrderWrapper__sDitD .transacitonDetailStyle__content__3RRUS .transacitonDetailStyle__item__2pwD_[data-v-9c86c1e4] {
  margin: 0.3rem 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.transacitonDetailStyle__splitOrderWrapper__sDitD .transacitonDetailStyle__content__3RRUS .transacitonDetailStyle__item__2pwD_ .transacitonDetailStyle__label__3y7pe[data-v-9c86c1e4] {
  color: #a5a9b3;
  font-size: 0.28rem;
  line-height: 0.4rem;
}

.transacitonDetailStyle__splitOrderWrapper__sDitD .transacitonDetailStyle__content__3RRUS .transacitonDetailStyle__item__2pwD_ .transacitonDetailStyle__value__3rbkZ[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #333;
  font-size: 0.28rem;
  line-height: 0.4rem;
}

.transacitonDetailStyle__splitOrderWrapper__sDitD .transacitonDetailStyle__content__3RRUS .transacitonDetailStyle__item__2pwD_ .transacitonDetailStyle__value__3rbkZ.transacitonDetailStyle__orderStatus__1J-B5[data-v-9c86c1e4] {
  color: #6aaaf5;
}

.transacitonDetailStyle__splitOrderWrapper__sDitD .transacitonDetailStyle__content__3RRUS .transacitonDetailStyle__item__2pwD_ .transacitonDetailStyle__value__3rbkZ.transacitonDetailStyle__color成功__1HG-H[data-v-9c86c1e4] {
  color: #00a870;
}

.transacitonDetailStyle__splitOrderWrapper__sDitD .transacitonDetailStyle__content__3RRUS .transacitonDetailStyle__item__2pwD_ .transacitonDetailStyle__value__3rbkZ.transacitonDetailStyle__color失败__1_K1T[data-v-9c86c1e4] {
  color: #db6372;
}

.transacitonDetailStyle__splitOrderWrapper__sDitD .transacitonDetailStyle__content__3RRUS .transacitonDetailStyle__item__2pwD_ .transacitonDetailStyle__value__3rbkZ>span[data-v-9c86c1e4] {
  font-size: 0.28rem;
}

.transacitonDetailStyle__splitOrderWrapper__sDitD .transacitonDetailStyle__content__3RRUS .transacitonDetailStyle__item__2pwD_ .transacitonDetailStyle__value__3rbkZ .transacitonDetailStyle__marginStatus__VgmgV[data-v-9c86c1e4] {
  color: #6aaaf5;
  margin-right: 0.16rem;
}

.transacitonDetailStyle__splitOrderWrapper__sDitD .transacitonDetailStyle__content__3RRUS .transacitonDetailStyle__item__2pwD_ .transacitonDetailStyle__value__3rbkZ .transacitonDetailStyle__marginAmount__o3Go5[data-v-9c86c1e4] {
  font-family: dinpro;
}

.transacitonDetailStyle__splitOrderWrapper__sDitD .transacitonDetailStyle__content__3RRUS .transacitonDetailStyle__item__2pwD_ .transacitonDetailStyle__value__3rbkZ .transacitonDetailStyle__subOrderNo__2fE2Y[data-v-9c86c1e4] {
  margin-right: 0.08rem;
  font-family: dinpro;
}

.style__hide__ql6P3[data-v-9c86c1e4] {
  display: none;
}

.style__show__1KNC_[data-v-9c86c1e4] {
  display: block;
}

.style__show__1KNC_[data-v-9c86c1e4]:after,
.style__show__1KNC_[data-v-9c86c1e4]:before {
  content: ' ';
  display: table;
  clear: both;
}

.TransferPickerStyle__model__l-qI6[data-v-9c86c1e4] {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 666;
  overflow: hidden;
}

.TransferPickerStyle__model__l-qI6 .TransferPickerStyle__container__FXnCv[data-v-9c86c1e4] {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 80%;
  background-color: #f8f8f8;
  z-index: 1001;
  border-radius: 0.2rem 0.2rem 0 0;
  overflow: hidden;
}

.TransferPickerStyle__model__l-qI6 .TransferPickerStyle__container__FXnCv.TransferPickerStyle__moveTop__32Py4[data-v-9c86c1e4] {
  -webkit-animation: TransferPickerStyle__moveTop__32Py4-data-v-9c86c1e4 0.5s;
  animation: TransferPickerStyle__moveTop__32Py4-data-v-9c86c1e4 0.5s;
}

.TransferPickerStyle__model__l-qI6 .TransferPickerStyle__container__FXnCv .TransferPickerStyle__header__2NMgf[data-v-9c86c1e4] {
  width: 100%;
  height: 1.46rem;
  background: #fff;
  position: relative;
  text-align: center;
}

.TransferPickerStyle__model__l-qI6 .TransferPickerStyle__container__FXnCv .TransferPickerStyle__header__2NMgf .TransferPickerStyle__tit__BVDjD[data-v-9c86c1e4] {
  color: #333;
  font-size: 0.32rem;
  line-height: 1.46rem;
}

.TransferPickerStyle__model__l-qI6 .TransferPickerStyle__container__FXnCv .TransferPickerStyle__header__2NMgf .TransferPickerStyle__close__2fQpK[data-v-9c86c1e4] {
  color: #158bf4;
  font-size: 0.32rem;
  position: absolute;
  left: 0.28rem;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}

.TransferPickerStyle__model__l-qI6 .TransferPickerStyle__container__FXnCv .TransferPickerStyle__walletList__2b_e-[data-v-9c86c1e4] {
  width: 100%;
  height: 80%;
  overflow: auto;
  background: #fff;
  margin-top: 0.2rem;
  padding-left: 0.28rem;
  -webkit-overflow-scrolling: touch;
}

.TransferPickerStyle__model__l-qI6 .TransferPickerStyle__container__FXnCv .TransferPickerStyle__walletList__2b_e- .TransferPickerStyle__liList__3w2WF[data-v-9c86c1e4] {
  width: 100%;
}

.TransferPickerStyle__model__l-qI6 .TransferPickerStyle__container__FXnCv .TransferPickerStyle__walletList__2b_e- li[data-v-9c86c1e4] {
  width: 100%;
  height: 1rem;
  border-bottom: 0.02rem solid #f8f8f8;
  line-height: 1rem;
  position: relative;
}

.TransferPickerStyle__model__l-qI6 .TransferPickerStyle__container__FXnCv .TransferPickerStyle__walletList__2b_e- li span[data-v-9c86c1e4] {
  font-size: 0.32rem;
  color: #414655;
}

.TransferPickerStyle__model__l-qI6 .TransferPickerStyle__container__FXnCv .TransferPickerStyle__walletList__2b_e- li .TransferPickerStyle__disable__1URWm[data-v-9c86c1e4] {
  margin-left: 0.2rem;
  color: #a5a9b3;
}

.TransferPickerStyle__model__l-qI6 .TransferPickerStyle__container__FXnCv .TransferPickerStyle__walletList__2b_e- li img[data-v-9c86c1e4] {
  width: 0.294rem;
  position: absolute;
  right: 0.292rem;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}

@-webkit-keyframes TransferPickerStyle__moveTop__32Py4-data-v-9c86c1e4 {
  0% {
    -webkit-transform: translateY(10rem);
    transform: translateY(10rem);
  }

  to {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}

@keyframes TransferPickerStyle__moveTop__32Py4-data-v-9c86c1e4 {
  0% {
    -webkit-transform: translateY(10rem);
    transform: translateY(10rem);
  }

  to {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}

.TransferPickerStyle__nyb__2ZcHE[data-v-9c86c1e4] {
  background: rgba(0, 0, 0, 0.3);
}

.TransferPickerStyle__nyb__2ZcHE .TransferPickerStyle__container__FXnCv[data-v-9c86c1e4] {
  height: 90%;
}

.TransferPickerStyle__nyb__2ZcHE .TransferPickerStyle__container__FXnCv .TransferPickerStyle__header__2NMgf[data-v-9c86c1e4] {
  -webkit-box-shadow: 0 0.04rem 0.08rem 0 rgba(0, 0, 0, 0.05);
  box-shadow: 0 0.04rem 0.08rem 0 rgba(0, 0, 0, 0.05);
}

.TransferPickerStyle__nyb__2ZcHE .TransferPickerStyle__container__FXnCv .TransferPickerStyle__header__2NMgf .TransferPickerStyle__close__2fQpK[data-v-9c86c1e4] {
  color: #b1987f;
}

.TransferPickerStyle__nyb__2ZcHE .TransferPickerStyle__container__FXnCv .TransferPickerStyle__header__2NMgf .TransferPickerStyle__tit__BVDjD[data-v-9c86c1e4] {
  color: #414655;
}

.TransferPickerStyle__nyb__2ZcHE .TransferPickerStyle__container__FXnCv .TransferPickerStyle__walletList__2b_e-[data-v-9c86c1e4] {
  background: #f8f8f8;
  margin: 0;
  padding-top: 0.2rem;
  padding-left: 0;
}

.TransferPickerStyle__nyb__2ZcHE .TransferPickerStyle__container__FXnCv .TransferPickerStyle__walletList__2b_e- li[data-v-9c86c1e4] {
  background-color: #fff;
  padding-left: 0.28rem;
  position: relative;
}

.TransferPickerStyle__nyb__2ZcHE .TransferPickerStyle__container__FXnCv .TransferPickerStyle__walletList__2b_e- li span[data-v-9c86c1e4] {
  font-size: 0.28rem;
  color: #414655;
}

.TransferPickerStyle__nyb__2ZcHE .TransferPickerStyle__container__FXnCv .TransferPickerStyle__walletList__2b_e- li i[data-v-9c86c1e4] {
  display: inline-block;
  width: 0.32rem;
  height: 0.32rem;
  background-image: url(/static/img/sprite.4255d1761e02a5a8047d5dd4b469ea0e.4255d176.png);
  background-repeat: no-repeat;
  background-position: -12.9rem 0;
  background-size: 14.3rem 0.48rem;
  position: absolute;
  right: 0.28rem;
  top: 0.32rem;
}

.webpa .TransferPickerStyle__nyb__2ZcHE .TransferPickerStyle__container__FXnCv .TransferPickerStyle__walletList__2b_e- li i[data-v-9c86c1e4] {
  background-image: url(/static/img/sprite.4255d1761e02a5a8047d5dd4b469ea0e.4255d176.png);
}

.transfer__box__g1TII[data-v-9c86c1e4] {
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: #f8f8f8;
  overflow: hidden;
}

.transfer__box__g1TII .transfer__container__1XyPv[data-v-9c86c1e4] {
  width: 100%;
  background: #fff;
  padding: 0 0.28rem;
}

.transfer__box__g1TII .transfer__container__1XyPv h2[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding: 0.2rem 0;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border-bottom: 0.02rem solid #f8f8f8;
}

.transfer__box__g1TII .transfer__container__1XyPv h2 span[data-v-9c86c1e4]:first-of-type {
  color: #333;
  font-size: 0.28rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.transfer__box__g1TII .transfer__container__1XyPv h2 span:first-of-type img[data-v-9c86c1e4] {
  width: 0.28rem;
  margin-left: 0.1rem;
}

.transfer__box__g1TII .transfer__container__1XyPv h2 span[data-v-9c86c1e4]:last-of-type {
  color: #697b8c;
  font-size: 0.28rem;
  font-weight: 400;
}

.transfer__box__g1TII .transfer__container__1XyPv .transfer__walletList__3inRZ[data-v-9c86c1e4] {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding: 0.22rem 0;
  border-bottom: 0.02rem solid #f8f8f8;
}

.transfer__box__g1TII .transfer__container__1XyPv .transfer__walletList__3inRZ li[data-v-9c86c1e4] {
  width: 50%;
}

.transfer__box__g1TII .transfer__container__1XyPv .transfer__walletList__3inRZ li[data-v-9c86c1e4]:first-of-type {
  position: relative;
}

.transfer__box__g1TII .transfer__container__1XyPv .transfer__walletList__3inRZ li[data-v-9c86c1e4]:first-of-type:after {
  content: '';
  width: 0.32px;
  width: 0.02rem;
  height: 6.08px;
  height: 0.38rem;
  position: absolute;
  top: 50%;
  right: 0;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #f8f8f8;
}

.transfer__box__g1TII .transfer__container__1XyPv .transfer__walletList__3inRZ li span[data-v-9c86c1e4]:first-of-type {
  color: #333;
  font-size: 0.24rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.transfer__box__g1TII .transfer__container__1XyPv .transfer__walletList__3inRZ li span:first-of-type img[data-v-9c86c1e4] {
  width: 0.28rem;
  margin-right: 0.1rem;
  margin-left: -0.1rem;
}

.transfer__box__g1TII .transfer__container__1XyPv .transfer__walletList__3inRZ li span[data-v-9c86c1e4]:last-of-type {
  color: #158bf4;
  font-size: 0.32rem;
  text-align: center;
  display: block;
  margin-top: 0.1rem;
  font-family: DINPro-Medium;
}

.transfer__box__g1TII .transfer__container__1XyPv .transfer__venueList__3i1SI[data-v-9c86c1e4] {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.transfer__box__g1TII .transfer__container__1XyPv .transfer__venueList__3i1SI li[data-v-9c86c1e4] {
  padding: 0.22rem 0;
  width: 25%;
  position: relative;
}

.transfer__box__g1TII .transfer__container__1XyPv .transfer__venueList__3i1SI li[data-v-9c86c1e4]:after {
  content: '';
  width: 0.32px;
  width: 0.02rem;
  height: 6.08px;
  height: 0.38rem;
  position: absolute;
  top: 50%;
  right: 0;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #f8f8f8;
}

.transfer__box__g1TII .transfer__container__1XyPv .transfer__venueList__3i1SI li span[data-v-9c86c1e4]:first-of-type {
  display: block;
  text-align: center;
  color: #333;
  font-size: 0.24rem;
}

.transfer__box__g1TII .transfer__container__1XyPv .transfer__venueList__3i1SI li span[data-v-9c86c1e4]:last-of-type {
  display: block;
  text-align: center;
  color: #a5a9b3;
  font-size: 0.24rem;
  margin-top: 0.1rem;
}

.transfer__box__g1TII .transfer__container__1XyPv .transfer__venueList__3i1SI .transfer__more__1pihk[data-v-9c86c1e4] {
  padding: 0.22rem 0;
  width: 25%;
  text-align: center;
}

.transfer__box__g1TII .transfer__container__1XyPv .transfer__venueList__3i1SI .transfer__more__1pihk span[data-v-9c86c1e4] {
  margin-top: 0 !important;
}

.transfer__box__g1TII .transfer__container__1XyPv .transfer__venueList__3i1SI .transfer__more__1pihk img[data-v-9c86c1e4] {
  height: 0.32rem;
  margin-top: 0.06rem;
}

.transfer__box__g1TII .transfer__automaTransfer__2XuD4[data-v-9c86c1e4] {
  width: 100%;
  background: #fff;
  padding: 0.3rem 0.38rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #333;
  font-weight: 700;
  margin-top: 0.2rem;
}

.transfer__box__g1TII .transfer__automaTransfer__2XuD4 span[data-v-9c86c1e4] {
  font-size: 0.28rem;
  width: 100%;
}

.transfer__box__g1TII .transfer__automaTransfer__2XuD4 span i[data-v-9c86c1e4] {
  font-size: 0.2rem;
  float: right;
  margin-right: 0.2rem;
  margin-top: 0.1rem;
  color: #a5a9b3;
}

.transfer__box__g1TII .transfer__automaTransfer__2XuD4 section[data-v-9c86c1e4] {
  background: #ede9e7;
}

.transfer__box__g1TII .transfer__transferInfo__2jlS8[data-v-9c86c1e4] {
  width: 100%;
  background: #fff;
  padding: 0 0.32rem;
  margin-top: 0.2rem;
}

.transfer__box__g1TII .transfer__transferInfo__2jlS8 .transfer__showList__2800t[data-v-9c86c1e4] {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.3rem;
  border-bottom: 0.02rem solid #eee;
}

.transfer__box__g1TII .transfer__transferInfo__2jlS8 .transfer__showList__2800t span[data-v-9c86c1e4] {
  width: 2rem;
  font-weight: 700;
  font-size: 0.28rem;
}

.transfer__box__g1TII .transfer__transferInfo__2jlS8 .transfer__showList__2800t span img[data-v-9c86c1e4] {
  width: 0.1rem;
  margin: 0 0 0 0.2rem;
}

.transfer__box__g1TII .transfer__transferInfo__2jlS8 .transfer__showList__2800t span[data-v-9c86c1e4]:first-of-type {
  text-align: right;
}

.transfer__box__g1TII .transfer__transferInfo__2jlS8 .transfer__showList__2800t img[data-v-9c86c1e4] {
  margin: 0 0.88rem;
  width: 0.4rem;
}

.transfer__box__g1TII .transfer__transferInfo__2jlS8 .transfer__notice__1WH7v[data-v-9c86c1e4] {
  width: 100%;
  padding: 0.2rem 0;
  font-size: 0.24rem;
  color: #a5a9b3;
}

.transfer__box__g1TII .transfer__transferInfo__2jlS8 .transfer__moneyTip__KIGdc[data-v-9c86c1e4] {
  color: red;
  text-indent: 0.3rem;
  line-height: 0.4rem;
}

.transfer__box__g1TII .transfer__transferInfo__2jlS8 .transfer__none__3i931[data-v-9c86c1e4] {
  display: none;
}

.transfer__box__g1TII .transfer__notice__1WH7v[data-v-9c86c1e4] {
  width: 100%;
  padding: 0.2rem 0.28rem;
  font-size: 0.24rem;
  color: #a5a9b3;
}

.transfer__loading__3dHHb[data-v-9c86c1e4] {
  width: 0.3rem;
  -webkit-animation: transfer__loading__3dHHb-data-v-9c86c1e4 1s linear infinite;
  animation: transfer__loading__3dHHb-data-v-9c86c1e4 1s linear infinite;
  -webkit-transform-origin: center center;
  transform-origin: center center;
}

@-webkit-keyframes transfer__loading__3dHHb-data-v-9c86c1e4 {
  0% {
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }

  to {
    transform: rotate(-1turn);
    -ms-transform: rotate(-1turn);
    -webkit-transform: rotate(-1turn);
  }
}

@keyframes transfer__loading__3dHHb-data-v-9c86c1e4 {
  0% {
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }

  to {
    transform: rotate(-1turn);
    -ms-transform: rotate(-1turn);
    -webkit-transform: rotate(-1turn);
  }
}

@-webkit-keyframes transfer__refresh__2B-_g-data-v-9c86c1e4 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}

@keyframes transfer__refresh__2B-_g-data-v-9c86c1e4 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}

p[data-v-9c86c1e4] {
  margin-bottom: 0;
}

.exchange__kunw__1VOAY[data-v-9c86c1e4] {
  font-family: PingFang SC;
  font-size: 0.36rem;
  text-align: center;
  color: #414655;
  padding: 0.8rem 1rem 0.4rem;
}

.exchange__kunw__1VOAY.exchange__yibo__2haXZ[data-v-9c86c1e4] {
  color: #dedede;
}

.exchange__exchangeContainer__5JIyV[data-v-9c86c1e4] {
  min-height: calc(100vh - 1.7rem);
}

.exchange__exchangeContainer__5JIyV .exchange__usdtIntroduce__1URYy[data-v-9c86c1e4] {
  padding: 0.2rem;
  background: #fff;
}

.exchange__exchangeContainer__5JIyV .exchange__usdtIntroduce__1URYy .exchange__usdtIntroducePanel__17J0r[data-v-9c86c1e4] {
  background: #f8f8f8;
  height: 1.42rem;
  padding: 0.2rem 0.4rem;
  position: relative;
}

.exchange__exchangeContainer__5JIyV .exchange__usdtIntroduce__1URYy .exchange__usdtIntroducePanel__17J0r>div[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.exchange__exchangeContainer__5JIyV .exchange__usdtIntroduce__1URYy .exchange__usdtIntroducePanel__17J0r>div[data-v-9c86c1e4]:first-child {
  font-family: PingFang SC;
  font-size: 0.24rem;
  color: #666;
}

.exchange__exchangeContainer__5JIyV .exchange__usdtIntroduce__1URYy .exchange__usdtIntroducePanel__17J0r>div:first-child img[data-v-9c86c1e4] {
  width: 0.24rem;
  height: 0.28rem;
  margin-right: 0.08rem;
}

.exchange__exchangeContainer__5JIyV .exchange__usdtIntroduce__1URYy .exchange__usdtIntroducePanel__17J0r>div:first-child img[data-v-9c86c1e4]:last-child {
  width: 0.3rem;
  height: 0.3rem;
  position: absolute;
  top: 0.16rem;
  right: 0.08rem;
}

.exchange__exchangeContainer__5JIyV .exchange__usdtIntroduce__1URYy .exchange__usdtIntroducePanel__17J0r>div[data-v-9c86c1e4]:last-child {
  margin-top: 0.3rem;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.exchange__exchangeContainer__5JIyV .exchange__usdtIntroduce__1URYy .exchange__usdtIntroducePanel__17J0r>div:last-child span[data-v-9c86c1e4] {
  height: 0.4rem;
  background: #fff;
  border-radius: 0.26rem;
  font-family: PingFang SC;
  font-size: 0.2rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  width: 1.56rem;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.exchange__exchangeContainer__5JIyV .exchange__usdtIntroduce__1URYy .exchange__usdtIntroducePanel__17J0r>div:last-child span[data-v-9c86c1e4]:last-child {
  margin: 0;
}

.exchange__exchangeContainer__5JIyV .exchange__topAdve__N20SS[data-v-9c86c1e4] {
  width: 100%;
  display: block;
}

.exchange__exchangeContainer__5JIyV .exchange__walletPanel__306Qn[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 1.2rem;
  padding: 0 0.28rem;
  background: #fff;
}

.exchange__exchangeContainer__5JIyV .exchange__walletPanel__306Qn>li[data-v-9c86c1e4] {
  width: 50%;
  text-align: center;
  padding: 0.22rem 0;
}

.exchange__exchangeContainer__5JIyV .exchange__walletPanel__306Qn .exchange__title__P2WA9[data-v-9c86c1e4] {
  font-size: 0.24rem;
  color: rgba(51, 51, 51, 0.85);
  line-height: 0.34rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.exchange__exchangeContainer__5JIyV .exchange__walletPanel__306Qn .exchange__title__P2WA9>img[data-v-9c86c1e4] {
  margin-right: 0.06rem;
}

.exchange__exchangeContainer__5JIyV .exchange__walletPanel__306Qn .exchange__value__1NwTQ[data-v-9c86c1e4] {
  font-family: DINPro-Medium;
  font-size: 0.32rem;
  color: #ede9e7;
  font-weight: 500;
  margin-top: 0.04rem;
  line-height: 0.38rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.exchange__exchangeContainer__5JIyV .exchange__walletPanel__306Qn .exchange__value__1NwTQ span[data-v-9c86c1e4] {
  font-size: 0.28rem;
}

.exchange__exchangeContainer__5JIyV .exchange__walletPanel__306Qn img[data-v-9c86c1e4] {
  width: 0.28rem;
}

.exchange__exchangeContainer__5JIyV .exchange__walletPanel__306Qn>span[data-v-9c86c1e4] {
  display: block;
  width: 0.02rem;
  height: 0.4rem;
  position: absolute;
  left: 50%;
  background: #eee;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__changeInput__2fHns[data-v-9c86c1e4],
.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__changeTtns__3P3Rx[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  background: #fff;
  font-family: DinPro;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__changeTtns__3P3Rx[data-v-9c86c1e4] {
  height: 2.5rem;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__changeTtns__3P3Rx>div[data-v-9c86c1e4] {
  width: 2rem;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__changeTtns__3P3Rx>div>div[data-v-9c86c1e4] {
  text-align: center;
  font-family: PingFang SC;
  font-size: 0.24rem;
  color: #414655;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__changeTtns__3P3Rx>div>div[data-v-9c86c1e4]:first-child {
  margin-bottom: 0.3rem;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__changeTtns__3P3Rx>div>div:first-child span[data-v-9c86c1e4] {
  margin-right: 0.1rem;
  color: #ccc;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__changeTtns__3P3Rx>div>div[data-v-9c86c1e4]:last-child {
  color: #ede9e7;
  font-size: 0.28rem;
  font-family: DINPro;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__changeTtns__3P3Rx>div>div:last-child img[data-v-9c86c1e4] {
  width: 0.24rem;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__changeTtns__3P3Rx>div>div:last-child span[data-v-9c86c1e4] {
  font-weight: 700;
  color: #414655;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__changeTtns__3P3Rx>span[data-v-9c86c1e4] {
  font-size: 0.28rem;
  color: #414655;
  font-weight: 700;
  height: 2.5rem;
  width: 2rem;
  text-align: center;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  margin: 0;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__changeTtns__3P3Rx img[data-v-9c86c1e4] {
  width: 0.52rem;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__changeTitle__2tiTJ[data-v-9c86c1e4] {
  margin-top: 0.2rem;
  font-family: PingFang SC;
  font-size: 0.28rem;
  color: #414655;
  height: 0.8rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 0.28rem;
  background: #fff;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__changeInput__2fHns[data-v-9c86c1e4] {
  padding: 0 0.28rem;
  height: 0.8rem;
  overflow: hidden;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__changeInput__2fHns span[data-v-9c86c1e4] {
  color: #414655;
  font-weight: 500;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__changeInput__2fHns span[data-v-9c86c1e4]:first-child {
  font-size: 0.36rem;
  font-weight: 700;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__changeInput__2fHns span[data-v-9c86c1e4]:last-child {
  font-size: 0.24rem;
  color: #ede9e7;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__changeInput__2fHns .exchange__input__3R6yg[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 0.8rem;
  padding: 0 0.1rem;
  background: #fff;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__changeInput__2fHns .exchange__input__3R6yg .fake-input[data-v-9c86c1e4] {
  font-size: 0.48rem;
  font-family: DinPro;
  font-weight: 700;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__changeInput__2fHns .exchange__input__3R6yg .fake-input-placeholder[data-v-9c86c1e4] {
  font-size: 0.36rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__changeInput__2fHns img[data-v-9c86c1e4] {
  width: 0.36rem;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__fenge__R7HEU[data-v-9c86c1e4] {
  background: #fff;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__fenge__R7HEU>div[data-v-9c86c1e4]:first-child {
  background: #eee;
  height: 0.02rem;
  margin: 0 0.28rem;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__expectPanel__377eh[data-v-9c86c1e4] {
  height: 0.8rem;
  font-family: DINPro;
  font-size: 0.24rem;
  color: #999;
  margin-bottom: 0.6rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 0.28rem;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__expectPanel__377eh b[data-v-9c86c1e4] {
  color: #ede9e7;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__expectPanel__377eh span[data-v-9c86c1e4] {
  color: #414655;
  font-weight: 700;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__immedBtn__NVijr[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding: 0 0.28rem;
  opacity: 0.5;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__immedBtn__NVijr span[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 0.9rem;
  border-radius: 0.1rem;
  background-color: #ede9e7;
  color: #fff;
  font-size: 0.32rem;
  font-weight: 700;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.exchange__exchangeContainer__5JIyV .exchange__exchangePanel__1YFsX .exchange__immedBtn__NVijr.exchange__active__2Eojb[data-v-9c86c1e4] {
  opacity: 1;
}

.exchange__exchangeContainer__5JIyV .exchange__btmAdve__xw4ZZ[data-v-9c86c1e4] {
  margin-top: 0.6rem;
}

.exchange__exchangeContainer__5JIyV .exchange__btmAdve__xw4ZZ>p[data-v-9c86c1e4] {
  text-align: center;
  color: #a5a9b3;
  font-size: 0.28rem;
}

.exchange__exchangeContainer__5JIyV .exchange__btmAdve__xw4ZZ>p span[data-v-9c86c1e4] {
  color: #ede9e7;
  margin: 0 0.1rem;
}

.exchange__exchangeContainer__5JIyV .exchange__btmAdve__xw4ZZ .exchange__adves__2zJ3d[data-v-9c86c1e4] {
  margin-top: 0.4rem;
  padding: 0 0.56rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.exchange__exchangeContainer__5JIyV .exchange__btmAdve__xw4ZZ .exchange__adves__2zJ3d>img[data-v-9c86c1e4] {
  width: 1.96rem;
  height: 2.3rem;
}

.exchange__exchangeContainer__5JIyV .am-input-clear[data-v-9c86c1e4] {
  background-color: initial;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAWlBMVEUAAABtboNtb4N8kZhsboNtboJucYVtcIRsboJ0dItucYRvc4Zuc4VsboJtboNtboJtb4Ntb4Ntb4JtcIN8fJttb4NzdIltboNvb4Rtb4Nsb4Jsb4Ntb4NsboKqh8QPAAAAHXRSTlMAyNcG7L0/cdoRMSch887Dt4iBVAhmGOo+qK6qinMF874AAADdSURBVCjPfZPbkoMgEESbWyCg68asJrub/v/fjIBxSh7oBynr1AxNM+BQnF0Yx+DmiFZ3zU2PR/7q+wkNipx8MoBJfiLVIOxiqZ7y+1S0l4ORN5x0I3c6WC5otNDWzqrWtbWq+KxLK8XsWdf2q7+iyPhUjWggctp3UYWab76QNTFipkfWj+PXNbO8ZHnOcEwQKgyJDoEGO92AMBgGjBYQKgywYxee2+o/6lXangzp1fwyrGJIjlKLNjp8jiIhFFbo/xEC2viwxD2+bvC9K+tedm9M+gPWH83+UHefwxtGghPEEBK9aAAAAABJRU5ErkJggg==);
  width: 0.28rem !important;
  height: 0.28rem !important;
  background-size: cover;
  background-position: 0 0;
}

.exchange__exchangeContainer__5JIyV.exchange__yibo__2haXZ .exchange__usdtIntroduce__1URYy .exchange__usdtIntroducePanel__17J0r[data-v-9c86c1e4] {
  background: #161a28;
}

.exchange__exchangeContainer__5JIyV.exchange__yibo__2haXZ .exchange__usdtIntroduce__1URYy .exchange__usdtIntroducePanel__17J0r>div[data-v-9c86c1e4]:first-child {
  color: #dedede;
}

.exchange__exchangeContainer__5JIyV.exchange__yibo__2haXZ .exchange__usdtIntroduce__1URYy .exchange__usdtIntroducePanel__17J0r>div:last-child span[data-v-9c86c1e4] {
  background: #fff;
  color: #6c6e82;
}

.exchange__exchangeContainer__5JIyV.exchange__yibo__2haXZ .exchange__walletPanel__306Qn .exchange__title__P2WA9[data-v-9c86c1e4] {
  color: #dedede;
}

.exchange__exchangeContainer__5JIyV.exchange__yibo__2haXZ .exchange__walletPanel__306Qn>span[data-v-9c86c1e4] {
  background: #373a4c;
}

.exchange__exchangeContainer__5JIyV.exchange__yibo__2haXZ .exchange__exchangePanel__1YFsX .exchange__changeTtns__3P3Rx>div>div[data-v-9c86c1e4] {
  color: #dedede;
}

.exchange__exchangeContainer__5JIyV.exchange__yibo__2haXZ .exchange__exchangePanel__1YFsX .exchange__changeTtns__3P3Rx>div>div:first-child span[data-v-9c86c1e4] {
  color: #6c6e82;
}

.exchange__exchangeContainer__5JIyV.exchange__yibo__2haXZ .exchange__exchangePanel__1YFsX .exchange__changeTtns__3P3Rx>div>div[data-v-9c86c1e4]:last-child {
  color: #ede9e7;
}

.exchange__exchangeContainer__5JIyV.exchange__yibo__2haXZ .exchange__exchangePanel__1YFsX .exchange__changeTtns__3P3Rx>div>div:last-child span[data-v-9c86c1e4] {
  color: #6c6e82;
}

.exchange__exchangeContainer__5JIyV.exchange__yibo__2haXZ .exchange__exchangePanel__1YFsX .exchange__changeInput__2fHns span[data-v-9c86c1e4],
.exchange__exchangeContainer__5JIyV.exchange__yibo__2haXZ .exchange__exchangePanel__1YFsX .exchange__changeTitle__2tiTJ[data-v-9c86c1e4] {
  color: #dedede;
}

.exchange__exchangeContainer__5JIyV.exchange__yibo__2haXZ .exchange__exchangePanel__1YFsX .exchange__changeInput__2fHns span[data-v-9c86c1e4]:last-child {
  color: #ede9e7;
}

.exchange__exchangeContainer__5JIyV.exchange__yibo__2haXZ .exchange__exchangePanel__1YFsX .exchange__changeInput__2fHns .exchange__input__3R6yg .fake-input[data-v-9c86c1e4] {
  color: #dedede;
}

.exchange__exchangeContainer__5JIyV.exchange__yibo__2haXZ .exchange__exchangePanel__1YFsX .exchange__changeInput__2fHns .exchange__input__3R6yg .fake-input-placeholder[data-v-9c86c1e4] {
  color: #6c6e82;
}

.exchange__exchangeContainer__5JIyV.exchange__yibo__2haXZ .exchange__exchangePanel__1YFsX .exchange__fenge__R7HEU>div[data-v-9c86c1e4]:first-child {
  background: #373a4c;
}

.exchange__exchangeContainer__5JIyV.exchange__yibo__2haXZ .exchange__exchangePanel__1YFsX .exchange__expectPanel__377eh[data-v-9c86c1e4] {
  color: #6c6e82;
}

.exchange__exchangeContainer__5JIyV.exchange__yibo__2haXZ .exchange__exchangePanel__1YFsX .exchange__expectPanel__377eh b[data-v-9c86c1e4] {
  color: #ede9e7;
}

.exchange__exchangeContainer__5JIyV.exchange__yibo__2haXZ .exchange__exchangePanel__1YFsX .exchange__expectPanel__377eh span[data-v-9c86c1e4] {
  color: #dedede;
}

.exchange__exchangeContainer__5JIyV.exchange__yibo__2haXZ .exchange__exchangePanel__1YFsX .exchange__immedBtn__NVijr span[data-v-9c86c1e4] {
  color: #79420d;
  background-image: -webkit-gradient(linear, left top, right top, from(#f4d3b4), to(#d9a76f));
  background-image: -webkit-linear-gradient(left, #f4d3b4, #d9a76f);
  background-image: linear-gradient(90deg, #f4d3b4, #d9a76f);
}

.exchange__exchangeContainer__5JIyV.exchange__yibo__2haXZ .exchange__btmAdve__xw4ZZ>p[data-v-9c86c1e4] {
  color: #6c6e82;
}

.abnormalModel .am-modal-transparent .am-modal-content .am-modal-body[data-v-9c86c1e4],
.bankModel .am-modal-transparent .am-modal-content .am-modal-body[data-v-9c86c1e4] {
  padding: 0 0.4rem 0.4rem;
}

.abnormalModel .am-modal-content[data-v-9c86c1e4],
.bankModel .am-modal-content[data-v-9c86c1e4] {
  border-radius: 0.2rem;
}

.exchange__exchangeModalWrapper__y_Xrm[data-v-9c86c1e4] {
  padding: 0.1rem;
}

.exchange__exchangeModalWrapper__y_Xrm .exchange__tipsTitle__HKJbl[data-v-9c86c1e4] {
  color: #333;
  font-size: 0.36rem;
  text-align: center;
  margin-bottom: 0.2rem;
}

.exchange__exchangeModalWrapper__y_Xrm .exchange__tip__3-bb4[data-v-9c86c1e4] {
  color: #666;
  font-size: 0.28rem;
}

.exchange__exchangeModalWrapper__y_Xrm .exchange__maintop__msTfW[data-v-9c86c1e4] {
  border-radius: 0.08rem;
  border: 0.02rem solid #ebedf0;
  padding: 0.2rem;
}

.exchange__exchangeModalWrapper__y_Xrm .exchange__main__cYqoW[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: space-around;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 0.14rem;
}

.exchange__exchangeModalWrapper__y_Xrm .exchange__main__cYqoW .exchange__left__27Bpx[data-v-9c86c1e4],
.exchange__exchangeModalWrapper__y_Xrm .exchange__main__cYqoW .exchange__right__EMk8n[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.exchange__exchangeModalWrapper__y_Xrm .exchange__main__cYqoW .exchange__left__27Bpx .exchange__name__2W5BP[data-v-9c86c1e4],
.exchange__exchangeModalWrapper__y_Xrm .exchange__main__cYqoW .exchange__right__EMk8n .exchange__name__2W5BP[data-v-9c86c1e4] {
  color: #383b43;
  font-size: 0.24rem;
  margin-bottom: 0.2rem;
}

.exchange__exchangeModalWrapper__y_Xrm .exchange__main__cYqoW .exchange__left__27Bpx .exchange__amount__2jL6S[data-v-9c86c1e4],
.exchange__exchangeModalWrapper__y_Xrm .exchange__main__cYqoW .exchange__right__EMk8n .exchange__amount__2jL6S[data-v-9c86c1e4] {
  font-size: 0.24rem;
  color: #ede9e7;
}

.exchange__exchangeModalWrapper__y_Xrm .exchange__main__cYqoW .exchange__imgbox__2jPp9[data-v-9c86c1e4] {
  width: 0.6rem;
  text-align: center;
}

.exchange__exchangeModalWrapper__y_Xrm .exchange__main__cYqoW .exchange__imgbox__2jPp9>div[data-v-9c86c1e4] {
  width: 0.4rem;
  height: 0.4rem;
  margin: 0.2rem auto 0;
}

.exchange__exchangeModalWrapper__y_Xrm .exchange__main__cYqoW .exchange__imgbox__2jPp9>div img[data-v-9c86c1e4] {
  width: 0.4rem;
}

.exchange__exchangeModalWrapper__y_Xrm .exchange__rate__3ihC7[data-v-9c86c1e4] {
  font-size: 0.2rem;
  text-align: center;
  color: #999;
}

.exchange__exchangeModalWrapper__y_Xrm .exchange__remind__1jiU0[data-v-9c86c1e4] {
  color: #db6372;
  font-size: 0.24rem;
}

.exchange__exchangeModalWrapper__y_Xrm .exchange__modelBtnBox__3OPIh[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-top: 0.4rem;
}

.exchange__exchangeModalWrapper__y_Xrm .exchange__modelBtnBox__3OPIh div[data-v-9c86c1e4] {
  width: 2.24rem;
  height: 0.8rem;
  font-size: 0.32rem;
  line-height: 0.8rem;
  border-radius: 0.1rem;
  border: 1px solid #4080ff;
  text-align: center;
}

.exchange__exchangeModalWrapper__y_Xrm .exchange__modelBtnBox__3OPIh .exchange__close__3Y9hP[data-v-9c86c1e4] {
  color: #4080ff;
}

.exchange__exchangeModalWrapper__y_Xrm .exchange__modelBtnBox__3OPIh .exchange__comfim__C-Eu4[data-v-9c86c1e4] {
  color: #fff;
  background-color: #4080ff;
}

.exchange__exchangeModalWrapper__y_Xrm.exchange__yibo__2haXZ .exchange__tipsTitle__HKJbl[data-v-9c86c1e4] {
  color: #deb489;
}

.exchange__exchangeModalWrapper__y_Xrm.exchange__yibo__2haXZ .exchange__tip__3-bb4[data-v-9c86c1e4] {
  color: #a1a2a7;
}

.exchange__exchangeModalWrapper__y_Xrm.exchange__yibo__2haXZ .exchange__maintop__msTfW[data-v-9c86c1e4] {
  border: 0.02rem solid rgba(108, 110, 130, 0.4);
  color: #a1a2a7;
}

.exchange__exchangeModalWrapper__y_Xrm.exchange__yibo__2haXZ .exchange__main__cYqoW .exchange__name__2W5BP[data-v-9c86c1e4] {
  color: #a1a2a7;
}

.exchange__exchangeModalWrapper__y_Xrm.exchange__yibo__2haXZ .exchange__btn___1KULG[data-v-9c86c1e4] {
  background-color: #ede9e7;
  color: #79420d !important;
  border: none !important;
  height: 0.72rem !important;
  line-height: 0.72rem !important;
  width: 2.24rem;
}

.style__header__1wC1C[data-v-9c86c1e4] {
  height: 0.9rem;
  padding-bottom: 0.1rem;
}

.style__header__1wC1C>div[data-v-9c86c1e4] {
  position: fixed;
  top: constant(safe-area-inset-top);
  top: env(safe-area-inset-top);
  height: 0.9rem;
  line-height: 0.9rem;
  width: 100%;
  z-index: 1001;
  background: #fff;
}

.style__header__1wC1C>div.style__isOB__2hbYw[data-v-9c86c1e4] {
  background: #edf1ff;
}

.style__header__1wC1C>div.style__isOB__2hbYw .style__title_text__eWMN3[data-v-9c86c1e4] {
  font-weight: 600;
  font-size: 0.36rem;
  color: #5d75a2;
  padding-top: 0.1rem;
}

.style__header__1wC1C>div.style__isApp__26eQX[data-v-9c86c1e4] {
  z-index: 98 !important;
  -webkit-box-shadow: 0 0 40px 40px #fff;
  box-shadow: 0 0 40px 40px #fff;
}

.style__header__1wC1C>div.style__isAndroid__1aN3r[data-v-9c86c1e4] {
  top: 1rem;
}

.style__header__1wC1C .style__headerIndexRedeem__RcKRc[data-v-9c86c1e4] {
  z-index: 980 !important;
}

.style__header__1wC1C>.style__tabList__3mIru[data-v-9c86c1e4] {
  padding: 0 1rem;
}

.style__header__1wC1C>.style__tabList__3mIru>div[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: space-around;
  -ms-flex-pack: distribute;
  justify-content: space-around;
}

.style__header__1wC1C>.style__tabList__3mIru>div span[data-v-9c86c1e4] {
  font-size: 0.32rem;
  color: #697b8c;
}

.style__header__1wC1C>.style__tabList__3mIru>div .style__active__2wNJ3[data-v-9c86c1e4] {
  position: relative;
  color: #ede9e7;
  font-weight: 700;
}

.style__header__1wC1C>.style__tabList__3mIru>div .style__active__2wNJ3[data-v-9c86c1e4]:after {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  background: #ede9e7;
}

.style__header__1wC1C .style__title__3BgQB[data-v-9c86c1e4] {
  height: 0.9rem;
  text-align: center;
  font-size: 0.36rem;
  color: #333;
  font-weight: 700;
}

.style__header__1wC1C .style__title__3BgQB.style__white__2GNa1 .style__title_text__eWMN3[data-v-9c86c1e4] {
  color: #fff;
}

.style__header__1wC1C .style__title_text__eWMN3[data-v-9c86c1e4] {
  width: 69%;
  text-align: center;
  font-size: 0.36rem;
  margin: 0 auto;
  color: #333;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.style__header__1wC1C .style__back__12tQV[data-v-9c86c1e4] {
  height: 0.48rem;
  display: block;
  position: absolute;
  left: 0.255rem;
  top: 0.21rem;
}

.style__header__1wC1C .style__customerservice__3ejby[data-v-9c86c1e4] {
  position: absolute;
  right: 0.4rem;
  top: 0.24rem;
  height: 0.36rem;
  width: 0.48rem;
  height: 0.48rem;
}

.style__header__1wC1C .style__cs__2Wkdn[data-v-9c86c1e4] {
  position: absolute;
  right: 0.2rem;
  top: 0.24rem;
  height: 0.36rem;
}

.style__headerIndex__3gkTm[data-v-9c86c1e4] {
  position: relative;
  z-index: 10000;
}

.style__subTitle__x5byO[data-v-9c86c1e4] {
  position: fixed;
  right: 0.2rem;
  top: 0.28rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  z-index: 1001;
  white-space: nowrap;
}

.style__subTitle__x5byO img[data-v-9c86c1e4] {
  position: relative;
  top: -0.05rem;
  margin-left: 0.1rem;
  height: 0.4rem;
  display: block;
}

.style__subTitle__x5byO .style__lastimg__1KvyX[data-v-9c86c1e4] {
  margin-left: 0.22rem;
}

.style__leftContent__Ph96M[data-v-9c86c1e4] {
  position: fixed;
  left: 0.2rem;
  top: 0.28rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  z-index: 1001;
  white-space: nowrap;
}

.style__yibo__V5Z2v .style__title__3BgQB[data-v-9c86c1e4] {
  background: #222536;
}

.style__yiboSubTitle__3ThRD[data-v-9c86c1e4] {
  color: #dedede;
}

.style__yiboSubTitle__3ThRD>span[data-v-9c86c1e4] {
  color: #6c6e82 !important;
  font-size: 0.32rem !important;
}

.style__yiboLeftContent__Ptzva[data-v-9c86c1e4] {
  color: #dedede;
}

.style__yiboLeftContent__Ptzva>span[data-v-9c86c1e4] {
  color: #6c6e82 !important;
  font-size: 0.32rem !important;
}

.style__full_toast_container__3gauB[data-v-9c86c1e4] {
  position: fixed;
  width: 100%;
  top: 0;
  padding: 0.14rem;
  text-align: center;
  font-size: 0.24rem;
  z-index: 1100;
  -webkit-animation: style__fadeout__5cZM_-data-v-9c86c1e4 0.8s 2s;
  animation: style__fadeout__5cZM_-data-v-9c86c1e4 0.8s 2s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}

@-webkit-keyframes style__fadeout__5cZM_-data-v-9c86c1e4 {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

@keyframes style__fadeout__5cZM_-data-v-9c86c1e4 {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.style__promotion_container__1EOa1[data-v-9c86c1e4] {
  position: fixed;
  top: calc(50% - 0.4rem);
  height: 0.8rem;
  width: 100%;
  left: 0;
  padding: 0;
  font-size: 0.24rem;
  text-align: center;
  line-height: 0.8rem;
  color: #fff;
  background: -webkit-radial-gradient(50% 50%, circle, #000, transparent) !important;
  background: radial-gradient(circle at 50% 50%, #000, transparent) !important;
  z-index: 1100;
}

.my-modal[data-v-9c86c1e4] {
  position: relative;
}

.my-modal[data-v-9c86c1e4]:not(.my-modal-transparent):not(.my-modal-popup) {
  width: 100%;
  height: 100%;
}

.my-modal-mask[data-v-9c86c1e4] {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  height: 100%;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.4);
}

.my-modal-mask-hidden[data-v-9c86c1e4] {
  display: none;
}

.my-modal-wrap[data-v-9c86c1e4] {
  position: fixed;
  overflow: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  z-index: 999;
  -webkit-overflow-scrolling: touch;
  outline: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}

.my-modal-wrap-popup[data-v-9c86c1e4] {
  display: block;
}

.my-modal-transparent[data-v-9c86c1e4] {
  width: 5.4rem;
}

.my-modal-transparent .my-modal-content[data-v-9c86c1e4] {
  border-radius: 0.2rem;
  padding-top: 0.4rem;
}

.my-modal-transparent .my-modal-content-discount[data-v-9c86c1e4] {
  padding-top: 0;
}

.my-modal-transparent .my-modal-content .my-modal-body[data-v-9c86c1e4] {
  padding: 0 0.4rem 0.3rem;
}

.my-modal-transparent .my-modal-content .my-modal-body-discount[data-v-9c86c1e4] {
  padding-top: 0.25rem;
}

.my-modal-popup[data-v-9c86c1e4] {
  position: fixed;
  left: 0;
  width: 100%;
}

.my-modal-popup-slide-down[data-v-9c86c1e4] {
  top: 0;
}

.my-modal-popup-slide-up[data-v-9c86c1e4] {
  bottom: 0;
}

.my-modal-popup .my-modal-content[data-v-9c86c1e4] {
  padding-bottom: env(safe-area-inset-bottom);
}

.my-modal-title[data-v-9c86c1e4] {
  font-size: 0.36rem;
  line-height: 1.5;
  text-align: center;
  color: #414655;
  line-height: 0.5rem;
  margin: 0 0 0.1rem;
  font-family: DINPro;
}

.my-modal-title-discount[data-v-9c86c1e4] {
  line-height: 1rem;
  font-size: 0.32rem;
}

.my-modal-header[data-v-9c86c1e4] {
  padding: 0 0.25rem;
}

.my-modal-header-discount[data-v-9c86c1e4] {
  background-color: #eae8e5;
  height: 1rem;
  padding: 0;
}

.my-modal-content[data-v-9c86c1e4] {
  position: relative;
  background-color: #fff;
  border: 0;
  background-clip: padding-box;
  text-align: center;
  height: 100%;
  overflow: hidden;
}

.my-modal-close[data-v-9c86c1e4] {
  border: 0;
  padding: 0;
  background-color: initial;
  outline: none;
  position: absolute;
  left: 0.3rem;
  z-index: 999;
  height: 0.25rem;
  width: 0.25rem;
}

.my-modal-close-discount[data-v-9c86c1e4] {
  height: 1rem;
  left: unset;
  right: 0.3rem;
}

.my-modal-close-x[data-v-9c86c1e4] {
  display: inline-block;
  width: 0.25rem;
  height: 0.25rem;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='30' height='30' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23888' fill-rule='evenodd'%3E%3Cpath d='M1.414 0l28.284 28.284-1.414 1.414L0 1.414z'/%3E%3Cpath d='M28.284 0L0 28.284l1.414 1.414L29.698 1.414z'/%3E%3C/g%3E%3C/svg%3E");
}

.my-modal-close-x-discount[data-v-9c86c1e4] {
  width: 0.28rem;
  height: 0.28rem;
}

.my-modal-body[data-v-9c86c1e4] {
  font-size: 0.3rem;
  color: #888;
  height: 100%;
  line-height: 1.5;
  overflow: auto;
}

.my-modal-button-group-h[data-v-9c86c1e4] {
  position: relative;
  border-top: 1px solid #eee;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

@media (-webkit-min-device-pixel-ratio: 2),
(min-resolution: 2dppx) {
  html:not([data-scale]) .my-modal-button-group-h[data-v-9c86c1e4] {
    border-top: none;
  }

  html:not([data-scale]) .my-modal-button-group-h[data-v-9c86c1e4]:before {
    content: '';
    position: absolute;
    background-color: #eee;
    display: block;
    z-index: 1;
    top: 0;
    right: auto;
    bottom: auto;
    left: 0;
    width: 100%;
    height: 1px;
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}

@media (-webkit-min-device-pixel-ratio: 2) and (-webkit-min-device-pixel-ratio: 3),
(min-resolution: 2dppx) and (min-resolution: 3dppx) {
  html:not([data-scale]) .my-modal-button-group-h[data-v-9c86c1e4]:before {
    -webkit-transform: scaleY(0.33);
    transform: scaleY(0.33);
  }
}

.my-modal-button-group-h .my-modal-button[data-v-9c86c1e4] {
  -webkit-touch-callout: none;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  text-decoration: none;
  outline: none;
  color: #ede9e7;
  font-size: 0.36rem;
  height: 1rem;
  line-height: 1rem;
  display: block;
  width: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.my-modal-button-group-h .my-modal-button[data-v-9c86c1e4]:first-child {
  color: #414655;
}

.my-modal-button-group-h .my-modal-button[data-v-9c86c1e4]:last-child {
  position: relative;
  border-left: 1px solid #eee;
}

@media (-webkit-min-device-pixel-ratio: 2),
(min-resolution: 2dppx) {
  html:not([data-scale]) .my-modal-button-group-h .my-modal-button[data-v-9c86c1e4]:last-child {
    border-left: none;
  }

  html:not([data-scale]) .my-modal-button-group-h .my-modal-button[data-v-9c86c1e4]:last-child:before {
    content: '';
    position: absolute;
    background-color: #eee;
    display: block;
    z-index: 1;
    top: 0;
    right: auto;
    bottom: auto;
    left: 0;
    width: 1px;
    height: 100%;
    -webkit-transform-origin: 100% 50%;
    transform-origin: 100% 50%;
    -webkit-transform: scaleX(0.5);
    transform: scaleX(0.5);
  }
}

@media (-webkit-min-device-pixel-ratio: 2) and (-webkit-min-device-pixel-ratio: 3),
(min-resolution: 2dppx) and (min-resolution: 3dppx) {
  html:not([data-scale]) .my-modal-button-group-h .my-modal-button[data-v-9c86c1e4]:last-child:before {
    -webkit-transform: scaleX(0.33);
    transform: scaleX(0.33);
  }
}

.my-modal-button-group-v .my-modal-button[data-v-9c86c1e4] {
  -webkit-touch-callout: none;
  position: relative;
  border-top: 1px solid #eee;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  text-decoration: none;
  outline: none;
  color: #ede9e7;
  font-size: 0.36rem;
  height: 1rem;
  line-height: 1rem;
  display: block;
  width: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.my-modal-button-group-signal .my-modal-button[data-v-9c86c1e4] {
  width: auto;
  width: calc(100% - 1.2rem);
  border-radius: 0.4rem;
  margin: 0 auto 0.4rem;
}

.my-modal-button-group-discount .my-modal-button[data-v-9c86c1e4],
.my-modal-button-group-signal .my-modal-button[data-v-9c86c1e4] {
  -webkit-touch-callout: none;
  position: relative;
  border-top: 1px solid #eee;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  text-decoration: none;
  outline: none;
  font-size: 0.36rem;
  height: 1rem;
  line-height: 1rem;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background-image: -webkit-gradient(linear, left top, right top, from(#dccab8), to(#d2b496));
  background-image: -webkit-linear-gradient(left, #dccab8, #d2b496);
  background-image: linear-gradient(90deg, #dccab8, #d2b496);
  height: 0.8rem;
  line-height: 0.8rem;
  color: #fff;
  font-size: 0.28rem;
}

.my-modal-button-group-discount .my-modal-button[data-v-9c86c1e4] {
  width: auto;
  margin: 0 0.28rem 0.5rem;
  border-radius: 0.2rem;
}

@media (-webkit-min-device-pixel-ratio: 2),
(min-resolution: 2dppx) {
  html:not([data-scale]) .my-modal-button-group-v .my-modal-button[data-v-9c86c1e4] {
    border-top: none;
  }

  html:not([data-scale]) .my-modal-button-group-v .my-modal-button[data-v-9c86c1e4]:before {
    content: '';
    position: absolute;
    background-color: #eee;
    display: block;
    z-index: 1;
    top: 0;
    right: auto;
    bottom: auto;
    left: 0;
    width: 100%;
    height: 1px;
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}

@media (-webkit-min-device-pixel-ratio: 2) and (-webkit-min-device-pixel-ratio: 3),
(min-resolution: 2dppx) and (min-resolution: 3dppx) {
  html:not([data-scale]) .my-modal-button-group-v .my-modal-button[data-v-9c86c1e4]:before {
    -webkit-transform: scaleY(0.33);
    transform: scaleY(0.33);
  }
}

.my-modal-button-active[data-v-9c86c1e4] {
  background-color: #ddd;
}

.my-modal-input-container[data-v-9c86c1e4] {
  margin-top: 0.18rem;
  border: 1px solid #ddd;
  border-radius: 0.06rem;
}

@media (-webkit-min-device-pixel-ratio: 2),
(min-resolution: 2dppx) {
  html:not([data-scale]) .my-modal-input-container[data-v-9c86c1e4] {
    position: relative;
    border: none;
  }

  html:not([data-scale]) .my-modal-input-container[data-v-9c86c1e4]:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 200%;
    height: 200%;
    border: 1px solid #ddd;
    border-radius: 1.92px;
    border-radius: 0.12rem;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    pointer-events: none;
  }
}

.my-modal-input[data-v-9c86c1e4] {
  height: 0.72rem;
  line-height: 1;
}

.my-modal-input[data-v-9c86c1e4]:nth-child(2) {
  position: relative;
  border-top: 1px solid #ddd;
}

@media (-webkit-min-device-pixel-ratio: 2),
(min-resolution: 2dppx) {
  html:not([data-scale]) .my-modal-input[data-v-9c86c1e4]:nth-child(2) {
    border-top: none;
  }

  html:not([data-scale]) .my-modal-input[data-v-9c86c1e4]:nth-child(2):before {
    content: '';
    position: absolute;
    background-color: #ddd;
    display: block;
    z-index: 1;
    top: 0;
    right: auto;
    bottom: auto;
    left: 0;
    width: 100%;
    height: 1px;
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}

@media (-webkit-min-device-pixel-ratio: 2) and (-webkit-min-device-pixel-ratio: 3),
(min-resolution: 2dppx) and (min-resolution: 3dppx) {
  html:not([data-scale]) .my-modal-input[data-v-9c86c1e4]:nth-child(2):before {
    -webkit-transform: scaleY(0.33);
    transform: scaleY(0.33);
  }
}

.my-modal-input uni-input[data-v-9c86c1e4] {
  position: relative;
  border: 0;
  width: 98%;
  height: 0.68rem;
  top: 1px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
}

.my-modal-input uni-input[data-v-9c86c1e4]::-webkit-input-placeholder {
  font-size: 0.28rem;
  color: #ccc;
  padding-left: 0.16rem;
}

.my-modal-input uni-input[data-v-9c86c1e4]::-moz-placeholder {
  font-size: 0.28rem;
  color: #ccc;
  padding-left: 0.16rem;
}

.my-modal-input uni-input[data-v-9c86c1e4]::-ms-input-placeholder {
  font-size: 0.28rem;
  color: #ccc;
  padding-left: 0.16rem;
}

.my-modal-input uni-input[data-v-9c86c1e4]::placeholder {
  font-size: 0.28rem;
  color: #ccc;
  padding-left: 0.16rem;
}

.my-modal.my-modal-transparent.my-modal-android .my-modal-content[data-v-9c86c1e4] {
  border-radius: 0;
}

.my-modal.my-modal-transparent.my-modal-android .my-modal-content .my-modal-header[data-v-9c86c1e4] {
  padding: 0.18rem 0.48rem 0.24rem;
}

.my-modal.my-modal-transparent.my-modal-android .my-modal-content .my-modal-header .my-modal-title[data-v-9c86c1e4] {
  text-align: left;
  font-size: 0.42rem;
  color: #000;
}

.my-modal.my-modal-transparent.my-modal-android .my-modal-content .my-modal-body[data-v-9c86c1e4] {
  color: #000;
  text-align: left;
  padding: 0 24rem 0.3rem;
}

.my-modal.my-modal-transparent.my-modal-android .my-modal-content .my-modal-body .my-modal-input-container[data-v-9c86c1e4] {
  border: 0;
  border-bottom: 1px solid #ddd;
}

.my-modal.my-modal-transparent.my-modal-android .my-modal-content .my-modal-body .my-modal-input-container[data-v-9c86c1e4]:before {
  display: none !important;
}

@media (-webkit-min-device-pixel-ratio: 2),
(min-resolution: 2dppx) {
  html:not([data-scale]) .my-modal.my-modal-transparent.my-modal-android .my-modal-content .my-modal-body .my-modal-input-container[data-v-9c86c1e4] {
    border-bottom: none;
  }

  html:not([data-scale]) .my-modal.my-modal-transparent.my-modal-android .my-modal-content .my-modal-body .my-modal-input-container[data-v-9c86c1e4]:after {
    content: '';
    position: absolute;
    background-color: #ddd;
    display: block;
    z-index: 1;
    top: auto;
    right: auto;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    -webkit-transform-origin: 50% 100%;
    transform-origin: 50% 100%;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}

@media (-webkit-min-device-pixel-ratio: 2) and (-webkit-min-device-pixel-ratio: 3),
(min-resolution: 2dppx) and (min-resolution: 3dppx) {
  html:not([data-scale]) .my-modal.my-modal-transparent.my-modal-android .my-modal-content .my-modal-body .my-modal-input-container[data-v-9c86c1e4]:after {
    -webkit-transform: scaleY(0.33);
    transform: scaleY(0.33);
  }
}

.my-modal.my-modal-transparent.my-modal-android .my-modal-content .my-modal-body .my-modal-input-container .my-modal-input[data-v-9c86c1e4]:first-child {
  border-top: 0;
}

.my-modal.my-modal-transparent.my-modal-android .my-modal-content .my-modal-body .my-modal-input-container .my-modal-input[data-v-9c86c1e4]:first-child:before {
  display: none !important;
}

.my-modal.my-modal-transparent.my-modal-android .my-modal-content .my-modal-footer[data-v-9c86c1e4] {
  padding-bottom: 0.24rem;
}

.my-modal.my-modal-transparent.my-modal-android .my-modal-content .my-modal-footer .my-modal-button-group-h[data-v-9c86c1e4] {
  overflow: hidden;
  border-top: 0;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  padding: 0 0.24rem;
}

.my-modal.my-modal-transparent.my-modal-android .my-modal-content .my-modal-footer .my-modal-button-group-h[data-v-9c86c1e4]:before {
  display: none !important;
}

.my-modal.my-modal-transparent.my-modal-android .my-modal-content .my-modal-footer .my-modal-button-group-h .my-modal-button[data-v-9c86c1e4] {
  -webkit-box-flex: initial;
  -webkit-flex: initial;
  -ms-flex: initial;
  flex: initial;
  margin-left: 0.06rem;
  padding: 0 0.3rem;
  height: 0.96rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.my-modal.my-modal-transparent.my-modal-android .my-modal-content .my-modal-footer .my-modal-button-group-h .my-modal-button[data-v-9c86c1e4]:first-child {
  color: #777;
}

.my-modal.my-modal-transparent.my-modal-android .my-modal-content .my-modal-footer .my-modal-button-group-h .my-modal-button[data-v-9c86c1e4]:last-child {
  border-left: 0;
}

.my-modal.my-modal-transparent.my-modal-android .my-modal-content .my-modal-footer .my-modal-button-group-h .my-modal-button[data-v-9c86c1e4]:last-child:before {
  display: none !important;
}

.my-modal.my-modal-transparent.my-modal-android .my-modal-content .my-modal-footer .my-modal-button-group-v.my-modal-button-group-normal[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  overflow: hidden;
  padding: 0 0.24rem;
}

.my-modal.my-modal-transparent.my-modal-android .my-modal-content .my-modal-footer .my-modal-button-group-v.my-modal-button-group-normal .my-modal-button[data-v-9c86c1e4] {
  border-top: 0;
  padding: 0 0.3rem;
  margin-left: 0.06rem;
  height: 0.96rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.my-modal.my-modal-transparent.my-modal-android .my-modal-content .my-modal-footer .my-modal-button-group-v.my-modal-button-group-normal .my-modal-button[data-v-9c86c1e4]:before {
  display: none !important;
}

.my-modal.my-modal-transparent.my-modal-android .my-modal-content .my-modal-footer .my-modal-button-group-operation .my-modal-button[data-v-9c86c1e4] {
  text-align: start;
  padding-left: 0.3rem;
}

.my-modal.my-modal-operation .my-modal-content[data-v-9c86c1e4] {
  border-radius: 0.14rem;
  height: auto;
  padding-top: 0;
}

.my-modal.my-modal-operation .my-modal-content .my-modal-body[data-v-9c86c1e4] {
  padding: 0 !important;
}

.my-modal.my-modal-operation .my-modal-content .my-modal-button[data-v-9c86c1e4] {
  color: #000;
  text-align: left;
  padding-left: 0.3rem;
}

.my-modal-alert-content[data-v-9c86c1e4],
.my-modal-propmt-content[data-v-9c86c1e4] {
  zoom: 1;
  overflow: hidden;
  font-size: 0.28rem;
  color: #a5a9b3;
  line-height: 0.4rem;
}

.my-modal-style-one .my-modal-title[data-v-9c86c1e4] {
  font-size: 0.32rem;
  font-family: PingFangSC-Regular;
  color: #394857;
}

.my-modal-style-one .my-modal-body[data-v-9c86c1e4] {
  font-size: 0.28rem;
  color: #4b5e6f;
}

.my-modal-style-one .my-modal-alert-content[data-v-9c86c1e4] {
  color: #4b5e6f;
}

.my-modal-style-one .my-modal-button-group-h[data-v-9c86c1e4] {
  padding: 0.1rem 0.3rem 0.36rem;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.my-modal-style-one .my-modal-button-group-h[data-v-9c86c1e4]:before {
  display: none !important;
}

.my-modal-style-one .my-modal-button-group-h .my-modal-button[data-v-9c86c1e4] {
  width: 2.24rem;
  height: 0.72rem;
  line-height: 0.72rem;
  font-size: 0.32rem;
  border: 1px solid #ede9e7;
  -webkit-box-flex: none;
  -webkit-flex: none;
  -ms-flex: none;
  flex: none;
  border-radius: 0.12rem;
}

.my-modal-style-one .my-modal-button-group-h .my-modal-button[data-v-9c86c1e4]:first-child {
  color: #ede9e7;
}

.my-modal-style-one .my-modal-button-group-h .my-modal-button[data-v-9c86c1e4]:last-child {
  border-left: 1px solid #ede9e7;
  background: #ede9e7;
  color: #fff;
}

.my-modal-style-one .my-modal-button-group-h .my-modal-button[data-v-9c86c1e4]:last-child:before {
  display: none !important;
}

.styles__wrap__2oMsT[data-v-9c86c1e4] {
  position: fixed;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  overflow: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  z-index: 1000;
  outline: 0;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6);
}

.styles__container__3bjJ0[data-v-9c86c1e4] {
  position: relative;
  background-clip: padding-box;
  -webkit-animation: styles__zoomIn__2Tpt4-data-v-9c86c1e4 0.2s both;
  animation: styles__zoomIn__2Tpt4-data-v-9c86c1e4 0.2s both;
}

@-webkit-keyframes styles__zoomIn__2Tpt4-data-v-9c86c1e4 {
  0% {
    opacity: 0;
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-transform: scale(0.8);
    transform: scale(0.8);
  }

  to {
    opacity: 1;
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

@keyframes styles__zoomIn__2Tpt4-data-v-9c86c1e4 {
  0% {
    opacity: 0;
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-transform: scale(0.8);
    transform: scale(0.8);
  }

  to {
    opacity: 1;
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

.style__footer_bar_icon_color_normal__O1RO0[data-v-9c86c1e4] {
  color: #98a7b5 !important;
}

.style__footer_bar_icon_color_select__3mj_U[data-v-9c86c1e4] {
  color: #ede9e7 !important;
}

.style__footer_bg_hidden__31YZD img.style__natural__1UHoF[data-v-9c86c1e4] {
  margin-top: 0 !important;
}

.style__footer_bg__Ryr4T[data-v-9c86c1e4],
.style__footer_bg_hidden__31YZD[data-v-9c86c1e4] {
  height: 1.2rem;
  -webkit-transition-duration: 0.2s;
  transition-duration: 0.2s;
  position: relative;
  bottom: 0;
}

.style__footer_bg__Ryr4T>div[data-v-9c86c1e4],
.style__footer_bg_hidden__31YZD>div[data-v-9c86c1e4] {
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 100;
  -webkit-transition-duration: 0.2s;
  transition-duration: 0.2s;
  background-color: #fff;
  height: 1.2rem;
  border-radius: 0;
}

.style__footer_bg__Ryr4T>div>ul[data-v-9c86c1e4],
.style__footer_bg_hidden__31YZD>div>ul[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  height: 1.2rem;
  position: relative;
}

.style__footer_bg__Ryr4T .style__hidden__ro0I_[data-v-9c86c1e4],
.style__footer_bg_hidden__31YZD[data-v-9c86c1e4],
.style__footer_bg_hidden__31YZD .style__hidden__ro0I_[data-v-9c86c1e4],
.style__footer_bg_hidden__31YZD>div[data-v-9c86c1e4] {
  height: 0;
}

.style__item__I7Zik[data-v-9c86c1e4] {
  -webkit-box-flex: 0;
  -webkit-flex: 0 0 20%;
  -ms-flex: 0 0 20%;
  flex: 0 0 20%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.16rem 0;
}

.style__item__I7Zik img[data-v-9c86c1e4] {
  width: 0.48rem;
}

.style__item__I7Zik img.style__natural__1UHoF[data-v-9c86c1e4] {
  width: 1rem;
  margin-top: -0.32rem;
}

.style__item__I7Zik img[data-v-9c86c1e4]:active {
  -webkit-transform: scale(0.95);
  transform: scale(0.95);
}

.style__item__I7Zik span[data-v-9c86c1e4] {
  padding-top: 0.08rem;
  font-size: 0.2rem;
}

.style__item__I7Zik[data-v-9c86c1e4]:active,
.style__item__I7Zik span[data-v-9c86c1e4]:active {
  -webkit-transform: scale(0.95);
  transform: scale(0.95);
}

.badge[data-v-9c86c1e4] {
  padding-top: 0 !important;
}

@-webkit-keyframes style__footerClick__1gWKS-data-v-9c86c1e4 {
  0% {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  20% {
    -webkit-transform: scale3d(0.6, 0.6, 1);
    transform: scale3d(0.6, 0.6, 1);
  }

  40% {
    -webkit-transform: scale3d(1.2, 1.2, 1);
    transform: scale3d(1.2, 1.2, 1);
  }

  60% {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  80% {
    -webkit-transform: scale3d(1.1, 1.1, 1);
    transform: scale3d(1.1, 1.1, 1);
  }

  to {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }
}

@keyframes style__footerClick__1gWKS-data-v-9c86c1e4 {
  0% {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  20% {
    -webkit-transform: scale3d(0.6, 0.6, 1);
    transform: scale3d(0.6, 0.6, 1);
  }

  40% {
    -webkit-transform: scale3d(1.2, 1.2, 1);
    transform: scale3d(1.2, 1.2, 1);
  }

  60% {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  80% {
    -webkit-transform: scale3d(1.1, 1.1, 1);
    transform: scale3d(1.1, 1.1, 1);
  }

  to {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }
}

.main__noticeBox__3Hu5b[data-v-9c86c1e4] {
  padding: 0.4rem 0.4rem 0.28rem;
  overflow: visible !important;
}

.main__cardTag__3HKK8[data-v-9c86c1e4]:after {
  content: '';
  display: block;
  position: absolute;
  top: -1.6px;
  top: -0.1rem;
  left: -1.28px;
  left: -0.08rem;
  width: 17.28px;
  width: 1.08rem;
  height: 17.28px;
  height: 1.08rem;
  background-size: cover;
}

.main__cardTag__3HKK8 h3[data-v-9c86c1e4] {
  width: 3.6rem;
  margin-left: auto;
  margin-right: auto;
}

.main__cardTag__3HKK8[game-type='IMTY'][data-v-9c86c1e4]:after {
  background-image: url(/static/img/tag-ty-im.b00d10e9fc374bb514bea502af1d8acf.b00d10e9.png);
}

.webpa .main__cardTag__3HKK8[game-type='IMTY'][data-v-9c86c1e4]:after {
  background-image: url(/static/img/tag-ty-im.b00d10e9fc374bb514bea502af1d8acf.b00d10e9.png);
}

.main__cardTag__3HKK8[game-type='XJTY'][data-v-9c86c1e4]:after {
  background-image: url(/static/img/tag-ty-xj.3aca4fe30b824a5578aeaf99f4b05f1e.3aca4fe3.png);
}

.webpa .main__cardTag__3HKK8[game-type='XJTY'][data-v-9c86c1e4]:after {
  background-image: url(/static/img/tag-ty-xj.3aca4fe30b824a5578aeaf99f4b05f1e.3aca4fe3.png);
}

.main__cardTag__3HKK8[game-type='YBTY'][data-v-9c86c1e4]:after {
  background-image: url(/static/img/tag-ty-ob.b1b71e7ceb4d61a0337b0eb3c0814350.b1b71e7c.png);
}

.webpa .main__cardTag__3HKK8[game-type='YBTY'][data-v-9c86c1e4]:after {
  background-image: url(/static/img/tag-ty-ob.b1b71e7ceb4d61a0337b0eb3c0814350.b1b71e7c.png);
}

.main__cardTag__3HKK8[game-type='YBDJ'][data-v-9c86c1e4]:after {
  background-image: url(/static/img/ob_label_dj_1.685261af988d8a4e83e481d2d694236a.685261af.png);
}

.webpa .main__cardTag__3HKK8[game-type='YBDJ'][data-v-9c86c1e4]:after {
  background-image: url(/static/img/ob_label_dj_1.685261af988d8a4e83e481d2d694236a.685261af.png);
}

.main__cardTag__3HKK8[game-type='LHDJ'][data-v-9c86c1e4]:after {
  background-image: url(/static/img/ob_label_dj_3.acd75e570facd960fc445d9118c92050.acd75e57.png);
}

.webpa .main__cardTag__3HKK8[game-type='LHDJ'][data-v-9c86c1e4]:after {
  background-image: url(/static/img/ob_label_dj_3.acd75e570facd960fc445d9118c92050.acd75e57.png);
}

.main__cardTag__3HKK8[game-type='IMDJ'][data-v-9c86c1e4]:after {
  background-image: url(/static/img/ob_label_dj_2.13140e86a10e944ba3b339598c87756c.13140e86.png);
}

.webpa .main__cardTag__3HKK8[game-type='IMDJ'][data-v-9c86c1e4]:after {
  background-image: url(/static/img/ob_label_dj_2.13140e86a10e944ba3b339598c87756c.13140e86.png);
}

.bankListStyle__bankList__3lhhs[data-v-9c86c1e4] {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: calc(100% - 0.54rem);
  overflow-y: auto;
  background-color: #fff;
  -webkit-animation: bankListStyle__movetop__368IY-data-v-9c86c1e4 0.5s ease;
  animation: bankListStyle__movetop__368IY-data-v-9c86c1e4 0.5s ease;
  z-index: 1001;
  -ms-touch-action: none;
  touch-action: none;
  border-radius: 0.2rem 0.2rem 0 0;
}

.bankListStyle__remark__3xYBg[data-v-9c86c1e4] {
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: contain;
}

.bankListStyle__bankList__3lhhs .bankListStyle__bank-main__12un0[data-v-9c86c1e4] {
  width: 100%;
  height: auto;
}

.bankListStyle__bankList__3lhhs .bankListStyle__bankMain__25z66[data-v-9c86c1e4] {
  height: 100%;
}

.bankListStyle__bankList__3lhhs .bankListStyle__bankMain__25z66 .bankListStyle__bankTitle__26uzT[data-v-9c86c1e4] {
  width: 100%;
  height: 1.46rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  border-bottom: 1px solid #dedede;
}

.bankListStyle__bankList__3lhhs .bankListStyle__bankMain__25z66 .bankListStyle__bankTitle__26uzT img[data-v-9c86c1e4] {
  width: 0.24rem;
  position: absolute;
  left: 0.4rem;
  top: 0.36rem;
}

.bankListStyle__bankList__3lhhs .bankListStyle__bankMain__25z66 .bankListStyle__bankTitle__26uzT span[data-v-9c86c1e4] {
  display: block;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0.28rem;
  color: #ede9e7;
  font-size: 0.32rem;
}

.bankListStyle__bankList__3lhhs .bankListStyle__bankMain__25z66 .bankListStyle__bankTitle__26uzT h4[data-v-9c86c1e4] {
  width: 100%;
  height: 100%;
  font-size: 0.32rem;
  color: #333;
  text-align: center;
  font-weight: 400;
  line-height: 1.46rem;
}

.bankListStyle__bankList__3lhhs .bankListStyle__bankMain__25z66 .bankListStyle__bankTitle__26uzT .bankListStyle__closeBtn__26kvA[data-v-9c86c1e4] {
  display: block;
  position: absolute;
  top: 0.27rem;
  right: 0.3rem;
  color: #007aff;
  font-size: 0.3rem;
}

.bankListStyle__bankList__3lhhs .bankListStyle__bankMain__25z66 .bankListStyle__banklist__1b_6Q[data-v-9c86c1e4] {
  height: calc(100% - 19.46667vw);
  padding-left: 0.36rem;
  overflow-y: auto;
}

.bankListStyle__bankList__3lhhs .bankListStyle__bankMain__25z66 .bankListStyle__banklist__1b_6Q li[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-flow: row nowrap;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 0.98rem;
  line-height: 0.98rem;
  position: relative;
  font-size: 0.48rem;
  color: #0d1a26;
}

.bankListStyle__bankList__3lhhs .bankListStyle__bankMain__25z66 .bankListStyle__banklist__1b_6Q li[data-v-9c86c1e4]:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  background-color: #f8f8f8;
}

.bankListStyle__bankList__3lhhs .bankListStyle__bankMain__25z66 .bankListStyle__banklist__1b_6Q li[data-v-9c86c1e4]:last-of-type:after {
  display: none;
}

.bankListStyle__bankList__3lhhs .bankListStyle__bankMain__25z66 .bankListStyle__banklist__1b_6Q li span[data-v-9c86c1e4] {
  display: block;
  width: 0.58rem;
  height: 0.58rem;
  background-position: 50%;
}

.bankListStyle__bankList__3lhhs .bankListStyle__bankMain__25z66 .bankListStyle__banklist__1b_6Q li p[data-v-9c86c1e4] {
  line-height: 1;
  color: #2e2e2e;
  padding-left: 0.24rem;
}

.bankListStyle__bankList__3lhhs .bankListStyle__bankMain__25z66 .bankListStyle__banklist__1b_6Q li a[data-v-9c86c1e4] {
  width: 0.32rem;
  height: 0.32rem;
  position: absolute;
  top: 50%;
  right: 0.34rem;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: transparent;
}

.bankListStyle__bankList__3lhhs .bankListStyle__bankMain__25z66 .bankListStyle__banklist__1b_6Q li a.bankListStyle__active__vM1eM[data-v-9c86c1e4] {
  background-size: 100%;
}

@keyframes bankListStyle__movetop__368IY-data-v-9c86c1e4 {
  0% {
    bottom: -7.12rem;
  }

  to {
    bottom: 0;
  }
}

@-webkit-keyframes bankListStyle__movetop__368IY-data-v-9c86c1e4 {
  0% {
    bottom: -7.12rem;
  }

  to {
    bottom: 0;
  }
}

.bankListStyle__bankdet__1TECu[data-v-9c86c1e4] {
  float: left;
  width: 5.69rem;
  height: 0.98rem;
  padding-left: 0.08rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.bankListStyle__bankdet__1TECu b[data-v-9c86c1e4] {
  display: block;
  height: 0.98rem;
  font: 4.48px/7.52px PingFangSC-Regular, sans-serif;
  font: 0.28rem/.47rem PingFangSC-Regular, sans-serif;
  color: #2e2e2e;
  line-height: 0.98rem;
}

.bankListStyle__bankdet__1TECu .bankListStyle__bankdetp__n0DZz[data-v-9c86c1e4] {
  height: auto !important;
  width: auto !important;
  color: #2e2e2e;
  margin-bottom: 0;
  line-height: 0.2rem !important;
  font: none !important;
  text-indent: 0 !important;
}

.bankListStyle__yibo__3eKWn[data-v-9c86c1e4] {
  background-color: #222536;
}

.bankListStyle__yibo__3eKWn .bankListStyle__bankMain__25z66 .bankListStyle__bankTitle__26uzT[data-v-9c86c1e4] {
  border-bottom: 1px solid #373a4c;
}

.bankListStyle__yibo__3eKWn .bankListStyle__bankMain__25z66 .bankListStyle__bankTitle__26uzT h4[data-v-9c86c1e4] {
  color: #6c6e82;
  font-size: 0.32rem;
}

.bankListStyle__yibo__3eKWn .bankListStyle__bankMain__25z66 .bankListStyle__banklist__1b_6Q[data-v-9c86c1e4] {
  border-top: 0.2rem solid #161a28;
}

.bankListStyle__yibo__3eKWn .bankListStyle__bankMain__25z66 .bankListStyle__banklist__1b_6Q li[data-v-9c86c1e4] {
  border-bottom: 1px solid #373a4c;
}

.bankListStyle__yibo__3eKWn .bankListStyle__bankMain__25z66 .bankListStyle__banklist__1b_6Q li[data-v-9c86c1e4]:after {
  background-color: initial;
}

.bankListStyle__yibo__3eKWn .bankListStyle__bankMain__25z66 .bankListStyle__banklist__1b_6Q li .bankListStyle__banklistWrapImg__3Wg-H[data-v-9c86c1e4] {
  width: 0.64rem;
  height: 0.64rem;
}

.bankListStyle__yibo__3eKWn .bankListStyle__bankMain__25z66 .bankListStyle__banklist__1b_6Q li .bankListStyle__bankdet__1TECu[data-v-9c86c1e4] {
  padding-left: 0.16rem;
  color: #dedede;
  font-size: 0.28rem;
}

.bankListStyle__nyb__1RG8e[data-v-9c86c1e4] {
  height: 90%;
}

.bankListStyle__nyb__1RG8e .bankListStyle__bankMain__25z66[data-v-9c86c1e4] {
  background-color: #f8f8f8;
}

.bankListStyle__nyb__1RG8e .bankListStyle__bankMain__25z66 .bankListStyle__bankTitle__26uzT[data-v-9c86c1e4] {
  border: none;
  background-color: #fff;
  -webkit-box-shadow: 0 0.04rem 0.08rem 0 rgba(0, 0, 0, 0.05);
  box-shadow: 0 0.04rem 0.08rem 0 rgba(0, 0, 0, 0.05);
}

.bankListStyle__nyb__1RG8e .bankListStyle__bankMain__25z66 .bankListStyle__banklist__1b_6Q[data-v-9c86c1e4] {
  margin-top: 0.2rem;
  background-color: #fff;
  padding-left: 0;
}

.bankListStyle__nyb__1RG8e .bankListStyle__bankMain__25z66 .bankListStyle__banklist__1b_6Q li[data-v-9c86c1e4] {
  padding-left: 0.28rem;
  border-bottom: 1px solid hsla(0, 0%, 93.3%, 0.43922);
  -webkit-box-sizing: content-box;
  box-sizing: initial;
}

.bankListStyle__nyb__1RG8e .bankListStyle__bankMain__25z66 .bankListStyle__banklist__1b_6Q li span[data-v-9c86c1e4] {
  width: 0.6rem;
  height: 0.6rem;
}

.bankListStyle__nyb__1RG8e .bankListStyle__bankMain__25z66 .bankListStyle__banklist__1b_6Q li .bankListStyle__bankdet__1TECu[data-v-9c86c1e4] {
  padding-left: 0.2rem;
  font-size: 0.28rem;
}

.bankListStyle__nyb__1RG8e .bankListStyle__bankMain__25z66 .bankListStyle__banklist__1b_6Q li[data-v-9c86c1e4]:after {
  opacity: 0;
}

.bankListStyle__nyb__1RG8e .bankListStyle__bankMain__25z66 .bankListStyle__banklist__1b_6Q li .bankListStyle__choosedNYB__2aiZ8[data-v-9c86c1e4] {
  display: inline-block;
  width: 0.32rem;
  height: 0.32rem;
  background-image: url(/static/img/sprite.4255d1761e02a5a8047d5dd4b469ea0e.4255d176.png);
  background-position: -12.9rem 0;
  background-repeat: no-repeat;
  background-size: 14.3rem 0.48rem;
  position: absolute;
  right: 0.28rem;
}

.webpa .bankListStyle__nyb__1RG8e .bankListStyle__bankMain__25z66 .bankListStyle__banklist__1b_6Q li .bankListStyle__choosedNYB__2aiZ8[data-v-9c86c1e4] {
  background-image: url(/static/img/sprite.4255d1761e02a5a8047d5dd4b469ea0e.4255d176.png);
}

.amountInputStyle__amountInput__1gHu1[data-v-9c86c1e4] {
  position: relative;
  padding-left: 0.1rem;
  width: 100%;
}

.amountInputStyle__amountInput__1gHu1 .am-input-control .fake-input-container .fake-input-placeholder[data-v-9c86c1e4] {
  top: 2px;
}

.amountInputStyle__amountInput__1gHu1>img[data-v-9c86c1e4] {
  height: 0.28rem;
  position: absolute;
  left: 0;
  top: 0.4rem;
  z-index: 2;
}

.amountInputStyle__amountInput__1gHu1 .amountInputStyle__remark__1Spk0[data-v-9c86c1e4] {
  border-top: 1px solid #f8fafa;
  line-height: 0.8rem;
  height: 1rem;
  font-size: 0.28rem;
  color: #ff4634;
}

.amountInputStyle__amountInput__1gHu1 section[data-v-9c86c1e4] {
  position: relative;
  overflow: hidden;
}

.amountInputStyle__amountInput__1gHu1 section .amountInputStyle__tips__r4zzG[data-v-9c86c1e4] {
  position: absolute;
  right: 0;
  top: 0;
  background: #fff;
  display: block;
  height: 100%;
  color: #ede9e7;
  padding: 0.15rem 0.15rem 0 0;
}

.amountInputStyle__amountInput__1gHu1 section .amountInputStyle__tips__r4zzG span[data-v-9c86c1e4] {
  height: 0.56rem;
  line-height: 0.56rem;
  padding: 0 0.15rem;
  border: 1px solid #c9e6fd;
  display: block;
  position: relative;
}

.amountInputStyle__amountInput__1gHu1 section .amountInputStyle__tips__r4zzG span[data-v-9c86c1e4]:after,
.amountInputStyle__amountInput__1gHu1 section .amountInputStyle__tips__r4zzG span[data-v-9c86c1e4]:before {
  content: '';
  display: block;
  width: 0;
  height: 0;
  border-top: 0.1rem solid transparent;
  border-right: 0.2rem solid #c9e6fd;
  border-bottom: 0.1rem solid transparent;
  position: absolute;
  left: 0;
  top: 50%;
  -webkit-transform: translate(-100%, -50%);
  transform: translate(-100%, -50%);
}

.amountInputStyle__amountInput__1gHu1 section .amountInputStyle__tips__r4zzG span[data-v-9c86c1e4]:after {
  left: 1px;
  border-right: 0.2rem solid #fff;
}

.amountInputStyle__amountInput__1gHu1 section .amountInputStyle__btn__1JWRG[data-v-9c86c1e4] {
  position: absolute;
  right: 0;
  top: 0;
  display: block;
  height: 100%;
  color: #a5a9b3;
  padding: 0.3rem 0.2rem 0 0;
}

.amountInputStyle__amountInput__1gHu1 section[data-v-9c86c1e4]:before {
  content: '';
  display: block;
  position: absolute;
  width: 4.48px;
  width: 0.28rem;
  height: 4.48px;
  height: 0.28rem;
  left: -2px;
  top: 30%;
  z-index: 1;
  background-image: url(/static/style/money.1a8fe4eaf87cde1fe1e0be5f31db146f.png);
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 4.48px 4.48px;
  background-size: 0.28rem 0.28rem;
}

.webpa .amountInputStyle__amountInput__1gHu1 section[data-v-9c86c1e4]:before {
  background-image: url(/static/style/money.1a8fe4eaf87cde1fe1e0be5f31db146f.png);
}

.buttonMStyle__btnM__1evsf[data-v-9c86c1e4] {
  padding: 0.2rem;
}

.buttonMStyle__btnM__1evsf>span[data-v-9c86c1e4] {
  margin-top: 0.45rem;
  display: block;
  height: 0.96rem;
  line-height: 0.96rem;
  font-size: 0.32rem;
  background: #ede9e7;
  color: #fff;
  border-radius: 3px;
  text-align: center;
  width: 100%;
  opacity: 1;
}

.buttonMStyle__btnM__1evsf.buttonMStyle__active__2_xPQ span[data-v-9c86c1e4] {
  background: #ede9e7;
  opacity: 1;
  position: relative;
  z-index: 2;
}

.buttonMStyle__btnMe__1SKO6[data-v-9c86c1e4] {
  padding: 0.2rem 0;
}

.buttonMStyle__btnMe__1SKO6>span[data-v-9c86c1e4] {
  margin-top: 0.45rem;
  display: block;
  height: 0.96rem;
  line-height: 0.96rem;
  font-size: 0.32rem;
  background: #ede9e7;
  color: #fff;
  border-radius: 0.06rem;
  text-align: center;
  width: 100%;
  opacity: 0.8;
}

.buttonMStyle__btnMe__1SKO6.buttonMStyle__active__2_xPQ span[data-v-9c86c1e4] {
  opacity: 0.9;
  background: #ede9e7;
}

.buttonMStyle__yibo__1qChi span[data-v-9c86c1e4] {
  margin-top: 0 !important;
  color: #79420d !important;
  background: -webkit-gradient(linear, left top, right top, from(#f4d3b4), to(#d9a76f)) !important;
  background: -webkit-linear-gradient(left, #f4d3b4, #d9a76f) !important;
  background: linear-gradient(90deg, #f4d3b4, #d9a76f) !important;
}

.buttonMStyle__hth__3n4y1.buttonMStyle__btnM__1evsf[data-v-9c86c1e4],
.buttonMStyle__leyu__p_EEh.buttonMStyle__btnM__1evsf[data-v-9c86c1e4],
.buttonMStyle__nyb__1n_-B.buttonMStyle__btnM__1evsf[data-v-9c86c1e4],
.buttonMStyle__yb__2jCxZ.buttonMStyle__btnM__1evsf[data-v-9c86c1e4] {
  padding: 0 !important;
  margin-top: 0.4rem;
  margin-bottom: 0.4rem;
}

.buttonMStyle__hth__3n4y1.buttonMStyle__btnM__1evsf span[data-v-9c86c1e4],
.buttonMStyle__leyu__p_EEh.buttonMStyle__btnM__1evsf span[data-v-9c86c1e4],
.buttonMStyle__nyb__1n_-B.buttonMStyle__btnM__1evsf span[data-v-9c86c1e4],
.buttonMStyle__yb__2jCxZ.buttonMStyle__btnM__1evsf span[data-v-9c86c1e4] {
  height: 0.9rem !important;
  background: #ede9e7 !important;
  opacity: 0.5;
  border-radius: 0.1rem !important;
  font-size: 0.32rem !important;
  font-weight: 700;
}

.buttonMStyle__hth__3n4y1.buttonMStyle__btnM__1evsf.buttonMStyle__active__2_xPQ span[data-v-9c86c1e4],
.buttonMStyle__leyu__p_EEh.buttonMStyle__btnM__1evsf.buttonMStyle__active__2_xPQ span[data-v-9c86c1e4],
.buttonMStyle__nyb__1n_-B.buttonMStyle__btnM__1evsf.buttonMStyle__active__2_xPQ span[data-v-9c86c1e4],
.buttonMStyle__yb__2jCxZ.buttonMStyle__btnM__1evsf.buttonMStyle__active__2_xPQ span[data-v-9c86c1e4] {
  opacity: 1;
}

.listXStyle__listMore__3vyo0[data-v-9c86c1e4] {
  position: fixed;
  z-index: 1;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
}

.listXStyle__listMore__3vyo0>div[data-v-9c86c1e4] {
  width: 100%;
  overflow-y: auto;
  position: relative;
  padding-bottom: 1.5rem;
}

.listXStyle__listToHeight__3MEpz>div[data-v-9c86c1e4] {
  height: 100%;
}

.listXStyle__pull__1efQJ[data-v-9c86c1e4] {
  height: 0;
  overflow: hidden;
  text-align: center;
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99;
}

.listXStyle__listMore__3vyo0 li[data-v-9c86c1e4]:active {
  -webkit-transform: scale(0.9);
  transform: scale(0.9);
  -webkit-transition: all 0s;
  transition: all 0s;
}

.listXStyle__noMore__2F9oT[data-v-9c86c1e4] {
  line-height: 1.56rem;
  color: #999;
  font-size: 0.24rem;
  text-align: center;
}

.listXStyle__isOBlistX__3_vHH[data-v-9c86c1e4] {
  background-color: #edf1ff;
}

.listXStyleYibo__listXDark__3ZTky[data-v-9c86c1e4] {
  padding: 0 0.28rem;
  background: #222536;
  border-top: 0.2rem solid #161a28;
}

.listXStyleYibo__listMoreDark__2AMBf[data-v-9c86c1e4] {
  position: fixed;
  padding-top: 0.9rem !important;
  z-index: 1;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
}

.listXStyleYibo__listMoreDark__2AMBf>div[data-v-9c86c1e4] {
  width: 100%;
  overflow-y: auto;
  position: relative;
  padding-bottom: 1rem;
}

.listXStyleYibo__listMore__3Q99g[data-v-9c86c1e4] {
  position: fixed;
  padding-top: 1.8rem;
  z-index: 1;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
}

.listXStyleYibo__listMore__3Q99g>div[data-v-9c86c1e4] {
  width: 100%;
  overflow-y: auto;
  position: relative;
  padding-bottom: 1rem;
}

.listXStyleYibo__listMore__3Q99g>div .listXStyleYibo__noMore__G-D-u[data-v-9c86c1e4] {
  color: #fdca93;
  font-size: 0.24rem;
  text-align: center;
  line-height: 0.4rem;
  padding-bottom: 1rem;
  margin-top: 0.8rem;
}

.listXStyleYibo__pull__yGJ6b[data-v-9c86c1e4] {
  height: 0;
  overflow: hidden;
  text-align: center;
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 102;
}

.listXStyleYibo__noMore__G-D-u[data-v-9c86c1e4] {
  color: #a1a2a7;
  font-size: 0.24rem;
  text-align: center;
  line-height: 1.56rem;
}

.listXStyleKok__listMore__CwyHj[data-v-9c86c1e4] {
  position: fixed;
  padding-top: 1.8rem;
  z-index: 1;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  background-color: #ebf3fc;
}

.listXStyleKok__listMore__CwyHj>div[data-v-9c86c1e4] {
  width: 100%;
  overflow-y: auto;
  position: relative;
  padding-bottom: 1.5rem;
}

.listXStyleKok__pull__3UxyR[data-v-9c86c1e4] {
  height: 0;
  overflow: hidden;
  text-align: center;
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 102;
}

.listXStyleKok__noMore__1dNUL[data-v-9c86c1e4] {
  color: #a1a2a7;
  font-size: 0.24rem;
  text-align: center;
  line-height: 1.56rem;
}

.style__switchLabel__3idkf[data-v-9c86c1e4] {
  display: block;
  position: relative;
  -webkit-box-sizing: content-box;
  box-sizing: initial;
  border: 1px solid #e5e5e5;
}

.style__switchLabel__3idkf .style__switchCheckbox__1PxMW[data-v-9c86c1e4] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  border: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.style__switchLabel__3idkf .style__switchCheckbox__1PxMW:checked+.style__checkbox__3UgOx .style__before__3giMy[data-v-9c86c1e4] {
  -webkit-transform: scale(0);
  transform: scale(0);
}

.style__switchLabel__3idkf .style__checkbox__3UgOx[data-v-9c86c1e4] {
  width: 100%;
  height: 100%;
  position: relative;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  background: #ede9e7;
  z-index: 0;
}

.style__switchLabel__3idkf .style__checkbox__3UgOx .style__after__1kBa_[data-v-9c86c1e4],
.style__switchLabel__3idkf .style__checkbox__3UgOx .style__before__3giMy[data-v-9c86c1e4] {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #fff;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

.style__switchLabel__3idkf .style__checkbox__3UgOx .style__before__3giMy[data-v-9c86c1e4] {
  width: 100%;
}

.style__switchLabel__3idkf .style__checkbox__3UgOx .style__after__1kBa_[data-v-9c86c1e4] {
  -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
}

.style__nyb__305U-[data-v-9c86c1e4] {
  border-color: #7d87a5 !important;
}

.style__nyb__305U- .style__checkbox__3UgOx[data-v-9c86c1e4] {
  background: #7d87a5 !important;
  -webkit-box-shadow: #7d87a5 0 0 2px !important;
  box-shadow: 0 0 2px #7d87a5 !important;
}

.loadingStyle__loading__NFB4t[data-v-9c86c1e4] {
  position: fixed;
  z-index: 2000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.loadingStyle__loading__NFB4t .loadingStyle__loadingWrap__2-Mo5[data-v-9c86c1e4] {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -100%);
  transform: translate(-50%, -100%);
  border-radius: 0.2rem;
  width: 1.2rem;
  height: 1.2rem;
  background: rgba(0, 0, 0, 0.6);
}

.loadingStyle__loading__NFB4t .loadingStyle__loadingWrap__2-Mo5 img[data-v-9c86c1e4] {
  width: 100%;
  height: 100%;
}

.loadingStyle__nyb_loading__3e_eg[data-v-9c86c1e4] {
  background: transparent !important;
}

.loadingStyle__nyb_loading__3e_eg .loadingStyle__loadingWrap__2-Mo5[data-v-9c86c1e4] {
  background: transparent !important;
  width: 0.72rem !important;
  height: 0.72rem !important;
}

.loadingStyle__nyb_loading__3e_eg .loadingStyle__loadingWrap__2-Mo5 img[data-v-9c86c1e4] {
  -webkit-animation: loadingStyle__rotation__iNS2M-data-v-9c86c1e4 2s linear infinite;
  animation: loadingStyle__rotation__iNS2M-data-v-9c86c1e4 2s linear infinite;
}

@-webkit-keyframes loadingStyle__rotation__iNS2M-data-v-9c86c1e4 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}

@keyframes loadingStyle__rotation__iNS2M-data-v-9c86c1e4 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}

.style__topCustom__3HQVY[data-v-9c86c1e4] {
  width: 100%;
  background: #ede9e7;
  height: 35px;
  line-height: 35px;
  padding: 0 12px;
}

.style__topCustom__3HQVY .style__AddBtn__3gsnK[data-v-9c86c1e4] {
  float: right;
  display: inline-block;
  margin: 0.1rem 0;
  width: 1.32rem;
  height: 0.48rem;
  font-size: 0.24rem;
  line-height: 0.44rem;
  text-align: center;
  color: #ede9e7;
  border: 1px solid #ede9e7;
  border-radius: 0.44rem;
}

.style__topCustom__3HQVY .style__closeIcon__1HZXI[data-v-9c86c1e4] {
  float: right;
  display: inline-block;
  height: 0.64rem;
  width: 0.36rem;
  text-align: center;
}

.style__save2client__3-hyN[data-v-9c86c1e4] {
  color: #fff;
  padding: 0 0.2rem;
  line-height: 0.5rem;
  height: 0.5rem;
  width: 1.36rem;
  border-radius: 0.24rem;
  background: -webkit-gradient(linear, right top, left top, from(#ede9e7), to(#829fff));
  background: -webkit-linear-gradient(to left, #ede9e7, #829fff);
  background: linear-gradient(270deg, #ede9e7, #829fff);
}

.styles__container__3XVtW[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.styles__container__3XVtW .styles__content__27RLh .styles__img__1U9dk[data-v-9c86c1e4] {
  width: 3.6rem;
}

.styles__container__3XVtW .styles__content__27RLh p[data-v-9c86c1e4] {
  color: #c2c2c2;
  text-align: center;
  font-size: 0.28rem;
}

.styles__container__3XVtW .styles__content__27RLh p[data-v-9c86c1e4]:first-of-type {
  margin-top: 0.48rem;
  margin-bottom: 0.22rem;
  font-weight: 700;
}

.styles__container__3XVtW .styles__content__27RLh p[data-v-9c86c1e4]:last-of-type {
  margin-bottom: 0.8rem;
}

.styles__btn__1IkYL[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  width: 3.2rem;
  height: 0.8rem;
  border-radius: 0.08rem;
  background-color: #ede9e7;
  color: #fff;
  font-size: 0.28rem;
}

.giftStyle__dialogBg__31PFx[data-v-9c86c1e4] {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 888;
  background: rgba(0, 0, 0, 0.5);
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContent__21cl1[data-v-9c86c1e4] {
  width: 700px;
  height: auto;
  border-radius: 8px;
  position: fixed;
  left: 50%;
  top: 120px;
  margin-left: -427.5px;
  background: #fff;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContent__21cl1 .giftStyle__dialogHeader__1D8Ko[data-v-9c86c1e4] {
  width: 100%;
  border-radius: 8px 8px 0 0;
  height: 69px;
  text-align: center;
  line-height: 68.8px;
  border-bottom: 1px solid #dedede;
  color: #fff;
  font-weight: bolder;
  font-size: 19.2px;
  position: relative;
  background: #ede9e7;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContent__21cl1 .giftStyle__dialogHeader__1D8Ko .giftStyle__close__zIJii[data-v-9c86c1e4] {
  width: 40px;
  height: 40px;
  position: absolute;
  right: 15px;
  top: 15px;
  color: #fff;
  background-size: 100% 100%;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContent__21cl1 .giftStyle__dialogHeader__1D8Ko .giftStyle__close__zIJii[data-v-9c86c1e4]:hover {
  cursor: pointer;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContent__21cl1 .giftStyle__dialogC__2AXhM[data-v-9c86c1e4] {
  width: 100%;
  padding: 32px 96px;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContent__21cl1 .giftStyle__dialogC__2AXhM h2[data-v-9c86c1e4] {
  color: #333;
  font-size: 16px;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContent__21cl1 .giftStyle__dialogC__2AXhM .giftStyle__colorList__1EWFn[data-v-9c86c1e4] {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 0;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContent__21cl1 .giftStyle__dialogC__2AXhM .giftStyle__colorList__1EWFn li[data-v-9c86c1e4] {
  display: inline-block;
  width: 108px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  color: #999;
  border: 1px solid #ccc;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContent__21cl1 .giftStyle__dialogC__2AXhM .giftStyle__colorList__1EWFn li[data-v-9c86c1e4]:hover {
  cursor: pointer;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContent__21cl1 .giftStyle__dialogC__2AXhM .giftStyle__colorList__1EWFn li.giftStyle__active__kUXdD[data-v-9c86c1e4] {
  border: 1px solid #ede9e7;
  color: #ede9e7;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContent__21cl1 .giftStyle__dialogC__2AXhM .giftStyle__form__2V9Zj[data-v-9c86c1e4] {
  width: 665px;
  margin: auto;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContent__21cl1 .giftStyle__dialogC__2AXhM .giftStyle__form__2V9Zj p[data-v-9c86c1e4] {
  display: inline-block;
  height: 20px;
  line-height: 20px;
  margin-top: 26.6px;
  color: #555;
  font-size: 16px;
  margin-bottom: 0;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContent__21cl1 .giftStyle__dialogC__2AXhM .giftStyle__form__2V9Zj dl[data-v-9c86c1e4] {
  width: 100%;
  height: 40px;
  margin-top: 10px;
  margin-bottom: 20.8px;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContent__21cl1 .giftStyle__dialogC__2AXhM .giftStyle__form__2V9Zj dl dt[data-v-9c86c1e4] {
  line-height: 40px;
  float: left;
  margin-right: 14px;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContent__21cl1 .giftStyle__dialogC__2AXhM .giftStyle__form__2V9Zj dl dd[data-v-9c86c1e4] {
  width: 100%;
  height: 48px;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContent__21cl1 .giftStyle__dialogC__2AXhM .giftStyle__form__2V9Zj dl dd uni-input[data-v-9c86c1e4] {
  width: 152px;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContent__21cl1 .giftStyle__dialogC__2AXhM .giftStyle__form__2V9Zj dl dt[data-v-9c86c1e4] {
  display: block;
  color: #555;
  font-size: 16px;
  min-width: 64px;
  text-align: right;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContent__21cl1 .giftStyle__dialogC__2AXhM .giftStyle__form__2V9Zj dl dd[data-v-9c86c1e4] {
  height: 100%;
  margin: 0;
  line-height: 40px;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContent__21cl1 .giftStyle__dialogC__2AXhM .giftStyle__form__2V9Zj dl dd uni-input[data-v-9c86c1e4] {
  width: 381px;
  height: 100%;
  border: 1px solid #ccc;
  font-size: 16px;
  padding-left: 17.6px;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContent__21cl1 .giftStyle__dialogC__2AXhM .giftStyle__form__2V9Zj uni-textarea[data-v-9c86c1e4] {
  border: 1px solid #ccc;
  resize: none;
  width: 381.6px;
  height: 72px;
  margin-left: 78px;
  padding: 8px 13.6px;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContent__21cl1 .giftStyle__dialogC__2AXhM .giftStyle__wran__A4FBJ[data-v-9c86c1e4] {
  color: #ede9e7;
  font-size: 16px;
  text-align: center;
  margin-top: 28px;
  margin-bottom: 18px;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContent__21cl1 .giftStyle__dialogC__2AXhM .giftStyle__subBtn__3S2Y7[data-v-9c86c1e4] {
  display: block;
  width: 112px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  background: #ede9e7;
  margin: auto;
  -webkit-box-shadow: 0 0 4px 2px rgba(0, 60, 255, 0.2);
  box-shadow: 0 0 4px 2px rgba(0, 60, 255, 0.2);
  border-radius: 5.5px;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContent__21cl1 .giftStyle__dialogC__2AXhM .giftStyle__subBtn__3S2Y7[data-v-9c86c1e4]:hover {
  opacity: 0.8;
  cursor: pointer;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContentTwo__mfBh9[data-v-9c86c1e4] {
  width: 6.8rem;
  position: fixed;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContentTwo__mfBh9 .giftStyle__dialogContentTwoHeader__14liR[data-v-9c86c1e4] {
  height: 0.84rem;
  background: #ede9e7;
  text-align: center;
  line-height: 0.84rem;
  color: #fff;
  font-size: 0.3rem;
  border-top-left-radius: 0.1rem;
  border-top-right-radius: 0.1rem;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContentTwo__mfBh9 .giftStyle__dialogContentTwoC__1BFsk[data-v-9c86c1e4] {
  background: #fff;
  width: 100%;
  padding: 0.24rem;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContentTwo__mfBh9 .giftStyle__dialogContentTwoC__1BFsk>span[data-v-9c86c1e4] {
  display: block;
  width: 2.62rem;
  height: 0.8rem;
  color: #fff;
  margin: 0.295rem auto;
  background: #ede9e7;
  text-align: center;
  line-height: 0.8rem;
  border-radius: 0.1rem;
  font-size: 0.32rem;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContentTwo__mfBh9 .giftStyle__dialogContentTwoC__1BFsk table[data-v-9c86c1e4] {
  width: 100%;
  border: 1px solid #ede9e7;
  border-collapse: collapse;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContentTwo__mfBh9 .giftStyle__dialogContentTwoC__1BFsk table tbody tr:first-of-type td[data-v-9c86c1e4] {
  font-size: 0.24rem;
  line-height: 0.4rem;
}

.giftStyle__dialogBg__31PFx .giftStyle__dilogContentTwo__mfBh9 .giftStyle__dialogContentTwoC__1BFsk table tbody tr td[data-v-9c86c1e4] {
  text-align: center;
  font-size: 0.24rem;
  line-height: 0.4rem;
}

.giftStyle__order__32_Oc[data-v-9c86c1e4] {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1001;
}

.giftStyle__order__32_Oc>div[data-v-9c86c1e4] {
  width: 100%;
  height: 100%;
}

.giftStyle__order__32_Oc .giftStyle__content__1Lqv6[data-v-9c86c1e4] {
  position: absolute;
  left: 0;
  width: 100%;
  bottom: 0;
  background: #fff;
  height: auto;
}

.giftStyle__order__32_Oc .giftStyle__content__1Lqv6>p[data-v-9c86c1e4] {
  height: 1rem;
  line-height: 1rem;
  font-size: 0.28rem;
  color: #000;
  position: relative;
  text-align: center;
  border-bottom: 1px solid hsla(0, 0%, 78.4%, 0.5);
  margin-bottom: 0.44rem;
}

.giftStyle__order__32_Oc .giftStyle__content__1Lqv6>p img[data-v-9c86c1e4] {
  position: absolute;
  width: 0.4rem;
  height: 0.4rem;
  right: 0.4rem;
  top: 0.4rem;
}

.giftStyle__order__32_Oc .giftStyle__content__1Lqv6>div[data-v-9c86c1e4] {
  padding: 0 0.32rem;
}

.giftStyle__order__32_Oc .giftStyle__content__1Lqv6>div>h3[data-v-9c86c1e4] {
  font-size: 0.24rem;
  color: #333;
  margin-bottom: 0.2rem;
}

.giftStyle__order__32_Oc .giftStyle__content__1Lqv6>div>.giftStyle__from__9a5Uj>p[data-v-9c86c1e4] {
  text-align: center;
}

.giftStyle__order__32_Oc .giftStyle__content__1Lqv6>div>.giftStyle__from__9a5Uj dl[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 0.2rem;
}

.giftStyle__order__32_Oc .giftStyle__content__1Lqv6>div>.giftStyle__from__9a5Uj dl dt[data-v-9c86c1e4] {
  width: 1.34rem;
  height: 0.8rem;
  line-height: 0.8rem;
  padding-right: 0.2rem;
  text-align: right;
}

.giftStyle__order__32_Oc .giftStyle__content__1Lqv6>div>.giftStyle__from__9a5Uj dl dd[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: auto;
  -ms-flex: auto;
  flex: auto;
}

.giftStyle__order__32_Oc .giftStyle__content__1Lqv6>div>.giftStyle__from__9a5Uj dl dd uni-input[data-v-9c86c1e4] {
  border: 1px solid #ccc;
  height: 0.8rem;
  width: 100%;
  padding-left: 0.2rem;
}

.giftStyle__order__32_Oc .giftStyle__content__1Lqv6>div>.giftStyle__from__9a5Uj dl dd>div[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  line-height: 0.8rem;
  width: 5.52rem;
  margin-bottom: 0.2rem;
}

.giftStyle__order__32_Oc .giftStyle__content__1Lqv6>div>.giftStyle__from__9a5Uj dl dd>div uni-input[data-v-9c86c1e4] {
  width: 2.2rem;
}

.giftStyle__order__32_Oc .giftStyle__content__1Lqv6>div>.giftStyle__from__9a5Uj dl dd>div span[data-v-9c86c1e4] {
  display: inline-block;
  font-size: 0.28rem;
  color: #555;
  padding: 0 0.2rem;
}

.giftStyle__order__32_Oc .giftStyle__content__1Lqv6>div>.giftStyle__from__9a5Uj dl dd uni-textarea[data-v-9c86c1e4] {
  width: 100%;
  height: 1.2rem;
  border: 1px solid #ccc;
  line-height: 0.32rem;
  padding: 0.2rem;
}

.giftStyle__transparent__-Hs8-[data-v-9c86c1e4] {
  opacity: 0 !important;
}

.recommendedExchange__fixedWrapper__1bz5t[data-v-9c86c1e4] {
  width: 100%;
  height: 1.88rem;
}

.recommendedExchange__container__2Lrn2[data-v-9c86c1e4] {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 1.88rem;
  padding-top: 0.24rem;
  background-color: #fff;
  z-index: 20;
  -webkit-box-shadow: 0 -2px 15px rgba(0, 0, 0, 0.05);
  box-shadow: 0 -2px 15px rgba(0, 0, 0, 0.05);
}

.recommendedExchange__container__2Lrn2 .recommendedExchange__wrapper__1Ppk8[data-v-9c86c1e4] {
  width: 6.94rem;
  margin: auto;
  height: 0.8rem;
  line-height: 0.8rem;
  font-size: 0.24rem;
  color: #333;
  border-radius: 0.58rem;
  padding: 0 0.32rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  background: rgba(198, 205, 224, 0.3);
}

.recommendedExchange__container__2Lrn2 .recommendedExchange__wrapper__1Ppk8 .recommendedExchange__icon__1vdHB[data-v-9c86c1e4] {
  width: 0.48rem;
  height: 0.48rem;
  border-radius: 0.08rem;
  overflow: hidden;
}

.recommendedExchange__container__2Lrn2 .recommendedExchange__wrapper__1Ppk8 .recommendedExchange__icon__1vdHB>img[data-v-9c86c1e4] {
  display: block;
  width: 100%;
  height: 100%;
}

.recommendedExchange__container__2Lrn2 .recommendedExchange__wrapper__1Ppk8 .recommendedExchange__slogan__12lry[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  margin-left: 0.2rem;
  font-family: PingFang SC;
  color: #414655;
}

.recommendedExchange__container__2Lrn2 .recommendedExchange__wrapper__1Ppk8 .recommendedExchange__button__2cWUx[data-v-9c86c1e4] {
  width: 2.24rem;
  height: 0.48rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #ede9e7;
  border: 0.02rem solid #ede9e7;
  border-radius: 0.06rem;
  font-family: PingFang SC;
}

.style__alert__3l7Nd[data-v-9c86c1e4],
.style__deposit__1NWbj[data-v-9c86c1e4],
.style__transfer__1VDdn[data-v-9c86c1e4] {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1001;
  -webkit-transform: translateZ(1px);
  transform: translateZ(1px);
}

.style__alert__3l7Nd>div[data-v-9c86c1e4],
.style__deposit__1NWbj>div[data-v-9c86c1e4],
.style__transfer__1VDdn>div[data-v-9c86c1e4] {
  width: 6.22rem;
  border-radius: 0.2rem;
  padding: 0.4rem;
  background: #fff;
  position: absolute;
  left: 50%;
  top: 25%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  -webkit-box-shadow: 1px 1px 10px 1px #888;
  box-shadow: 1px 1px 10px 1px #888;
}

.style__alert__3l7Nd>div h3[data-v-9c86c1e4],
.style__deposit__1NWbj>div h3[data-v-9c86c1e4],
.style__transfer__1VDdn>div h3[data-v-9c86c1e4] {
  font-size: 0.32rem;
  color: #000;
  font-weight: 400;
  padding-bottom: 0.2rem;
  text-align: center;
}

.style__alert__3l7Nd>div p[data-v-9c86c1e4],
.style__deposit__1NWbj>div p[data-v-9c86c1e4],
.style__transfer__1VDdn>div p[data-v-9c86c1e4] {
  font-size: 0.28rem;
  line-height: 0.44rem;
  color: #666;
  margin-bottom: 0.24rem;
  text-align: center;
}

.style__alert__3l7Nd>div p>span[data-v-9c86c1e4],
.style__deposit__1NWbj>div p>span[data-v-9c86c1e4],
.style__transfer__1VDdn>div p>span[data-v-9c86c1e4] {
  color: #ede9e7;
  font-size: 0.28rem;
  font-weight: 500;
}

.style__alert__3l7Nd>div>div[data-v-9c86c1e4],
.style__deposit__1NWbj>div>div[data-v-9c86c1e4],
.style__transfer__1VDdn>div>div[data-v-9c86c1e4] {
  padding-top: 0.48rem;
  text-align: center;
}

.style__alert__3l7Nd>div>div.style__two__3LmIm[data-v-9c86c1e4],
.style__deposit__1NWbj>div>div.style__two__3LmIm[data-v-9c86c1e4],
.style__transfer__1VDdn>div>div.style__two__3LmIm[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.style__alert__3l7Nd>div>div uni-button[data-v-9c86c1e4],
.style__deposit__1NWbj>div>div uni-button[data-v-9c86c1e4],
.style__transfer__1VDdn>div>div uni-button[data-v-9c86c1e4] {
  width: 2.5rem;
  height: 0.8rem;
  line-height: 0.8rem;
  border: 1px solid #ede9e7;
  color: #ede9e7;
  background: #fff;
  font-size: 0.32rem;
  border-radius: 0.1rem;
  padding: 0;
}

.style__alert__3l7Nd>div>div uni-button.style__active__3gjvO[data-v-9c86c1e4],
.style__deposit__1NWbj>div>div uni-button.style__active__3gjvO[data-v-9c86c1e4],
.style__transfer__1VDdn>div>div uni-button.style__active__3gjvO[data-v-9c86c1e4] {
  color: #fff;
  background: #ede9e7;
}

.style__alert__3l7Nd>div>div uni-button.style__block__39bmw[data-v-9c86c1e4],
.style__deposit__1NWbj>div>div uni-button.style__block__39bmw[data-v-9c86c1e4],
.style__transfer__1VDdn>div>div uni-button.style__block__39bmw[data-v-9c86c1e4] {
  width: 100%;
}

.style__transfer__1VDdn .style__input__2Lykb[data-v-9c86c1e4] {
  padding-top: 0.1rem;
  text-align: left;
}

.style__transfer__1VDdn .style__input__2Lykb>uni-input[data-v-9c86c1e4] {
  border: 1px solid #ccc;
  height: 0.7rem;
  line-height: 0.7rem;
  display: block;
  padding-left: 0.2rem;
  width: 100%;
}

.style__close__12NXT[data-v-9c86c1e4] {
  position: absolute;
  top: 0.15rem;
  right: 0.15rem;
  width: 0.3rem;
}

.style__deposit__1NWbj h3 span[data-v-9c86c1e4] {
  color: #ede9e7;
  font-size: 14px;
}

.style__deposit__1NWbj p[data-v-9c86c1e4] {
  font-size: 12px !important;
  color: #ff4d4f !important;
}

.style__deposit__1NWbj .style__subContent__3M6cT[data-v-9c86c1e4] {
  padding: 6px;
}

.style__deposit__1NWbj .style__subContent__3M6cT uni-label[data-v-9c86c1e4] {
  display: inline-block;
  width: 1.6rem;
  font-size: 0.24rem;
  color: #98a5b3;
}

.style__deposit__1NWbj .style__subContent__3M6cT span[data-v-9c86c1e4] {
  font-size: 0.28rem;
  color: #ede9e7;
}

.style__yibo__1xcug[data-v-9c86c1e4] {
  color: red;
}

.style__yibo__1xcug>div[data-v-9c86c1e4] {
  background-color: #222536;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.style__yibo__1xcug>div h3[data-v-9c86c1e4] {
  color: #ede9e7;
}

.style__yibo__1xcug>div p[data-v-9c86c1e4] {
  color: #a1a2a7;
}

.style__yibo__1xcug>div uni-button[data-v-9c86c1e4] {
  background-color: #ede9e7;
  color: #79420d !important;
}

.style__yibo__1xcug>div .style__two__3LmIm uni-button[data-v-9c86c1e4] {
  background-color: initial;
  color: #ede9e7 !important;
}

.style__yibo__1xcug>div .style__two__3LmIm .style__active__3gjvO[data-v-9c86c1e4] {
  background-color: #ede9e7;
  color: #79420d !important;
}

.style__toast__2bxAo[data-v-9c86c1e4] {
  position: fixed;
  left: 50%;
  top: 30%;
  display: inline-block;
  background: rgba(0, 0, 0, 0.8);
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  padding: 0.2rem 0.4rem;
  color: #fff;
  font-size: 0.24rem;
  border-radius: 0.16rem;
  font-weight: 700;
  z-index: 9999;
  min-width: 60%;
  text-align: center;
}

.style__opacity0__22i_3[data-v-9c86c1e4] {
  opacity: 0;
  -webkit-transform: translateY(-10px);
  transform: translateY(-10px);
}

.loadingStyle__loading__D_5Ik[data-v-9c86c1e4] {
  position: fixed;
  z-index: 2000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.loadingStyle__loading__D_5Ik .loadingStyle__loadingWrap__1VumE[data-v-9c86c1e4] {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -100%);
  transform: translate(-50%, -100%);
  border-radius: 0.2rem;
  width: 1.2rem;
  height: 1.2rem;
  background: rgba(0, 0, 0, 0.6);
}

.loadingStyle__loading__D_5Ik .loadingStyle__loadingWrap__1VumE img[data-v-9c86c1e4] {
  width: 100%;
  height: 100%;
  border: 0;
}

.loadingStyle__nyb_loading__2rHcV[data-v-9c86c1e4] {
  background: transparent !important;
}

.loadingStyle__nyb_loading__2rHcV .loadingStyle__loadingWrap__1VumE[data-v-9c86c1e4] {
  background: transparent !important;
  width: 0.72rem !important;
  height: 0.72rem !important;
}

.loadingStyle__nyb_loading__2rHcV .loadingStyle__loadingWrap__1VumE img[data-v-9c86c1e4] {
  -webkit-animation: loadingStyle__rotation__M02UH-data-v-9c86c1e4 2s linear infinite;
  animation: loadingStyle__rotation__M02UH-data-v-9c86c1e4 2s linear infinite;
}

@-webkit-keyframes loadingStyle__rotation__M02UH-data-v-9c86c1e4 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}

@keyframes loadingStyle__rotation__M02UH-data-v-9c86c1e4 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}

.pickerM__btnClass__e24Of[data-v-9c86c1e4] {
  color: #ede9e7;
}

p[data-v-9c86c1e4] {
  margin-bottom: 0;
}

.style__ybToastContainer__1G729[data-v-9c86c1e4] {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
  -webkit-transform: translateZ(1px);
  transform: translateZ(1px);
}

.style__ybToastContainer__1G729 .style__ybToastContent__lQ9sI[data-v-9c86c1e4] {
  max-width: 5.4rem;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-animation: style__fadeIn__3aDFS-data-v-9c86c1e4 0.3s ease forwards;
  animation: style__fadeIn__3aDFS-data-v-9c86c1e4 0.3s ease forwards;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate3d(-50%, -50%, 0);
  transform: translate3d(-50%, -50%, 0);
}

.style__ybToastContainer__1G729 .style__ybToastContent__lQ9sI .style__toastText__sNW_r[data-v-9c86c1e4] {
  line-height: 1.5;
  text-align: center;
  color: #fff;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
  overflow: hidden;
}

.style__ybToastContainer__1G729 .style__ybToastContent__lQ9sI .style__icon_1__1cKsg[data-v-9c86c1e4] {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: url(data:image/png;base64,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);
}

.webpa .style__ybToastContainer__1G729 .style__ybToastContent__lQ9sI .style__icon_1__1cKsg[data-v-9c86c1e4] {
  background-image: url(data:image/png;base64,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);
}

.style__ybToastContainer__1G729 .style__ybToastContent__lQ9sI .style__icon_2__HmlDV[data-v-9c86c1e4] {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: url(data:image/png;base64,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);
}

.webpa .style__ybToastContainer__1G729 .style__ybToastContent__lQ9sI .style__icon_2__HmlDV[data-v-9c86c1e4] {
  background-image: url(data:image/png;base64,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);
}

.style__ybToastContainer__1G729 .style__ybToastContent__lQ9sI .style__toastIcon__3NOpJ[data-v-9c86c1e4] {
  display: inline-block;
  width: 0.74rem;
  height: 0.72rem;
  margin-bottom: 0.04rem;
}

.style__ybToastContainer__1G729 .style__ybToastIcon__1QCd4[data-v-9c86c1e4] {
  min-width: 1.8rem;
  padding: 0.28rem;
  border-radius: 0.2rem;
}

.style__ybToastContainer__1G729 .style__ybToastInfo__2_5d8[data-v-9c86c1e4] {
  min-width: 3.4rem;
  padding: 0.18rem 0.3rem;
  position: absolute;
  top: 35%;
  left: 50%;
  -webkit-transform: translate3d(-50%, -50%, 0);
  transform: translate3d(-50%, -50%, 0);
  border-radius: 0.1rem;
}

@-webkit-keyframes style__fadeIn__3aDFS-data-v-9c86c1e4 {
  0% {
    background: transparent;
  }

  to {
    background: rgba(65, 70, 85, 0.8);
  }
}

@keyframes style__fadeIn__3aDFS-data-v-9c86c1e4 {
  0% {
    background: transparent;
  }

  to {
    background: rgba(65, 70, 85, 0.8);
  }
}

.privilegeModal__modal__10z2x[data-v-9c86c1e4] {
  width: 100%;
}

.privilegeModal__modal__10z2x .am-modal-content[data-v-9c86c1e4] {
  background: none;
  padding: 0;
  overflow: visible;
  text-align: left;
}

.privilegeModal__modal__10z2x .am-modal-content .am-modal-body[data-v-9c86c1e4] {
  padding: 0;
  overflow: visible;
}

.privilegeModal__box__2sJOa[data-v-9c86c1e4] {
  width: 5.9rem;
  margin: 0 auto -2.5rem;
}

.privilegeModal__boxInner__25Rs8[data-v-9c86c1e4] {
  height: 6.52rem;
  border-radius: 0.2rem;
  -webkit-box-shadow: 0 0.04rem 0.4rem rgba(0, 0, 0, 0.3);
  box-shadow: 0 0.04rem 0.4rem rgba(0, 0, 0, 0.3);
}

.privilegeModal__container__wozRh[data-v-9c86c1e4] {
  position: relative;
  height: 9.02rem;
  background-image: url(/static/img/modal_privilege_bg.516c1ad5312adf55acf6784c4c307c94.516c1ad5.png);
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: contain;
  top: -2.5rem;
}

.webpa .privilegeModal__container__wozRh[data-v-9c86c1e4] {
  background-image: url(/static/img/modal_privilege_bg.516c1ad5312adf55acf6784c4c307c94.516c1ad5.png);
}

.privilegeModal__close__QX8KD[data-v-9c86c1e4] {
  position: absolute;
  right: 0;
  top: -0.74rem;
  width: 0.4rem;
  height: 0.4rem;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAZlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+Vn2moAAAAIXRSTlMAh/rGCnLy18OzrKagmUs/dxUH9ezl39SBaGRcVUYoGTceee6mAAAB6UlEQVRYw+1Y25KDIAyNFO+X1Wq1Xtv9/59c0BkpBUQ340uneSMNp5CchET4yqcJHfPkUleEVPUlyUf6P5TCDcivJCRwi8MwP+GKImGFP8dggnVnE8ZpGofNihvsh3rEyxYvaiehndrIW/TxYx9Otthfeqo4v78s/5DtwXFnW99gm/nzz64V5ppwu1tntuhu3CK5WmI+nz2im+yK5psXm+eZce5gkfuMtHUmfq9yAKsMJb/dtp/LJ+yQZ7nl8YyfeIBdMnDbzMBDT/aP3U+enpkxjxfslohzXJtfnD/0QI3hfNLlHc/TDg5IxzNYfyD/hVGprwlK7qcv7PG1RwrlKKRs6bzbOEyZylEOldwgjKsg/ZtAEjjSqYHlASk0XOyltYLkKHnf87Xqao+q2xyNQgj1FHdTIjikblSXgktEZszIjFrQI5lxoGW6UY4r00ygRzLjwMSU+Xv9IAAGJAVHCFmriQhkA0YkIw40MmkAak4tI5LA0dC4lhSVyGQDkmOqGNX7XVMwI6k4IpPICUDIq53gbGT4TyAkMkXOSVp8GcEXNkupzU2lNreUWnTxxz9H9gcyP/5A4p9sfBNxYluDb7TwrR++GT27PcY37PgRAj/U4Mes8wc//CiKH47x4zr+AwL+k8ZXPkz+AMtVZ7x/PFXuAAAAAElFTkSuQmCC);
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: contain;
  text-indent: -9999px;
}

.webpa .privilegeModal__close__QX8KD[data-v-9c86c1e4] {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAZlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+Vn2moAAAAIXRSTlMAh/rGCnLy18OzrKagmUs/dxUH9ezl39SBaGRcVUYoGTceee6mAAAB6UlEQVRYw+1Y25KDIAyNFO+X1Wq1Xtv9/59c0BkpBUQ340uneSMNp5CchET4yqcJHfPkUleEVPUlyUf6P5TCDcivJCRwi8MwP+GKImGFP8dggnVnE8ZpGofNihvsh3rEyxYvaiehndrIW/TxYx9Otthfeqo4v78s/5DtwXFnW99gm/nzz64V5ppwu1tntuhu3CK5WmI+nz2im+yK5psXm+eZce5gkfuMtHUmfq9yAKsMJb/dtp/LJ+yQZ7nl8YyfeIBdMnDbzMBDT/aP3U+enpkxjxfslohzXJtfnD/0QI3hfNLlHc/TDg5IxzNYfyD/hVGprwlK7qcv7PG1RwrlKKRs6bzbOEyZylEOldwgjKsg/ZtAEjjSqYHlASk0XOyltYLkKHnf87Xqao+q2xyNQgj1FHdTIjikblSXgktEZszIjFrQI5lxoGW6UY4r00ygRzLjwMSU+Xv9IAAGJAVHCFmriQhkA0YkIw40MmkAak4tI5LA0dC4lhSVyGQDkmOqGNX7XVMwI6k4IpPICUDIq53gbGT4TyAkMkXOSVp8GcEXNkupzU2lNreUWnTxxz9H9gcyP/5A4p9sfBNxYluDb7TwrR++GT27PcY37PgRAj/U4Mes8wc//CiKH47x4zr+AwL+k8ZXPkz+AMtVZ7x/PFXuAAAAAElFTkSuQmCC);
}

.privilegeModal__upgrade__jI3ma[data-v-9c86c1e4] {
  padding-top: 0.84rem;
  margin: 0 1.04rem;
  color: #333;
}

.privilegeModal__upgrade__jI3ma .privilegeModal__congrat__11WZm[data-v-9c86c1e4] {
  font-size: 0.32rem;
  opacity: 0.85;
}

.privilegeModal__upgrade__jI3ma .privilegeModal__congrat__11WZm *[data-v-9c86c1e4] {
  font-size: 0.32rem;
}

.privilegeModal__upgrade__jI3ma .privilegeModal__status__fPB-B[data-v-9c86c1e4] {
  font-size: 0.72rem;
  font-weight: 700;
  margin-top: -0.12rem;
}

.privilegeModal__upgrade__jI3ma .privilegeModal__status__fPB-B *[data-v-9c86c1e4] {
  font-size: 0.72rem;
}

.privilegeModal__upgrade__jI3ma .privilegeModal__gift__12Wlt[data-v-9c86c1e4] {
  margin-top: 0.72rem;
  border-top: 0.02rem solid rgba(70, 76, 94, 0.2);
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.privilegeModal__upgrade__jI3ma .privilegeModal__gift__12Wlt img[data-v-9c86c1e4] {
  display: block;
  width: 0.88rem;
  margin-top: 0.2rem;
}

.privilegeModal__upgrade__jI3ma .privilegeModal__gift__12Wlt>div[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  margin-left: 0.2rem;
  margin-right: -1rem;
}

.privilegeModal__upgrade__jI3ma .privilegeModal__gift__12Wlt .privilegeModal__detail__umCi-[data-v-9c86c1e4] {
  margin-top: 0.16rem;
  font-size: 0.32rem;
}

.privilegeModal__upgrade__jI3ma .privilegeModal__gift__12Wlt .privilegeModal__detail__umCi- *[data-v-9c86c1e4] {
  font-size: 0.32rem;
}

.privilegeModal__upgrade__jI3ma .privilegeModal__gift__12Wlt .privilegeModal__detail__umCi- strong[data-v-9c86c1e4] {
  font-size: 0.36rem;
}

.privilegeModal__upgrade__jI3ma .privilegeModal__gift__12Wlt .privilegeModal__sub__29g01[data-v-9c86c1e4] {
  margin-top: -0.02rem;
  -webkit-transform: scale(0.9);
  transform: scale(0.9);
  -webkit-transform-origin: left;
  transform-origin: left;
}

.privilegeModal__privileges__36yI9[data-v-9c86c1e4] {
  margin: 1.84rem 0.5rem 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: space-around;
  -ms-flex-pack: distribute;
  justify-content: space-around;
}

.privilegeModal__privileges__36yI9 li[data-v-9c86c1e4] {
  width: 0.66rem;
}

.privilegeModal__privileges__36yI9 .privilegeModal__icon__1RirG>img[data-v-9c86c1e4] {
  display: block;
  width: 100%;
}

.privilegeModal__privileges__36yI9 .privilegeModal__des__360c6[data-v-9c86c1e4] {
  color: #fff;
  text-align: center;
  -webkit-transform: scale(0.9);
  transform: scale(0.9);
  -webkit-transform-origin: center;
  transform-origin: center;
  margin: 0.08rem 0.08rem 0;
  line-height: 120%;
}

.privilegeModal__btn__3jc-0[data-v-9c86c1e4] {
  display: block;
  margin: 0.32rem 0.38rem 0;
  background: #fff;
  color: #ede9e7;
  text-align: center;
  font-size: 0.32rem;
  font-weight: 700;
  line-height: 0.9rem;
  border-radius: 0.45rem;
}

.privilegeModal__btn__3jc-0 *[data-v-9c86c1e4] {
  font-size: 0.32rem;
}

.birthdayModal__modal__1PBLQ[data-v-9c86c1e4] {
  width: 5.6rem;
}

.birthdayModal__modal__1PBLQ .am-modal-content[data-v-9c86c1e4] {
  background: none;
  padding: 0;
  overflow: visible;
  text-align: left;
}

.birthdayModal__modal__1PBLQ .am-modal-content .am-modal-body[data-v-9c86c1e4] {
  padding: 0;
  overflow: visible;
  position: relative;
}

.birthdayModal__close__Pn3Al[data-v-9c86c1e4] {
  position: absolute;
  right: 0;
  top: -0.74rem;
  width: 0.4rem;
  height: 0.4rem;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAZlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+Vn2moAAAAIXRSTlMAh/rGCnLy18OzrKagmUs/dxUH9ezl39SBaGRcVUYoGTceee6mAAAB6UlEQVRYw+1Y25KDIAyNFO+X1Wq1Xtv9/59c0BkpBUQ340uneSMNp5CchET4yqcJHfPkUleEVPUlyUf6P5TCDcivJCRwi8MwP+GKImGFP8dggnVnE8ZpGofNihvsh3rEyxYvaiehndrIW/TxYx9Otthfeqo4v78s/5DtwXFnW99gm/nzz64V5ppwu1tntuhu3CK5WmI+nz2im+yK5psXm+eZce5gkfuMtHUmfq9yAKsMJb/dtp/LJ+yQZ7nl8YyfeIBdMnDbzMBDT/aP3U+enpkxjxfslohzXJtfnD/0QI3hfNLlHc/TDg5IxzNYfyD/hVGprwlK7qcv7PG1RwrlKKRs6bzbOEyZylEOldwgjKsg/ZtAEjjSqYHlASk0XOyltYLkKHnf87Xqao+q2xyNQgj1FHdTIjikblSXgktEZszIjFrQI5lxoGW6UY4r00ygRzLjwMSU+Xv9IAAGJAVHCFmriQhkA0YkIw40MmkAak4tI5LA0dC4lhSVyGQDkmOqGNX7XVMwI6k4IpPICUDIq53gbGT4TyAkMkXOSVp8GcEXNkupzU2lNreUWnTxxz9H9gcyP/5A4p9sfBNxYluDb7TwrR++GT27PcY37PgRAj/U4Mes8wc//CiKH47x4zr+AwL+k8ZXPkz+AMtVZ7x/PFXuAAAAAElFTkSuQmCC) no-repeat 50% 50%;
  background-size: contain;
  text-indent: -9999px;
}

.birthdayModal__container__lFAaz[data-v-9c86c1e4] {
  margin: 0 auto;
  border-radius: 0.2rem;
  overflow: hidden;
  -webkit-box-shadow: 0 0.04rem 0.4rem rgba(0, 0, 0, 0.3);
  box-shadow: 0 0.04rem 0.4rem rgba(0, 0, 0, 0.3);
}

.birthdayModal__banner__3Eky2[data-v-9c86c1e4] {
  display: block;
  width: 100%;
}

.birthdayModal__content__VWHjK[data-v-9c86c1e4] {
  padding: 0.44rem 0.6rem 0.5rem;
  background-color: #7bb8fb;
  background-image: -webkit-gradient(linear, left top, left bottom, from(#7cb9fc), to(#80c3ff));
  background-image: -webkit-linear-gradient(top, #7cb9fc, #80c3ff);
  background-image: linear-gradient(180deg, #7cb9fc, #80c3ff);
  color: #fff;
}

.birthdayModal__content__VWHjK .birthdayModal__user__AIxvp[data-v-9c86c1e4],
.birthdayModal__content__VWHjK .birthdayModal__user__AIxvp *[data-v-9c86c1e4] {
  font-size: 0.28rem;
}

.birthdayModal__content__VWHjK .birthdayModal__msg__3--jg[data-v-9c86c1e4] {
  margin-top: 0.2rem;
  line-height: 0.4rem;
}

.birthdayModal__content__VWHjK .birthdayModal__date__2F6aD[data-v-9c86c1e4] {
  line-height: 0.4rem;
  text-align: right;
}

.birthdayModal__content__VWHjK .birthdayModal__btn__2gGN4[data-v-9c86c1e4] {
  display: block;
  margin-top: 0.3rem;
  background: #fff;
  color: #ede9e7;
  text-align: center;
  font-size: 0.32rem;
  font-weight: 700;
  line-height: 0.9rem;
  border-radius: 0.45rem;
}

.birthdayModal__content__VWHjK .birthdayModal__btn__2gGN4 *[data-v-9c86c1e4] {
  font-size: 0.32rem;
}

.birthdayModal2__modal__3Amx2[data-v-9c86c1e4] {
  width: 5.6rem;
}

.birthdayModal2__modal__3Amx2 .am-modal-content[data-v-9c86c1e4] {
  background: none;
  padding: 0;
  overflow: visible;
  text-align: left;
}

.birthdayModal2__modal__3Amx2 .am-modal-content .am-modal-body[data-v-9c86c1e4] {
  padding: 0;
  overflow: visible;
  position: relative;
}

.birthdayModal2__close__2Ps0G[data-v-9c86c1e4] {
  position: absolute;
  right: 0;
  top: -0.74rem;
  width: 0.4rem;
  height: 0.4rem;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAZlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+Vn2moAAAAIXRSTlMAh/rGCnLy18OzrKagmUs/dxUH9ezl39SBaGRcVUYoGTceee6mAAAB6UlEQVRYw+1Y25KDIAyNFO+X1Wq1Xtv9/59c0BkpBUQ340uneSMNp5CchET4yqcJHfPkUleEVPUlyUf6P5TCDcivJCRwi8MwP+GKImGFP8dggnVnE8ZpGofNihvsh3rEyxYvaiehndrIW/TxYx9Otthfeqo4v78s/5DtwXFnW99gm/nzz64V5ppwu1tntuhu3CK5WmI+nz2im+yK5psXm+eZce5gkfuMtHUmfq9yAKsMJb/dtp/LJ+yQZ7nl8YyfeIBdMnDbzMBDT/aP3U+enpkxjxfslohzXJtfnD/0QI3hfNLlHc/TDg5IxzNYfyD/hVGprwlK7qcv7PG1RwrlKKRs6bzbOEyZylEOldwgjKsg/ZtAEjjSqYHlASk0XOyltYLkKHnf87Xqao+q2xyNQgj1FHdTIjikblSXgktEZszIjFrQI5lxoGW6UY4r00ygRzLjwMSU+Xv9IAAGJAVHCFmriQhkA0YkIw40MmkAak4tI5LA0dC4lhSVyGQDkmOqGNX7XVMwI6k4IpPICUDIq53gbGT4TyAkMkXOSVp8GcEXNkupzU2lNreUWnTxxz9H9gcyP/5A4p9sfBNxYluDb7TwrR++GT27PcY37PgRAj/U4Mes8wc//CiKH47x4zr+AwL+k8ZXPkz+AMtVZ7x/PFXuAAAAAElFTkSuQmCC);
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: contain;
  text-indent: -9999px;
}

.webpa .birthdayModal2__close__2Ps0G[data-v-9c86c1e4] {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAZlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+Vn2moAAAAIXRSTlMAh/rGCnLy18OzrKagmUs/dxUH9ezl39SBaGRcVUYoGTceee6mAAAB6UlEQVRYw+1Y25KDIAyNFO+X1Wq1Xtv9/59c0BkpBUQ340uneSMNp5CchET4yqcJHfPkUleEVPUlyUf6P5TCDcivJCRwi8MwP+GKImGFP8dggnVnE8ZpGofNihvsh3rEyxYvaiehndrIW/TxYx9Otthfeqo4v78s/5DtwXFnW99gm/nzz64V5ppwu1tntuhu3CK5WmI+nz2im+yK5psXm+eZce5gkfuMtHUmfq9yAKsMJb/dtp/LJ+yQZ7nl8YyfeIBdMnDbzMBDT/aP3U+enpkxjxfslohzXJtfnD/0QI3hfNLlHc/TDg5IxzNYfyD/hVGprwlK7qcv7PG1RwrlKKRs6bzbOEyZylEOldwgjKsg/ZtAEjjSqYHlASk0XOyltYLkKHnf87Xqao+q2xyNQgj1FHdTIjikblSXgktEZszIjFrQI5lxoGW6UY4r00ygRzLjwMSU+Xv9IAAGJAVHCFmriQhkA0YkIw40MmkAak4tI5LA0dC4lhSVyGQDkmOqGNX7XVMwI6k4IpPICUDIq53gbGT4TyAkMkXOSVp8GcEXNkupzU2lNreUWnTxxz9H9gcyP/5A4p9sfBNxYluDb7TwrR++GT27PcY37PgRAj/U4Mes8wc//CiKH47x4zr+AwL+k8ZXPkz+AMtVZ7x/PFXuAAAAAElFTkSuQmCC);
}

.birthdayModal2__container__3aXkr[data-v-9c86c1e4] {
  margin: 0 auto;
  background-image: url(/static/img/__al__modal_birthday2_bg.16a1012ebab367571fc9f322b6120ca1.16a1012e.png);
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: 100% auto;
  padding-top: 2.72rem;
  border-radius: 0.2rem;
  -webkit-box-shadow: 0 0.04rem 0.4rem rgba(0, 0, 0, 0.3);
  box-shadow: 0 0.04rem 0.4rem rgba(0, 0, 0, 0.3);
}

.webpa .birthdayModal2__container__3aXkr[data-v-9c86c1e4] {
  background-image: url(/static/img/__al__modal_birthday2_bg.16a1012ebab367571fc9f322b6120ca1.16a1012e.png);
}

.birthdayModal2__content__ekO1j[data-v-9c86c1e4] {
  padding: 0 0.4rem 0.4rem;
  border-radius: 0 0 0.2rem 0.2rem;
  color: #9ba4c2;
}

.birthdayModal2__content__ekO1j .birthdayModal2__user__2lDxP[data-v-9c86c1e4] {
  font-size: 0.28rem;
  color: #414655;
  font-weight: 700;
}

.birthdayModal2__content__ekO1j .birthdayModal2__user__2lDxP *[data-v-9c86c1e4] {
  font-size: 0.28rem;
}

.birthdayModal2__content__ekO1j .birthdayModal2__user__2lDxP strong[data-v-9c86c1e4] {
  color: #ede9e7;
}

.birthdayModal2__content__ekO1j .birthdayModal2__msg__1A8Jl[data-v-9c86c1e4] {
  margin-top: 0.2rem;
  line-height: 0.4rem;
}

.birthdayModal2__content__ekO1j .birthdayModal2__msg__1A8Jl .birthdayModal2__amount__1ipRs[data-v-9c86c1e4] {
  color: #414655;
}

.birthdayModal2__content__ekO1j .birthdayModal2__date__21rIS[data-v-9c86c1e4] {
  margin-top: 0.08rem;
  line-height: 0.4rem;
  text-align: right;
}

.birthdayModal2__content__ekO1j .birthdayModal2__btn__2FOEB[data-v-9c86c1e4] {
  display: block;
  margin-top: 0.32rem;
  background-color: #ede9e7;
  background-image: -webkit-gradient(linear, left top, right top, from(#80c3ff), to(#ede9e7));
  background-image: -webkit-linear-gradient(left, #80c3ff, #ede9e7);
  background-image: linear-gradient(90deg, #80c3ff, #ede9e7);
  color: #fff;
  text-align: center;
  font-size: 0.32rem;
  font-weight: 700;
  line-height: 0.9rem;
  border-radius: 0.1rem;
}

.birthdayModal2__content__ekO1j .birthdayModal2__btn__2FOEB *[data-v-9c86c1e4] {
  font-size: 0.32rem;
}

.confirm__container__7WKlU[data-v-9c86c1e4] {
  text-align: left;
  color: #a5a9b3;
  padding: 0.1rem;
}

.confirm__container__7WKlU *[data-v-9c86c1e4] {
  font-size: 0.28rem;
  line-height: 0.5rem;
}

.confirm__container__7WKlU .confirm__title__1-Uej[data-v-9c86c1e4] {
  color: #414655;
  margin-bottom: 0.1rem;
}

.confirm__container__7WKlU .confirm__value__vrgbT[data-v-9c86c1e4] {
  color: #ede9e7;
}

a.custom-function[data-v-9c86c1e4] {
  color: #ede9e7;
  font-weight: 700;
}

.am-picker-popup-header[data-v-9c86c1e4] {
  width: 100% !important;
  width: 100% !important;
}

.height100vh[data-v-9c86c1e4] {
  height: 100vh;
}

.yibo .am-tabs-default-bar-top .am-tabs-default-bar-tab[data-v-9c86c1e4]:after {
  background: #373a4c !important;
}

.am-tabs-default-bar-underline[data-v-9c86c1e4] {
  border: 1px solid #ede9e7 !important;
}

.am-tabs-default-bar-tab-active[data-v-9c86c1e4] {
  color: #ede9e7 !important;
}

.am-action-sheet-button-list .am-action-sheet-button-list-item[data-v-9c86c1e4]:first-of-type {
  color: #ede9e7;
  font-size: 0.36rem;
}

.am-action-sheet-button-list .am-action-sheet-cancel-button[data-v-9c86c1e4] {
  height: 84px;
}

.am-action-sheet-button-list .am-action-sheet-cancel-button-mask[data-v-9c86c1e4] {
  height: 0.2rem;
  top: -0.2rem;
}

.bankCardStyle__bankAddTips__3hKyP .addimgs[data-v-9c86c1e4] {
  width: 2.72rem;
  height: 2.72rem;
  margin: 0 30%;
}

.bankCardStyle__bankAddTips__3hKyP.bankCardStyle__coin__1Q4SB a>img[data-v-9c86c1e4] {
  left: 0.4rem;
}

.bankCardStyle__bankAddTips__3hKyP .addbank[data-v-9c86c1e4] {
  display: block;
  width: 3.8rem;
  height: 0.84rem;
  line-height: 0.84rem;
  border-radius: 4px;
  background-color: #fff;
  font-size: 0.3rem;
  color: #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0.5rem 25%;
}

.bankCardStyle__bankAddTips__3hKyP .addbank .img[data-v-9c86c1e4] {
  width: 0.32rem;
  height: 0.32rem;
  margin-top: 0.2rem;
}

.bankCardStyle__bankCardList__7YP0J[data-v-9c86c1e4] {
  padding: 0.4rem 0;
}

.bankCardStyle__bankCardList__7YP0J>div[data-v-9c86c1e4] {
  font-size: 0.36rem;
  color: #0d1a26;
  line-height: 0.4rem;
  margin: 0 0.2rem 0.24rem;
}

.bankCardStyle__bankCardList__7YP0J>div span[data-v-9c86c1e4] {
  display: inline-block;
  margin-left: 0.1rem;
  font-size: 0.24rem;
  color: #999;
}

.bankCardStyle__bankCardList__7YP0J>div img[data-v-9c86c1e4] {
  height: 0.4rem;
  width: 0.4rem;
  float: right;
}

.bankCardStyle__bankCardList__7YP0J .bankCardStyle__addTips__3POVq[data-v-9c86c1e4] {
  text-align: center;
  color: #a5a9b3;
  margin-top: 0.2rem;
  font-size: 0.28rem;
}

.bankCardStyle__bankCardList__7YP0J>p[data-v-9c86c1e4] {
  text-align: center;
  margin-top: 0.24rem;
  font-size: 0.28rem;
  color: #6c6e82;
}

.bankCardStyle__bankCardList__7YP0J .bankCardStyle__addBox__18oGO[data-v-9c86c1e4] {
  padding: 0 0.28rem;
  margin: 0.34rem 0 0;
  border-radius: 0.2rem;
  width: 100%;
}

.bankCardStyle__bankCardList__7YP0J .bankCardStyle__addBox__18oGO .bankCardStyle__addBank__35RVi[data-v-9c86c1e4] {
  width: 100%;
  border-radius: 0.2rem;
  padding: 0.6rem 0;
  background: #fff;
  color: #333;
  font-size: 0.32rem;
  margin: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  font-weight: 500;
}

.bankCardStyle__bankCardList__7YP0J .bankCardStyle__addBox__18oGO .bankCardStyle__addBank__35RVi span[data-v-9c86c1e4] {
  font-size: 0.6rem;
  -webkit-transform: translateY(-0.06rem);
  transform: translateY(-0.06rem);
  margin-right: 0.1rem;
}

.bankCardStyle__bankCardList__7YP0J ul[data-v-9c86c1e4] {
  padding: 0 0.28rem;
}

.bankCardStyle__bankCardList__7YP0J ul li[data-v-9c86c1e4] {
  height: 2.68rem;
  padding: 0.4rem 0 0 1.36rem;
  color: #fff;
  border-radius: 0.1rem;
  position: relative;
  background: -webkit-gradient(linear, left top, right top, from(#429de6), to(#386fc3));
  background: -webkit-linear-gradient(left, #429de6, #386fc3);
  background: linear-gradient(90deg, #429de6, #386fc3);
  margin-top: 0.6rem;
}

.bankCardStyle__bankCardList__7YP0J ul li h3[data-v-9c86c1e4] {
  font-size: 0.36rem;
  font-weight: 400;
  color: #fff;
  font-weight: 500;
}

.bankCardStyle__bankCardList__7YP0J ul li>span[data-v-9c86c1e4] {
  display: block;
  color: #fff;
  font-size: 0.24rem;
  line-height: 0.4rem;
  opacity: 0.5;
}

.bankCardStyle__bankCardList__7YP0J ul li>div[data-v-9c86c1e4] {
  width: 0.84rem;
  height: 0.84rem;
  border-radius: 50%;
  background: #fff;
  position: absolute;
  top: 0.4rem;
  left: 0.32rem;
  text-align: center;
}

.bankCardStyle__bankCardList__7YP0J ul li>div>div[data-v-9c86c1e4] {
  position: absolute;
  width: 70%;
  height: 70%;
  left: 15%;
  top: 15%;
  border-radius: 50%;
  overflow: hidden;
}

.bankCardStyle__bankCardList__7YP0J ul li>div>div img[data-v-9c86c1e4] {
  width: 100%;
  height: 100%;
}

.bankCardStyle__bankCardList__7YP0J ul li>p[data-v-9c86c1e4] {
  line-height: 0.6rem;
  font-size: 0.4rem;
  font-weight: 500;
  color: #fff;
}

.bankCardStyle__bankCardList__7YP0J ul li>p span[data-v-9c86c1e4] {
  display: inline-block;
  margin-right: 0.3rem;
  color: #fff;
  opacity: 0.5;
}

.bankCardStyle__bankCardList__7YP0J ul .bankCardStyle__large__2RJon[data-v-9c86c1e4] {
  height: 3.84rem;
  padding-top: 0.8rem;
}

.bankCardStyle__bankCardList__7YP0J ul .bankCardStyle__large__2RJon>div[data-v-9c86c1e4] {
  top: 0.8rem;
}

.bankCardStyle__virtualCardList__ZHY9F[data-v-9c86c1e4] {
  padding: 0.4rem 0;
}

.bankCardStyle__virtualCardList__ZHY9F li div[data-v-9c86c1e4] {
  font-size: 0.36rem;
  color: #0d1a26;
  line-height: 0.4rem;
}

.bankCardStyle__virtualCardList__ZHY9F li div span[data-v-9c86c1e4] {
  display: inline-block;
  font-size: 0.36rem;
  font-family: PingFangSC-Bold, sans-serif;
  color: #999;
  margin-bottom: 0.2rem;
}

.bankCardStyle__virtualCardList__ZHY9F li div img[data-v-9c86c1e4] {
  height: 0.4rem;
  width: 0.4rem;
  float: right;
}

.bankCardStyle__virtualCardList__ZHY9F li span[data-v-9c86c1e4]:nth-of-type(2) {
  line-height: 0.28rem;
  color: hsla(0, 0%, 100%, 0.5);
  font-size: 0.28rem;
  margin-top: 0.3rem;
}

.bankCardStyle__virtualCardList__ZHY9F p[data-v-9c86c1e4] {
  text-align: center;
  color: #a5a9b3;
  margin-top: 0.2rem;
  font-size: 0.28rem;
}

.bankCardStyle__virtualCardList__ZHY9F .bankCardStyle__addBox__18oGO[data-v-9c86c1e4] {
  padding: 0 0.28rem;
  margin-top: 0.34rem;
  border-radius: 0.2rem;
  width: 100%;
}

.bankCardStyle__virtualCardList__ZHY9F .bankCardStyle__addBox__18oGO .bankCardStyle__addBank__35RVi[data-v-9c86c1e4] {
  width: 100%;
  font-family: PingFangSC-Bold, sans-serif;
  border-radius: 0.2rem;
  padding: 0.6rem 0;
  background: #fff;
  color: #333;
  font-size: 0.32rem;
  margin: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  font-weight: 500;
}

.bankCardStyle__virtualCardList__ZHY9F .bankCardStyle__addBox__18oGO .bankCardStyle__addBank__35RVi span[data-v-9c86c1e4] {
  font-size: 0.6rem;
  -webkit-transform: translateY(-0.06rem);
  transform: translateY(-0.06rem);
  margin-right: 0.1rem;
}

.bankCardStyle__virtualCardList__ZHY9F ul[data-v-9c86c1e4] {
  padding: 0 0.28rem;
}

.bankCardStyle__virtualCardList__ZHY9F ul li[data-v-9c86c1e4] {
  min-height: 2.6rem;
  padding: 0.6rem 0.46rem 0.26rem 0.4rem;
  color: #fff;
  border-radius: 0.1rem;
  position: relative;
  margin-top: 0.3rem;
}

.bankCardStyle__virtualCardList__ZHY9F ul li.bankCardStyle__ERC20__2N3Sf[data-v-9c86c1e4] {
  background: -webkit-gradient(linear, left top, right top, from(#429de6), to(#386fc3));
  background: -webkit-linear-gradient(left, #429de6, #386fc3);
  background: linear-gradient(90deg, #429de6, #386fc3);
}

.bankCardStyle__virtualCardList__ZHY9F ul li.bankCardStyle__OMNI__x64Ur[data-v-9c86c1e4] {
  background: -webkit-gradient(linear, left top, right top, from(#9da3ff), to(#616aed));
  background: -webkit-linear-gradient(left, #9da3ff, #616aed);
  background: linear-gradient(90deg, #9da3ff, #616aed);
}

.bankCardStyle__virtualCardList__ZHY9F ul li.bankCardStyle__TRC20__1RsLi[data-v-9c86c1e4] {
  background: -webkit-gradient(linear, left top, right top, from(#029baa), to(#16c1b2));
  background: -webkit-linear-gradient(left, #029baa, #16c1b2);
  background: linear-gradient(90deg, #029baa, #16c1b2);
}

.bankCardStyle__virtualCardList__ZHY9F ul li h3[data-v-9c86c1e4] {
  font-size: 0.36rem;
  font-weight: 400;
  color: #fff;
  font-weight: 500;
}

.bankCardStyle__virtualCardList__ZHY9F ul li>div[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 0.4rem;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  color: #fff;
  font-size: 0.36rem;
}

.bankCardStyle__virtualCardList__ZHY9F ul li>div>span[data-v-9c86c1e4] {
  color: #fff;
}

.bankCardStyle__virtualCardList__ZHY9F ul li span[data-v-9c86c1e4] {
  color: hsla(0, 0%, 100%, 0.5);
  display: block;
  word-break: break-word;
  line-height: 0.4rem;
}

.bankCardStyle__virtualCardList__ZHY9F ul li span[data-v-9c86c1e4]:nth-of-type(2) {
  width: 100%;
  margin-top: 0.3rem;
}

.bankCardStyle__virtualCardList__ZHY9F ul li[data-v-9c86c1e4]:first-of-type {
  margin-top: 0;
}

.bankCardStyle__virtualCardList__ZHY9F ul .bankCardStyle__large__2RJon[data-v-9c86c1e4] {
  height: 3.84rem;
  padding-top: 0.8rem;
}

.bankCardStyle__virtualCardList__ZHY9F ul .bankCardStyle__large__2RJon>div[data-v-9c86c1e4] {
  top: 0.8rem;
}

.bankCardStyle__alertBtn__2_MbD[data-v-9c86c1e4] {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
  text-align: center;
}

.bankCardStyle__alertBtn__2_MbD>div[data-v-9c86c1e4] {
  position: absolute;
  width: 100%;
  background: #f8f8f8;
  bottom: 0;
}

.bankCardStyle__alertBtn__2_MbD>div span[data-v-9c86c1e4] {
  display: block;
  font-size: 0.36rem;
  background: #fff;
  color: #56576e;
}

.bankCardStyle__alertBtn__2_MbD>div span[data-v-9c86c1e4]:first-of-type {
  color: #ff4634;
  padding: 0.26rem 0;
}

.bankCardStyle__alertBtn__2_MbD>div span[data-v-9c86c1e4]:last-of-type {
  margin-top: 0.2rem;
  padding: 0.26rem 0 0.92rem;
}

.bankCardStyle__yiboAlertBtn__46cXq>div[data-v-9c86c1e4] {
  background: #161a28;
}

.bankCardStyle__yiboAlertBtn__46cXq>div span[data-v-9c86c1e4] {
  color: #6c6e82 !important;
  background: #222536;
}

.bankCardStyle__bankAddTips__3hKyP[data-v-9c86c1e4] {
  padding-top: 30%;
}

.bankCardStyle__bankAddTips__3hKyP>img[data-v-9c86c1e4] {
  width: 3.3rem;
  display: block;
  margin: 0 auto 0.36rem;
}

.bankCardStyle__bankAddTips__3hKyP a[data-v-9c86c1e4] {
  position: relative;
  border: none;
  width: 6.94rem;
  height: 1.64rem;
  line-height: 1.64rem;
  border-radius: 0.2rem;
  text-align: center;
  background-color: #222536;
  color: #a1a2a7;
  margin: 0 auto;
}

.bankCardStyle__bankAddTips__3hKyP a[data-v-9c86c1e4],
.bankCardStyle__bankAddTips__3hKyP a>div[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 0.32rem;
}

.bankCardStyle__bankAddTips__3hKyP a>div[data-v-9c86c1e4] {
  -webkit-transform: translateX(-0.2rem);
  transform: translateX(-0.2rem);
}

.bankCardStyle__bankAddTips__3hKyP a.bankCardStyle__normal__KhZ8t[data-v-9c86c1e4] {
  background-color: #fff;
}

.bankCardStyle__bankAddTips__3hKyP p[data-v-9c86c1e4] {
  text-align: center;
  margin-top: 0.24rem;
  font-size: 0.28rem;
  color: #6c6e82;
}

.bankCardStyle__yiboBankCardList__3fTAd>div[data-v-9c86c1e4] {
  color: #a1a2a7;
}

.bankCardStyle__yiboBankCardList__3fTAd .bankCardStyle__addBank__35RVi[data-v-9c86c1e4] {
  background-color: #222536 !important;
  color: #a1a2a7 !important;
}

.bankCardStyle__yiboBankCardList__3fTAd .bankCardStyle__addBank__35RVi span[data-v-9c86c1e4] {
  padding-top: 2px;
}

.bankCardStyle__yiboBankCardList__3fTAd p[data-v-9c86c1e4] {
  color: #6c6e82;
}

.bankCardStyle__cradItem__1Tqfo[data-v-9c86c1e4] {
  position: relative;
  height: 2.6rem;
  padding: 0.4rem 0 0 0.4rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 0.2rem;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
}

.bankCardStyle__cradItem__1Tqfo .bankCardStyle__bankTypeIconDiv__6He1B[data-v-9c86c1e4] {
  width: 0.8rem;
  height: 0.8rem;
  padding: 0.08rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: #fff;
  border-radius: 50%;
  margin-right: 0.2rem;
  float: left;
}

.bankCardStyle__cradItem__1Tqfo .bankCardStyle__bankTypeIconDiv__6He1B .bankCardStyle__bankTypeIcon__2h_CC[data-v-9c86c1e4] {
  display: inline-block;
  width: 100%;
  height: 100%;
}

.bankCardStyle__cradItem__1Tqfo[data-v-9c86c1e4]:nth-child(2),
.bankCardStyle__cradItem__1Tqfo[data-v-9c86c1e4]:nth-child(3) {
  margin-top: -0.4rem;
}

.am-tabs[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  position: relative;
  overflow: hidden;
  height: 100%;
  width: 100%;
}

.am-tabs[data-v-9c86c1e4],
.am-tabs *[data-v-9c86c1e4] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.am-tabs-content-wrap[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: 100%;
  height: 100%;
  min-height: 0;
}

.am-tabs-content-wrap-animated[data-v-9c86c1e4] {
  -webkit-transition: left 0.3s cubic-bezier(0.35, 0, 0.25, 1), top 0.3s cubic-bezier(0.35, 0, 0.25, 1), -webkit-transform 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  transition: left 0.3s cubic-bezier(0.35, 0, 0.25, 1), top 0.3s cubic-bezier(0.35, 0, 0.25, 1), -webkit-transform 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1), left 0.3s cubic-bezier(0.35, 0, 0.25, 1), top 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1), left 0.3s cubic-bezier(0.35, 0, 0.25, 1), top 0.3s cubic-bezier(0.35, 0, 0.25, 1), -webkit-transform 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  will-change: transform, left, top;
}

.am-tabs-pane-wrap[data-v-9c86c1e4] {
  width: 100%;
  overflow-y: auto;
}

.am-tabs-pane-wrap[data-v-9c86c1e4],
.am-tabs-tab-bar-wrap[data-v-9c86c1e4] {
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}

.am-tabs-horizontal .am-tabs-pane-wrap-active[data-v-9c86c1e4] {
  height: auto;
}

.am-tabs-horizontal .am-tabs-pane-wrap-inactive[data-v-9c86c1e4] {
  height: 0;
  overflow: visible;
}

.am-tabs-vertical .am-tabs-content-wrap[data-v-9c86c1e4] {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.am-tabs-vertical .am-tabs-pane-wrap[data-v-9c86c1e4],
.am-tabs-vertical .am-tabs-tab-bar-wrap[data-v-9c86c1e4] {
  height: 100%;
}

.am-tabs-vertical .am-tabs-pane-wrap-active[data-v-9c86c1e4] {
  overflow: auto;
}

.am-tabs-vertical .am-tabs-pane-wrap-inactive[data-v-9c86c1e4] {
  overflow: hidden;
}

.am-tabs-bottom[data-v-9c86c1e4],
.am-tabs-top[data-v-9c86c1e4] {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.am-tabs-default-bar[data-v-9c86c1e4],
.am-tabs-left[data-v-9c86c1e4],
.am-tabs-right[data-v-9c86c1e4] {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
}

.am-tabs-default-bar[data-v-9c86c1e4] {
  width: 100%;
  height: 100%;
  overflow: visible;
  z-index: 1;
}

.am-tabs-default-bar[data-v-9c86c1e4],
.am-tabs-default-bar-tab[data-v-9c86c1e4] {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}

.am-tabs-default-bar-tab[data-v-9c86c1e4] {
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 15px;
  height: 43.5px;
  line-height: 43.5px;
}

.am-tabs-default-bar-tab .am-badge .am-badge-text[data-v-9c86c1e4] {
  top: -13px;
  -webkit-transform: translateX(-5px);
  transform: translateX(-5px);
}

.am-tabs-default-bar-tab .am-badge .am-badge-dot[data-v-9c86c1e4] {
  top: -6px;
  -webkit-transform: translateX(0);
  transform: translateX(0);
}

.am-tabs-default-bar-tab-active[data-v-9c86c1e4] {
  color: #108ee9;
}

.am-tabs-default-bar-underline[data-v-9c86c1e4] {
  position: absolute;
  border: 1px solid #108ee9;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}

.am-tabs-default-bar-animated .am-tabs-default-bar-content[data-v-9c86c1e4] {
  -webkit-transition: -webkit-transform 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  transition: -webkit-transform 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1), -webkit-transform 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  will-change: transform;
}

.am-tabs-default-bar-animated .am-tabs-default-bar-underline[data-v-9c86c1e4] {
  -webkit-transition: top 0.3s cubic-bezier(0.35, 0, 0.25, 1), left 0.3s cubic-bezier(0.35, 0, 0.25, 1), color 0.3s cubic-bezier(0.35, 0, 0.25, 1), width 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  transition: top 0.3s cubic-bezier(0.35, 0, 0.25, 1), left 0.3s cubic-bezier(0.35, 0, 0.25, 1), color 0.3s cubic-bezier(0.35, 0, 0.25, 1), width 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  will-change: top, left, width, color;
}

.am-tabs-default-bar-bottom[data-v-9c86c1e4],
.am-tabs-default-bar-bottom .am-tabs-default-bar-content[data-v-9c86c1e4],
.am-tabs-default-bar-top[data-v-9c86c1e4],
.am-tabs-default-bar-top .am-tabs-default-bar-content[data-v-9c86c1e4] {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
}

.am-tabs-default-bar-bottom .am-tabs-default-bar-content[data-v-9c86c1e4],
.am-tabs-default-bar-top .am-tabs-default-bar-content[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
}

.am-tabs-default-bar-bottom .am-tabs-default-bar-prevpage[data-v-9c86c1e4],
.am-tabs-default-bar-top .am-tabs-default-bar-prevpage[data-v-9c86c1e4] {
  pointer-events: none;
  position: absolute;
  top: 0;
  display: block;
  width: 59px;
  height: 100%;
  content: ' ';
  z-index: 999;
  left: 0;
  background: -webkit-gradient(linear, left top, right top, from(#fff), to(hsla(0, 0%, 100%, 0)));
  background: -webkit-linear-gradient(left, #fff, hsla(0, 0%, 100%, 0));
  background: linear-gradient(90deg, #fff, hsla(0, 0%, 100%, 0));
}

.am-tabs-default-bar-bottom .am-tabs-default-bar-nextpage[data-v-9c86c1e4],
.am-tabs-default-bar-top .am-tabs-default-bar-nextpage[data-v-9c86c1e4] {
  pointer-events: none;
  position: absolute;
  top: 0;
  display: block;
  width: 59px;
  height: 100%;
  content: ' ';
  z-index: 999;
  right: 0;
  background: -webkit-gradient(linear, left top, right top, from(hsla(0, 0%, 100%, 0)), to(#fff));
  background: -webkit-linear-gradient(left, hsla(0, 0%, 100%, 0), #fff);
  background: linear-gradient(90deg, hsla(0, 0%, 100%, 0), #fff);
}

.am-tabs-default-bar-bottom .am-tabs-default-bar-tab[data-v-9c86c1e4],
.am-tabs-default-bar-top .am-tabs-default-bar-tab[data-v-9c86c1e4] {
  padding: 8px 0;
}

.am-tabs-default-bar-bottom .am-tabs-default-bar-underline[data-v-9c86c1e4],
.am-tabs-default-bar-top .am-tabs-default-bar-underline[data-v-9c86c1e4] {
  bottom: 0;
}

.am-tabs-default-bar-top .am-tabs-default-bar-tab[data-v-9c86c1e4] {
  border-bottom: 1px solid #ddd;
}

@media (-webkit-min-device-pixel-ratio: 2),
(min-resolution: 2dppx) {
  html:not([data-scale]) .am-tabs-default-bar-top .am-tabs-default-bar-tab[data-v-9c86c1e4] {
    border-bottom: none;
  }

  html:not([data-scale]) .am-tabs-default-bar-top .am-tabs-default-bar-tab[data-v-9c86c1e4]:after {
    content: '';
    position: absolute;
    background-color: #ddd;
    display: block;
    z-index: 1;
    top: auto;
    right: auto;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    -webkit-transform-origin: 50% 100%;
    transform-origin: 50% 100%;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}

@media (-webkit-min-device-pixel-ratio: 2) and (-webkit-min-device-pixel-ratio: 3),
(min-resolution: 2dppx) and (min-resolution: 3dppx) {
  html:not([data-scale]) .am-tabs-default-bar-top .am-tabs-default-bar-tab[data-v-9c86c1e4]:after {
    -webkit-transform: scaleY(0.33);
    transform: scaleY(0.33);
  }
}

.am-tabs-default-bar-bottom .am-tabs-default-bar-tab[data-v-9c86c1e4] {
  border-top: 1px solid #ddd;
}

@media (-webkit-min-device-pixel-ratio: 2),
(min-resolution: 2dppx) {
  html:not([data-scale]) .am-tabs-default-bar-bottom .am-tabs-default-bar-tab[data-v-9c86c1e4] {
    border-top: none;
  }

  html:not([data-scale]) .am-tabs-default-bar-bottom .am-tabs-default-bar-tab[data-v-9c86c1e4]:before {
    content: '';
    position: absolute;
    background-color: #ddd;
    display: block;
    z-index: 1;
    top: 0;
    right: auto;
    bottom: auto;
    left: 0;
    width: 100%;
    height: 1px;
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}

@media (-webkit-min-device-pixel-ratio: 2) and (-webkit-min-device-pixel-ratio: 3),
(min-resolution: 2dppx) and (min-resolution: 3dppx) {
  html:not([data-scale]) .am-tabs-default-bar-bottom .am-tabs-default-bar-tab[data-v-9c86c1e4]:before {
    -webkit-transform: scaleY(0.33);
    transform: scaleY(0.33);
  }
}

.am-tabs-default-bar-left[data-v-9c86c1e4],
.am-tabs-default-bar-left .am-tabs-default-bar-content[data-v-9c86c1e4],
.am-tabs-default-bar-right[data-v-9c86c1e4],
.am-tabs-default-bar-right .am-tabs-default-bar-content[data-v-9c86c1e4] {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.am-tabs-default-bar-left .am-tabs-default-bar-content[data-v-9c86c1e4],
.am-tabs-default-bar-right .am-tabs-default-bar-content[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 100%;
}

.am-tabs-default-bar-left .am-tabs-default-bar-tab[data-v-9c86c1e4],
.am-tabs-default-bar-right .am-tabs-default-bar-tab[data-v-9c86c1e4] {
  padding: 0 8px;
}

.am-tabs-default-bar-left .am-tabs-default-bar-underline[data-v-9c86c1e4] {
  right: 0;
}

.am-tabs-default-bar-left .am-tabs-default-bar-tab[data-v-9c86c1e4] {
  border-right: 1px solid #ddd;
}

@media (-webkit-min-device-pixel-ratio: 2),
(min-resolution: 2dppx) {
  html:not([data-scale]) .am-tabs-default-bar-left .am-tabs-default-bar-tab[data-v-9c86c1e4] {
    border-right: none;
  }

  html:not([data-scale]) .am-tabs-default-bar-left .am-tabs-default-bar-tab[data-v-9c86c1e4]:after {
    content: '';
    position: absolute;
    background-color: #ddd;
    display: block;
    z-index: 1;
    top: 0;
    right: 0;
    bottom: auto;
    left: auto;
    width: 1px;
    height: 100%;
    background: #ddd;
    -webkit-transform-origin: 100% 50%;
    transform-origin: 100% 50%;
    -webkit-transform: scaleX(0.5);
    transform: scaleX(0.5);
  }
}

@media (-webkit-min-device-pixel-ratio: 2) and (-webkit-min-device-pixel-ratio: 3),
(min-resolution: 2dppx) and (min-resolution: 3dppx) {
  html:not([data-scale]) .am-tabs-default-bar-left .am-tabs-default-bar-tab[data-v-9c86c1e4]:after {
    -webkit-transform: scaleX(0.33);
    transform: scaleX(0.33);
  }
}

.am-tabs-default-bar-right .am-tabs-default-bar-underline[data-v-9c86c1e4] {
  left: 0;
}

.am-tabs-default-bar-right .am-tabs-default-bar-tab[data-v-9c86c1e4] {
  border-left: 1px solid #ddd;
}

@media (-webkit-min-device-pixel-ratio: 2),
(min-resolution: 2dppx) {
  html:not([data-scale]) .am-tabs-default-bar-right .am-tabs-default-bar-tab[data-v-9c86c1e4] {
    border-left: none;
  }

  html:not([data-scale]) .am-tabs-default-bar-right .am-tabs-default-bar-tab[data-v-9c86c1e4]:before {
    content: '';
    position: absolute;
    background-color: #ddd;
    display: block;
    z-index: 1;
    top: 0;
    right: auto;
    bottom: auto;
    left: 0;
    width: 1px;
    height: 100%;
    -webkit-transform-origin: 100% 50%;
    transform-origin: 100% 50%;
    -webkit-transform: scaleX(0.5);
    transform: scaleX(0.5);
  }
}

@media (-webkit-min-device-pixel-ratio: 2) and (-webkit-min-device-pixel-ratio: 3),
(min-resolution: 2dppx) and (min-resolution: 3dppx) {
  html:not([data-scale]) .am-tabs-default-bar-right .am-tabs-default-bar-tab[data-v-9c86c1e4]:before {
    -webkit-transform: scaleX(0.33);
    transform: scaleX(0.33);
  }
}

.am-action-sheet-wrap[data-v-9c86c1e4] {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  outline: 0;
}

.am-action-sheet-mask[data-v-9c86c1e4],
.am-action-sheet-wrap[data-v-9c86c1e4] {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
}

.am-action-sheet-mask[data-v-9c86c1e4] {
  background-color: rgba(0, 0, 0, 0.4);
  height: 100%;
}

.am-action-sheet-close[data-v-9c86c1e4],
.am-action-sheet-mask-hidden[data-v-9c86c1e4] {
  display: none;
}

.am-action-sheet[data-v-9c86c1e4] {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  padding-bottom: env(safe-area-inset-bottom);
}

.am-action-sheet.am-action-sheet-share[data-v-9c86c1e4] {
  background-color: #f2f2f2;
}

.am-action-sheet-message[data-v-9c86c1e4],
.am-action-sheet-title[data-v-9c86c1e4] {
  margin: 15px auto;
  padding: 0 15px;
  text-align: center;
}

.am-action-sheet-title[data-v-9c86c1e4] {
  font-size: 17px;
}

.am-action-sheet-message[data-v-9c86c1e4] {
  color: #888;
  font-size: 14px;
}

.am-action-sheet-button-list[data-v-9c86c1e4] {
  text-align: center;
  color: #000;
}

.am-action-sheet-button-list-item[data-v-9c86c1e4] {
  font-size: 18px;
  padding: 0 8px;
  margin: 0;
  position: relative;
  height: 50px;
  line-height: 50px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: hidden;
  border-top: 1px solid #ddd;
}

@media (-webkit-min-device-pixel-ratio: 2),
(min-resolution: 2dppx) {
  html:not([data-scale]) .am-action-sheet-button-list-item[data-v-9c86c1e4] {
    border-top: none;
  }

  html:not([data-scale]) .am-action-sheet-button-list-item[data-v-9c86c1e4]:before {
    content: '';
    position: absolute;
    background-color: #ddd;
    display: block;
    z-index: 1;
    top: 0;
    right: auto;
    bottom: auto;
    left: 0;
    width: 100%;
    height: 1px;
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}

@media (-webkit-min-device-pixel-ratio: 2) and (-webkit-min-device-pixel-ratio: 3),
(min-resolution: 2dppx) and (min-resolution: 3dppx) {
  html:not([data-scale]) .am-action-sheet-button-list-item[data-v-9c86c1e4]:before {
    -webkit-transform: scaleY(0.33);
    transform: scaleY(0.33);
  }
}

.am-action-sheet-button-list-item.am-action-sheet-button-list-item-active[data-v-9c86c1e4] {
  background-color: #ddd;
}

.am-action-sheet-button-list-badge[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.am-action-sheet-button-list-badge .am-badge[data-v-9c86c1e4] {
  margin-left: 8px;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}

.am-action-sheet-button-list-item-content[data-v-9c86c1e4] {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.am-action-sheet-button-list .am-action-sheet-cancel-button[data-v-9c86c1e4] {
  padding-top: 6px;
  position: relative;
}

.am-action-sheet-button-list .am-action-sheet-cancel-button-mask[data-v-9c86c1e4] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 6px;
  background-color: #e7e7ed;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}

@media (-webkit-min-device-pixel-ratio: 2),
(min-resolution: 2dppx) {
  html:not([data-scale]) .am-action-sheet-button-list .am-action-sheet-cancel-button-mask[data-v-9c86c1e4] {
    border-top: none;
  }

  html:not([data-scale]) .am-action-sheet-button-list .am-action-sheet-cancel-button-mask[data-v-9c86c1e4]:before {
    content: '';
    position: absolute;
    background-color: #ddd;
    display: block;
    z-index: 1;
    top: 0;
    right: auto;
    bottom: auto;
    left: 0;
    width: 100%;
    height: 1px;
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}

@media (-webkit-min-device-pixel-ratio: 2) and (-webkit-min-device-pixel-ratio: 3),
(min-resolution: 2dppx) and (min-resolution: 3dppx) {
  html:not([data-scale]) .am-action-sheet-button-list .am-action-sheet-cancel-button-mask[data-v-9c86c1e4]:before {
    -webkit-transform: scaleY(0.33);
    transform: scaleY(0.33);
  }
}

@media (-webkit-min-device-pixel-ratio: 2),
(min-resolution: 2dppx) {
  html:not([data-scale]) .am-action-sheet-button-list .am-action-sheet-cancel-button-mask[data-v-9c86c1e4] {
    border-bottom: none;
  }

  html:not([data-scale]) .am-action-sheet-button-list .am-action-sheet-cancel-button-mask[data-v-9c86c1e4]:after {
    content: '';
    position: absolute;
    background-color: #ddd;
    display: block;
    z-index: 1;
    top: auto;
    right: auto;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    -webkit-transform-origin: 50% 100%;
    transform-origin: 50% 100%;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}

@media (-webkit-min-device-pixel-ratio: 2) and (-webkit-min-device-pixel-ratio: 3),
(min-resolution: 2dppx) and (min-resolution: 3dppx) {
  html:not([data-scale]) .am-action-sheet-button-list .am-action-sheet-cancel-button-mask[data-v-9c86c1e4]:after {
    -webkit-transform: scaleY(0.33);
    transform: scaleY(0.33);
  }
}

.am-action-sheet-button-list .am-action-sheet-destructive-button[data-v-9c86c1e4] {
  color: #f4333c;
}

.am-action-sheet-share-list[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  border-top: 1px solid #ddd;
  padding: 21px 0 21px 15px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}

@media (-webkit-min-device-pixel-ratio: 2),
(min-resolution: 2dppx) {
  html:not([data-scale]) .am-action-sheet-share-list[data-v-9c86c1e4] {
    border-top: none;
  }

  html:not([data-scale]) .am-action-sheet-share-list[data-v-9c86c1e4]:before {
    content: '';
    position: absolute;
    background-color: #ddd;
    display: block;
    z-index: 1;
    top: 0;
    right: auto;
    bottom: auto;
    left: 0;
    width: 100%;
    height: 1px;
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}

@media (-webkit-min-device-pixel-ratio: 2) and (-webkit-min-device-pixel-ratio: 3),
(min-resolution: 2dppx) and (min-resolution: 3dppx) {
  html:not([data-scale]) .am-action-sheet-share-list[data-v-9c86c1e4]:before {
    -webkit-transform: scaleY(0.33);
    transform: scaleY(0.33);
  }
}

.am-action-sheet-share-list-item[data-v-9c86c1e4] {
  -webkit-box-flex: 0;
  -webkit-flex: none;
  -ms-flex: none;
  flex: none;
  margin: 0 12px 0 0;
}

.am-action-sheet-share-list-item-icon[data-v-9c86c1e4] {
  margin-bottom: 9px;
  width: 60px;
  height: 60px;
  background-color: #fff;
  border-radius: 3px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.am-action-sheet-share-list-item-title[data-v-9c86c1e4] {
  color: #888;
  font-size: 10px;
  text-align: center;
}

.am-action-sheet-share-cancel-button[data-v-9c86c1e4] {
  height: 50px;
  line-height: 50px;
  text-align: center;
  background-color: #fff;
  color: #000;
  font-size: 18px;
  position: relative;
  border-top: 1px solid #ddd;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

@media (-webkit-min-device-pixel-ratio: 2),
(min-resolution: 2dppx) {
  html:not([data-scale]) .am-action-sheet-share-cancel-button[data-v-9c86c1e4] {
    border-top: none;
  }

  html:not([data-scale]) .am-action-sheet-share-cancel-button[data-v-9c86c1e4]:before {
    content: '';
    position: absolute;
    background-color: #ddd;
    display: block;
    z-index: 1;
    top: 0;
    right: auto;
    bottom: auto;
    left: 0;
    width: 100%;
    height: 1px;
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}

@media (-webkit-min-device-pixel-ratio: 2) and (-webkit-min-device-pixel-ratio: 3),
(min-resolution: 2dppx) and (min-resolution: 3dppx) {
  html:not([data-scale]) .am-action-sheet-share-cancel-button[data-v-9c86c1e4]:before {
    -webkit-transform: scaleY(0.33);
    transform: scaleY(0.33);
  }
}

.am-action-sheet-share-cancel-button.am-action-sheet-share-cancel-button-active[data-v-9c86c1e4] {
  background-color: #ddd;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__tips__3rcbz[data-v-9c86c1e4] {
  margin: 0.2rem 0.32rem;
  line-height: 0.4rem;
  height: 0.8rem;
  font-size: 0.24rem;
  color: #98a5b3;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__tips__3rcbz>span[data-v-9c86c1e4] {
  padding: 0 0.1rem;
  color: #ede9e7;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__matchTips__3toS5[data-v-9c86c1e4] {
  padding: 0 0.2rem;
  font-size: 0.24rem;
  color: #98a5b3;
  margin-bottom: 0.4rem;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__matchTips__3toS5 h3[data-v-9c86c1e4] {
  font-size: 0.4rem;
  color: #158bf4;
  line-height: 0.72rem;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__row__3jP1Y[data-v-9c86c1e4] {
  padding: 0.24rem 0.32rem;
  font-size: 0.32rem;
  color: #0d1a26;
  background: #fff;
  position: relative;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__row__3jP1Y p[data-v-9c86c1e4] {
  padding: 0.4rem 0;
  color: 0.24rem;
  color: #a5a9b3;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__row__3jP1Y span[data-v-9c86c1e4] {
  font-size: 0.28rem;
  color: #333;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__row__3jP1Y .bankCardAddStyle__icon__3R1tu[data-v-9c86c1e4] {
  position: absolute;
  width: 0.2rem;
  height: 0.2rem;
  right: 0.24rem;
  top: 0;
  bottom: 0;
  margin: auto;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__row__3jP1Y uni-button[data-v-9c86c1e4] {
  display: block;
  width: 2rem;
  border-radius: 0.1rem;
  border: none;
  color: #fff;
  background-color: #ede9e7;
  font-size: 0.28rem;
  white-space: nowrap;
  position: absolute;
  right: 0.28rem;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  padding: 0.14rem 0;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__row__3jP1Y uni-button span[data-v-9c86c1e4] {
  font-size: 0.28rem;
  color: #ced4d9;
  white-space: nowrap;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__row__3jP1Y .bankCardAddStyle__disabled__fA-Bu[data-v-9c86c1e4] {
  opacity: 0.5;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__row__3jP1Y uni-input[data-v-9c86c1e4] {
  border: none;
  width: 100%;
  font-size: 0.28rem;
  margin-top: 0.12rem;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__row__3jP1Y uni-input[data-v-9c86c1e4]::-webkit-input-placeholder {
  color: #ced4d9;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__row__3jP1Y uni-input[data-v-9c86c1e4]::-moz-placeholder {
  color: #ced4d9;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__row__3jP1Y uni-input[data-v-9c86c1e4]::-ms-input-placeholder {
  color: #ced4d9;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__row__3jP1Y uni-input[data-v-9c86c1e4]::placeholder {
  color: #ced4d9;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__row__3jP1Y .bankCardAddStyle__bindedName__S5isg[data-v-9c86c1e4]::-webkit-input-placeholder {
  color: #000;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__row__3jP1Y .bankCardAddStyle__bindedName__S5isg[data-v-9c86c1e4]::-moz-placeholder {
  color: #000;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__row__3jP1Y .bankCardAddStyle__bindedName__S5isg[data-v-9c86c1e4]::-ms-input-placeholder {
  color: #000;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__row__3jP1Y .bankCardAddStyle__bindedName__S5isg[data-v-9c86c1e4]::placeholder {
  color: #000;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__row__3jP1Y .bankCardAddStyle__rowName__1dXWr[data-v-9c86c1e4] {
  white-space: nowrap;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__row__3jP1Y .bankCardAddStyle__input__1yN82[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__bankRow__3aEEH span[data-v-9c86c1e4] {
  display: block;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__bankRow__3aEEH .bankCardAddStyle__bankInfo__1yopd[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 0.12rem;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__bankRow__3aEEH .bankCardAddStyle__bankInfo__1yopd span[data-v-9c86c1e4] {
  font-size: 0.28rem;
  color: #ced4d9;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__bankRow__3aEEH .bankCardAddStyle__bankInfo__1yopd img[data-v-9c86c1e4] {
  margin-left: 0.18rem;
  vertical-align: middle;
  width: 0.26rem;
  height: 0.26rem;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__bankRow__3aEEH .bankCardAddStyle__bankInfo__1yopd .bankCardAddStyle__color__yvlhn[data-v-9c86c1e4] {
  color: #000;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__verifyCode__2acQ3[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__verifyCode__2acQ3 uni-input[data-v-9c86c1e4] {
  display: block;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: 200px;
  margin-left: 0;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__verifyCode__2acQ3 uni-button[data-v-9c86c1e4] {
  display: block;
  -webkit-box-flex: 0;
  -webkit-flex: none;
  -ms-flex: none;
  flex: none;
  width: 2.1rem;
  border: none;
  color: #1e2024;
  background-color: initial;
  font-size: 0.28rem;
  white-space: nowrap;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__verifyCode__2acQ3 uni-button span[data-v-9c86c1e4] {
  font-size: 0.28rem;
  color: #ced4d9;
  white-space: nowrap;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__border__p3LDq[data-v-9c86c1e4]:after {
  content: '';
  position: absolute;
  left: 5.12px;
  left: 0.32rem;
  bottom: 0;
  right: 0;
  height: 1px;
  background-color: #ebedf0;
}

.bankCardAddStyle__bankCardAdd__3g9FG .bankCardAddStyle__notice__1G1NM[data-v-9c86c1e4] {
  margin: 0.4rem 0.28rem 0.2rem;
  color: #98a5b3;
}

.bankCardAddStyle__hide__Nwirb[data-v-9c86c1e4] {
  display: none !important;
}

.bankCardAddStyle__noInput__17iyC[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.bankCardAddStyle__noInput__17iyC uni-input[data-v-9c86c1e4] {
  padding-right: 0.32rem;
  text-align: right;
}

.bankCardAddStyle__noInput__17iyC uni-input[data-v-9c86c1e4]:disabled {
  background-color: initial;
}

.bankCardAddStyle__margin__1Hdrn[data-v-9c86c1e4] {
  margin-top: 0.32rem;
  margin-bottom: 0.32rem;
}

.bankCardAddStyle__margin__1Hdrn>span[data-v-9c86c1e4]:first-of-type {
  display: inline-block;
  width: 1.28rem;
}

.bankCardAddStyle__margin__1Hdrn .bankCardAddStyle__color__yvlhn[data-v-9c86c1e4] {
  display: inline-block;
  line-height: 1;
  max-width: 4rem;
  white-space: normal;
  vertical-align: middle;
}

.bankCardAddStyle__yibo__3I4d3[data-v-9c86c1e4] {
  background-color: #222536;
}

.bankCardAddStyle__yibo__3I4d3 .bankCardAddStyle__row__3jP1Y[data-v-9c86c1e4] {
  background-color: #222536 !important;
  border: none;
}

.bankCardAddStyle__yibo__3I4d3 .bankCardAddStyle__row__3jP1Y>span[data-v-9c86c1e4]:first-of-type {
  color: #dedede !important;
}

.bankCardAddStyle__yibo__3I4d3 .bankCardAddStyle__row__3jP1Y[data-v-9c86c1e4]:after {
  content: '';
  position: absolute;
  left: 4.48px;
  left: 0.28rem;
  right: 4.48px !important;
  right: 0.28rem !important;
  bottom: 0;
  height: 1px;
  background-color: #373a4c !important;
}

.bankCardAddStyle__yibo__3I4d3 .bankCardAddStyle__row__3jP1Y .bankCardAddStyle__bankInfo__1yopd span[data-v-9c86c1e4] {
  color: #6c6e82 !important;
}

.bankCardAddStyle__yibo__3I4d3 .bankCardAddStyle__row__3jP1Y .bankCardAddStyle__bankInfo__1yopd .bankCardAddStyle__color__yvlhn[data-v-9c86c1e4] {
  color: #dedede !important;
}

.bankCardAddStyle__yibo__3I4d3 .bankCardAddStyle__row__3jP1Y>uni-button[data-v-9c86c1e4],
.bankCardAddStyle__yibo__3I4d3 .bankCardAddStyle__row__3jP1Y>uni-button>span[data-v-9c86c1e4] {
  color: #79420d !important;
}

.bankCardAddStyle__yibo__3I4d3 .bankCardAddStyle__row__3jP1Y .bankCardAddStyle__icon__3R1tu[data-v-9c86c1e4] {
  width: 0.32rem;
  height: 0.32rem;
}

.bankCardAddStyle__yibo__3I4d3 .bankCardAddStyle__tips__3rcbz[data-v-9c86c1e4] {
  margin: 0.12rem 0 !important;
  padding: 0.48rem 0.32rem;
  background-color: #161a28;
  font-size: 0.28rem !important;
  color: #6c6e82 !important;
}

.bankCardAddStyle__yibo__3I4d3 .bankCardAddStyle__tips__3rcbz span[data-v-9c86c1e4] {
  color: #deb489 !important;
}

.bankCardAddStyle__yibo__3I4d3 .bankCardAddStyle__nameTips__3Fhip[data-v-9c86c1e4] {
  padding: 0.24rem 0.28rem !important;
  margin: 0 !important;
  font-size: 0.24rem !important;
  color: #6c6e82;
  height: auto !important;
}

.bankCardAddStyle__yibo__3I4d3 .bankCardAddStyle__margin__1Hdrn[data-v-9c86c1e4] {
  margin: 0 !important;
  border-top: 0.2rem solid #161a28;
}

.bankCardAddStyle__yibo__3I4d3 .bankCardAddStyle__margin__1Hdrn p[data-v-9c86c1e4] {
  margin-top: 0.3rem;
  border-top: 1px solid #373a4c;
  padding: 0.5rem 0 0;
}

.bankCardAddStyle__yibo__3I4d3 .bankCardAddStyle__margin__1Hdrn[data-v-9c86c1e4]:after {
  background-color: initial !important;
}

.bankCardAddStyle__yibo__3I4d3 .bankCardAddStyle__notice__1G1NM[data-v-9c86c1e4] {
  margin: 0.4rem 0.28rem 0.2rem;
  color: #6c6e82;
}

p[data-v-9c86c1e4] {
  margin-bottom: 0;
}

.virtualCoinAdd__bankCardAdd__GQ-AS[data-v-9c86c1e4] {
  margin-top: 0.2rem;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__tips__3Cba9[data-v-9c86c1e4] {
  margin: 0.4rem 0.32rem -0.2rem;
  line-height: 0.4rem;
  font-size: 0.24rem;
  color: #98a5b3;
  font-family: PingFang SC;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__tips__3Cba9>span[data-v-9c86c1e4] {
  padding: 0 0.1rem;
  color: #ede9e7;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__matchTips__1gbVH[data-v-9c86c1e4] {
  padding: 0 0.2rem;
  font-size: 0.24rem;
  color: #98a5b3;
  margin-bottom: 0.4rem;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__matchTips__1gbVH h3[data-v-9c86c1e4] {
  font-size: 0.4rem;
  color: #158bf4;
  line-height: 0.72rem;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv[data-v-9c86c1e4] {
  padding: 0 0.28rem;
  font-size: 0.32rem;
  color: #0d1a26;
  background: #fff;
  position: relative;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv .virtualCoinAdd__protoWrap__kN71Y[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-left: 0.24rem;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv .virtualCoinAdd__protoWrap__kN71Y>div[data-v-9c86c1e4] {
  width: 1.58rem;
  height: 0.7rem;
  border-radius: 0.1rem;
  border: 1px solid #eee;
  text-align: center;
  line-height: 0.7rem;
  color: #333;
  font-size: 0.28rem;
  margin-right: 0.26rem;
  position: relative;
  overflow: hidden;
  font-family: DINPro;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv .virtualCoinAdd__protoWrap__kN71Y>div .virtualCoinAdd__jiaoBiao__Db_H6[data-v-9c86c1e4] {
  position: absolute;
  right: -0.02rem;
  height: 0.32rem;
  bottom: -0.02rem;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv .virtualCoinAdd__protoWrap__kN71Y>div.virtualCoinAdd__yibo__ABco6[data-v-9c86c1e4] {
  color: #a1a2a7;
  border: 1px solid rgba(108, 110, 130, 0.4);
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv .virtualCoinAdd__protoWrap__kN71Y>div span[data-v-9c86c1e4] {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 0.42rem;
  width: 0.42rem;
  color: #fff;
  text-indent: 0.1rem;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv .virtualCoinAdd__protoWrap__kN71Y>div.virtualCoinAdd__active__3stlB[data-v-9c86c1e4] {
  color: #ede9e7 !important;
  border: 1px solid #ede9e7;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv[data-v-9c86c1e4]:after {
  content: '';
  position: absolute;
  left: 4.48px;
  left: 0.28rem;
  right: 4.48px;
  right: 0.28rem;
  bottom: 0;
  height: 1px;
  background-color: #ebedf0;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv p[data-v-9c86c1e4] {
  padding: 0.4rem 0;
  color: 0.24rem;
  color: #a5a9b3;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv span[data-v-9c86c1e4] {
  font-size: 0.28rem;
  color: #333;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv .virtualCoinAdd__icon__2XJhk[data-v-9c86c1e4] {
  position: absolute;
  width: 0.2rem;
  height: 0.2rem;
  right: 0.24rem;
  top: 0;
  bottom: 0;
  margin: auto;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv uni-button[data-v-9c86c1e4] {
  display: block;
  width: 2rem;
  border-radius: 0.1rem;
  border: none;
  color: #fff;
  background-color: #ede9e7;
  font-size: 0.28rem;
  white-space: nowrap;
  position: absolute;
  right: 0.28rem;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  padding: 0.14rem 0;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv uni-button uni-input span[data-v-9c86c1e4] {
  font-size: 0.28rem;
  color: #ced4d9;
  white-space: nowrap;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv .virtualCoinAdd__disabled__17xGh[data-v-9c86c1e4] {
  opacity: 0.5;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv uni-input[data-v-9c86c1e4] {
  border: none;
  width: 100%;
  font-size: 0.48rem;
  font-family: DINPro;
  color: #414655;
  height: 100%;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv uni-input[data-v-9c86c1e4]::-webkit-input-placeholder {
  color: #e0e3eb;
  font-size: 0.36rem;
  font-family: PingFang SC;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv uni-input[data-v-9c86c1e4]::-moz-placeholder {
  color: #e0e3eb;
  font-size: 0.36rem;
  font-family: PingFang SC;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv uni-input[data-v-9c86c1e4]::-ms-input-placeholder {
  color: #e0e3eb;
  font-size: 0.36rem;
  font-family: PingFang SC;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv uni-input[data-v-9c86c1e4]::placeholder {
  color: #e0e3eb;
  font-size: 0.36rem;
  font-family: PingFang SC;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv .virtualCoinAdd__accountInput__KKBoe[data-v-9c86c1e4] {
  font-size: 0.28rem;
  font-family: PingFang SC;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv .virtualCoinAdd__bindedName__1aPD9[data-v-9c86c1e4]::-webkit-input-placeholder {
  color: #000;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv .virtualCoinAdd__bindedName__1aPD9[data-v-9c86c1e4]::-moz-placeholder {
  color: #000;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv .virtualCoinAdd__bindedName__1aPD9[data-v-9c86c1e4]::-ms-input-placeholder {
  color: #000;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv .virtualCoinAdd__bindedName__1aPD9[data-v-9c86c1e4]::placeholder {
  color: #000;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv .virtualCoinAdd__rowName__9LNLO[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  white-space: nowrap;
  font-size: 0.28rem;
  color: #414655;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  font-family: PingFang SC;
  height: 0.8rem;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv .virtualCoinAdd__input__3E0j2[data-v-9c86c1e4] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 1rem;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  line-height: 1;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__row__1MlYv .virtualCoinAdd__input__3E0j2 .virtualCoinAdd__circle__1IO3N[data-v-9c86c1e4] {
  position: absolute;
  top: 0.16rem;
  right: 0;
  width: 0.42rem;
  height: 0.42rem;
  border-radius: 50%;
  overflow: hidden;
  font-style: normal;
  color: #fff;
  background-color: #ccc;
  background-repeat: no-repeat;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg fill='%23fff' viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E");
  background-size: 21px auto;
  background-position: 2px 2px;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__rowHelp__3xARM .virtualCoinAdd__rowName__9LNLO[data-v-9c86c1e4] {
  font-family: PingFang SC;
  font-size: 0.24rem;
  color: #a5a9b3;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__rowHelp__3xARM[data-v-9c86c1e4]:after {
  display: none;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__virtual-coin-protocol-wrapper__pLXIh[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 1.4rem;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__bankRow__jmue6 span[data-v-9c86c1e4] {
  display: block;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__bankRow__jmue6 .virtualCoinAdd__bankInfo__2tYIH[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 0.12rem;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__bankRow__jmue6 .virtualCoinAdd__bankInfo__2tYIH span[data-v-9c86c1e4] {
  font-size: 0.28rem;
  color: #ced4d9;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__bankRow__jmue6 .virtualCoinAdd__bankInfo__2tYIH img[data-v-9c86c1e4] {
  margin-left: 0.18rem;
  vertical-align: middle;
  width: 0.26rem;
  height: 0.26rem;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__bankRow__jmue6 .virtualCoinAdd__bankInfo__2tYIH .virtualCoinAdd__color__13s0j[data-v-9c86c1e4] {
  color: #000;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__verifyCode__tVUhw[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__verifyCode__tVUhw uni-input[data-v-9c86c1e4] {
  display: block;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: 200px;
  margin-left: 0;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__verifyCode__tVUhw uni-button[data-v-9c86c1e4] {
  display: block;
  -webkit-box-flex: 0;
  -webkit-flex: none;
  -ms-flex: none;
  flex: none;
  width: 2.1rem;
  border: none;
  color: #1e2024;
  background-color: initial;
  font-size: 0.28rem;
  white-space: nowrap;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__verifyCode__tVUhw uni-button span[data-v-9c86c1e4] {
  font-size: 0.28rem;
  color: #ced4d9;
  white-space: nowrap;
}

.virtualCoinAdd__bankCardAdd__GQ-AS .virtualCoinAdd__border__1k0Cy[data-v-9c86c1e4]:after {
  content: '';
  position: absolute;
  left: 5.12px;
  left: 0.32rem;
  bottom: 0;
  right: 0;
  height: 1px;
  background-color: #ebedf0;
}

.virtualCoinAdd__hide__18Ewz[data-v-9c86c1e4] {
  display: none !important;
}

.virtualCoinAdd__noInput__2gkQ1[data-v-9c86c1e4] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.virtualCoinAdd__noInput__2gkQ1 uni-input[data-v-9c86c1e4] {
  padding-right: 0.32rem;
  text-align: right;
}

.virtualCoinAdd__noInput__2gkQ1 uni-input[data-v-9c86c1e4]:disabled {
  background-color: initial;
}

.virtualCoinAdd__margin__1SplH[data-v-9c86c1e4] {
  margin-top: 0.32rem;
  margin-bottom: 0.32rem;
}

.virtualCoinAdd__margin__1SplH>span[data-v-9c86c1e4]:first-of-type {
  display: inline-block;
  width: 1.28rem;
}

.virtualCoinAdd__margin__1SplH .virtualCoinAdd__color__13s0j[data-v-9c86c1e4] {
  display: inline-block;
  line-height: 1;
  max-width: 4rem;
  white-space: normal;
  vertical-align: middle;
}

.virtualCoinAdd__yibo__ABco6[data-v-9c86c1e4] {
  background-color: #222536;
}

.virtualCoinAdd__yibo__ABco6 .virtualCoinAdd__row__1MlYv[data-v-9c86c1e4] {
  background-color: #222536 !important;
  border: none;
}

.virtualCoinAdd__yibo__ABco6 .virtualCoinAdd__row__1MlYv>span[data-v-9c86c1e4]:first-of-type {
  color: #dedede !important;
}

.virtualCoinAdd__yibo__ABco6 .virtualCoinAdd__row__1MlYv[data-v-9c86c1e4]:after {
  content: '';
  position: absolute;
  left: 4.48px;
  left: 0.28rem;
  right: 4.48px !important;
  right: 0.28rem !important;
  bottom: 0;
  height: 1px;
  background-color: #373a4c !important;
}

.virtualCoinAdd__yibo__ABco6 .virtualCoinAdd__row__1MlYv .virtualCoinAdd__bankInfo__2tYIH span[data-v-9c86c1e4] {
  color: #6c6e82 !important;
}

.virtualCoinAdd__yibo__ABco6 .virtualCoinAdd__row__1MlYv .virtualCoinAdd__bankInfo__2tYIH .virtualCoinAdd__color__13s0j[data-v-9c86c1e4] {
  color: #dedede !important;
}

.virtualCoinAdd__yibo__ABco6 .virtualCoinAdd__row__1MlYv>uni-button[data-v-9c86c1e4],
.virtualCoinAdd__yibo__ABco6 .virtualCoinAdd__row__1MlYv>uni-button>span[data-v-9c86c1e4] {
  color: #79420d !important;
}

.virtualCoinAdd__yibo__ABco6 .virtualCoinAdd__row__1MlYv .virtualCoinAdd__icon__2XJhk[data-v-9c86c1e4] {
  width: 0.32rem;
  height: 0.32rem;
}

.virtualCoinAdd__yibo__ABco6 .virtualCoinAdd__tips__3Cba9[data-v-9c86c1e4] {
  margin: 0.05rem 0 !important;
  padding: 0.48rem 0.32rem;
  background: #161a28;
  font-size: 0.24rem !important;
  color: #6c6e82 !important;
}

.virtualCoinAdd__yibo__ABco6 .virtualCoinAdd__tips__3Cba9 span[data-v-9c86c1e4] {
  color: #deb489 !important;
}

.virtualCoinAdd__yibo__ABco6 .virtualCoinAdd__tips__3Cba9.virtualCoinAdd__nobg__152cX[data-v-9c86c1e4] {
  background: none !important;
}

.virtualCoinAdd__yibo__ABco6 .virtualCoinAdd__nameTips__jyIH-[data-v-9c86c1e4] {
  padding: 0.24rem 0.28rem !important;
  margin: 0 !important;
  font-size: 0.24rem !important;
  color: #6c6e82;
  height: auto !important;
}

.virtualCoinAdd__yibo__ABco6 .virtualCoinAdd__margin__1SplH[data-v-9c86c1e4] {
  margin: 0 !important;
  border-top: 0.2rem solid #161a28;
}

.virtualCoinAdd__yibo__ABco6 .virtualCoinAdd__margin__1SplH p[data-v-9c86c1e4] {
  margin-top: 0.3rem;
  border-top: 1px solid #373a4c;
  padding: 0.5rem 0 0;
}

.virtualCoinAdd__yibo__ABco6 .virtualCoinAdd__margin__1SplH[data-v-9c86c1e4]:after {
  background-color: initial !important;
}

.virtualCoinAdd__yibo__ABco6 .virtualCoinAdd__notice__2UUuq[data-v-9c86c1e4] {
  margin: 0.4rem 0.28rem 0.2rem;
  color: #6c6e82;
}

.input-money-placeholder[data-v-9c86c1e4] {
  padding-left: 15px;
}
</style>
